module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 249);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/button");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/message");

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hideMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isNotEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return distinguishUserAgentUtils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return loadJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return urlDelP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataURLtoFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return downloadGenerateQRCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserAgentInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isWxMiniApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return insertHTML; });
// 获取url链接中的参数
function getQueryString(name) {
  let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
  const r = source.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

// 手机打*号
function hideMobile(mobile) {
  if (!mobile) return "";
  return `${mobile.substr(0, 3)}****${mobile.substr(-4)}`;
}

// 判断变量是否为空
function isNotEmpty(obj) {
  if (typeof obj === "undefined" || obj == null) {
    return false;
  }
  if (typeof obj === "function") {
    return true;
  }
  if (obj.constructor == Number) {
    if (obj) {
      return true;
    }
    return false;
  }
  if (typeof obj === "string") {
    if (obj !== "") {
      return true;
    }
    return false;
  }
  return Object.keys(obj).length > 0;
}

// 区分浏览器类型
function distinguishUserAgentUtils(userAgent) {
  if (typeof window !== "undefined") {
    var _window;
    const ua = userAgent || window.navigator.userAgent;
    return {
      isEdge: ua.includes("Edge"),
      isFF: ua.includes("Firefox"),
      isOpera: ua.includes("Opera"),
      isBB: ua.includes("BlackBerry"),
      isChrome: ua.includes("Chrome"),
      isMaxthon: ua.includes("Maxthon"),
      isFeishu: ua.includes("Lark/"),
      isIos: /(iPhone|iPad|iPod|iOS)/i.test(ua),
      isSafari: ua.includes("Safari") && !ua.includes("Chrome"),
      isIE: !!window.ActiveXObject || "ActiveXObject" in window,
      isMobile: /(iPad|iPhone|iPod|Opera Mini|Android.*Mobile|NetFront|PSP|BlackBerry|Windows Phone)/gi.test(ua),
      isWeixin: ua.toLowerCase().match(/MicroMessenger/i) == "micromessenger",
      isWeibo: ua.toLowerCase().match(/WeiBo/i) == "weibo",
      isWxwork: ua.toLowerCase().match(/wxwork/i) == "wxwork",
      isQQ: ua.toLowerCase().match(/QQ/i) == "qq",
      isAndroidApp: ua.toLowerCase() == "android_app/1.0.0",
      isAndroid: (ua.toLowerCase().match(/android/i) == "android" || ua.toLowerCase().match(/adr/i) == "adr") && ua.toLowerCase() != "android_app/1.0.0",
      // ios android 客户端
      isNative: ua.toLowerCase().match(/android_app\//i) == "android_app/" || ua.toLowerCase().match(/wenjuan\//i) == "wenjuan/",
      isBaiying: ua.toLowerCase().match(/Baiying/i) == "baiying",
      isDingding: ua.includes("DingTalk"),
      isTencentWemeet: ua.toLowerCase().match(/tencent_wemeet/i) == "tencent_wemeet",
      isMac: /macintosh|mac os x/i.test(ua),
      isPWA: (_window = window) === null || _window === void 0 ? void 0 : _window.matchMedia("(display-mode: minimal-ui)").matches
    };
  }
  return {};
}

// js中动态加载script，并在load后触发cb
function loadJS(url, callback) {
  const script = document.createElement("script");
  const fn = callback || function () {};
  script.type = "text/javascript";
  // IE
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;
        fn();
      }
    };
  } else {
    // 其他浏览器
    script.onload = function () {
      fn();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

// 删除URL上某个参数
function urlDelP(url, name) {
  const urlArr = url.split("?");
  if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
    const query = urlArr[1];
    const obj = {};
    const arr = query.split("&");
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    const querys = JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
    let searchs = "";
    if (querys) {
      searchs = `?${querys}`;
    }
    const urlte = urlArr[0] + searchs;
    return urlte;
  }
  return url;
}
/**
 * 将base64转换为文件
 * @param {String} dataUrl 图片地址
 * @param {String} imgType 图片类型 传png,jpg等 而不是image/png
 * @return blob文件
 */
function dataURLtoFile(dataUrl, imgType) {
  var _arr$;
  // 替换base64图片的图片类型
  if (imgType) {
    const types = dataUrl.match(/data:image[^;]*;base64,/gi);
    types.forEach(type => {
      dataUrl = dataUrl.replace(new RegExp(`${type}`, "g"), `data:image/${imgType};base64,`);
    });
  }
  const arr = dataUrl.split(",");
  const reg = (_arr$ = arr[0]) === null || _arr$ === void 0 ? void 0 : _arr$.match(/:(.*?);/);
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: reg ? reg[1] : ""
  });
}

// 前端生成二维码-下载二维码
function downloadGenerateQRCode(url) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "图片";
  if (window.navigator.msSaveOrOpenBlob) {
    // ie
    const bstr = atob(url.split(",")[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const blob = new Blob([u8arr]);
    window.navigator.msSaveOrOpenBlob(blob, `${name}.png`);
  } else {
    // 非ie
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", `${name}.png`);
    a.click();
  }
}
function getUserAgentInfo() {
  const {
    userAgent
  } = navigator;
  let version;
  if (/opera/i.test(userAgent) || /OPR/i.test(userAgent)) {
    version = getVersion(userAgent, "OPR/(\\d+\\.+\\d+)");
    return ["Opera", version];
  }
  if (/compatible/i.test(userAgent) && /MSIE/i.test(userAgent)) {
    version = getVersion(userAgent, "MSIE (\\d+\\.+\\d+)");
    return ["IE", version];
  }
  if (/Edg/i.test(userAgent)) {
    version = getVersion(userAgent, "Edg/(\\d+\\.+\\d+)");
    return ["Edge", version];
  }
  if (/Firefox/i.test(userAgent)) {
    version = getVersion(userAgent, "Firefox/(\\d+\\.+\\d+)");
    return ["Firefox", version];
  }
  if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
    version = getVersion(userAgent, "Version/(\\d+\\.+\\d+)");
    return ["Safari", version];
  }
  if (/Chrome/i.test(userAgent) && /Safari/i.test(userAgent)) {
    version = getVersion(userAgent, "Chrome/(\\d+\\.+\\d+)");
    return ["Chrome", version];
  }
  if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
    return ["IE", "any"];
  }
}
function getVersion(userAgent, reg) {
  const reBrowser = new RegExp(reg);
  reBrowser.test(userAgent);
  return parseInt(RegExp.$1);
}

// 判断是否是小程序环境
function isWxMiniApp() {
  try {
    var _window2, _window2$navigator, _window2$navigator$us;
    const ua = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$navigator = _window2.navigator) === null || _window2$navigator === void 0 ? void 0 : (_window2$navigator$us = _window2$navigator.userAgent) === null || _window2$navigator$us === void 0 ? void 0 : _window2$navigator$us.toLowerCase();
    const uaIsWxMiniApp = ua.includes("micromessenger") && ua.includes("miniprogram");
    if (uaIsWxMiniApp) return true;
    const appname = getQueryString("appname");
    if (appname === "wj-miniapp") return true;
    if (window.__wxjs_environment === "miniprogram") return true;
  } catch (error) {}
}

// insert HTML
function insertHTML(html, editor) {
  if (window.getSelection) {
    // IE9 and non-IE
    const sel = window.getSelection();
    if (editor && sel.focusNode !== editor && sel.focusNode.parentNode !== editor) {
      editor.innerHTML += html;
      return;
    }
    if (sel.getRangeAt && sel.rangeCount) {
      let range = sel.getRangeAt(0);
      range.deleteContents();
      const el = document.createElement("div");
      el.innerHTML = html;
      const frag = document.createDocumentFragment();
      let node = el.firstChild;
      let lastNode;
      while (node) {
        lastNode = frag.appendChild(node);
        node = el.firstChild;
      }
      range.insertNode(frag);

      // Preserve the selection
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  } else if (document.selection && document.selection.type !== "Control") {
    // IE < 9
    document.selection.createRange().pasteHTML(html);
  }
}

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return del; });
/* unused harmony export getParseDomain */
// 操作cookie
function set(c_name, value, expiredays, beforeDomain) {
  let exdate;
  const domain = getParseDomain(beforeDomain);
  // expiredays 可以是Number类型的过期天数
  // 也可以是String类型的日期字符串
  // 还可以是Date类型的
  if (expiredays && expiredays instanceof Date) {
    // expiredays是Date类型
    exdate = expiredays;
  } else if (expiredays && isDate(expiredays)) {
    // expiredays是日期字符串
    exdate = new Date(expiredays).toUTCString();
  } else {
    // expiredays为Nubmer类型或者未设置
    const newDate = new Date();
    expiredays = !expiredays || expiredays != Number(expiredays) ? 1 : expiredays;
    newDate.setDate(newDate.getDate() + expiredays);
    exdate = newDate.toUTCString();
  }
  document.cookie = `${c_name}=${escape(value)};expires=${exdate};path=/;domain=${domain}`;
}
function get(c_name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(`${c_name}=`);
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      let c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}
function del(name) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cval = get(name);
  const domain = getParseDomain();
  if (cval != null) {
    document.cookie = `${name}=${cval};expires=${exp.toUTCString()};path=/;domain=${domain}`;
  }
}
// 获取设置cookie的domain（和后端设置逻辑保持统一）
function getParseDomain(beforeDomain) {
  const hostname = location.hostname.toLocaleLowerCase();
  let domain = beforeDomain || hostname;
  const reWenjuan = /.wenjuan.com$/;
  const reLocalhost = /^(192.168.)|^(127.0.0.)/;
  if (reWenjuan.test(domain)) {
    domain = ".wenjuan.com";
  } else if (reLocalhost.test(domain)) {
    // domain = domain;
  } else if (domain == "localhost") {
    domain = hostname;
  } else {
    domain = `.${domain}`;
  }
  return domain;
}

// 验证字符串str是否为日期格式的字符串
function isDate(str) {
  const reg = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
  if (!str) return false;
  if (reg.test(str) && RegExp.$2 <= 12 && RegExp.$3 <= 31 && RegExp.$4 <= 23 && RegExp.$5 <= 59 && RegExp.$6 <= 59) {
    return true;
  }
  return false;
}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dialog");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/button.css");

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var _assets_js_utils_use_pwa_signature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);
/**
 * @author kyol
 * @description： 代码设计，手写响应式猜源码
 */

global.auxiliaryVars = global.auxiliaryVars || {
  onloaded: false,
  watchProperties: {}
};
// eslint-disable-next-line no-multi-assign
const {
  auxiliaryVars
} = global;
const [preFc,, append] = ["com", "pipe", "pose"];
const preFix = "use";
// this is use auxiliary tools

class ObserverData {
  constructor(value) {
    this.value = value;
  }
  toString() {
    return this.value;
  }

  // eslint-disable-next-line class-methods-use-this
  toOrigin() {
    return auxiliaryVars.watchProperties;
  }

  // eslint-disable-next-line class-methods-use-this
  [Symbol.toStringTag]() {
    return "ObserverEffect";
  }
}
const useCacheHooks = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "localStorage";
  return (key, hook) => {
    let value = "";
    const saveType = window[type];
    if (Reflect.has(localStorage, key)) {
      value = JSON.parse(saveType.getItem(key));
    } else {
      value = typeof hook === "string" ? hook : hook();
      saveType.setItem(key, JSON.stringify(value));
    }
    return new Proxy(new ObserverData(value), {
      get(origin, keyName) {
        return Reflect.get(origin, keyName);
      },
      set(origin, keyName, val) {
        if (val === null) {
          saveType.removeItem(key);
        } else {
          saveType.setItem(key, JSON.stringify(val));
        }
        return Reflect.set(origin, keyName, val);
      }
    });
  };
};

/**
 *
 * @param {String} keyName
 * @param {any} definePayload
 * @param {Boolean} isRef  : 是不是ref对象，真是ref,false 为reactive
 * @returns ProxyObserver
 */

const useEffect = function () {
  let isRef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (keyName, definePayload) {
    let {
      reset = false,
      ref
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // 构造器
    const seDefval = typeof definePayload === "function" ? definePayload() : definePayload;
    if (!auxiliaryVars.watchProperties[keyName]) {
      auxiliaryVars.watchProperties[keyName] = ref ? ref(seDefval) : new ObserverData(seDefval);
    }
    if (reset) auxiliaryVars.watchProperties[keyName].value = seDefval;
    // 拦截器
    return new Proxy(auxiliaryVars.watchProperties[keyName], {
      get(origin, key) {
        let value = Reflect.get(origin, key);
        console.log(typeof value === "object", 99999, value, key);
        if (typeof Reflect.get(origin, "value") === "object" && !isRef) value = Reflect.get(origin.value, key);
        return value;
      },
      set(origin, key, value) {
        return Reflect.set(origin, key, value);
      }
    });
  };
};
const defineFunction = Function || (() => {});
const defineObject = Object || {};
const mapFuncNames = ["forEach", "map", "some", "every"];
// 扩展USEhooks
const useObjects = mapFuncNames.reduce((p, funcName) => {
  p[funcName] = (object, currayFactory) => originKeys(object)[funcName](hightFn(currayFactory, object));
  return p;
}, {});
useObjects.find = (object, currayFactory) => {
  const amiKey = originKeys(object).find(hightFn(currayFactory, object));
  return amiKey ? object[amiKey] : undefined;
};
const originKeys = defineObject.keys.bind(defineObject);
const hightFn = (transformTask, origin) => key => transformTask(origin[key], key, origin);
const useHooks = {
  [`${preFix}Local`]: useCacheHooks(),
  [`${preFix}Session`]: useCacheHooks("sessionStorage"),
  [`${preFix}Ref`]: useEffect(),
  [`${preFix}Reactive`]: useEffect(false),
  [`${preFix}Watch`]: function (watchTask) {
    let watchProNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    const keys = typeof watchProNames === "string" ? [watchProNames] : watchProNames;
    const symbolName = Symbol(keys);
    auxiliaryVars.watchEffects[symbolName] = watchTask;
    return symbolName;
  },
  delRef: keyName => {
    return Reflect.defineProperty(auxiliaryVars.watchProperties, keyName);
  },
  isRef: instance => defineObject.prototype.toString().call(instance).slice(8, -1) === "ObserverData",
  [`${preFc}${append}`]: function () {
    for (var _len = arguments.length, warrior = new Array(_len), _key = 0; _key < _len; _key++) {
      warrior[_key] = arguments[_key];
    }
    return function () {
      const unFunc = warrior.findIndex(f => typeof f !== "function");
      // eslint-disable-next-line no-bitwise
      if (~unFunc) return new Error(`${unFunc}坐标参数必须是函数,${warrior[unFunc]}`);
      for (var _len2 = arguments.length, intor = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        intor[_key2] = arguments[_key2];
      }
      return warrior.reduceRight((h, f, i) => warrior.length === i + 1 ? f(...h) : f(h), intor);
    };
  },
  syncToggle: function (data, key, value) {
    let time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 300;
    return new Promise(resolve => {
      const oval = data[key];
      data[key] = value;
      setTimeout(() => {
        data[key] = oval;
        resolve();
      }, time);
    });
  }
};
const $wj_tools = {
  $ENV: function () {
    const payload = {
      userAgent: "",
      /*
       * 所有key名对应的value
       * value：[ [第一个数组是需要存在的匹配关键字],[第二个数组是需要不匹配上的关键字] ]
       */
      isWeixin: [["MicroMessenger"], ["wxwork"]],
      isWxwork: [["MicroMessenger", "wxwork"]],
      isLark: [["Lark"]],
      // 飞书
      isDingTalk: [["DingTalk"]] // 钉钉
    };

    const state = {};
    // 存储信息数据
    return {
      // 设置Ua的来源信息
      setUserAgent(ua) {
        Reflect.set(payload, "userAgent", ua);
      },
      // 扩展列表私有属性 payload 对象
      $extend(name, value) {
        if (typeof name === "object") {
          Object.assign(payload, name);
        } else {
          payload[name] = value;
        }
      },
      // 查看对应的key 或者全部key
      viewList(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (key && payload.hasOwnProperty(key)) return Reflect.get(payload, key);
        return payload;
      },
      /**
       * @description： 返回判断环境
       * @param {String in keyof payload} name
       * @return {Boolean}
       *
       */
      get(name) {
        var _global, _global$window, _global$window$naviga;
        // 缓存已经读取过的数据
        if (Reflect.has(state, name)) return Reflect.get(state, name);
        if (name === "userAgent") return Reflect.get(payload, name);
        const [inc = [], exc = []] = Reflect.get(payload, name) || [];
        const au = payload.userAgent || ((_global = global) === null || _global === void 0 ? void 0 : (_global$window = _global.window) === null || _global$window === void 0 ? void 0 : (_global$window$naviga = _global$window.navigator) === null || _global$window$naviga === void 0 ? void 0 : _global$window$naviga.userAgent) || "";
        const status = inc.every(s => au.includes(s)) && exc.every(s => !au.includes(s));
        Reflect.set(state, name, status);
        return status;
      },
      // 移除数据中心
      remove(key) {
        Reflect.deleteProperty(payload, key);
      },
      // thunk执行者函数
      defineState() {
        let middlewareThunk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => ({});
        let keyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "defineState";
        // eslint-disable-next-line no-return-assign
        return this[keyName] = function () {
          return middlewareThunk(...arguments);
        };
      }
    };
  }(),
  // 后续扩展其定义
  defineInit() {},
  /**
   *
   * @param {Object} data , 就是接口对象
   * @description : 获取套餐接口数据，格式化有效数据
   * @returns Object <{
   *               version：: 当前版本
   *               expireTime：有效时间
   *               nextVersion：下一个版本
   *           }>
   * }
   */
  formatUserPackageInfo(data) {
    // 套餐类型
    const versiobnMap = ["free", "advance_version", "enterprise_version", "enterprise_ultimate_version"];
    let [version, expireTime, isTry] = ["free", "", false];
    if (data.package_status) {
      /**
       * advance_version 高级版本
       * enterprise_version 企业版标准版
       * enterprise_ultimate_version'; // 企业旗舰版
       */
      isTry = !!data.package_status.is_trial;
      version = data.package_status.version;
      expireTime = data.package_status.expire_time || "";
    }
    // 免费版本能升级,其他版本只能续费
    const index = versiobnMap.indexOf(version); // 当前版本索引
    const nextVersion = versiobnMap[index === versiobnMap.length - 1 ? versiobnMap.length - 1 : index + 1]; // 下一本版本名称
    return {
      version,
      // 当前版本
      expireTime,
      // 有效时间
      nextVersion,
      // 下一个升级版本  名称
      isTry,
      // 是不是试用版
      isFree: version == "free",
      // 是不是免费版本
      isAdv: version === "advance_version" && !isTry,
      // 是不是高级版
      isEnt: version === "enterprise_version" && !isTry,
      // 是不是企业版
      isUlt: version === "enterprise_ultimate_version" && !isTry,
      // 是不是旗舰版
      freeName: "free",
      advName: "advance_version",
      // 高级版名称
      entName: "enterprise_version",
      ultName: "enterprise_ultimate_version"
    };
  },
  /**
   * 校验格式函数
   */
  checkRules: (() => ({
    // 邮箱校验
    isEmail(value, customExp) {
      const exp = customExp || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return exp === null || exp === void 0 ? void 0 : exp.test(value);
    },
    // 国内座机号
    isLandlinePhone(value, customExp) {
      const exp = customExp || /0\d{2,3}-?\d{7,8}/;
      return exp.test(value);
    },
    // 国内手机号
    isMobile(value) {
      let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
      let customExp = arguments.length > 2 ? arguments[2] : undefined;
      const exp = customExp || new RegExp(`^1[3456789]\\d{${size}}$`);
      return exp.test(value);
    },
    // 纯数字 0 - 9
    isNumber(value) {
      return /^[0-9]+$/.test(value);
    }
  }))(),
  questionTypeList(expendsData) {
    const types = {
      "2": {
        template: "q-select",
        name: "单选",
        formName: "单选",
        satisName: "单选",
        title: "请选择一个选项",
        option: "选项",
        trackName: "single_select"
      },
      "3": {
        template: "q-select",
        name: "多选",
        formName: "多选",
        satisName: "多选",
        title: "请选择以下选项 (多选)",
        subtitle: "单选题",
        option: "选项",
        trackName: "multiple_select"
      },
      "4": {
        template: "q-matrix-default",
        name: "矩阵选择",
        title: "请选择以下选项",
        option: "选项",
        suboption: "矩阵行",
        trackName: "matrix_select"
      },
      "5": {
        template: "q-matrix-default",
        name: "矩阵选择",
        title: "矩阵单选题",
        option: "选项",
        suboption: "矩阵行",
        trackName: "matrix_select"
      },
      "6": {
        template: "q-blank",
        name: "填空",
        formName: "填空",
        title: "请填写本项内容",
        trackName: "blank"
      },
      "7": {
        template: "q-matrix-default",
        name: "矩阵打分",
        title: "请给以下各项打分",
        satisTitle: "请问你对以下描述的感觉是",
        option: "打分",
        suboption: "矩阵行",
        trackName: "matrix_blank"
      },
      "8": {
        template: "q-blank",
        name: "级联题",
        title: "出生日期",
        trackName: "date"
      },
      "9": {
        template: "q-classification",
        name: "分类",
        title: "请按照分类规则，将左侧选项拖入右侧分组中",
        option: "选项",
        suboption: "类别",
        trackName: "classification"
      },
      "50": {
        template: "q-score",
        name: "打分",
        formName: "打分",
        title: "请给本项打分",
        appraiseTitle: "以下人员在沟通能力方面，能够做到善于沟通，合理协调。",
        option: "选项",
        trackName: "score"
      },
      "60": {
        template: "q-default",
        name: "排序",
        formName: "排序",
        title: "请给以下选项排序",
        option: "选项",
        trackName: "sort"
      },
      "70": {
        template: "q-desc",
        name: "段落说明",
        title: "请阅读本项说明，然后回答问题",
        trackName: "remark"
      },
      "95": {
        template: "q-multi-blank",
        name: "多项填空",
        title: "请填写以下内容",
        option: "填空",
        trackName: "multiple_blank"
      },
      "100": {
        template: "q-matrix-default",
        name: "矩阵填空",
        title: "请填写以下内容",
        option: "填空",
        suboption: "矩阵行",
        trackName: "matrix_blank"
      },
      "105": {
        template: "q-goods",
        name: "商品",
        formName: "商品",
        title: "请挑选您喜欢的商品",
        subtitle: "商品题",
        option: "选项",
        trackName: "goods"
      },
      collection: {
        template: "q-collection",
        name: "收款题",
        formName: "收款",
        createFn: "createCollection",
        trackName: "collection"
      },
      contact_us: {
        template: "q-contact-us",
        name: "联系我们",
        createFn: "createContactUs",
        trackName: "contact_us"
      },
      enterprise_certification_info: {
        template: "q-enterprise-auth",
        createFn: "createEnterpriseAuth",
        name: "企业认证",
        trackName: "enterprise_certification_info"
      },
      user_info: {
        template: "q-user-info",
        name: "个人信息",
        title: "个人信息录入"
      },
      exam_inform: {
        template: "q-exam-inform",
        name: "考前须知",
        title: "考前须知"
      },
      geographical_multiple_blank: {
        template: "q-geographical",
        name: "地理位置",
        title: "所在位置",
        trackName: "geography"
      },
      rich_text: {
        template: "q-rich",
        name: "图文介绍",
        title: "请阅读本项说明，然后回答问题",
        trackName: "rich"
      },
      occupation: {
        template: "q-select",
        name: "职业",
        title: "您目前的职业是？",
        option: "在校学生",
        suboption: "政府/机关干部/公务员",
        trackName: "occupation"
      },
      singlevote: {
        template: "q-default",
        name: "文字投票",
        title: "请给以下选项投票",
        option: "选项",
        trackName: "font_vote"
      },
      education: {
        template: "q-select",
        name: "学历",
        title: "您的最高学历（含目前在读）是？",
        option: "小学及以下",
        suboption: "初中",
        trackName: "education"
      },
      sex: {
        template: "q-select",
        name: "性别",
        title: "性别",
        option: "男",
        suboption: "女",
        trackName: "sex"
      },
      age: {
        template: "q-select",
        name: "年龄",
        satisName: "年龄段",
        title: "您的年龄是？",
        option: "18岁以下",
        suboption: "18~24岁",
        trackName: "age"
      },
      judge: {
        template: "q-select",
        name: "判断题",
        title: "请判断本项叙述是否正确？",
        option: "是",
        suboption: "否",
        trackName: "single_select"
      },
      multiplevote: {
        template: "q-default",
        name: "文字投票题",
        title: "请给以下选项投票（多选）",
        option: "选项",
        trackName: "font_vote_multiple"
      },
      groupvote_single: {
        template: "q-video-vote",
        name: "分组投票",
        title: "请给以下分组投票",
        option: "选项",
        trackName: "groupvote_single"
      },
      groupvote_multiple: {
        template: "q-video-vote",
        name: "分组投票",
        title: "请给以下分组投票（多选）",
        option: "选项",
        trackName: "groupvote_multiple"
      },
      videovote_single: {
        template: "q-video-vote",
        name: "视频投票",
        title: "请给以下视频投票"
      },
      videovote_multiple: {
        template: "q-video-vote",
        name: "视频投票",
        title: "请给以下视频投票（多选）"
      },
      listening_single: {
        template: "q-select",
        name: "听力题",
        title: "点击上传音频/视频文件",
        option: "选项",
        trackName: "listen"
      },
      dropdown: {
        template: "q-default",
        name: "下拉",
        formName: "下拉",
        title: "请选择一个选项",
        option: "选项",
        trackName: "dropdown"
      },
      short_answer: {
        template: "q-blank",
        name: "简答题",
        title: "请简要阐述你的观点",
        trackName: "short_answer"
      },
      name: {
        template: "q-blank",
        name: "姓名",
        title: "姓名",
        trackName: "name"
      },
      mobile: {
        template: "q-blank",
        name: "手机",
        title: "手机",
        trackName: "mobile"
      },
      email: {
        template: "q-blank",
        name: "邮箱",
        title: "邮箱",
        trackName: "email"
      },
      wechat_id: {
        template: "q-blank",
        name: "微信号",
        title: "微信号",
        trackName: "wechat_id"
      },
      id_card: {
        template: "q-blank",
        name: "身份证号",
        title: "身份证号",
        trackName: "id_card"
      },
      employee_id: {
        template: "q-blank",
        name: "工号",
        title: "工号",
        trackName: "employee_id"
      },
      blank_num: {
        template: "q-blank",
        name: "数字填空",
        title: "数字",
        trackName: "blank_num"
      },
      classes: {
        template: "q-blank",
        name: "班级",
        title: "班级",
        trackName: "classes"
      },
      grades: {
        template: "q-blank",
        name: "年级",
        title: "年级",
        trackName: "grades"
      },
      student_id: {
        template: "q-blank",
        name: "学号",
        title: "学号",
        trackName: "student_id"
      },
      company: {
        template: "q-blank",
        name: "公司",
        title: "公司",
        trackName: "company"
      },
      department: {
        template: "q-blank",
        name: "部门",
        title: "部门",
        trackName: "department"
      },
      university_form: {
        template: "q-blank",
        name: "学校",
        title: "学校",
        trackName: "university_form"
      },
      major_form: {
        template: "q-blank",
        name: "专业",
        title: "专业",
        trackName: "major_form"
      },
      phone: {
        template: "q-phone",
        trackName: "mobile"
      },
      multi_line_blank: {
        template: "q-multiline-blank",
        trackName: "multiple_blank"
      },
      auto_table: {
        template: "q-auto-table",
        name: "自增表格",
        title: "请填写你的团队成员信息",
        option: "标题",
        trackName: "auto_table"
      },
      horz_blank: {
        template: "q-horz-blank",
        name: "横向填空",
        title: "请填写以下信息",
        option: '姓名<span class="ipt-wrap"><input type="text" style="width: 64px"></span>年龄<span class="ipt-wrap"><input type="text" style="width: 32px"></span>岁<br>联系方式<span class="ipt-wrap"><input type="text" style="width: 88px"></span>',
        trackName: "horizontal_blank"
      },
      cloze: {
        template: "q-cloze",
        name: "完形填空",
        title: "完形填空",
        trackName: "cloze"
      },
      banked_cloze: {
        template: "q-banked-cloze",
        name: "选词填空",
        title: "选词填空",
        option: "选项",
        suboption: ["请输入标题", "的", "地", "得"],
        trackName: "banked_cloze"
      },
      date: {
        template: "q-blank",
        name: "日期",
        title: "日期",
        trackName: "date"
      },
      upload_file: {
        template: "q-upload-file",
        name: "文件收集",
        title: "请上传文件",
        trackName: "upload"
      },
      image_upload: {
        template: "q-image-upload",
        name: "图片收集",
        assessName: "图片收集",
        title: "请上传图片",
        trackName: "image_upload"
      },
      time: {
        template: "q-time",
        name: "时间",
        title: "时间",
        trackName: "time"
      },
      signature: {
        template: "q-signature",
        name: "电子签名",
        subtitle: "请在此处签名",
        title: "签名",
        trackName: "signature"
      },
      image_single: {
        template: "q-image",
        name: "图片选择",
        formName: "图片单选",
        title: "请选择以下图片",
        option: "图片",
        trackName: "image_select"
      },
      image_multiple: {
        template: "q-image",
        name: "图片多选",
        title: "请选择以下图片（多选）",
        option: "图片",
        trackName: "image_multiple"
      },
      imagevote_single: {
        template: "q-video-vote",
        name: "图片投票",
        title: "请给以下图片投票",
        option: "图片",
        trackName: "image_vote"
      },
      imagevote_multiple: {
        template: "q-video-vote",
        name: "图片投票",
        title: "请给以下图片投票（多选）",
        option: "图片",
        trackName: "image_vote"
      },
      nps_score: {
        template: "q-nps-score",
        name: "NPS",
        formName: "NPS",
        title: "您向朋友或同事推荐我们的可能性有多大？",
        trackName: "nps"
      },
      scale: {
        template: "q-scale",
        name: "量表",
        title: "请您对此项目进行评价",
        satisTitle: "请问你对以下描述的感觉是",
        option: "标题",
        trackName: "scale"
      },
      matrix_scale: {
        template: "q-matrix-scale",
        name: "矩阵量表",
        title: "请您对以下各行内容进行评价",
        satisTitle: "请问你对以下描述的感觉是",
        appraiseTitle: "以下人员在沟通能力方面，能够做到善于沟通，合理协调。",
        option: "标题",
        trackName: "matrix_scale"
      },
      city: {
        template: "q-city",
        trackName: "address"
      },
      address: {
        template: "q-address",
        name: "城市/地址",
        formName: "城市/地址",
        satisName: "城市",
        title: "地址",
        trackName: "address"
      },
      major: {
        template: "q-cascader",
        name: "专业",
        trackName: "major"
      },
      industry: {
        template: "q-cascader",
        name: "行业",
        trackName: "industry"
      },
      cascader: {
        template: "q-cascader",
        name: "多级下拉",
        formName: "多级下拉",
        title: "请选择以下选项",
        trackName: "cascader"
      },
      university: {
        template: "q-cascader",
        name: "院校",
        trackName: "university"
      },
      proportion: {
        template: "q-proportion",
        name: "比重",
        formName: "比重",
        title: "请选择以下各项所占的百分比",
        option: "选项",
        trackName: "proportion"
      },
      evaluation: {
        template: "q-evaluation",
        name: "评价",
        formName: "评价",
        title: "请您对我们的服务进行评价",
        subtitle: "单选题",
        option: "选项",
        trackName: "evaluation"
      },
      split_line: {
        template: "q-split-line",
        name: "分割线",
        trackName: "split_line"
      },
      countdown: {
        template: "q-count-down",
        name: "倒计时",
        trackName: "pc_q_count_down"
      },
      countdown_show_only: {
        template: "q-count-down",
        name: "倒计时",
        trackName: "pc_q_count_down"
      },
      score_single: {
        template: "q-select",
        title: "请问你对以下描述的感觉是",
        name: "评分单选",
        trackName: "pc_q_grade_single"
      },
      work_age: {
        template: "q-select",
        title: "您的工作年限是？",
        name: "工龄",
        trackName: "pc_q_seniority"
      },
      base_info: {
        template: "q-multi-blank",
        title: "请填写您的基本信息",
        name: "基本信息",
        trackName: "pc_q_basic"
      },
      navigation: {
        template: "q-navigation",
        name: "地图导航",
        trackName: "navigation",
        title: "导航到这里"
      },
      page: {
        template: "q-page",
        name: "分页",
        trackName: "page"
      },
      multiple_dropdown: {
        template: "q-default",
        name: "下拉",
        title: "请选择以下选项 (多选)",
        option: "选项",
        trackName: "dropdown"
      },
      delivery_address: {
        template: "q-delivery-address",
        name: "收货信息",
        title: "请输入收货信息",
        trackName: "delivery_address"
      },
      ...expendsData
    };
    return {
      typeList: Object.keys(types),
      typesData: types,
      // 正向操作
      has() {
        for (var _len3 = arguments.length, keys = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          keys[_key3] = arguments[_key3];
        }
        return keys.every(item => this.typeList.includes(item));
      },
      // 反向操作
      revHas(name) {
        let prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "name";
        let typeKey = "undefined";
        this.typeList.find(
        // eslint-disable-next-line no-return-assign
        key => {
          var _types$key;
          return (types === null || types === void 0 ? void 0 : (_types$key = types[key]) === null || _types$key === void 0 ? void 0 : _types$key[prop]) === name && (typeKey = key);
        });
        return typeKey;
      }
    };
  },
  //  新增接口参数
  appendLoginParams(params) {
    var _this$$route;
    const {
      page_id,
      invite_id,
      reg_from_source,
      reg_fromm_id
    } = (this === null || this === void 0 ? void 0 : (_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : _this$$route.query) || {};
    const obj = {
      page_id,
      invite_id,
      reg_from_source,
      reg_fromm_id
    };
    Object.keys(obj).forEach(key => {
      if (obj[key] == 0 || !!obj[key]) params[key] = obj[key];
    });
  },
  usePWASignature: _assets_js_utils_use_pwa_signature_js__WEBPACK_IMPORTED_MODULE_0__,
  defineFunction,
  defineObject,
  useHooks,
  useObjects,
  hooks: {
    install(Vm) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      /**
       * @author: wei
       * @date 24.01.08
       * @description 项目中必使用的扩展函数
       */
      const [FactoryVue, getCurrentInstanceFc] = [Vm, options === null || options === void 0 ? void 0 : options.getCurrentInstance];
      Object.assign(FactoryVue, {
        [`${preFix}Instance`]: () => getCurrentInstanceFc().proxy,
        [`${preFix}Router`]: () => getCurrentInstanceFc().proxy.$router,
        [`${preFix}Route`]: () => getCurrentInstanceFc().proxy.$route,
        [`${preFix}State`]: () => {
          var _getCurrentInstanceFc;
          return (_getCurrentInstanceFc = getCurrentInstanceFc().proxy.$store) === null || _getCurrentInstanceFc === void 0 ? void 0 : _getCurrentInstanceFc.state;
        },
        [`${preFix}Refs`]: () => getCurrentInstanceFc().proxy.$refs,
        [`${preFix}Options`]: options => Object.assign(getCurrentInstanceFc().proxy.$options, options),
        ...useHooks
      });
    },
    ...useHooks,
    ...useObjects
  }
};
// if (typeof exports !== "undefined") {
//     export default $wj_tools;
// }
// if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
//     module.exports = $wj_tools;
// }

/* harmony default export */ __webpack_exports__["default"] = ($wj_tools);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCreateProjectUrl", function() { return isCreateProjectUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isUsedPWASignature", function() { return isUsedPWASignature; });
/* harmony import */ var _tools_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/**
 * @description: 项目在 pwa 中访问时，创建项目的接口应带有 pwa 标记，方便后端统计项目创建方式
 */



// 创建项目相关接口
const createProjectUrl = ["/edit/ajax/survey_copy/",
// 复制模板
"/edit/api/create/",
// 空白创建
"/edit/api/copy/",
// 复制已有项目
"/edit/api/textproject/",
// 文本创建
"/edit/api/ref/" // 引用收藏的模板创建
];

// 判断 url 是否为创建项目接口
function isCreateProjectUrl(url) {
  return createProjectUrl.some(item => url.includes(item));
}

// 判断是否使用 pwa 的签名
function isUsedPWASignature(url) {
  const {
    isPWA
  } = Object(_tools_js__WEBPACK_IMPORTED_MODULE_0__[/* distinguishUserAgentUtils */ "b"])();
  console.log("pwa isUsedPWASignature", url, isCreateProjectUrl(url));
  if (isPWA && isCreateProjectUrl(url)) {
    return true;
  }
  return false;
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg-icon/index.vue?vue&type=template&id=2ea9bd34&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", {
    staticClass: "svg-icon",
    domProps: { innerHTML: _vm._s(_vm.icon) }
  })
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./src/components/svg-icon/index.vue?vue&type=template&id=2ea9bd34&scoped=true&

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg-icon/index.vue?vue&type=script&lang=js&
var svg_iconvue_type_script_lang_js_ = __webpack_require__(22);

// CONCATENATED MODULE: ./src/components/svg-icon/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_svg_iconvue_type_script_lang_js_ = (svg_iconvue_type_script_lang_js_["a" /* default */]); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg-icon/index.vue?vue&type=style&index=0&id=2ea9bd34&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/svg-icon/index.vue?vue&type=style&index=0&id=2ea9bd34&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/components/svg-icon/index.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_svg_iconvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9bd34",
  null
  
)

/* harmony default export */ var svg_icon = __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/message-box");

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/message.css");

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dialog.css");

/***/ }),
/* 16 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/tooltip");

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SvgIcon",
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      icon: null
    };
  },
  watch: {
    name: {
      async handler() {
        this.icon = await this.getIcon();
      },
      immediate: true
    }
  },
  methods: {
    async getIcon() {
      if (process.env.VITE) {
        const url = `/src/assets/image/icons/svg/${this.name}.svg?raw`;
        const module = await __webpack_require__(61)(url);
        return module.default;
      }
      return __webpack_require__(62)(`./${this.name}.svg`);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(37)))

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dropdown-item");

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dropdown-menu");

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dropdown");

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui/lib/button");

/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/message-box.css");

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/tooltip.css");

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = require("dayjs");

/***/ }),
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/input-number");

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return httpMemberPackageInfo; });
/* unused harmony export httpPackageList */
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

let request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

/**
 * 获取用户现有套餐版本
 * @returns
 */
function httpMemberPackageInfo(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/plugin/api/v1/member_package/info/", {
    ...params
  });
}

/**
 * 获取各种套餐详细内容
 * @returns
 */
function httpPackageList() {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/plugin/api/v1/package/info/");
}

/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui/lib/dialog");

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, exports) {

module.exports = require("blueimp-md5");

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/ww-open-component/src/main.vue?vue&type=template&id=3acd64da&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ww-open-data" },
    [_c("ww-open-data", { attrs: { type: _vm.openType, openid: _vm.openId } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/ww-open-component/src/main.vue?vue&type=template&id=3acd64da&scoped=true&

// EXTERNAL MODULE: ./packages/ww-open-component/src/wxConfig.js + 1 modules
var wxConfig = __webpack_require__(107);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/ww-open-component/src/main.vue?vue&type=script&lang=js&

/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: "WwOpenComponent",
  props: {
    openType: {
      type: String,
      default: "userName"
    },
    openId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  mounted() {
    // 注册open data
    this.$nextTick(() => {
      Object(wxConfig["a" /* default */])();
    });
  },
  methods: {}
});
// CONCATENATED MODULE: ./packages/ww-open-component/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/ww-open-component/src/main.vue?vue&type=style&index=0&id=3acd64da&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/ww-open-component/src/main.vue?vue&type=style&index=0&id=3acd64da&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/ww-open-component/src/main.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "3acd64da",
  null
  
)

/* harmony default export */ var main = __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserPackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return httpGetStroeBaseInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sendPayClue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return httpDeployCurrentRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deloyLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return httpLoginAsAdmin; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

let request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

// 获取用户信息
function getUserInfo(data) {
  // data?.unInterceptors = true;
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get(`/member/api/info/simple/`, data);
}
function getUserPackage() {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/plugin/api/v1/member_package/info/");
}

/**
 * 获取商户基础详细
 * @param {*}
 */
function httpGetStroeBaseInfo() {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/member/api/merchant_info/", {});
}

// 发送付费套餐线索
function sendPayClue(data) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/cms_pay_clue/pay_clue/create/", data);
}

/**
 * 获取部署版用户角色
 * @returns
 */
function httpDeployCurrentRole(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/api/deployment/member/role/", params);
}

/**
 * 部署版退出登录
 * @returns
 */
function deloyLogout() {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/api/deployment/member/logout/");
}

// 已登录用户尝试直接登入后台管理页面
function httpLoginAsAdmin() {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/api/deployment/member/login_as_admin/");
}

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/index.vue?vue&type=template&id=29c574a7&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLoading
    ? _c(
        "div",
        [
          _vm.visible && !_vm.isWAUser
            ? _c(
                "div",
                {
                  staticClass: "package-dialog mask",
                  style: { zIndex: _vm.zIndex }
                },
                [
                  _c("div", { staticClass: "inner" }, [
                    _c("div", { staticClass: "account" }, [
                      _c("div", { staticClass: "user-part" }, [
                        _c("img", {
                          staticClass: "user-avator",
                          attrs: {
                            src: _vm.userInfo.portrait,
                            alt: "问卷网用户头像"
                          }
                        }),
                        _vm._v(" "),
                        _c("section", { staticClass: "right-info" }, [
                          _c("p", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.userInfo.nickname || _vm.userInfo.username
                                ) +
                                "\n                            "
                            ),
                            _vm.phoneNum
                              ? _c("span", { staticClass: "phone-star-num" }, [
                                  _vm._v("（" + _vm._s(_vm.phoneNum) + "）")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "version-icon",
                            class: [
                              _vm.currentVersion === "free" ? "free" : "",
                              _vm.currentVersion === "advance_version"
                                ? "advance-version"
                                : "",
                              _vm.currentVersion === "enterprise_version"
                                ? "enterprise-version"
                                : "",
                              _vm.currentVersion ===
                              "enterprise_ultimate_version"
                                ? "enterprise-ultimate-version"
                                : ""
                            ],
                            attrs: { "data-typeicon": _vm.currentVersion }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "close-icon wj-icon-close",
                        on: {
                          click: function($event) {
                            return _vm.$emit("input", false)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c("PackageDetail", {
                          staticClass: "pkgs",
                          attrs: {
                            "version-list": _vm.versionList,
                            "active-version": _vm.innerActiveVersion,
                            "active-time": _vm.activeTime,
                            "active-equity": _vm.activeEquity,
                            "rest-indate": _vm.restIndate,
                            "service-qrcode": _vm.serviceQrcode,
                            "service-num": _vm.serviceNum,
                            "is-pkg-upgrad": _vm.isPkgUpgrad,
                            goods_id: _vm.goods_id
                          },
                          on: {
                            "update:goods_id": function($event) {
                              _vm.goods_id = $event
                            },
                            changeVersion: _vm.changeVersion
                          }
                        }),
                        _vm._v(" "),
                        _c("payment", {
                          attrs: {
                            "is-pkg-upgrad": _vm.isPkgUpgrad,
                            disabled: _vm.disableUpgrade,
                            "pay-version": _vm.innerActiveVersion,
                            "pay-time": _vm.activeTime,
                            "coupon-list": _vm.coupons,
                            "current-version": _vm.currentVersion,
                            "current-version-expire-time": _vm.restIndate,
                            "current-version-sub-account":
                              _vm.currentSubAccount,
                            "service-qrcode": _vm.serviceQrcode,
                            "z-index": _vm.zIndex,
                            "confirm-zindex": _vm.confirmZindex,
                            "is-free-try": _vm.microAppInfo.isFreeTry,
                            goods_id: _vm.goods_id
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm.visible && _vm.isWAUser
            ? _c(
                "wd-dialog",
                {
                  attrs: {
                    title: "套餐购买操作指引",
                    visible: _vm.dialogVisile
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisile = $event
                    },
                    close: function($event) {
                      return _vm.$emit("input", false)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "pop-up-guide" }, [
                    _c("span", [_vm._v("请选择以下方式购买套餐")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _vm._v(
                        "\n                1. " +
                          _vm._s(_vm.dialogInfo[_vm.isWAUser].description) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "2." +
                          _vm._s(_vm.dialogInfo[_vm.isWAUser].scanQR) +
                          "，添加问卷网客户顾问，获取更多支持\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "QR-Code" }, [
                      _c("img", {
                        staticClass: "QR",
                        attrs: {
                          src: _vm.dialogInfo[_vm.isWAUser][_vm.randomSale]
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "icon",
                        attrs: {
                          src: _vm.dialogInfo[_vm.isWAUser].iconImg,
                          alt: ""
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "wd-button",
                        {
                          attrs: { type: "primary", width: "100px" },
                          on: { click: _vm.JumpLink }
                        },
                        [_vm._v(_vm._s(_vm.jumpButton[_vm.isWAUser]))]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/package-dialog/src/index.vue?vue&type=template&id=29c574a7&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/message.css"
var message_css_ = __webpack_require__(14);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/message"
var message_ = __webpack_require__(3);
var message_default = /*#__PURE__*/__webpack_require__.n(message_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dialog.css"
var dialog_css_ = __webpack_require__(15);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dialog"
var dialog_ = __webpack_require__(7);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/button.css"
var button_css_ = __webpack_require__(8);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/button"
var button_ = __webpack_require__(2);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(1);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./src/http/vue-package-dialog/index.js

let request = external_vue_default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

// 获取用户信息
function getUserInfo(data) {
  // data?.unInterceptors = true;
  request = external_vue_default.a.prototype.commonRequest;
  return request.get(`/member/api/info/simple/`, data);
}

// 获取钉钉corpId
function dingTalkCorpId(data) {
  return request.get(`/api/member/third_part/dingtalk/user_info/`, data);
}

/**
 * 查询可用优惠券
 * @param {"sub_account"|"advance_version"|"enterprise_version"|"enterprise_ultimate_version"} scope 优惠券使用范围
 * @returns
 */
function avaliableCoupons(scope) {
  request = external_vue_default.a.prototype.commonRequest;
  const formParams = new URLSearchParams();
  formParams.append("currency_type", "0|3");
  formParams.append("scope", scope);
  return request.post("/auth/ajax/get_currency_info/", formParams);
}

/**
 * 生成支付订单
 * @param {"alipay"|"wechatpay"} pay_channel 充值渠道
 * @param {number} amount_cent 充值金额，单位为分
 * @returns
 */
function payOrder(pay_channel, amount_cent) {
  request = external_vue_default.a.prototype.commonRequest;
  return request.post("/member/api/payorder/", {
    pay_channel,
    amount_cent
  });
}

/**
 * 获取订单支付状态
 * @param {string} order_id
 */
function payOrderStatus(order_id) {
  request = external_vue_default.a.prototype.commonRequest;
  return request.post("/member/api/validate_payorder/", {
    order_id
  });
}

/**
 * 获取各种套餐详细内容
 * @returns
 */
function httpPackageList() {
  request = external_vue_default.a.prototype.commonRequest;
  return request.get("/plugin/api/v1/package/info/");
}

/**
 * 升级/续费套餐，需要前置httpPackageList获取到各套餐的plugin_id等必要字段
 * @param {*} data
 * @returns
 */
function consumeOrder(data) {
  request = external_vue_default.a.prototype.commonRequest;
  const formParams = new URLSearchParams();
  for (const key of Object.keys(data)) {
    formParams.append(key, data[key]);
  }
  return request.post("/plugin/ajax/consume/", formParams);
}

/**
 * 获取服务顾问手机、二维码和对公转账二维码
 * @returns
 */
function getQrcodeInfo() {
  request = external_vue_default.a.prototype.commonRequest;
  return request.get("/api/call_center/admin/info");
}

// 获取企业信息
function getCorpInfo() {
  return request.get("/api/package/corp_info/");
}

/**
 * 购买弹窗立即支付按钮逻辑更新 生成支付订单
 * @returns
 */
function createOrder(params) {
  return request.post("/api/order/create/", {
    ...params
  });
}
// EXTERNAL MODULE: ./src/http/package-dialog/index.js
var package_dialog = __webpack_require__(43);

// EXTERNAL MODULE: ./packages/tools.js
var tools = __webpack_require__(10);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/payment.vue?vue&type=template&id=970e15d0&scoped=true&
var paymentvue_type_template_id_970e15d0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "package-payment" },
    [
      !_vm.disabled
        ? _c("div", { staticClass: "payment" }, [
            _c("div", { staticClass: "cost-wrap" }, [
              _c("div", { staticClass: "cost" }, [
                _c("span", { staticClass: "symbol" }, [_vm._v("￥")]),
                _vm._v(" "),
                _c("span", { staticClass: "price" }, [
                  _vm._v(_vm._s(_vm.actualPayCost))
                ])
              ]),
              _vm._v(" "),
              _vm.subAcconutNum > 0
                ? _c("div", { staticClass: "sub_account" }, [
                    _c(
                      "div",
                      { staticClass: "label" },
                      [
                        _c("span", [_vm._v("子账号数量")]),
                        _vm._v(" "),
                        _c(
                          "wd-tooltip",
                          { attrs: { placement: "top", effect: "light" } },
                          [
                            _c("img", {
                              staticClass: "icon-help",
                              attrs: { src: _vm.IconQuestion }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._v(
                                  "\n                            子账号数量不得低于赠送的子账"
                                ),
                                _c("br"),
                                _vm._v("号数量和您正在使用的子账号数"),
                                _c("br"),
                                _vm._v("量\n                        ")
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "account_num" }, [
                      _vm._v(_vm._s(_vm.subAcconutNum))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("ul", { staticClass: "cost_info" }, [
                _c("li", [
                  _c("span", [_vm._v("账号套餐费用")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.costPrice) + "元")])
                ]),
                _vm._v(" "),
                _vm.subAccountCost > 0
                  ? _c("li", [
                      _c("span", [_vm._v("子账号增购费用")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.subAccountCost) + "元")])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.versionDeduction > 0
                  ? _c("li", [
                      _c(
                        "div",
                        { staticClass: "version_wroth" },
                        [
                          _c("span", [_vm._v("版本升级抵扣")]),
                          _vm._v(" "),
                          _c(
                            "wd-tooltip",
                            { attrs: { placement: "top", effect: "light" } },
                            [
                              _c("img", {
                                staticClass: "icon-help",
                                attrs: { src: _vm.IconQuestion }
                              }),
                              _vm._v(" "),
                              _c(
                                "p",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _vm._v(
                                    "\n                                我们会按照您原先付费版本的年"
                                  ),
                                  _c("br"),
                                  _vm._v("付价格及该版本的剩余有效时"),
                                  _c("br"),
                                  _vm._v(
                                    "长，为您抵扣相应金额\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("-" + _vm._s(_vm.versionDeduction) + "元")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.subAccountDeduction > 0
                  ? _c("li", [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("-" + _vm._s(_vm.subAccountDeduction) + "元")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.avaliableCoupons.length > 0
                  ? _c(
                      "li",
                      [
                        _c(
                          "wd-dropdown",
                          {
                            attrs: { trigger: "click" },
                            on: { command: _vm.selectCoupon }
                          },
                          [
                            _c("div", { staticClass: "coupon" }, [
                              _c("span", [
                                _vm._v(
                                  "\n                                优惠券"
                                ),
                                _c("i", { staticClass: "wd-icon-caret-bottom" })
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v("-" + _vm._s(_vm.couponDeduction) + "元")
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "wd-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              _vm._l(_vm.avaliableCoupons, function(coupon, i) {
                                return _c(
                                  "wd-dropdown-item",
                                  {
                                    key: `coupon-${i}`,
                                    attrs: { command: coupon }
                                  },
                                  [
                                    _c("span", [_vm._v("优惠券")]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v("-" + _vm._s(coupon.value) + "元")
                                    ])
                                  ]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "font_bold" }, [
                    _vm._v("实际支付")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "font_bold" }, [
                    _vm._v(_vm._s(_vm.actualPayCost) + "元")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pay_area" }, [
              _c("p", [
                _c("span", { staticClass: "font_bold" }, [_vm._v("支付方式")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "font_light",
                    on: { click: _vm.openPublicAccount }
                  },
                  [
                    _vm._v("对公转账 "),
                    _c("i", { staticClass: "wd-icon-arrow-right" })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("p", { staticStyle: { "margin-top": "8px" } }, [
                _c("button", {
                  staticClass: "pay_way alipay",
                  class: { inactive: _vm.payWayIndex === 1 },
                  on: {
                    click: function($event) {
                      return _vm.changePayWay(0)
                    }
                  }
                }),
                _vm._v(" "),
                _c("button", {
                  staticClass: "pay_way wechat",
                  class: { inactive: _vm.payWayIndex === 0 },
                  on: {
                    click: function($event) {
                      return _vm.changePayWay(1)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "pay_btn" },
                [
                  _c(
                    "wd-button",
                    { attrs: { type: "danger" }, on: { click: _vm.payNow } },
                    [_vm._v("立即支付")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "pay_extra_info" }, [
                _vm._v("购买后有效期至 " + _vm._s(_vm.pkgDeadTime))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "wd-dialog",
        {
          staticClass: "contact-service-counselor",
          attrs: {
            title: "联系对公顾问",
            visible: _vm.dialogVisible,
            "show-close": false,
            width: "280px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "content-contact" }, [
            _c("p", { staticClass: "line-title" }, [
              _vm._v("请使用微信扫一扫联系对公顾问")
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "wx-ercode",
              attrs: { src: _vm.serviceQrcode, alt: "服务顾问" }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ok-btn",
                on: {
                  click: function($event) {
                    _vm.dialogVisible = false
                  }
                }
              },
              [_vm._v("\n                好的\n            ")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var paymentvue_type_template_id_970e15d0_scoped_true_staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "version_wroth" }, [
      _c("span", [_vm._v("子账号升级抵扣")])
    ])
  }
]
paymentvue_type_template_id_970e15d0_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/package-dialog/src/payment.vue?vue&type=template&id=970e15d0&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/message-box.css"
var message_box_css_ = __webpack_require__(33);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/message-box"
var message_box_ = __webpack_require__(13);
var message_box_default = /*#__PURE__*/__webpack_require__.n(message_box_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dropdown-item.css"
var dropdown_item_css_ = __webpack_require__(55);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dropdown-item"
var dropdown_item_ = __webpack_require__(25);
var dropdown_item_default = /*#__PURE__*/__webpack_require__.n(dropdown_item_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dropdown-menu.css"
var dropdown_menu_css_ = __webpack_require__(56);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dropdown-menu"
var dropdown_menu_ = __webpack_require__(26);
var dropdown_menu_default = /*#__PURE__*/__webpack_require__.n(dropdown_menu_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dropdown.css"
var dropdown_css_ = __webpack_require__(57);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dropdown"
var dropdown_ = __webpack_require__(27);
var dropdown_default = /*#__PURE__*/__webpack_require__.n(dropdown_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/input-number.css"
var input_number_css_ = __webpack_require__(113);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/input-number"
var input_number_ = __webpack_require__(42);
var input_number_default = /*#__PURE__*/__webpack_require__.n(input_number_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/tooltip.css"
var tooltip_css_ = __webpack_require__(39);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/tooltip"
var tooltip_ = __webpack_require__(20);
var tooltip_default = /*#__PURE__*/__webpack_require__.n(tooltip_);

// EXTERNAL MODULE: external "dayjs"
var external_dayjs_ = __webpack_require__(40);
var external_dayjs_default = /*#__PURE__*/__webpack_require__.n(external_dayjs_);

// CONCATENATED MODULE: ./src/assets/js/vue-package-dialog/info-config.js
// 用户套餐版本对应中文
const MEMBER_PKG_TYPE_MAPPING = {
  free: "基础版",
  advance_version: "高级版",
  enterprise_version: "企业版",
  enterprise_ultimate_version: "旗舰版",
  enterprise_ultimate_free_version: "旗舰版（试用）"
};

// 各套餐对应价格
const packagePrice = {
  advance_version: [{
    indate: 1,
    totalPrice: 2499,
    averagePrice: 6.9,
    goods_id: "6540a51a8b3d75612d17220e"
  }, {
    indate: 3,
    totalPrice: 7497,
    averagePrice: 5.2,
    goods_id: "6540a51a8b3d75612d17220f"
  }, {
    indate: 5,
    totalPrice: 12495,
    averagePrice: 4.9,
    goods_id: "6540a51a8b3d75612d172210"
  }],
  enterprise_version: [{
    indate: 1,
    totalPrice: 5499,
    averagePrice: 1.6,
    goods_id: "6540a51a8b3d75612d172211"
  }, {
    indate: 3,
    totalPrice: 16497,
    averagePrice: 1.2,
    goods_id: "6540a51a8b3d75612d172212"
  }, {
    indate: 5,
    totalPrice: 27495,
    averagePrice: 1.1,
    goods_id: "6540a51a8b3d75612d172213"
  }],
  enterprise_ultimate_version: [{
    indate: 1,
    totalPrice: 24999,
    averagePrice: 2.3,
    goods_id: "6540a51a8b3d75612d172214"
  }, {
    indate: 3,
    totalPrice: 74997,
    averagePrice: 1.8,
    goods_id: "6540a51a8b3d75612d172215"
  }, {
    indate: 5,
    totalPrice: 124995,
    averagePrice: 1.7,
    goods_id: "6540a51a8b3d75612d172216"
  }]
};

// 付费版本简介
const payVersionList = [{
  name: "高级版",
  key: "advance_version",
  intro: "适用有去广告需求的用户"
}, {
  name: "企业标准版",
  key: "enterprise_version",
  intro: "适用有解决方案需求的企业"
}, {
  name: "企业旗舰版",
  key: "enterprise_ultimate_version",
  intro: "适用团队30人以上的企业"
}];
// advance_version: '高级版',
// advance_free_version: '高级版(试用版)',
// enterprise_version: '企业版',
// enterprise_free_version: '企业版(试用版)',
// enterprise_ultimate_free_version: '企业旗舰版(试用版)',
// enterprise_ultimate_version: '企业旗舰版',
const payVersionListProxy = {
  advance_version: "advance_version",
  advance_free_version: "advance_version",
  enterprise_version: "enterprise_version",
  enterprise_free_version: "enterprise_free_version",
  enterprise_ultimate_version: "enterprise_ultimate_version",
  enterprise_ultimate_free_version: "enterprise_ultimate_version"
};

// 各套餐展示权益
const packageShowEquity = {
  advance_version: [{
    key: "advertising-free",
    text: "免广告10万次"
  }, {
    key: "hide-logo",
    text: "隐藏问卷支持"
  }, {
    key: "lottery",
    text: "自定义抽奖"
  }, {
    key: "voting-wall",
    text: "投票墙"
  }, {
    key: "wx-sign-in",
    text: "微信签到"
  }, {
    key: "upload-multi-media",
    text: "上传音频/视频"
  }, {
    key: "single-upload-size",
    text: "单个文件50MB"
  }, {
    key: "upload-total-size",
    text: "上传空间10GB"
  }, {
    key: "geographical_navigate",
    text: "位置/导航题"
  }, {
    key: "export-volume-unlimited",
    text: "不限数据导出量"
  }],
  enterprise_version: [{
    key: "advertising-free",
    text: "免广告30万次"
  },
  // { key: "hide-logo", text: "隐藏问卷支持" },
  {
    key: "ent-cooperation",
    text: "团队成员10位"
  }, {
    key: "large-vote",
    text: "大型投票"
  }, {
    key: "360-appraise",
    text: "360评估"
  },
  // { key: "lottery", text: "自定义抽奖" },
  {
    key: "export-volume-unlimited",
    text: "不限数据导出量"
  }, {
    key: "export-answer-collection",
    text: "可导出答卷集合"
  }, {
    key: "single-upload-size",
    text: "单个文件100MB"
  }, {
    key: "upload-total-size",
    text: "上传空间20GB"
  }, {
    key: "brand-show",
    text: "企业品牌展示"
  }, {
    key: "open-api",
    text: "开放平台"
  }],
  enterprise_ultimate_version: [{
    key: "advertising-free",
    text: "免广告150万次"
  },
  // { key: "hide-logo", text: "隐藏问卷支持" },
  {
    key: "ent-cooperation",
    text: "团队成员30位"
  }, {
    key: "large-vote",
    text: "大型投票"
  }, {
    key: "360-appraise",
    text: "360评估"
  },
  // { key: "lottery", text: "自定义抽奖" },
  {
    key: "export-volume-unlimited",
    text: "不限数据导出量"
  }, {
    key: "export-answer-collection",
    text: "可导出答卷集合"
  }, {
    key: "single-upload-size",
    text: "单个文件200MB"
  }, {
    key: "upload-total-size",
    text: "上传空间50GB"
  }, {
    key: "brand-show",
    text: "企业品牌展示"
  }, {
    key: "open-api",
    text: "开放平台"
  }]
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/payment.vue?vue&type=script&lang=js&





















const defaultSubAccount = {
  free: 0,
  advance_version: 0,
  enterprise_version: 10,
  enterprise_ultimate_version: 30
};
/* harmony default export */ var paymentvue_type_script_lang_js_ = ({
  components: {
    [tooltip_default.a.name]: tooltip_default.a,
    [input_number_default.a.name]: input_number_default.a,
    [dropdown_default.a.name]: dropdown_default.a,
    [dropdown_menu_default.a.name]: dropdown_menu_default.a,
    [dropdown_item_default.a.name]: dropdown_item_default.a,
    [button_default.a.name]: button_default.a,
    [dialog_default.a.name]: dialog_default.a
  },
  props: {
    // 是否禁止操作，当用户无法选择升级套餐时，会隐藏所有信息
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否升级套餐
    isPkgUpgrad: {
      type: Boolean,
      default: false
    },
    // 当前账号套餐版本
    currentVersion: {
      type: String,
      default: ""
    },
    // 当前账号套餐到期时间(天)
    currentVersionExpireTime: {
      type: Number,
      default: 0
    },
    // // 当前账号套餐版本的子账号
    currentVersionSubAccount: {
      type: Number,
      default: 0
    },
    // 支付的套餐版本
    payVersion: {
      type: String,
      default: ""
    },
    // 支付的套餐年数
    payTime: {
      type: Number,
      default: 0
    },
    // 支付的套餐优惠券列表
    couponList: {
      type: Array,
      default: () => []
    },
    serviceQrcode: {
      type: String,
      default: ""
    },
    // 是不是需要自动提高Messasge
    zIndex: {
      type: Number,
      default: null
    },
    // 最高级解决层级问题，手动解决层级问题
    confirmZindex: {
      type: Number,
      default: null
    },
    // 当前套餐是否为试用版，试用版参与不抵扣
    isFreeTry: {
      type: Boolean,
      default: false
    },
    // 套餐goods_id
    goods_id: {
      type: String,
      default: ""
    }
  },
  data() {
    const appendUrl = this.$parent.appendUrl || "";
    return {
      IconQuestion: `${appendUrl}question.png`,
      payWays: ["alipay", "wechatpay"],
      payWayIndex: 0,
      checkedCoupon: null,
      dialogVisible: false,
      peerAccountCost: 500,
      // 一个增购子账号一年的价格
      pkgYearDays: 365 // 套餐购买/抵扣时计算的一年天数
    };
  },

  computed: {
    // 套餐标准费用
    costPrice() {
      var _packagePrice$this$pa;
      return (_packagePrice$this$pa = packagePrice[this.payVersion].find(v => v.indate === this.payTime)) === null || _packagePrice$this$pa === void 0 ? void 0 : _packagePrice$this$pa.totalPrice;
    },
    // 当前套餐默认赠送的子账号数量
    currentPkgDefaultAccount() {
      return defaultSubAccount[this.currentVersion];
    },
    // 选中套餐默认赠送的子账号数量
    payPkgDefaultAccount() {
      return defaultSubAccount[this.payVersion];
    },
    // 子账号数量
    subAcconutNum() {
      if (this.payPkgDefaultAccount === 0) {
        return 0;
      }
      // 当前套餐如果有子账号，则取当前套餐的子账号数量和已选套餐默认赠送的最大值
      return Math.max(this.currentVersionSubAccount, this.payPkgDefaultAccount);
    },
    // 子账号增购费用，比套餐赠送数量多的部分
    subAccountCost() {
      return (this.subAcconutNum - this.payPkgDefaultAccount) * this.peerAccountCost * this.payTime;
    },
    // 当前套餐版本费用抵扣，保留小数后2位
    versionDeduction() {
      var _packagePrice$this$cu;
      // 试用版不抵扣
      if (this.isFreeTry) {
        return 0;
      }
      // 续费不抵扣
      if (!this.isPkgUpgrad) {
        return 0;
      }
      // 非高级版、企业版不抵扣
      if (this.currentVersion !== "advance_version" && this.currentVersion !== "enterprise_version") {
        return 0;
      }
      const pricePerYear = (_packagePrice$this$cu = packagePrice[this.currentVersion][0]) === null || _packagePrice$this$cu === void 0 ? void 0 : _packagePrice$this$cu.totalPrice;

      // 保留2位小数，四舍五入
      // 11.27套餐重构取消四舍五入
      let r = (this.currentVersionExpireTime / this.pkgYearDays * pricePerYear).toString();
      r = (r.includes(".") ? r.substring(0, r.indexOf(".") + 3) : r) - 0;
      return r;
    },
    // 当前套餐版本增购的子账号抵扣，保留小数后2位
    subAccountDeduction() {
      return 0;

      // 产品要求：去除掉所有抵扣费用
      //
      // // 续费不抵扣
      // if (!this.isPkgUpgrad) {
      //     return 0;
      // }
      // // 非企业版、期间版不抵扣
      // if (
      //     this.currentVersion !== "enterprise_version" &&
      //     this.currentVersion !== "enterprise_ultimate_version"
      // ) {
      //     return 0;
      // }

      // // 保留2位小数，四舍五入
      // let r =
      //     (this.currentVersionExpireTime / this.pkgYearDays) *
      //     this.peerAccountCost *
      //     (this.currentVersionSubAccount - this.currentPkgDefaultAccount);
      // r = r.toFixed(2) - 0;
      // return r;
    },

    // 选中的优惠券面额
    couponDeduction() {
      var _this$checkedCoupon;
      return (_this$checkedCoupon = this.checkedCoupon) === null || _this$checkedCoupon === void 0 ? void 0 : _this$checkedCoupon.value;
    },
    // 实际支付费用
    actualPayCost() {
      let r = this.costPrice + this.subAccountCost - this.versionDeduction - this.subAccountDeduction - this.couponDeduction;

      // 保留2位小数，四舍五入
      r = r.toFixed(2) - 0;
      return Math.max(r, 0);
    },
    // 支付的套餐版本过期时间
    pkgDeadTime() {
      if (this.isPkgUpgrad) {
        return this.daysToDate();
      }
      return this.daysToDate(this.currentVersionExpireTime);
    },
    payWay() {
      return this.payWays[this.payWayIndex];
    },
    // 优惠券有使用门槛，支付金额(除优惠券以外的部分)必须大于等于优惠券最低门槛价格
    avaliableCoupons() {
      const payCost = this.costPrice + this.subAccountCost - this.versionDeduction - this.subAccountDeduction;
      return this.couponList.filter(v => {
        const satisfyV = Number.isNaN(Number.parseFloat(v.satisfy_value)) ? 0 : Number.parseFloat(v.satisfy_value);
        return payCost >= satisfyV;
      });
    }
  },
  watch: {
    avaliableCoupons: {
      handler(v) {
        if (v.length > 0) {
          let maxCoupon = v[0];
          // 当优惠券列表更新，默认取最大面值
          // eslint-disable-next-line no-restricted-syntax
          for (const coupon of v) {
            if (maxCoupon.value < coupon.value) {
              maxCoupon = coupon;
            }
          }
          this.selectCoupon(maxCoupon);
        } else {
          this.selectCoupon({
            value: 0,
            oid: ""
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    // 套餐过期时间转换
    daysToDate() {
      let initDays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      // 满3送1，满5送2
      const yearsMap = {
        1: 1,
        3: 4,
        5: 7
      };
      const years = yearsMap[this.payTime];
      return external_dayjs_default()().add(initDays, "d").add(years * this.pkgYearDays, "d").format("YYYY-MM-DD");
    },
    // 修改支付方式
    changePayWay(i) {
      this.payWayIndex = i;
    },
    // 选择优惠券
    selectCoupon(v) {
      this.checkedCoupon = v;
    },
    // 调起支付
    async payNow() {
      if (this.payNow.user) return;
      this.payNow.user = true;
      setTimeout(() => {
        this.payNow.user = false;
      }, 200);
      let checkPamentTicker = null;
      try {
        var _res$data, _res$data2, _res$data3, _res$data5;
        const res = await createOrder({
          cargo_to_buy: [{
            goods_id: this.goods_id,
            amount: 1
          }],
          payment_info: [{
            pay_channel: ["alipay", "wechatpay"].indexOf(this.payWay) + 1,
            cent_to_pay: (this.actualPayCost * 100).toFixed() - 0
          }],
          coupon_to_use: this.checkedCoupon.oid ? [this.checkedCoupon.oid] : []
        });
        if (!(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.is_success)) return;

        // 使用优惠券实际支付金额小于等于0时且购买成功时 不返回order_id
        if (!((_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.order_id)) {
          this.afterPayment(true);
          return;
        }

        // 接口返回pay_redirect_url 新开支付页面
        ((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.pay_redirect_url) && window.open(res.data.pay_redirect_url, "_blank");

        // // 开启轮询，只是为了保证二次确认弹窗还在的时候，用户支付成功，自动关闭弹窗
        // // 一旦二次确认弹窗关闭（无论点击确定还是取消），都会取消轮询
        checkPamentTicker = setInterval(async () => {
          try {
            var _res$data4;
            await this.checkPayment((_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.order_id);
            // 如果轮询检查支付成功，关闭轮询，关闭弹窗
            clearInterval(checkPamentTicker);
            // 手动关闭支付确认弹窗
            message_box_default.a.close();
            this.afterPayment(true);
          } catch (error) {
            //
          }
        }, 3000);
        await message_box_default.a.confirm("支付完成前，请勿关闭此窗口<br />支付完成后，请根据支付情况点击以下按钮", "支付成功确认", {
          confirmButtonText: "支付成功",
          closeOnPressEscape: false,
          dangerouslyUseHTMLString: true,
          ...(this.confirmZindex || this.zIndex ? {
            zIndex: this.confirmZindex || this.zIndex + 1
          } : null)
        });
        await this.checkPayment((_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.order_id);
        this.afterPayment(true);
      } catch (error) {
        // 支付过程中产生的所有错误，不包括用户取消支付确认
        if (error !== "cancel") {
          this.afterPayment(false);
        }
        console.log("payment errors: ", error);
      }

      // 只要用户操作了二次确认弹窗，弹窗关闭后，则关闭轮询
      clearInterval(checkPamentTicker);
    },
    // 检查订单是否支付成功，如果成功则购买，否则返回错误
    async checkPayment(order_id) {
      try {
        const {
          data
        } = await payOrderStatus(order_id);
        if ((data === null || data === void 0 ? void 0 : data.order_status) === 1) {
          // await this.buyPackage(order_id);
          console.log("购买成功");
        } else {
          return Promise.reject(new Error("checkPayment faild."));
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    // 支付之后
    afterPayment() {
      let successful = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (successful) {
        message_default()({
          message: "支付成功",
          type: "success"
        });
        this.$parent.$emit("input", false);
        this.$parent.$emit("payment", true);
        if (this.$parent.needReload) {
          window.location.reload();
        }
      } else {
        message_default()({
          message: "您未完成支付",
          type: "warning"
        });
        this.$parent.$emit("payment", false);
      }
    },
    // 打卡对公转账弹框
    openPublicAccount() {
      this.dialogVisible = true;
    }
  }
});
// CONCATENATED MODULE: ./packages/package-dialog/src/payment.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_paymentvue_type_script_lang_js_ = (paymentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/payment.vue?vue&type=style&index=0&id=970e15d0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/package-dialog/src/payment.vue?vue&type=style&index=0&id=970e15d0&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/package-dialog/src/payment.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_paymentvue_type_script_lang_js_,
  paymentvue_type_template_id_970e15d0_scoped_true_render,
  paymentvue_type_template_id_970e15d0_scoped_true_staticRenderFns,
  false,
  null,
  "970e15d0",
  null
  
)

/* harmony default export */ var payment = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/package-detail.vue?vue&type=template&id=cd1b38ec&scoped=true&
var package_detailvue_type_template_id_cd1b38ec_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "package-detail",
      class: [
        {
          "three-left":
            _vm.showVersionList.length === 3 &&
            _vm.activeVersion === "advance_version"
        },
        {
          "three-center":
            _vm.showVersionList.length === 3 &&
            _vm.activeVersion === "enterprise_version"
        },
        {
          "three-right":
            _vm.showVersionList.length === 3 &&
            _vm.activeVersion === "enterprise_ultimate_version"
        },
        {
          "two-left":
            _vm.versionList.length === 1 ||
            (_vm.versionList.length === 2 &&
              _vm.activeVersion === "enterprise_version")
        },
        {
          "two-right":
            _vm.showVersionList.length === 2 &&
            _vm.activeVersion === "enterprise_ultimate_version" &&
            _vm.showVersionList[0].key === "enterprise_version"
        }
      ]
    },
    [
      _c(
        "ul",
        { staticClass: "tabs" },
        _vm._l(_vm.showVersionList, function(item) {
          return _c(
            "li",
            {
              key: item.key,
              staticClass: "tab",
              on: {
                click: function($event) {
                  return _vm.changePackage(item)
                }
              }
            },
            [
              _c("h3", { staticClass: "name" }, [_vm._v(_vm._s(item.name))]),
              _vm._v(" "),
              _c("p", { staticClass: "intro" }, [_vm._v(_vm._s(item.intro))])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "detail-part" }, [
        _c(
          "ul",
          { staticClass: "price-part", class: [] },
          _vm._l(_vm.packagePriceList, function(item, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "every-time",
                class: [
                  _vm.restIndate > item.indate * 365 && _vm.isPkgUpgrad
                    ? "disabled"
                    : "",
                  item.indate == _vm.activeTime ? "active" : ""
                ],
                on: {
                  click: function($event) {
                    return _vm.changeTime(item)
                  }
                }
              },
              [
                _c("span", {
                  staticClass: "give-icon",
                  class: [
                    { one: item.indate === 3 },
                    { two: item.indate === 5 }
                  ]
                }),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "year" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.indate) +
                        "年\n                    "
                    ),
                    _vm.restIndate > item.indate * 365 && _vm.isPkgUpgrad
                      ? _c(
                          "wd-tooltip",
                          { attrs: { placement: "top", effect: "light" } },
                          [
                            _c("img", {
                              staticClass: "icon-help",
                              attrs: { src: _vm.IconQuestion }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._v(
                                  "\n                            账号套餐升级时的购买时长不得"
                                ),
                                _c("br"),
                                _vm._v(
                                  "低于原套餐的剩余有效时长\n                        "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "total-money" }, [
                  _c("span", { staticClass: "rmb" }, [_vm._v("￥")]),
                  _vm._v(_vm._s(item.totalPrice) + "\n                ")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "day-money" }, [
                  _vm._v(
                    "\n                    低至日均" +
                      _vm._s(item.averagePrice) +
                      "元"
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeVersion !== "advance_version",
                          expression: "activeVersion !== 'advance_version'"
                        }
                      ]
                    },
                    [_vm._v("/人")]
                  )
                ])
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "equity-part" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "equity-ul" },
            _vm._l(_vm.equityList, function(item) {
              return _c(
                "li",
                {
                  key: item.key,
                  staticClass: "equity-li",
                  class: [_vm.activeEquity === item.key ? "active" : ""]
                },
                [
                  _c("span", {
                    staticClass: "equity-icon",
                    attrs: { "data-type": item.key }
                  }),
                  _vm._v(" "),
                  _c("span", { class: item.key }, [_vm._v(_vm._s(item.text))])
                ]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "contact-service",
            on: { click: _vm.showServiceDialog }
          },
          [
            _c("span", { staticClass: "service-icon" }),
            _vm._v(" "),
            _c("span", [_vm._v("联系服务顾问")])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "wd-dialog",
        {
          staticClass: "contact-service-counselor",
          attrs: {
            title: "联系服务顾问",
            visible: _vm.serviceShow,
            "show-close": false,
            width: "280px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.serviceShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "content-contact" }, [
            _c("p", { staticClass: "line-title" }, [_vm._v("电话联系")]),
            _vm._v(" "),
            _c("p", { staticClass: "phone-num" }, [
              _vm._v(_vm._s(_vm.serviceNum || "02180394911"))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "line-title" }, [_vm._v("微信联系")]),
            _vm._v(" "),
            _c("img", {
              staticClass: "wx-ercode",
              attrs: { src: _vm.serviceQrcode, alt: "服务顾问" }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ok-btn",
                on: {
                  click: function($event) {
                    _vm.serviceShow = false
                  }
                }
              },
              [_vm._v("\n                好的\n            ")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var package_detailvue_type_template_id_cd1b38ec_scoped_true_staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "equity-title" }, [
      _c("h3", [_vm._v("套餐权益")]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "go-senior",
          attrs: { href: "/senior_user/", target: "_blank" }
        },
        [_vm._v("全部权益"), _c("span", { staticClass: "right-icon" })]
      )
    ])
  }
]
package_detailvue_type_template_id_cd1b38ec_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/package-dialog/src/package-detail.vue?vue&type=template&id=cd1b38ec&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/package-detail.vue?vue&type=script&lang=js&





/* harmony default export */ var package_detailvue_type_script_lang_js_ = ({
  name: "PackageDetail",
  components: {
    "wd-dialog": dialog_default.a,
    "wd-tooltip": tooltip_default.a
  },
  props: {
    // 当前高亮版本
    activeVersion: {
      type: String,
      default: "enterprise_ultimate_version"
    },
    // 当前高亮购买时长
    activeTime: {
      type: Number,
      default: 1
    },
    // 高亮的权益
    activeEquity: {
      type: String,
      default: ""
    },
    // 用户当前套餐剩余的有效期
    restIndate: {
      type: Number,
      default: 0
    },
    // 展示的版本列表
    versionList: {
      type: Array,
      default: () => payVersionList
    },
    // 服务顾问二维码
    serviceQrcode: {
      type: String,
      default: ""
    },
    serviceNum: {
      type: String,
      default: ""
    },
    // 是否升级套餐
    isPkgUpgrad: {
      type: Boolean,
      default: false
    },
    // 套餐goods_id
    goods_id: {
      type: String,
      default: ""
    }
  },
  data() {
    const appendUrl = this.$parent.appendUrl || "";
    return {
      appendUrl,
      IconQuestion: `${appendUrl}question-disabled.png`,
      serviceShow: false // 服务顾问弹框显隐
    };
  },

  computed: {
    // 选中的套餐版本
    selectedVersion: {
      get() {
        return this.activeVersion;
      },
      set(val) {
        this.$emit("changeVersion", {
          activeVersion: val,
          activeTime: this.selectedTime
        });
      }
    },
    // 选中的购买时长
    selectedTime: {
      get() {
        return this.activeTime;
      },
      set(val) {
        this.$emit("changeVersion", {
          activeVersion: this.activeVersion,
          activeTime: val
        });
      }
    },
    // 权益列表
    equityList() {
      return packageShowEquity[this.selectedVersion];
    },
    // 购买时长和价格数组
    packagePriceList() {
      return packagePrice[this.activeVersion];
    },
    showVersionList() {
      if (this.versionList.length === 1) {
        return this.versionList.concat({});
      }
      return this.versionList;
    }
  },
  watch: {
    activeTime: {
      handler() {
        var _packagePrice$this$ac;
        this.$emit("update:goods_id", (_packagePrice$this$ac = packagePrice[this.activeVersion].find(item => item.indate == this.activeTime)) === null || _packagePrice$this$ac === void 0 ? void 0 : _packagePrice$this$ac.goods_id);
      },
      immediate: true
    },
    activeVersion: {
      handler() {
        var _packagePrice$this$ac2;
        this.$emit("update:goods_id", (_packagePrice$this$ac2 = packagePrice[this.activeVersion].find(item => item.indate == this.activeTime)) === null || _packagePrice$this$ac2 === void 0 ? void 0 : _packagePrice$this$ac2.goods_id);
      }
    }
  },
  methods: {
    // 切换套餐
    changePackage(item) {
      if (item && item.key) {
        this.selectedVersion = item.key;
        item.selectedTime = this.activeTime;
      }
    },
    // 切换有效期
    changeTime(item) {
      if (this.restIndate > item.indate * 365 && this.isPkgUpgrad) {
        return;
      }
      this.selectedTime = item.indate;
    },
    showServiceDialog() {
      this.serviceShow = true;
    }
  }
});
// CONCATENATED MODULE: ./packages/package-dialog/src/package-detail.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_package_detailvue_type_script_lang_js_ = (package_detailvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/package-detail.vue?vue&type=style&index=0&id=cd1b38ec&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/package-dialog/src/package-detail.vue?vue&type=style&index=0&id=cd1b38ec&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/package-dialog/src/package-detail.vue






/* normalize component */

var package_detail_component = Object(componentNormalizer["a" /* default */])(
  src_package_detailvue_type_script_lang_js_,
  package_detailvue_type_template_id_cd1b38ec_scoped_true_render,
  package_detailvue_type_template_id_cd1b38ec_scoped_true_staticRenderFns,
  false,
  null,
  "cd1b38ec",
  null
  
)

/* harmony default export */ var package_detail = (package_detail_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/index.vue?vue&type=script&lang=js&












/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: "PackageDialog",
  components: {
    "wd-button": button_default.a,
    "wd-dialog": dialog_default.a,
    payment: payment,
    PackageDetail: package_detail
  },
  model: {
    prop: "visible"
  },
  props: {
    // 是否展示弹窗，可以用v-model绑定
    visible: {
      type: Boolean,
      default: false
    },
    // 弹框要展示的最低版本,
    // eg:
    // 当前版本free，升级当前套餐，正常是从高级版显示
    // 如果lowestVersion是enterprise_version，则只展示企业版、旗舰版
    lowestVersion: {
      type: String,
      default: "advance_version",
      validator(v) {
        return ["advance_version", "enterprise_version", "enterprise_ultimate_version"].includes(v);
      }
    },
    // 弹框要高亮的版本
    activeVersion: {
      type: String,
      default: "enterprise_version",
      validator(v) {
        return ["advance_version", "enterprise_version", "enterprise_ultimate_version"].includes(v);
      }
    },
    // 高亮的权益
    activeEquity: {
      type: String,
      default: ""
    },
    // 弹窗在body节点内的层级
    zIndex: {
      type: Number,
      default: 1000
    },
    // 套餐购买成功后是否需要刷新当前页
    needReload: {
      type: Boolean,
      default: true
    },
    // 弹框来源、入口
    source: {
      type: String,
      default: ""
    },
    // 确认弹窗支付的最高级样式,解决特出场景下继承父类层级关系无法解决弹窗位置的时候单独使用   confirmZindex > zIndex
    confirmZindex: {
      type: Number,
      default: null
    },
    // 微应用调整
    microData: {
      type: Object,
      default: null
    },
    // 最高优先级移除某个版本 这是最先的
    excludes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const appendUrl = "//s1.wenjuan.com/assets/images/business/package-dialog/";
    // eslint-disable-next-line no-bitwise
    const index = ~~(Math.random() * 2) + 1;
    const serviceQrcode = `https://s1.wenjuan.com/assets/images/customer-service/support${index}.png`;
    return {
      appendUrl,
      show: false,
      userInfo: {},
      // 用户信息
      innerActiveVersion: "",
      // 当前高亮的版本
      activeTime: 1,
      // 当前高亮的套餐购买年份
      currentVersion: "free",
      // 当前版本信息
      restIndate: 0,
      // 当前版本剩余有效期，单位(天)
      coupons: [],
      // 选中版本的优惠券列表
      currentSubAccount: 0,
      // 当前版本子账号
      serviceQrcode,
      // "https://s1.wenjuan.com/assets/images/customer-service/wx-wsh.png", // 服务顾问,也是对公账号二维码
      serviceNum: "02180394911",
      // 服务顾问电话号码
      accountQrcode: "",
      // 对公转账二维码
      disableUpgrade: false,
      // 当前账号套餐过期时长超过5年，禁止升级
      microAppInfo: {},
      // 微应用账号信息
      isLoading: false,
      // 是否加载完成
      corpId: "",
      // 钉钉用户corp_id
      dialogInfo: {
        isDingTalk: {
          scanQR: "钉钉扫描二维码",
          description: "企业管理员登录钉钉应用中心，进入问卷网页面点击右上角“立即购买”，选择套餐进行购买 ",
          imgTLX: `${appendUrl}TLX-dd.png`,
          imgHA: `${appendUrl}HA-dd.png`,
          iconImg: `${appendUrl}dingTalk.svg`
        },
        isFeishu: {
          scanQR: "飞书扫描二维码",
          description: "企业管理员登录飞书管理后台，进入问卷网，在应用付费处点击“购买付费方案”进行购买 ",
          imgTLX: `${appendUrl}TLX-fs.png`,
          imgHA: `${appendUrl}HA-fs.png`,
          iconImg: `${appendUrl}feiShu.svg`
        },
        isWxwork: {
          scanQR: "微信或企业微信扫描二维码",
          description: "企业管理员登录企业微信管理后台，在第三方应用-问卷网页面点击“进入应用管理”，在应用版本处选择套餐进行购买",
          imgTLX: `${appendUrl}TLX-wx .png`,
          imgHA: `${appendUrl}HA-wx.png`,
          iconImg: `${appendUrl}wxWork.svg`
        }
      },
      jumpButton: {
        isDingTalk: "登录钉钉应用中心",
        isFeishu: "登录飞书管理后台",
        isWxwork: "登录企微管理后台"
      },
      corpIdIndex: "",
      // 根据corpId余数随机销售二维码
      goods_id: "" // 选择套餐的goods_id
    };
  },

  computed: {
    isPkgUpgrad() {
      const versionEnums = Object.keys(MEMBER_PKG_TYPE_MAPPING);
      const currentVersionIndex = versionEnums.findIndex(v => v === this.currentVersion);
      const activeVersionIndex = versionEnums.findIndex(v => v === this.activeVersion);
      return activeVersionIndex > currentVersionIndex;
    },
    isWAUser() {
      console.log(this.microAppInfo.isWAUser);
      return this.microAppInfo.isWAUser;
    },
    versionList() {
      var _this$microAppInfo, _this$microAppInfo2;
      const versionEnums = Object.keys(MEMBER_PKG_TYPE_MAPPING);
      const currentVersionIndex = versionEnums.findIndex(v => v === this.currentVersion);
      const lowestVersionIndex = versionEnums.findIndex(v => v === this.lowestVersion);
      const activeVersionIndex = versionEnums.findIndex(v => v === this.activeVersion);
      let mapList = payVersionList;
      // 升级版本是free🙅‍，或者当前版本是免费版 支持三个选项不支持此操作
      if (activeVersionIndex === 0 || (_this$microAppInfo = this.microAppInfo) !== null && _this$microAppInfo !== void 0 && _this$microAppInfo.isFreeTry) {
        mapList = payVersionList;
      } else if (currentVersionIndex === activeVersionIndex) {
        // 续费（非free） 只有一个结果
        mapList = [payVersionList[activeVersionIndex - 1]];
      } else if (activeVersionIndex > currentVersionIndex) {
        // 升级，有2种情况
        // 默认会把currentVersion（不包含）之后的所有版本都展示
        // 如果lowestVersion大于activeVersionIndex，则只展示lowestVersion（包含）之后的版本
        mapList = payVersionList.filter((v, i) => i > currentVersionIndex - 1 && i >= lowestVersionIndex - 1);
      }
      if (activeVersionIndex < currentVersionIndex && !((_this$microAppInfo2 = this.microAppInfo) !== null && _this$microAppInfo2 !== void 0 && _this$microAppInfo2.isFreeTry)) {
        message_default()({
          message: "不可以购买低于现有套餐版本的套餐，请注意传参",
          type: "warning"
        });
      }
      mapList = mapList.filter(v => !this.excludes.includes(v.key));
      // 反向升级😅或者参数无效
      return mapList;
    },
    // 隐藏中间四位的手机号
    phoneNum() {
      if (this.userInfo.mobile) {
        return `${this.userInfo.mobile.toString().slice(0, 3)}****${this.userInfo.mobile.toString().slice(-4)}`;
      }
      return "";
    },
    dialogVisile: {
      get() {
        return this.visible;
      },
      set() {
        this.$emit("close");
      }
    },
    // 随机分配销售
    randomSale() {
      return ["imgTLX", "imgHA"][this.corpIdIndex];
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        this.innerActiveVersion = payVersionListProxy[this.activeVersion];
        this.activeTime = 1;
        // 仅当弹窗打开时再请求接口，避免组件被挂载后，因为接口获取而出现各种toast
        if (v) {
          this.initBefore();
          // 挂载弹窗到body，提高zindex层级
          this.$nextTick(() => {
            document.body.appendChild(this.$el);
          });
        }
      }
    },
    // 外界传入改变内部
    microData: {
      handler(cval) {
        cval && (this.microAppInfo = cval);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 在弹窗打开时候预先执行的逻辑
    initBefore() {
      this.getUserInfo();
      this.getCouponsAndPackage();
      // this.getQrcodeInfo();
      getCorpInfo().then(res => {
        this.corpIdIndex = res.data.corp_id.charCodeAt(res.data.corp_id.length - 1) % 2;
      });
    },
    // 左侧更改套餐版本及购买时长emit
    changeVersion(obj) {
      this.innerActiveVersion = obj.activeVersion;
      this.activeTime = obj.activeTime;
      this.getCouponsAndPackage();
    },
    // 获取用户基本信息
    getUserInfo() {
      getUserInfo().then(res => {
        if (res.status == 200) {
          this.userInfo = res.data || {};
          this.httpMemberPackageInfo();
        }
      }).catch(err => {
        console.log("err", err);
        if (typeof err === "object" && err.data.err_msg) {
          message_default()({
            message: err.data.err_msg,
            type: "warning"
          });
        } else {
          return Promise.reject(err);
        }
      });
    },
    httpDingTalkCorpId() {
      dingTalkCorpId({
        member_id: this.userInfo.id
      }).then(res => {
        if (res.status === 200 && res.status_code === 1) {
          this.corpId = res.data.corp_id;
          window.open(`dingtalk://dingtalkclient/page/link?url=https%3A%2F%2Fh5.dingtalk.com%2Fappcenter%2Findex-pc.html%3Fddtab%3Dtrue%26funnelsource%3D%26source%3D%26corpId%3D${this.corpId}%23%2Fdetail%2FDT_GOODS_881650260477337`, "_blank");
        }
      }).catch(err => {
        console.log(err);
      });
    },
    JumpLink() {
      if (this.isWAUser === "isDingTalk") {
        this.httpDingTalkCorpId();
      } else if (this.isWAUser === "isFeishu") {
        window.open("https://applink.feishu.cn/client/web_url/open?mode=window&url=https%3A%2F%2Fwww.feishu.cn%2Fadmin%2FappCenter%2Fmanage%2Fcli_9c10807b13b01108", "_blank");
      } else if (this.isWAUser === "isWxwork") {
        window.open("https://work.weixin.qq.com/wework_admin/frame#/apps/appStore/detail/MTk3MDMyNTA4MzA0NTk1NF8zNjU1Nl8x/show", "_blank");
      }
    },
    //  获取套餐信息
    httpMemberPackageInfo() {
      Object(package_dialog["a" /* httpMemberPackageInfo */])().then(res => {
        if (res.status === 200 && res.status_code === 1) {
          const {
            data
          } = res;
          console.log(data);
          // 当前套餐是否为试用套餐
          this.getMicroAppInfo(data);
        }
      }).catch(err => {
        console.log(err, "指引弹窗报错提示");
      });
    },
    // 获取优惠券信息及账号套餐信息
    getCouponsAndPackage() {
      avaliableCoupons(this.innerActiveVersion).then(res => {
        this.coupons = res.data;
        // 免费版不存在package字段
        if (res.package) {
          this.currentSubAccount = res.package.sub_account_count;
          this.currentVersion = res.package.version;
          console.log(this.currentVersion, "this.currentVersion");
          this.restIndate = this.dateToDays(res.package.expire_time);

          // 若用户版本套餐时间超过5年，点击升级打开付费套餐弹窗toast
          this.disableUpgrade = this.restIndate > 1825 && this.isPkgUpgrad;
          if (this.disableUpgrade) {
            this.activeTime = 0;
            message_default()({
              message: "当前套餐升级时长不可选，请联系服务顾问",
              type: "warning"
            });
          }
          // 用户当前套餐有效期超过3年，但不超过5年，默认选中5年
          if (this.restIndate > 1095 && !this.disableUpgrade && this.isPkgUpgrad) {
            this.activeTime = 5;
          }
        }
      }).catch(err => {
        if (typeof err === "object" && err.data.err_msg) {
          message_default()({
            message: err.data.err_msg,
            type: "warning"
          });
        } else {
          return Promise.reject(err);
        }
      });
    },
    // 有效期转换为剩余天数
    dateToDays(expireTime) {
      // 因为到期时间包含当天，所以需要以当天最晚时间来计算
      return Math.ceil((new Date(`${expireTime} 23:59:59`) - new Date().getTime()) / 1000 / 60 / 60 / 24);
    },
    // 返回微应用账号信息
    getMicroAppInfo(data) {
      const curMicroData = {};
      if (data) {
        var _data$package_status, _data$package_status2;
        curMicroData.isFreeTry = data === null || data === void 0 ? void 0 : (_data$package_status = data.package_status) === null || _data$package_status === void 0 ? void 0 : _data$package_status.is_trial;
        curMicroData.isWAUser = data === null || data === void 0 ? void 0 : data.third_part_type;
        curMicroData.version = data === null || data === void 0 ? void 0 : (_data$package_status2 = data.package_status) === null || _data$package_status2 === void 0 ? void 0 : _data$package_status2.version;
      }
      const [isWxwork, isDingTalk, isFeishu] = [tools["default"].$ENV.get("isWxwork"), tools["default"].$ENV.get("isDingTalk"), tools["default"].$ENV.get("isLark")];
      const mapList = {
        isWxwork: "isWxwork",
        isDingTalk: "isDingTalk",
        business_wx: "isWxwork",
        ding_talk: "isDingTalk",
        feishu: "isFeishu",
        isFeishu: "isFeishu",
        default: ""
      };
      // 合并所有数据来源
      Object.assign(curMicroData, {
        isWAUser: mapList[curMicroData.isWAUser] || mapList.default,
        // 微应用账户
        isMicroEnv: isWxwork || isDingTalk || isFeishu,
        // 是不是微应用环境
        isWxwork,
        isDingTalk,
        isFeishu,
        curMicro: isDingTalk ? "isDingTalk" : isFeishu ? "isFeishu" : isWxwork ? "isWxwork" : "Mozilla" // 当前微笑应用环境
      }, this.microData);
      this.microAppInfo = curMicroData;
      //  如果当前版本是试用版， 则高亮对应的正式版版本
      if (this.microAppInfo.isFreeTry && !this.excludes.length) this.innerActiveVersion = this.microAppInfo.version;
      this.isLoading = true;
    },
    // 随机二维码
    ramdonEQcode() {
      // eslint-disable-next-line no-bitwise
    }
  }
});
// CONCATENATED MODULE: ./packages/package-dialog/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var package_dialog_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/index.vue?vue&type=style&index=0&id=29c574a7&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/package-dialog/src/index.vue?vue&type=style&index=0&id=29c574a7&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/package-dialog/src/index.vue






/* normalize component */

var src_component = Object(componentNormalizer["a" /* default */])(
  package_dialog_srcvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "29c574a7",
  null
  
)

/* harmony default export */ var src = (src_component.exports);
// CONCATENATED MODULE: ./packages/package-dialog/index.js

src.install = function (Vue) {
  Vue.component(src.name, src);
};
/* harmony default export */ var packages_package_dialog = __webpack_exports__["default"] = (src);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return menuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return menuConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return innerFoundMenu; });
/* unused harmony export helpMenu */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mobileMenuList; });
/* unused harmony export pcFooterConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pcFooterConfigOne; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pcFooterConfigTwo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mobileFooterConfig; });
const menuList = {
  product: {
    text: "产品介绍",
    key: "product",
    type: "sub",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true,
    subMenu: [{
      text: "场景",
      menu: [{
        key: "survey",
        href: "/survey/",
        text: "问卷调查"
      }, {
        key: "satisfaction",
        href: "/satisfaction/",
        text: "满意度调查"
      }, {
        key: "assess",
        href: "/assess/",
        text: "考试测评"
      }, {
        key: "form",
        href: "/form/",
        text: "在线收集表单"
      }, {
        key: "vote",
        href: "/vote/",
        text: "投票评选",
        label: "new-tip-icon"
      }, {
        key: "pay",
        href: "/pay/",
        text: "在线收款"
      }, {
        key: "appraise",
        href: "/appraise/",
        text: "360度评估"
      }, {
        key: "knowledge",
        href: "/knowledge/",
        text: "知识竞赛"
      }]
    }, {
      text: "版本",
      menu: [
      // {
      //     key: "senior_user",
      //     href: "/senior_user/",
      //     text: "版本定价"
      // },
      {
        key: "app",
        href: "/app/",
        text: "问卷网APP"
      }, {
        key: "campus",
        href: "https://campus.wenjuan.com/",
        target: "_blank",
        text: "问卷网教师版"
      }

      // {
      //     text: "企业微信版",
      //     key: "wxbusiness",
      //     href: "/wxbusiness/"
      // }
      ]
    }]
  },

  list: {
    text: "项目",
    key: "list",
    href: "/list/"
  },
  lib: {
    text: "免费模板",
    key: "lib",
    href: "/lib/",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true
  },
  libs: {
    text: "模板",
    key: "lib",
    href: "/lib/",
    target: "_blank",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true
  },
  collectPost: {
    text: "样本收集",
    key: "collectPost",
    href: "/collect_post/",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true
  },
  contact: {
    text: "联系人",
    key: "contact",
    href: "/contact/list/"
  },
  found: {
    text: "发现",
    type: "sub",
    key: "found",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true,
    subMenu: [{
      text: "内容资源",
      menu: [{
        text: "考试题库",
        key: "question_square",
        href: "/question_square/",
        label: "new-tip-icon"
        // hideInFeiShu: true
      }, {
        text: "经典测试",
        key: "classical_test",
        href: "/classical_test/"
      }, {
        text: "调研专栏",
        key: "content_center",
        href: "/casecenter/articles/"
      }]
    }, {
      text: "师生服务",
      menu: [{
        text: "互答广场",
        key: "answer_square",
        href: "/discover/answer_square/",
        hideInFeiShu: true
      }, {
        text: "论文查重",
        key: "paper_check",
        href: "/station/paper/check/",
        hideInFeiShu: true
      }, {
        text: "师生专题",
        key: "topic",
        href: "/topic/campus/",
        target: "_blank",
        hideInFeiShu: true
      }]
    }]
  },
  plugin: {
    text: "应用",
    key: "plugin",
    href: "/plugin/",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true
  },
  enterprise: {
    text: "企业服务",
    key: "enterprise",
    type: "sub",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true,
    subMenu: [{
      text: "企业应用",
      menu: [{
        text: "企业版",
        key: "ent",
        href: "/pro/"
      }, {
        text: "倍市得CEM",
        key: "bestcem",
        href: "https://www.bestcem.com/?utm_source=wenjuan_top",
        label: "recommend-tip-icon",
        target: "_blank"
      }, {
        text: "SPSSPRO",
        key: "sps",
        href: "https://www.spsspro.com/?utm_source=wenjuan_top",
        label: "new-tip-icon",
        target: "_blank"
      }, {
        text: "问卷网-开放平台",
        key: "open",
        href: "https://open.wenjuan.com/",
        target: "_blank"
      }]
    }, {
      text: "专业服务",
      menu: [{
        text: "专业调研服务",
        key: "biz",
        href: "http://biz.wenjuan.com/",
        target: "_blank"
      }, {
        text: "专业样本服务",
        key: "collectPost",
        href: "/sample_service/"
      }, {
        text: "商务合作",
        key: "bd",
        href: "/bd/"
      }, {
        text: "私有化部署",
        key: "private",
        href: "/senior_user/#private"
      }]
    }]
  },
  senior_user: {
    key: "senior_user",
    href: "/senior_user/",
    text: "版本定价"
  },
  merchant: {
    text: "收款",
    key: "merchant",
    href: ""
  },
  innerCollectPost: {
    text: "样本收集",
    key: "innerCollectPost",
    href: "/inner_collect_post",
    subTextConf: {
      subText: "NEW",
      style: {
        color: "white",
        background: "#FF6D56"
      },
      isHide: false
    }
  }
};
const menuConfig = {
  inner: ["list", "libs", "contact", "merchant", "plugin", "innerCollectPost"],
  index: ["product", "lib", "collectPost", "enterprise", "senior_user", "found"],
  feishu: ["list", "contact"],
  dingding: ["list", "contact"],
  baiying: ["list", "contact"]
};
const innerFoundMenu = [
// {
//     title: "首页",
//     desc: "问卷网官网",
//     href: "/",
//     target: "_blank"
// },
{
  title: "产品介绍",
  desc: "8种用途介绍",
  subMenu: [{
    text: "场景",
    key: "scene",
    menu: [{
      key: "survey",
      href: "/survey/",
      text: "问卷调查",
      desc: "丰富模板·简单易用",
      target: "_blank"
    }, {
      key: "satisfaction",
      href: "/satisfaction/",
      text: "满意度调查",
      target: "_blank",
      desc: "专业的维度报告"
    }, {
      key: "assess",
      href: "/assess/",
      text: "考试测评",
      target: "_blank",
      desc: "简单高效的考试助手"
    }, {
      key: "form",
      href: "/form/",
      text: "在线收集表单",
      target: "_blank",
      desc: "信息收集从此高效"
    }, {
      key: "vote",
      href: "/vote/",
      text: "投票评选",
      label: "new-tip-icon",
      target: "_blank",
      desc: "轻松创建大型投票评选"
    }, {
      key: "knowledge",
      href: "/knowledge/",
      text: "知识竞赛",
      target: "_blank",
      desc: "支持大型竞赛活动"
    }, {
      key: "pay",
      href: "/pay/",
      text: "在线收款",
      target: "_blank",
      desc: "免费入驻·安全快速"
    }, {
      key: "appraise",
      href: "/appraise/",
      text: "360度评估",
      target: "_blank",
      desc: "人才测评助手"
    }]
  }
  // {
  //     text: "版本",
  //     key: "version",
  //     menu: [
  //         {
  //             key: "senior_user",
  //             href: "/senior_user/",
  //             text: "版本定价",
  //             target: "_blank",
  //             desc: "高级版·企业版·旗舰版"
  //         },
  //         {
  //             key: "app",
  //             href: "/app/",
  //             text: "问卷网APP",
  //             target: "_blank",
  //             desc: "随时随地查看数据"
  //         }
  //     ]
  // }
  ]
}, {
  title: "企业服务",
  desc: "体验·数据分析·数据对接",
  subMenu: [{
    text: "企业应用",
    key: "entApp",
    menu: [
    // {
    //     text: "问卷网·企业版",
    //     key: "ent",
    //     target: "_blank",
    //     href: "/pro/",
    //     target: "_blank",
    //     desc: "团队协作·品牌露出"
    // },
    {
      text: "倍市得CEM",
      key: "bestcem",
      href: "https://www.bestcem.com/?utm_source=wenjuan_inner_nav",
      label: "recommend-tip-icon",
      target: "_blank",
      desc: "体验管理·倍市可得"
    }, {
      text: "SPSSPRO",
      key: "sps",
      href: "https://www.spsspro.com/?utm_source=wenjuan_inner_nav",
      label: "new-tip-icon",
      target: "_blank",
      desc: "数据分析神器"
    }, {
      text: "专业调研服务",
      key: "biz",
      href: "http://biz.wenjuan.com/",
      target: "_blank",
      desc: "全方位市场研究与洞察"
    }, {
      text: "专业样本服务",
      key: "collectPost",
      href: "/sample_service/",
      target: "_blank",
      desc: "精准快速的问卷样本收集"
    }, {
      text: "商务合作",
      key: "bd",
      href: "/bd/",
      target: "_blank",
      desc: "品牌合作·VIP服务"
    }, {
      text: "开放平台",
      key: "open",
      href: "https://open.wenjuan.com/",
      target: "_blank",
      desc: "数据对接更轻松"
    }]
  }
  // {
  //     text: "专业服务",
  //     key: "service",
  //     menu: [
  //         {
  //             text: "专业调研服务",
  //             key: "biz",
  //             href: "http://biz.wenjuan.com/",
  //             target: "_blank",
  //             desc: "全方位市场研究与洞察"
  //         },
  //         {
  //             text: "专业样本服务",
  //             key: "collectPost",
  //             href: "/sample_service/",
  //             target: "_blank",
  //             desc: "精准快速的问卷样本收集"
  //         },
  //         {
  //             text: "商务合作",
  //             key: "bd",
  //             href: "/bd/",
  //             target: "_blank",
  //             desc: "品牌合作·VIP服务"
  //         }
  //     ]
  // }
  ]
}, {
  title: "内容资源",
  desc: "题库·经典测评·调研专栏",
  subMenu: [{
    text: "",
    key: "resource",
    menu: [{
      text: "考试题库",
      key: "question_square",
      href: "/question_square/",
      label: "new-tip-icon",
      target: "_blank",
      desc: "搜题组题更简单"
      // hideInFeiShu: true
    }, {
      text: "经典测试",
      key: "classical_test",
      href: "/classical_test/",
      target: "_blank",
      desc: "职业·人格·趣味测试"
    }, {
      text: "调研专栏",
      key: "content_center",
      href: "/casecenter/articles/",
      target: "_blank",
      desc: "学习调研好帮手"
    }]
  }]
}, {
  title: "师生服务",
  desc: "互答·论文查重·模板·素养测评",
  subMenu: [{
    text: "",
    key: "tasServer",
    menu: [{
      text: "问卷网教师版",
      key: "campus",
      href: "https://campus.wenjuan.com/",
      desc: " 老师的教学教务好帮手",
      target: "_blank",
      hideInFeiShu: true
    }, {
      text: "样本收集",
      key: "collectPost",
      href: "/collect_post/",
      desc: " 低价·收集速度快",
      target: "_blank",
      hideInFeiShu: true
    }, {
      text: "互答广场",
      key: "answer_square",
      href: "/discover/answer_square/",
      desc: "大学生免费样本收集",
      target: "_blank",
      hideInFeiShu: true
    }, {
      text: "论文查重",
      key: "paper_check",
      href: "/station/paper/check/",
      desc: "最高10万字免费查询",
      target: "_blank",
      hideInFeiShu: true
    }, {
      text: "师生专题",
      key: "topic",
      href: "/topic/campus/",
      target: "_blank",
      desc: "学生老师常用模板",
      hideInFeiShu: true
    }]
  }]
}, {
  title: "问卷网公众号",
  desc: "手机查看数据更轻松",
  showQrCode: true // 展示问卷网公众号
}];

const helpMenu = [{
  title: "问卷网官网",
  desc: "",
  href: "/"
}, {
  title: "问卷网官网",
  desc: "",
  href: "/"
}];
const mobileMenuList = [{
  text: "产品介绍",
  key: "product",
  showMenu: false,
  subMenu: [{
    key: "survey",
    href: "/survey/",
    text: "问卷调查"
  }, {
    key: "satisfaction",
    href: "/satisfaction/",
    text: "满意度调查"
  }, {
    key: "assess",
    href: "/assess/",
    text: "考试测评"
  }, {
    key: "form",
    href: "/form/",
    text: "在线收集表单"
  }, {
    key: "vote",
    href: "/vote/",
    text: "投票评选",
    label: "new-tip-icon"
  }, {
    key: "knowledge",
    href: "/knowledge/",
    text: "知识竞赛"
  }, {
    key: "appraise",
    href: "/appraise/",
    text: "360评估"
  }, {
    text: "样本收集",
    key: "collectPost",
    href: "/collect_post/"
  }, {
    key: "senior_user",
    href: "/senior_user/",
    text: "版本定价"
  }, {
    key: "app",
    href: "/app/",
    text: "下载APP"
  }, {
    key: "campus",
    href: "https://campus.wenjuan.com/",
    text: "问卷网教师版"
  }]
}, {
  text: "内容资源",
  key: "resource",
  showMenu: false,
  subMenu: [{
    text: "免费模板",
    key: "lib",
    href: "/lib/"
  }, {
    text: "考试题库",
    key: "question_square",
    href: "/question_square/",
    label: "new-tip-icon",
    desc: "搜题组题更简单"
    // hideInFeiShu: true
  }, {
    text: "经典测试",
    key: "classical_test",
    href: "/classical_test/",
    desc: "职业·人格·趣味测试"
  }, {
    text: "调研专栏",
    key: "content_center",
    href: "/casecenter/articles/",
    desc: "学习调研好帮手"
  }, {
    text: "帮助中心",
    key: "help_center",
    href: "/helpcenter/"
  }]
}, {
  text: "企业服务",
  key: "enterprise",
  showMenu: false,
  subMenu: [{
    text: "企业版",
    key: "ent",
    href: "/pro/"
  }, {
    text: "倍市得CEM",
    key: "bestcem",
    href: "https://www.bestcem.com/?utm_source=wenjuan_top",
    label: "recommend-tip-icon",
    target: "_blank"
  }, {
    text: "SPSSPRO",
    key: "sps",
    href: "https://www.spsspro.com/?utm_source=wenjuan_top",
    label: "new-tip-icon",
    target: "_blank"
  }, {
    text: "专业调研服务",
    key: "biz",
    href: "http://biz.wenjuan.com/"
  }]
}];
const pcFooterConfig = [{
  text: "使用场景",
  key: "product",
  type: "sub",
  subMenu: [{
    key: "survey",
    href: "/survey/",
    text: "问卷调查"
  }, {
    key: "satisfaction",
    href: "/satisfaction/",
    text: "满意度调查"
  }, {
    key: "assess",
    href: "/assess/",
    text: "考试测评"
  }, {
    key: "form",
    href: "/form/",
    text: "在线收集表单"
  }, {
    key: "vote",
    href: "/vote/",
    text: "投票评选",
    label: "new-tip-icon"
  }, {
    key: "pay",
    href: "/pay/",
    text: "在线收款"
  }, {
    key: "appraise",
    href: "/appraise/",
    text: "360度评估"
  }]
}, {
  text: "企业服务",
  key: "enterprise",
  type: "sub",
  subMenu: [{
    text: "企业版",
    key: "ent",
    href: "/pro/"
  }, {
    text: "SPSSPRO",
    key: "sps",
    href: "https://www.spsspro.com/?utm_source=wenjuan_footer",
    label: "new-tip-icon",
    target: "_blank"
  }, {
    text: "倍市得CEM",
    key: "bestcem",
    href: "https://www.bestcem.com/?utm_source=wenjuan_footer",
    label: "recommend-tip-icon",
    target: "_blank"
  }, {
    text: "开放平台",
    key: "open",
    href: "https://open.wenjuan.com/",
    target: "_blank"
  }, {
    text: "专业调研服务",
    key: "biz",
    href: "http://biz.wenjuan.com/",
    target: "_blank"
  }, {
    text: "专业样本服务",
    key: "collectPost",
    href: "/sample_service/"
  }]
}, {
  text: "资源",
  key: "resource",
  subMenu: [{
    text: "免费模板",
    key: "lib",
    href: "/lib/"
  }, {
    text: "考试题库",
    key: "question_square",
    href: "/question_square/",
    label: "new-tip-icon"
    // hideInFeiShu: true
  }, {
    text: "经典测试",
    key: "classical_test",
    href: "/classical_test/"
  }, {
    text: "调研专栏",
    key: "content_center",
    href: "/casecenter/articles/"
  }, {
    text: "答题赚钱",
    href: "https://www.idiaoyan.com/desktop_login?type=quick&id=&source=263453&plan=&device=&suid=",
    target: "_blank"
  }, {
    text: "帮助中心",
    key: "help_center",
    href: "/helpcenter/"
  }]
}, {
  text: "版本",
  key: "version",
  hideInMobile: true,
  subMenu: [{
    key: "senior_user",
    href: "/senior_user/",
    text: "版本定价"
  }, {
    key: "app",
    href: "/app/",
    text: "问卷网APP"
  }, {
    text: "企业微信版",
    href: "/wxbusiness/",
    target: "_blank"
  }, {
    text: "钉钉版",
    href: "https://appcenter.dingtalk.com/detail.html?goodsCode=DT_GOODS_881650260477337&sig=919627509847c6e2112690d5168d19e2",
    target: "_blank"
  }, {
    text: "飞书版",
    href: "https://app.feishu.cn/app/cli_9c10807b13b01108",
    target: "_blank"
  }, {
    text: "腾讯会议版",
    href: "https://meeting.tencent.com/marketplace/support-collect-detail?sdk_id=19170189429&page_channel_source=webmarket",
    target: "_blank"
  }, {
    text: "问卷网教师版",
    href: "https://campus.wenjuan.com/",
    target: "_blank"
  }]
}, {
  text: "师生服务",
  key: "teacherStudent",
  hideInMobile: true,
  subMenu: [{
    text: "样本收集",
    key: "collectPost",
    href: "/collect_post/"
  }, {
    text: "互答广场",
    key: "answer_square",
    href: "/discover/answer_square/"
  }, {
    text: "论文查重",
    key: "paper_check",
    href: "/station/paper/check/"
  }, {
    text: "校园专题",
    href: "/topic/campus/",
    target: "_blank"
  }]
}, {
  text: "公司",
  key: "company",
  subMenu: [{
    text: "关于我们",
    href: "/about/"
  }, {
    text: "合作伙伴",
    href: "/about/partner/"
  }, {
    text: "商务合作",
    href: "/bd/"
  }, {
    text: "咨询反馈",
    href: "/about/zxzx/"
  }]
}];
const pcFooterConfigOne = [{
  text: "使用场景",
  key: "product",
  type: "sub",
  subMenu: [{
    key: "survey",
    href: "/survey/",
    text: "问卷调查"
  }, {
    key: "satisfaction",
    href: "/satisfaction/",
    text: "满意度调查"
  }, {
    key: "assess",
    href: "/assess/",
    text: "考试测评"
  }, {
    key: "form",
    href: "/form/",
    text: "在线收集表单"
  }, {
    key: "vote",
    href: "/vote/",
    text: "投票评选",
    label: "new-tip-icon"
  }, {
    key: "pay",
    href: "/pay/",
    text: "在线收款"
  }, {
    key: "appraise",
    href: "/appraise/",
    text: "360度评估"
  }]
}, {
  text: "企业服务",
  key: "enterprise",
  type: "sub",
  subMenu: [{
    text: "企业版",
    key: "ent",
    href: "/pro/"
  }, {
    text: "SPSSPRO",
    key: "sps",
    href: "https://www.spsspro.com/?utm_source=wenjuan_footer",
    label: "new-tip-icon",
    target: "_blank"
  }, {
    text: "倍市得CEM",
    key: "bestcem",
    href: "https://www.bestcem.com/?utm_source=wenjuan_footer",
    label: "recommend-tip-icon",
    target: "_blank"
  }, {
    text: "开放平台",
    key: "open",
    href: "https://open.wenjuan.com/",
    target: "_blank"
  }, {
    text: "专业调研服务",
    key: "biz",
    href: "http://biz.wenjuan.com/",
    target: "_blank"
  }, {
    text: "专业样本服务",
    key: "collectPost",
    href: "/sample_service/"
  }, {
    text: "人工服务",
    key: "manualService",
    href: "/service/"
  }]
}, {
  text: "资源",
  key: "resource",
  subMenu: [{
    text: "免费模板",
    key: "lib",
    href: "/lib/"
  }, {
    text: "考试题库",
    key: "question_square",
    href: "/question_square/",
    label: "new-tip-icon"
    // hideInFeiShu: true
  }, {
    text: "经典测试",
    key: "classical_test",
    href: "/classical_test/"
  }, {
    text: "调研专栏",
    key: "content_center",
    href: "/casecenter/articles/"
  }, {
    text: "答题赚钱",
    href: "https://www.idiaoyan.com/desktop_login?type=quick&id=&source=263453&plan=&device=&suid=",
    target: "_blank"
  }, {
    text: "帮助中心",
    key: "help_center",
    href: "/helpcenter/"
  }]
}];
const pcFooterConfigTwo = [{
  text: "版本",
  key: "version",
  hideInMobile: true,
  subMenu: [{
    key: "senior_user",
    href: "/senior_user/",
    text: "版本定价"
  }, {
    key: "app",
    href: "/app/",
    text: "问卷网APP"
  }, {
    text: "企业微信版",
    href: "/wxbusiness/",
    target: "_blank"
  }, {
    text: "钉钉版",
    href: "https://appcenter.dingtalk.com/detail.html?goodsCode=DT_GOODS_881650260477337&sig=919627509847c6e2112690d5168d19e2",
    target: "_blank"
  }, {
    text: "飞书版",
    href: "https://app.feishu.cn/app/cli_9c10807b13b01108",
    target: "_blank"
  }, {
    text: "腾讯会议版",
    href: "https://meeting.tencent.com/marketplace/support-collect-detail?sdk_id=19170189429&page_channel_source=webmarket",
    target: "_blank"
  }, {
    text: "问卷网教师版",
    key: "campus",
    href: "https://campus.wenjuan.com/",
    target: "_blank"
  }]
}, {
  text: "师生服务",
  key: "teacherStudent",
  hideInMobile: true,
  subMenu: [{
    text: "样本收集",
    key: "collectPost",
    href: "/collect_post/"
  }, {
    text: "互答广场",
    key: "answer_square",
    href: "/discover/answer_square/"
  }, {
    text: "论文查重",
    key: "paper_check",
    href: "/station/paper/check/"
  }, {
    text: "校园专题",
    href: "/topic/campus/",
    target: "_blank"
  }]
}, {
  text: "公司",
  key: "company",
  subMenu: [{
    text: "关于我们",
    href: "/about/"
  }, {
    text: "广告合作",
    href: "javascript:void(0);",
    type: "tooltips"
  }, {
    text: "商务合作",
    href: "/bd/"
  }, {
    text: "咨询反馈",
    href: "/about/zxzx/"
  }, {
    text: "友情链接",
    href: "/about/partner/"
  }]
}];
const mobileFooterConfig = [{
  text: "使用场景",
  key: "product",
  type: "sub",
  subMenu: [{
    key: "survey",
    href: "/survey/",
    text: "问卷调查"
  }, {
    key: "satisfaction",
    href: "/satisfaction/",
    text: "满意度调查"
  }, {
    key: "assess",
    href: "/assess/",
    text: "考试测评"
  }, {
    key: "form",
    href: "/form/",
    text: "在线收集表单"
  }, {
    key: "vote",
    href: "/vote/",
    text: "投票评选",
    label: "new-tip-icon"
  }, {
    key: "pay",
    href: "/pay/",
    text: "在线收款"
  }, {
    key: "appraise",
    href: "/appraise/",
    text: "360度评估"
  }]
}, {
  text: "企业服务",
  key: "enterprise",
  type: "sub",
  subMenu: [{
    text: "企业版",
    key: "ent",
    href: "/pro/"
  }, {
    text: "SPSSPRO",
    key: "sps",
    href: "https://www.spsspro.com/?utm_source=wenjuan_footer",
    label: "new-tip-icon",
    target: "_blank"
  }, {
    text: "倍市得CEM",
    key: "bestcem",
    href: "https://www.bestcem.com/?utm_source=wenjuan_footer",
    label: "recommend-tip-icon",
    target: "_blank"
  }, {
    text: "开放平台",
    key: "open",
    href: "https://open.wenjuan.com/",
    target: "_blank"
  }, {
    text: "专业调研服务",
    key: "biz",
    href: "http://biz.wenjuan.com/",
    target: "_blank"
  }, {
    text: "专业样本服务",
    key: "collectPost",
    href: "/sample_service/"
  }, {
    text: "人工服务",
    key: "manualService",
    href: "/service/"
  }]
}, {
  text: "资源",
  key: "resource",
  subMenu: [{
    text: "免费模板",
    key: "lib",
    href: "/lib/"
  }, {
    text: "考试题库",
    key: "question_square",
    href: "/question_square/",
    label: "new-tip-icon"
    // hideInFeiShu: true
  }, {
    text: "经典测试",
    key: "classical_test",
    href: "/classical_test/"
  }, {
    text: "调研专栏",
    key: "content_center",
    href: "/casecenter/articles/"
  }, {
    text: "答题赚钱",
    href: "https://www.idiaoyan.com/desktop_login?type=quick&id=&source=263453&plan=&device=&suid=",
    target: "_blank"
  }, {
    text: "帮助中心",
    key: "help_center",
    href: "/helpcenter/"
  }]
}, {
  text: "公司",
  key: "company",
  subMenu: [{
    text: "关于我们",
    href: "/about/"
  }, {
    text: "广告合作",
    href: "javascript:void(0);",
    type: "tooltips"
  }, {
    text: "商务合作",
    href: "/bd/"
  }, {
    text: "友情链接",
    href: "/about/partner/"
  }]
}];

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dropdown-item.css");

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dropdown-menu.css");

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dropdown.css");

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui/lib/theme-chalk/button.css");

/***/ }),
/* 61 */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = 61;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./enterprise-icon.svg": 63,
	"./header/desktop.svg": 64,
	"./header/phone.svg": 65,
	"./header/right-arrow.svg": 66,
	"./header/weixin.svg": 67,
	"./help-icon.svg": 68,
	"./import-contact/delete-icon.svg": 69,
	"./import-contact/expand-icon.svg": 70,
	"./import-contact/role-icon.svg": 71,
	"./import-contact/search-icon.svg": 72,
	"./preview-refresh.svg": 73,
	"./sms-email-share/contact-icon.svg": 74,
	"./sms-email-share/excel-icon.svg": 75,
	"./sms-email-share/history-icon.svg": 76,
	"./sms-email-share/link-icon.svg": 77,
	"./sms-email-share/link.svg": 78,
	"./sms-email-share/name-icon.svg": 79,
	"./sms-email-share/name.svg": 80,
	"./sms-email-share/triangle.svg": 81,
	"./sms-email-share/upload-icon.svg": 82,
	"./video-player/back.svg": 83,
	"./video-player/loading.svg": 84,
	"./video-player/muted.svg": 85,
	"./video-player/no-muted.svg": 86,
	"./video-player/player.svg": 87,
	"./warning-icon.svg": 88,
	"./warning.svg": 89,
	"./wenwen-ai/arrow-right.svg": 90,
	"./wenwen-ai/close.svg": 91,
	"./wenwen-ai/history-loading.svg": 92,
	"./wenwen-ai/more.svg": 93,
	"./wenwen-ai/pdf.svg": 94,
	"./wenwen-ai/send-solid.svg": 95,
	"./wenwen-ai/success.svg": 96,
	"./wenwen-ai/waiting.svg": 97,
	"./wenwen-ai/warning.svg": 98,
	"./wenwen-ai/word.svg": 99,
	"./wenwen-ai/xls.svg": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"66\" height=\"20\" viewBox=\"0 0 66 20\"><defs><clipPath id=\"master_svg0_169_5055\"><rect x=\"0\" y=\"0\" width=\"66\" height=\"20\" rx=\"0\"></rect></clipPath><linearGradient x1=\"1\" y1=\"1\" x2=\"-0.469696968793869\" y2=\"-0.6499999761581421\" id=\"master_svg1_1_1992\"><stop offset=\"0%\" stop-color=\"#E7B56C\" stop-opacity=\"1\"></stop><stop offset=\"100%\" stop-color=\"#F6E5A6\" stop-opacity=\"1\"></stop></linearGradient></defs><g clip-path=\"url(#master_svg0_169_5055)\"><g><path d=\"M10,9.09495e-13L56,9.09495e-13C61.5228,9.09495e-13,66,4.47715,66,10C66,15.5228,61.5228,20,56,20L10,20C4.47715,20,0,15.5228,0,10C0,4.47715,4.47715,9.09495e-13,10,9.09495e-13\" fill-rule=\"evenodd\" fill=\"url(#master_svg1_1_1992)\" fill-opacity=\"1\"></path></g><g><path d=\"M28.000000442504884,5.191999931335449C26.728000442504882,6.727999931335449,25.036000442504882,8.047999931335449,22.94800044250488,9.16399993133545L22.336000442504883,8.05999993133545C24.436000442504884,7.027999931335449,26.188000442504883,5.73199993133545,27.580000442504883,4.171999931335449L28.420000442504882,4.171999931335449C29.932000442504883,5.815999931335449,31.66000044250488,7.111999931335449,33.628000442504884,8.047999931335449L33.00400044250488,9.15199993133545Q30.070000442504885,7.639999931335449,28.000000442504884,5.191999931335449ZM52.64800044250488,15.271999931335449C53.512000442504885,14.803999931335449,54.256000442504885,14.21599993133545,54.88000044250488,13.51999993133545C55.45600044250488,14.239999931335449,56.164000442504886,14.82799993133545,57.01600044250488,15.259999931335448L57.58000044250488,14.26399993133545C56.80000044250488,13.867999931335449,56.140000442504885,13.303999931335449,55.588000442504885,12.58399993133545C56.308000442504884,11.479999931335449,56.78800044250488,10.12399993133545,57.052000442504884,8.53999993133545L57.052000442504884,7.567999931335449L52.67200044250488,7.567999931335449L52.67200044250488,5.971999931335449C54.37600044250488,5.899999931335449,55.91200044250488,5.659999931335449,57.304000442504886,5.251999931335449L56.75200044250488,4.231997531335449C55.240000442504886,4.711997931335449,53.536000442504886,4.963997931335449,51.628000442504884,4.999997931335449L51.628000442504884,9.65599993133545C51.58000044250488,11.647999931335448,51.268000442504885,13.21999993133545,50.66800044250488,14.34799993133545L51.44800044250488,15.175999931335449C52.21600044250488,13.807999931335448,52.62400044250488,11.95999993133545,52.67200044250488,9.65599993133545L52.67200044250488,8.647999931335448L52.94800044250488,8.647999931335448C53.18800044250489,10.18399993133545,53.60800044250488,11.479999931335449,54.22000044250488,12.547999931335449C53.64400044250488,13.21999993133545,52.94800044250488,13.79599993133545,52.10800044250488,14.26399993133545L52.64800044250488,15.271999931335449ZM45.35200044250488,14.803999931335449L45.35200044250488,13.68797993133545L41.84800044250488,13.68797993133545L41.84800044250488,4.2559843313354495L40.70800044250488,4.2559843313354495L40.70800044250488,13.68797993133545L39.268000442504885,13.68797993133545L39.268000442504885,4.2559843313354495L38.128000442504884,4.2559843313354495L38.128000442504884,13.68797993133545L34.64800044250488,13.68797993133545L34.64800044250488,14.803999931335449L45.35200044250488,14.803999931335449ZM50.60800044250488,15.18799993133545L50.60800044250488,9.919989931335449L48.304000442504886,9.919989931335449C48.31600044250489,9.60799993133545,48.32800044250489,9.28399993133545,48.32800044250489,8.947999931335449L48.32800044250489,8.49198993133545L51.02800044250488,8.49198993133545L51.02800044250488,7.37599993133545L50.45200044250488,7.37599993133545L50.45200044250488,4.2919949313354495L49.33600044250488,4.2919949313354495L49.33600044250488,7.37599993133545L48.32800044250489,7.37599993133545L48.32800044250489,4.531994931335449L47.21200044250489,4.531994931335449L47.21200044250489,8.947999931335449C47.20000044250489,11.39599993133545,46.936000442504884,13.17199993133545,46.43200044250489,14.29999993133545L47.296000442504884,15.043999931335449C47.77600044250488,14.10799993133545,48.10000044250488,12.76399993133545,48.244000442504884,11.01198993133545L49.49200044250488,11.01198993133545L49.49200044250488,15.18799993133545L50.60800044250488,15.18799993133545ZM36.448000442504885,12.23598993133545L37.49200044250488,11.97198993133545C37.012000442504885,9.90798993133545,36.47200044250488,8.071989931335448,35.860000442504884,6.463989931335449L34.88800044250488,6.775989931335449C35.512000442504885,8.52798993133545,36.04000044250488,10.35198993133545,36.448000442504885,12.23598993133545ZM43.33600044250488,12.18797993133545C44.05600044250488,10.63997993133545,44.64400044250488,8.83997993133545,45.10000044250488,6.775979931335449L44.09200044250488,6.487979931335449C43.58800044250488,8.647979931335449,42.988000442504884,10.43597993133545,42.31600044250489,11.827979931335449L43.33600044250488,12.18797993133545ZM32.95600044250488,13.700029931335449L32.95600044250488,14.803999931335449L22.90002644250488,14.803999931335449L22.90002644250488,13.700029931335449L24.628030442504883,13.700029931335449L24.628030442504883,9.12802993133545L25.756030442504883,9.12802993133545L25.756030442504883,13.700029931335449L27.77203044250488,13.700029931335449L27.77203044250488,7.40002993133545L28.912030442504882,7.40002993133545L28.912030442504882,9.96802993133545L32.092030442504885,9.96802993133545L32.092030442504885,11.06002993133545L28.912030442504882,11.06002993133545L28.912030442504882,13.700029931335449L32.95600044250488,13.700029931335449ZM54.92800044250488,11.54000993133545C54.49600044250488,10.724009931335448,54.18400044250488,9.752009931335449,53.96800044250489,8.648009931335448L55.960000442504885,8.648009931335448C55.768000442504885,9.72800993133545,55.420000442504886,10.688009931335449,54.92800044250488,11.54000993133545Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g><path d=\"M15.36933,5C15.57347,5.0000226626,15.76071,5.106426,15.85531,5.276175L17.9376,8.42522C18.0426,8.61379,18.013199999999998,8.84357,17.863500000000002,9.00338L12.41188,14.82509C12.30777,14.93627,12.15767,15,11.999939999999999,15C11.84221,15,11.69212,14.93627,11.588000000000001,14.82509L6.136415,9.00338C5.9867657,8.84354,5.9573779,8.61375,6.062472,8.42522L8.14476,5.276175C8.23936,5.106426,8.4266,5.000022667,8.63074,5L15.36933,5ZM9.588239999999999,7.35297Q9.5303,7.35297,9.47348,7.364269999999999Q9.41665,7.37557,9.36313,7.397740000000001Q9.3096,7.41991,9.26143,7.4521Q9.21326,7.48429,9.17229,7.525259999999999Q9.13132,7.5662199999999995,9.09913,7.6144Q9.06695,7.6625700000000005,9.04478,7.7160899999999994Q9.0226,7.76962,9.0113,7.82644Q9,7.8832699999999996,9,7.9412Q9,7.999140000000001,9.0113,8.055959999999999Q9.0226,8.11278,9.04478,8.16631Q9.06695,8.21984,9.09913,8.26801Q9.13132,8.31618,9.17229,8.35715Q9.21326,8.398109999999999,9.26143,8.430299999999999Q9.3096,8.462489999999999,9.36313,8.48466Q9.41665,8.50683,9.47348,8.51813Q9.5303,8.529440000000001,9.588239999999999,8.529440000000001L14.41176,8.529440000000001Q14.4697,8.529440000000001,14.52652,8.51813Q14.58335,8.50683,14.63687,8.48466Q14.6904,8.462489999999999,14.73857,8.430299999999999Q14.78674,8.398109999999999,14.82771,8.35715Q14.86868,8.31618,14.90086,8.26801Q14.93305,8.21984,14.95522,8.16631Q14.97739,8.11278,14.9887,8.055959999999999Q15,7.999140000000001,15,7.9412Q15,7.8832699999999996,14.9887,7.82644Q14.97739,7.76962,14.95522,7.7160899999999994Q14.93305,7.6625700000000005,14.90086,7.6144Q14.86868,7.5662199999999995,14.82771,7.525259999999999Q14.78674,7.48429,14.73857,7.4521Q14.6904,7.41991,14.63687,7.397740000000001Q14.58335,7.37557,14.52652,7.364269999999999Q14.4697,7.35297,14.41176,7.35297L9.588239999999999,7.35297Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"15\" height=\"14.25\" viewBox=\"0 0 15 14.25\"><path d=\"M11.25 12.75h-7.5v1.5h7.5v-1.5zM.744 11.25h13.512a.755.755 0 0 0 .744-.755V.755A.749.749 0 0 0 14.256 0H.744A.755.755 0 0 0 0 .755v9.74a.749.749 0 0 0 .744.755zm8.79-5.65H8V2.9a.4.4 0 0 0-.4-.4h-.2a.4.4 0 0 0-.4.4v2.7H5.466a.4.4 0 0 0-.283.683l2.034 2.034a.4.4 0 0 0 .566 0l2.034-2.034a.4.4 0 0 0-.283-.683z\" fill-rule=\"evenodd\" fill=\"currentColor\"></path></svg>"

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"10\" height=\"14\" viewBox=\"0 0 10 14\"><g><path d=\"M9,0C9.55229,0,10,0.447715,10,1L10,13C10,13.5523,9.55229,14,9,14L1,14C0.447715,14,0,13.5523,0,13L0,1C0,0.447715,0.447715,0,1,0L9,0ZM8.8002,1.20001L1.2002,1.20001L1.2002,9L8.8002,9L8.8002,1.20001ZM8.8002,10.2L1.2002,10.2L1.2002,12.8L8.8002,12.8L8.8002,10.2ZM5.1001,10.65Q5.02623,10.65,4.95378,10.6644Q4.88133,10.6788,4.81308,10.7071Q4.74484,10.7354,4.68342,10.7764Q4.622,10.8174,4.56977,10.8697Q4.51753,10.9219,4.4765,10.9833Q4.43546,11.0447,4.40719,11.113Q4.37892,11.1812,4.36451,11.2537Q4.3501,11.3261,4.3501,11.4Q4.3501,11.4739,4.36451,11.5463Q4.37892,11.6188,4.40719,11.687Q4.43546,11.7553,4.4765,11.8167Q4.51753,11.8781,4.56977,11.9303Q4.622,11.9826,4.68342,12.0236Q4.74484,12.0646,4.81308,12.0929Q4.88133,12.1212,4.95378,12.1356Q5.02623,12.15,5.1001,12.15Q5.17397,12.15,5.24642,12.1356Q5.31886,12.1212,5.38711,12.0929Q5.45536,12.0646,5.51678,12.0236Q5.57819,11.9826,5.63043,11.9303Q5.68266,11.8781,5.7237,11.8167Q5.76474,11.7553,5.79301,11.687Q5.82128,11.6188,5.83569,11.5463Q5.8501,11.4739,5.8501,11.4Q5.8501,11.3261,5.83569,11.2537Q5.82128,11.1812,5.79301,11.113Q5.76474,11.0447,5.7237,10.9833Q5.68266,10.9219,5.63043,10.8697Q5.57819,10.8174,5.51677,10.7764Q5.45536,10.7354,5.38711,10.7071Q5.31886,10.6788,5.24642,10.6644Q5.17397,10.65,5.1001,10.65Z\" fill-rule=\"evenodd\" fill=\"currentColor\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"a\"><rect width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#a)\"><path d=\"M6.556 10.314a.614.614 0 0 1-.88 0 .622.622 0 0 1 0-.867L8.065 7 5.676 4.553a.622.622 0 0 1 0-.867.614.614 0 0 1 .88 0L9.324 6.52A.62.62 0 0 1 9.499 7a.62.62 0 0 1-.175.479l-2.768 2.835z\" fill-rule=\"evenodd\" fill=\"#333\"></path></g></svg>"

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"14\" height=\"12\" viewBox=\"0 0 14 12\"><path d=\"M5.12 0c2.328 0 4.42 1.41 5.043 3.369l.06.211.14.021c1.909.325 3.423 1.788 3.616 3.548l.016.19.005.19c0 .967-.466 1.92-1.312 2.739l-.198.181.232.8a.598.598 0 0 1-.058.473l-.056.079-.07.07a.552.552 0 0 1-.539.097l-.086-.04-1.058-.598-.09.024a5.78 5.78 0 0 1-.887.162l-.155.01-.156.003c-1.673 0-3.176-.846-3.93-2.146l-.099-.18-.022-.045-.16.011-.236.006a5.03 5.03 0 0 1-.885-.082l-.633-.127-1.42.735-.081.034-.084.02-.086.007a.556.556 0 0 1-.37-.143.594.594 0 0 1-.187-.526l.022-.097.327-1.018-.19-.163C.658 7.027.141 6.08.025 5.04l-.019-.225L0 4.587C0 2.044 2.308 0 5.12 0zM1.127 4.587c0-1.872 1.78-3.422 3.993-3.422l.21.004c1.665.074 3.128 1.025 3.669 2.315l.03.08-.156.019c-2.114.3-3.746 1.946-3.746 3.947l.008.233c.005.078.013.155.024.233l.001.012h-.155a7.416 7.416 0 0 1-.711-.072q-.198-.034-.716-.168l-1.092.68.23-1.15-.2-.156c-.93-.733-1.39-1.586-1.39-2.555zm1.707-1.414c0-.411.378-.71.806-.71.408 0 .687.287.687.71 0 .42-.28.71-.687.71-.426 0-.806-.302-.806-.71zm3.098 0c0-.411.376-.71.804-.71.41 0 .69.287.69.71 0 .42-.283.71-.69.71-.426 0-.803-.302-.804-.71zm.323 4.356c0-1.547 1.474-2.834 3.313-2.834 1.8 0 3.305 1.317 3.305 2.834 0 .733-.454 1.515-1.306 2.197q.001-.002.154 1.056l-.963-.624-.35.087-.281.06c-.213.042-.38.059-.56.059-1.838 0-3.312-1.287-3.312-2.835zm1.457-1.057c0-.317.292-.62.599-.62.397 0 .711.28.711.62 0 .34-.313.618-.711.618-.307 0-.599-.3-.599-.618zm2.468 0c0-.316.29-.62.595-.62.397 0 .714.28.714.62 0 .34-.317.618-.714.618-.305 0-.595-.301-.595-.618z\" fill-rule=\"evenodd\" fill=\"currentColor\"></path></svg>"

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_169_5073\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_169_5073)\"><g><path d=\"M6.999986494140625,12.833371752929688C3.778236494140625,12.833371752929688,1.166656494140625,10.221751752929688,1.166656494140625,7.000001752929688C1.166656494140625,3.7782517529296875,3.778236494140625,1.1666717529296875,6.999986494140625,1.1666717529296875C10.221736494140625,1.1666717529296875,12.833356494140626,3.7782517529296875,12.833356494140626,7.000001752929688C12.833356494140626,10.221751752929688,10.221736494140625,12.833371752929688,6.999986494140625,12.833371752929688ZM6.999986494140625,11.666671752929688C9.577316494140625,11.666671752929688,11.666656494140625,9.577331752929688,11.666656494140625,7.000001752929688C11.666656494140625,4.422671752929688,9.577316494140625,2.3333417529296874,6.999986494140625,2.3333417529296874C4.422656494140625,2.3333417529296874,2.333326494140625,4.422671752929688,2.333326494140625,7.000001752929688C2.333326494140625,9.577331752929688,4.422656494140625,11.666671752929688,6.999986494140625,11.666671752929688ZM6.416656494140625,8.750001752929688L7.583326494140625,8.750001752929688L7.583326494140625,9.916671752929688L6.416656494140625,9.916671752929688L6.416656494140625,8.750001752929688ZM7.583326494140625,7.790421752929688L7.583326494140625,8.166671752929688L6.416656494140625,8.166671752929688L6.416656494140625,7.2916717529296875C6.416656494140625,6.969501752929688,6.677826494140625,6.708341752929687,6.999986494140625,6.708341752929687C7.460906494140625,6.708311752929688,7.842776494140625,6.3507217529296875,7.873046494140625,5.890801752929687C7.903316494140625,5.430871752929687,7.571606494140625,5.026331752929687,7.114666494140625,4.9658917529296875C6.657726494140625,4.905461752929687,6.232246494140625,5.209861752929688,6.141906494140625,5.661841752929687L4.997406494140625,5.432591752929688C5.193686494140625,4.451561752929687,6.071756494140625,3.7571717529296875,7.071616494140625,3.7922717529296874C8.071466494140626,3.8273617529296877,8.898686494140625,4.581621752929688,9.025696494140625,5.573991752929688C9.152706494140624,6.566371752929688,8.542106494140626,7.504641752929688,7.583326494140625,7.790421752929688Z\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><g style=\"mix-blend-mode:passthrough\"><path d=\"M7,14Q7.17184,14,7.34347,13.9916Q7.51511,13.9831,7.68612,13.9663Q7.85713,13.9494,8.02711,13.9242Q8.19709,13.899,8.36563,13.8655Q8.53417,13.832,8.70086,13.7902Q8.86755,13.7485,9.03199,13.6986Q9.19643,13.6487,9.35823,13.5908Q9.52002,13.5329,9.67878,13.4672Q9.83754,13.4014,9.99288,13.3279Q10.1482,13.2545,10.2998,13.1734Q10.4513,13.0924,10.5987,13.0041Q10.7461,12.9158,10.889,12.8203Q11.0319,12.7248,11.1699,12.6225Q11.3079,12.5201,11.4408,12.4111Q11.5736,12.3021,11.7009,12.1867Q11.8282,12.0713,11.9497,11.9497Q12.0713,11.8282,12.1867,11.7009Q12.3021,11.5736,12.4111,11.4408Q12.5201,11.3079,12.6225,11.1699Q12.7248,11.0319,12.8203,10.889Q12.9158,10.7461,13.0041,10.5987Q13.0924,10.4513,13.1734,10.2998Q13.2545,10.1482,13.3279,9.99288Q13.4014,9.83754,13.4672,9.67878Q13.5329,9.52002,13.5908,9.35823Q13.6487,9.19643,13.6986,9.03199Q13.7485,8.86755,13.7902,8.70086Q13.832,8.53417,13.8655,8.36563Q13.899,8.19709,13.9242,8.02711Q13.9494,7.85713,13.9663,7.68612Q13.9831,7.51511,13.9916,7.34347Q14,7.17184,14,7Q14,6.82816,13.9916,6.65653Q13.9831,6.48489,13.9663,6.31388Q13.9494,6.14287,13.9242,5.97289Q13.899,5.80291,13.8655,5.63437Q13.832,5.46583,13.7902,5.29914Q13.7485,5.13245,13.6986,4.96801Q13.6487,4.80357,13.5908,4.64177Q13.5329,4.47998,13.4672,4.32122Q13.4014,4.16246,13.3279,4.00711Q13.2545,3.85177,13.1734,3.70022Q13.0924,3.54867,13.0041,3.40128Q12.9158,3.25389,12.8203,3.11101Q12.7248,2.96813,12.6225,2.8301Q12.5201,2.69208,12.4111,2.55925Q12.3021,2.42641,12.1867,2.29909Q12.0713,2.17176,11.9497,2.05025Q11.8282,1.92874,11.7009,1.81334Q11.5736,1.69794,11.4408,1.58893Q11.3079,1.47991,11.1699,1.37755Q11.0319,1.27518,10.889,1.17971Q10.7461,1.08424,10.5987,0.9959Q10.4513,0.907556,10.2998,0.826551Q10.1482,0.745546,9.99288,0.672075Q9.83754,0.598604,9.67878,0.532843Q9.52002,0.467083,9.35823,0.409191Q9.19643,0.3513,9.03199,0.301418Q8.86755,0.251535,8.70086,0.209781Q8.53417,0.168027,8.36563,0.134503Q8.19709,0.100979,8.02711,0.0757644Q7.85713,0.0505502,7.68612,0.0337069Q7.51511,0.0168636,7.34347,0.0084318Q7.17184,0,7,0Q6.82816,0,6.65653,0.0084318Q6.48489,0.0168636,6.31388,0.0337069Q6.14287,0.0505502,5.97289,0.0757644Q5.80291,0.100979,5.63437,0.134503Q5.46583,0.168027,5.29914,0.209781Q5.13245,0.251535,4.96801,0.301418Q4.80357,0.3513,4.64177,0.409191Q4.47998,0.467083,4.32122,0.532843Q4.16246,0.598604,4.00711,0.672075Q3.85177,0.745546,3.70022,0.826551Q3.54867,0.907556,3.40128,0.995899Q3.25389,1.08424,3.11101,1.17971Q2.96813,1.27518,2.8301,1.37755Q2.69208,1.47991,2.55925,1.58893Q2.42641,1.69794,2.29909,1.81334Q2.17176,1.92874,2.05025,2.05025Q1.92874,2.17176,1.81334,2.29909Q1.69794,2.42641,1.58893,2.55925Q1.47991,2.69208,1.37755,2.8301Q1.27518,2.96813,1.17971,3.11101Q1.08424,3.25389,0.9959,3.40128Q0.907556,3.54867,0.826551,3.70022Q0.745546,3.85177,0.672075,4.00711Q0.598604,4.16246,0.532843,4.32122Q0.467083,4.47998,0.409191,4.64177Q0.3513,4.80357,0.301418,4.96801Q0.251535,5.13245,0.209781,5.29914Q0.168027,5.46583,0.134503,5.63437Q0.100979,5.80291,0.0757644,5.97289Q0.0505502,6.14287,0.0337069,6.31388Q0.0168636,6.48489,0.0084318,6.65653Q0,6.82816,0,7Q0,7.17184,0.0084318,7.34347Q0.0168636,7.51511,0.0337069,7.68612Q0.0505502,7.85713,0.0757644,8.02711Q0.100979,8.19709,0.134503,8.36563Q0.168027,8.53417,0.209781,8.70086Q0.251535,8.86755,0.301418,9.03199Q0.3513,9.19643,0.409191,9.35823Q0.467083,9.52002,0.532843,9.67878Q0.598604,9.83754,0.672075,9.99288Q0.745546,10.1482,0.826551,10.2998Q0.907556,10.4513,0.995899,10.5987Q1.08424,10.7461,1.17971,10.889Q1.27518,11.0319,1.37755,11.1699Q1.47991,11.3079,1.58893,11.4408Q1.69794,11.5736,1.81334,11.7009Q1.92874,11.8282,2.05025,11.9497Q2.17176,12.0713,2.29909,12.1867Q2.42641,12.3021,2.55925,12.4111Q2.69208,12.5201,2.8301,12.6225Q2.96813,12.7248,3.11101,12.8203Q3.25389,12.9158,3.40128,13.0041Q3.54867,13.0924,3.70022,13.1734Q3.85177,13.2545,4.00711,13.3279Q4.16246,13.4014,4.32122,13.4672Q4.47998,13.5329,4.64177,13.5908Q4.80357,13.6487,4.96801,13.6986Q5.13245,13.7485,5.29914,13.7902Q5.46583,13.832,5.63437,13.8655Q5.80291,13.899,5.97289,13.9242Q6.14287,13.9494,6.31388,13.9663Q6.48489,13.9831,6.65653,13.9916Q6.82816,14,7,14ZM9.45093,4.54907C9.68298,4.78112,9.68298,5.15735,9.45093,5.3894L7.84033,7L9.451,8.61067C9.68305,8.84272,9.68305,9.21894,9.451,9.45099C9.21895,9.68305,8.84272,9.68305,8.61067,9.45099L7,7.84033L5.38933,9.45099C5.15728,9.68305,4.78105,9.68305,4.549,9.45099C4.31695,9.21894,4.31695,8.84272,4.549,8.61067L6.15967,7L4.54907,5.3894C4.31702,5.15735,4.31702,4.78112,4.54907,4.54907C4.78112,4.31702,5.15735,4.31702,5.3894,4.54907L7,6.15967L8.6106,4.54907C8.84265,4.31702,9.21888,4.31702,9.45093,4.54907Z\" fill-rule=\"evenodd\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\"><g style=\"mix-blend-mode:passthrough\" transform=\"matrix(0,1,-1,0,18,-18)\"><g><rect x=\"18\" y=\"0\" width=\"18\" height=\"18\" rx=\"0\" fill=\"#FFFFFF\" fill-opacity=\"0.009999999776482582\"></rect></g><g><path d=\"M25,7L29,9.5L25,12L25,7Z\" fill=\"#666666\" fill-opacity=\"1\"></path><path d=\"M24,12L24,7Q24,6.9015086,24.019215,6.80491Q24.038429999999998,6.708311,24.076121,6.617317Q24.113812,6.526322,24.16853,6.44443Q24.223249,6.362537,24.292893,6.292893Q24.362537,6.223249,24.44443,6.16853Q24.526322,6.113812,24.617317,6.076121Q24.708311,6.03843,24.80491,6.019215Q24.9015086,6,25,6Q25.286796,6,25.529999,6.1520019999999995L29.53,8.652Q29.61352,8.7042,29.68525,8.77169Q29.75698,8.83918,29.81417,8.91937Q29.87136,8.99956,29.9118,9.08937Q29.95224,9.17917,29.97439,9.27514Q29.99654,9.37111,29.99954,9.46956Q30.00253,9.568,29.98627,9.665140000000001Q29.97,9.76228,29.9351,9.854379999999999Q29.900199999999998,9.946480000000001,29.848,10.03Q29.72569,10.22569,29.53,10.347999999999999L25.529999,12.847999999999999Q25.446478,12.9002,25.354379,12.9351Q25.262279,12.97001,25.16514,12.986270000000001Q25.0680012,13.00253,24.9695554,12.99954Q24.87111,12.99654,24.775141,12.97439Q24.679171,12.95224,24.589367,12.9118Q24.499562,12.87136,24.419374,12.81417Q24.339185,12.75698,24.271693,12.68525Q24.204202,12.613520000000001,24.152002,12.530000000000001Q24,12.2868,24,12ZM26,12L25,12L24.470001,11.152000000000001L28.47,8.652L29,9.5L28.47,10.347999999999999L24.470001,7.8479980000000005L25,7L26,7L26,12Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><g><path d=\"M8,0C12.416,0,16,3.584,16,8C16,12.416,12.416,16,8,16C3.584,16,0,12.416,0,8C0,3.584,3.584,0,8,0ZM3.2184,10.7328C4.3928,12.4848,6.156,13.6,8.128,13.6C10.0992,13.6,11.8632,12.4856,13.0368,10.7328C11.7054,9.48848,9.95036,8.79745,8.128,8.8C6.30537,8.79724,4.55001,9.48829,3.2184,10.7328ZM8,7.2C9.32548,7.2,10.4,6.12548,10.4,4.8C10.4,3.47452,9.32548,2.4,8,2.4C6.67452,2.4,5.6,3.47452,5.6,4.8C5.6,6.12548,6.67452,7.2,8,7.2Z\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><defs><clipPath id=\"master_svg0_95_06837/1_24458\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"24\" rx=\"0\"></rect></clipPath></defs><g style=\"mix-blend-mode:passthrough\" clip-path=\"url(#master_svg0_95_06837/1_24458)\"><g style=\"mix-blend-mode:passthrough\"><path d=\"M14.84759,15.7002Q14.44664,16.028,13.99569,16.282600000000002Q13.54473,16.537100000000002,13.05698,16.711100000000002Q12.569230000000001,16.8851,12.058959999999999,16.973399999999998Q11.548680000000001,17.061700000000002,11.03083,17.061700000000002Q10.88278,17.061700000000002,10.73491,17.0544Q10.58704,17.0471,10.43971,17.032600000000002Q10.29237,17.0181,10.14593,16.9964Q9.99948,16.9747,9.85427,16.9458Q9.70907,16.9169,9.56546,16.8809Q9.42185,16.845,9.28017,16.802Q9.1385,16.759,8.99911,16.7091Q8.85971,16.6592,8.72293,16.602600000000002Q8.58615,16.5459,8.45232,16.482599999999998Q8.318480000000001,16.4193,8.18792,16.3495Q8.05735,16.2798,7.93036,16.2036Q7.803380000000001,16.127499999999998,7.68028,16.045299999999997Q7.55718,15.963,7.43827,15.8748Q7.31936,15.7866,7.20491,15.6927Q7.09047,15.5988,6.98077,15.4994Q6.87108,15.4,6.7663899999999995,15.2953Q6.6617,15.1906,6.5622799999999994,15.0809Q6.46286,14.97119,6.36894,14.85675Q6.27501,14.74231,6.18682,14.62339Q6.09863,14.50448,6.01638,14.38138Q5.934127,14.25828,5.858015,14.1313Q5.781902,14.00431,5.712113,13.87374Q5.642323,13.74318,5.579024,13.60934Q5.515725,13.47551,5.45907,13.33873Q5.402414,13.20195,5.352538,13.06256Q5.302662,12.92316,5.259686,12.78149Q5.216709,12.63982,5.180736,12.4962Q5.144764,12.35259,5.115881,12.20739Q5.0869979,12.06218,5.0652746,11.91574Q5.0435514,11.76929,5.0290401,11.62196Q5.0145288,11.47462,5.0072644,11.32675Q5,11.17888,5,11.03083Q5,10.88278,5.0072644,10.73491Q5.0145288,10.58704,5.0290401,10.43971Q5.0435514,10.29237,5.0652746,10.14593Q5.0869979,9.99948,5.115881,9.85427Q5.144764,9.70907,5.180736,9.56546Q5.216709,9.42185,5.259686,9.28017Q5.302662,9.1385,5.352538,8.99911Q5.402414,8.85971,5.45907,8.72293Q5.515725,8.58615,5.579024,8.45232Q5.642323,8.318480000000001,5.712113,8.18792Q5.781902,8.05735,5.858015,7.93036Q5.934127,7.803380000000001,6.01638,7.68028Q6.09863,7.55718,6.18682,7.43827Q6.27501,7.31936,6.36894,7.20491Q6.46286,7.09047,6.5622799999999994,6.98077Q6.6617,6.87108,6.7663899999999995,6.7663899999999995Q6.87108,6.6617,6.98077,6.5622799999999994Q7.09047,6.46286,7.20491,6.36894Q7.31936,6.27501,7.43827,6.18682Q7.55718,6.09863,7.68028,6.01638Q7.803380000000001,5.934127,7.93036,5.858015Q8.05735,5.781902,8.18792,5.712113Q8.318480000000001,5.642323,8.45232,5.579024Q8.58615,5.515725,8.72293,5.45907Q8.85971,5.402414,8.99911,5.352538Q9.1385,5.302662,9.28017,5.259686Q9.42185,5.216709,9.56546,5.180736Q9.70907,5.144764,9.85427,5.115881Q9.99948,5.0869979,10.14592,5.0652746Q10.29237,5.0435514,10.43971,5.0290401Q10.58704,5.0145288,10.73491,5.0072644Q10.88278,5,11.03083,5Q11.17888,5,11.32675,5.0072644Q11.47462,5.0145288,11.62196,5.0290401Q11.76929,5.0435514,11.91574,5.0652746Q12.06218,5.0869979,12.20739,5.115881Q12.35259,5.144764,12.4962,5.180736Q12.63981,5.216709,12.78149,5.259686Q12.92316,5.302662,13.06256,5.352538Q13.20195,5.402414,13.33873,5.45907Q13.47551,5.515725,13.60934,5.579024Q13.74318,5.642323,13.87374,5.712113Q14.00431,5.781902,14.1313,5.858015Q14.25828,5.934127,14.38138,6.01638Q14.50448,6.09863,14.62339,6.18682Q14.74231,6.27501,14.85675,6.36894Q14.97119,6.46286,15.0809,6.5622799999999994Q15.1906,6.6617,15.2953,6.7663899999999995Q15.4,6.87108,15.4994,6.98077Q15.5988,7.09047,15.6927,7.20491Q15.7866,7.31936,15.8748,7.43827Q15.963,7.55718,16.045299999999997,7.68028Q16.127499999999998,7.803380000000001,16.2036,7.93036Q16.2798,8.05735,16.349600000000002,8.18792Q16.4193,8.318480000000001,16.482599999999998,8.45232Q16.5459,8.58615,16.602600000000002,8.72293Q16.6592,8.85971,16.7091,8.99911Q16.759,9.1385,16.802,9.28017Q16.845,9.42185,16.8809,9.56546Q16.9169,9.70907,16.9458,9.85427Q16.9747,9.99948,16.9964,10.14592Q17.0181,10.29237,17.032600000000002,10.43971Q17.0471,10.58704,17.0544,10.73491Q17.061700000000002,10.88278,17.061700000000002,11.03083Q17.061700000000002,11.548639999999999,16.973399999999998,12.058869999999999Q16.8851,12.569099999999999,16.711199999999998,13.05682Q16.5372,13.54453,16.2827,13.99546Q16.028100000000002,14.44638,15.7005,14.84732L18.8234,17.9703C19.0589,18.2058,19.0589,18.587600000000002,18.8234,18.8231C18.614,19.0325,18.289099999999998,19.055799999999998,18.054000000000002,18.892899999999997L17.9705,18.8231L14.84759,15.7002ZM15.8554,11.030719999999999Q15.8554,11.14916,15.8496,11.26746Q15.8438,11.38575,15.8322,11.50362Q15.8205,11.62149,15.8032,11.73865Q15.7858,11.8558,15.7627,11.971969999999999Q15.7396,12.08813,15.7108,12.20302Q15.682,12.317910000000001,15.6476,12.43125Q15.6133,12.54459,15.5734,12.6561Q15.5335,12.76762,15.4881,12.877040000000001Q15.4428,12.986460000000001,15.3922,13.09353Q15.3415,13.2006,15.2857,13.30505Q15.2299,13.4095,15.169,13.51109Q15.1081,13.61268,15.0423,13.71116Q14.97648,13.80964,14.90593,13.90477Q14.83537,13.9999,14.76024,14.09146Q14.6851,14.18301,14.60556,14.27077Q14.52602,14.35852,14.44227,14.44227Q14.35852,14.52602,14.27077,14.60556Q14.18301,14.6851,14.09146,14.76024Q13.9999,14.83537,13.90477,14.90593Q13.80964,14.97648,13.71116,15.0423Q13.61268,15.1081,13.51109,15.169Q13.4095,15.2299,13.30505,15.2857Q13.2006,15.3415,13.09353,15.3922Q12.986460000000001,15.4428,12.877040000000001,15.4881Q12.76762,15.5335,12.6561,15.5734Q12.54459,15.6133,12.43125,15.6476Q12.317910000000001,15.682,12.20302,15.7108Q12.08813,15.7396,11.971969999999999,15.7627Q11.8558,15.7858,11.73865,15.8032Q11.62149,15.8205,11.50362,15.8322Q11.38575,15.8438,11.26746,15.8496Q11.14916,15.8554,11.030719999999999,15.8554Q10.912279999999999,15.8554,10.79399,15.8496Q10.67569,15.8438,10.55782,15.8322Q10.43995,15.8205,10.322790000000001,15.8032Q10.205639999999999,15.7858,10.08947,15.7627Q9.97331,15.7396,9.858419999999999,15.7108Q9.74353,15.682,9.630189999999999,15.6476Q9.51685,15.6133,9.405339999999999,15.5734Q9.29382,15.5335,9.1844,15.4881Q9.07498,15.4428,8.96791,15.3922Q8.86084,15.3415,8.75639,15.2857Q8.65193,15.2299,8.55035,15.169Q8.44876,15.1081,8.35028,15.0423Q8.2518,14.97648,8.15667,14.90593Q8.06154,14.83537,7.96998,14.76024Q7.87843,14.6851,7.79067,14.60556Q7.702920000000001,14.52602,7.61917,14.44227Q7.53542,14.35852,7.4558800000000005,14.27077Q7.37634,14.18301,7.3012,14.09146Q7.22607,13.9999,7.15551,13.90477Q7.084960000000001,13.80964,7.019159999999999,13.71116Q6.95336,13.61268,6.89247,13.51109Q6.83158,13.4095,6.77575,13.30505Q6.7199100000000005,13.2006,6.66927,13.09353Q6.61863,12.986460000000001,6.57331,12.877040000000001Q6.52799,12.76762,6.48808,12.6561Q6.44818,12.54459,6.4138,12.43125Q6.37942,12.317910000000001,6.35064,12.20302Q6.3218700000000005,12.08813,6.29876,11.971969999999999Q6.27565,11.8558,6.2582699999999996,11.73865Q6.2409,11.62149,6.22929,11.50362Q6.21768,11.38575,6.21187,11.26746Q6.20605,11.14916,6.20605,11.030719999999999Q6.20605,10.912279999999999,6.21187,10.79399Q6.21768,10.67569,6.22929,10.55782Q6.2409,10.43995,6.2582699999999996,10.322790000000001Q6.27565,10.205639999999999,6.29876,10.08947Q6.3218700000000005,9.97331,6.35064,9.858419999999999Q6.37942,9.74353,6.4138,9.630189999999999Q6.44818,9.51685,6.48808,9.405339999999999Q6.52799,9.29382,6.57331,9.1844Q6.61863,9.07498,6.66927,8.96791Q6.7199100000000005,8.86084,6.77575,8.75639Q6.83158,8.65193,6.89247,8.55035Q6.95336,8.44876,7.019159999999999,8.35028Q7.084960000000001,8.2518,7.15551,8.15667Q7.22607,8.06154,7.3012,7.96998Q7.37634,7.87843,7.4558800000000005,7.79067Q7.53542,7.702920000000001,7.61917,7.61917Q7.702920000000001,7.53542,7.79067,7.4558800000000005Q7.87843,7.37634,7.96999,7.3012Q8.06154,7.22607,8.15667,7.15551Q8.2518,7.084960000000001,8.35028,7.019159999999999Q8.44876,6.95336,8.55035,6.89247Q8.65193,6.83158,8.75639,6.77575Q8.86084,6.7199100000000005,8.96791,6.66927Q9.07498,6.61863,9.1844,6.57331Q9.29382,6.52799,9.405339999999999,6.48808Q9.51685,6.44818,9.630189999999999,6.4138Q9.74353,6.37942,9.858419999999999,6.35064Q9.97331,6.3218700000000005,10.08947,6.29876Q10.205639999999999,6.27565,10.322790000000001,6.2582699999999996Q10.43995,6.2409,10.55782,6.22929Q10.67569,6.21768,10.793980000000001,6.21187Q10.912279999999999,6.20605,11.030719999999999,6.20605Q11.14916,6.20605,11.26746,6.21187Q11.38575,6.21768,11.50362,6.22929Q11.62149,6.2409,11.73865,6.2582699999999996Q11.8558,6.27565,11.971969999999999,6.29876Q12.08813,6.3218700000000005,12.20302,6.35064Q12.317910000000001,6.37942,12.43125,6.4138Q12.54459,6.44818,12.6561,6.48808Q12.76762,6.52799,12.877040000000001,6.57331Q12.986460000000001,6.61863,13.09353,6.66927Q13.2006,6.7199100000000005,13.30505,6.77575Q13.4095,6.83158,13.51109,6.89247Q13.61268,6.95336,13.71116,7.019159999999999Q13.80964,7.084960000000001,13.90477,7.15551Q13.9999,7.22607,14.09146,7.3012Q14.18301,7.37634,14.27077,7.4558800000000005Q14.35852,7.53542,14.44227,7.61917Q14.52602,7.702920000000001,14.60556,7.79067Q14.6851,7.87843,14.76024,7.96999Q14.83537,8.06154,14.90593,8.15667Q14.97648,8.2518,15.0423,8.35028Q15.1081,8.44876,15.169,8.55035Q15.2299,8.65193,15.2857,8.75639Q15.3415,8.86084,15.3922,8.96791Q15.4428,9.07498,15.4881,9.1844Q15.5335,9.29382,15.5734,9.405339999999999Q15.6133,9.51685,15.6476,9.630189999999999Q15.682,9.74353,15.7108,9.858419999999999Q15.7396,9.97331,15.7627,10.08947Q15.7858,10.205639999999999,15.8032,10.322790000000001Q15.8205,10.43995,15.8322,10.55782Q15.8438,10.67569,15.8496,10.793980000000001Q15.8554,10.912279999999999,15.8554,11.030719999999999Z\" fill-rule=\"evenodd\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><path fill=\"currentColor\" d=\"M13.148 9.281a.462.462 0 0 0-.61.23 6.097 6.097 0 0 1-5.54 3.567 6.091 6.091 0 0 1-5.953-4.836l1.023 1.023a.461.461 0 0 0 .653-.653L.782 6.675a.55.55 0 0 0-.07-.059C.7 6.61.687 6.604.676 6.596l-.044-.023c-.015-.006-.031-.01-.046-.015-.012-.004-.025-.01-.04-.013a.457.457 0 0 0-.086-.009H.454a.441.441 0 0 0-.086.01.258.258 0 0 0-.04.012c-.014.004-.03.007-.045.015a.335.335 0 0 0-.044.023c-.011.008-.024.011-.035.02a.448.448 0 0 0-.127.128c-.008.01-.013.024-.019.035l-.023.043c-.006.015-.01.031-.015.048-.004.012-.01.025-.01.04A.498.498 0 0 0 0 7c0 3.86 3.143 7 7.004 7a7.024 7.024 0 0 0 6.38-4.108.467.467 0 0 0-.236-.61zm.57-1.854a.515.515 0 0 0 .043-.023c.011-.008.024-.011.035-.02a.448.448 0 0 0 .127-.128c.008-.01.013-.024.019-.035l.023-.043c.006-.015.01-.031.015-.048.004-.012.01-.025.01-.04.006-.029.01-.06.01-.09 0-3.86-3.143-7-7.004-7a7.01 7.01 0 0 0-6.41 4.176.462.462 0 0 0 .844.373A6.092 6.092 0 0 1 6.998.924a6.091 6.091 0 0 1 5.953 4.836l-1.023-1.023a.461.461 0 1 0-.653.653l1.94 1.939a.55.55 0 0 0 .072.058c.01.008.024.013.035.02l.043.024c.015.006.031.01.046.015.013.003.025.009.04.01a.499.499 0 0 0 .182 0c.015-.001.028-.007.04-.01.013-.01.028-.013.044-.019z\"></path></svg>"

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_1_2048\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_1_2048)\"><g><path d=\"M11.66667,12.83338701171875L3.5,12.83338701171875C2.533502,12.83338701171875,1.75,12.04988701171875,1.75,11.08335701171875L1.75,2.91668701171875C1.75,1.95018901171875,2.533502,1.16668701171875,3.5,1.16668701171875L11.66667,1.16668701171875C11.9888,1.16668701171875,12.25,1.42785401171875,12.25,1.75002001171875L12.25,12.24998701171875C12.25,12.57218701171875,11.9888,12.83338701171875,11.66667,12.83338701171875ZM11.08333,11.66668701171875L11.08333,10.50001701171875L3.5,10.50001701171875C3.17783,10.50001701171875,2.91667,10.76118701171875,2.91667,11.08335701171875C2.91667,11.40548701171875,3.17783,11.66668701171875,3.5,11.66668701171875L11.08333,11.66668701171875ZM2.91667,9.43251701171875C3.09925,9.36835701171875,3.29583,9.33335701171875,3.5,9.33335701171875L11.08333,9.33335701171875L11.08333,2.33335701171875L3.5,2.33335701171875C3.17783,2.33335701171875,2.91667,2.59451701171875,2.91667,2.91668701171875L2.91667,9.43251701171875ZM7,5.83335701171875C6.35567,5.83335701171875,5.83333,5.31101701171875,5.83333,4.66668701171875C5.83333,4.02235701171875,6.35567,3.50001701171875,7,3.50001701171875C7.64433,3.50001701171875,8.16667,4.02235701171875,8.16667,4.66668701171875C8.16667,5.31101701171875,7.64433,5.83335701171875,7,5.83335701171875ZM5.25,8.16668701171875C5.25,7.20018701171875,6.0335,6.41668701171875,7,6.41668701171875C7.9665,6.41668701171875,8.75,7.20018701171875,8.75,8.16668701171875L5.25,8.16668701171875Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_1_2050\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_1_2050)\"><g><path d=\"M1.6678046953124999,1.678273828125L9.0003076953125,0.631189168125C9.1760576953125,0.605952628125,9.3333876953125,0.742340828125,9.3333876953125,0.919938828125L9.3333876953125,13.080073828125C9.3333576953125,13.257373828125,9.1764476953125,13.393673828125,9.0008876953125,13.368873828125L1.6672206953125,12.321773828125C1.3797306953125,12.280773828125,1.1661376953125,12.034673828125,1.1661376953125,11.744273828125L1.1661376953125,2.255773828125C1.1661404768625,1.965383828125,1.3797336953125,1.719213828125,1.6678046953124999,1.678273828125L1.6678046953124999,1.678273828125ZM2.3333876953125,2.762103828125L2.3333876953125,11.237973828125L8.1667176953125,12.071473828125L8.1667176953125,1.928523828125L2.3333876953125,2.762103828125ZM9.9167176953125,11.083373828125L11.6667376953125,11.083373828125L11.6667376953125,2.916693828125L9.9167176953125,2.916693828125L9.9167176953125,1.750023828125L12.2500376953125,1.750023828125C12.5722376953125,1.750023828125,12.8333376953125,2.011193828125,12.8333376953125,2.333353828125L12.8333376953125,11.666673828125C12.8333376953125,11.988873828125,12.5722376953125,12.249973828125,12.2500376953125,12.249973828125L9.9167176953125,12.249973828125L9.9167176953125,11.083373828125ZM5.9500576953125,7.000023828125L7.5833876953125,9.333353828125L6.1833876953125,9.333353828125L5.2500576953125,7.999853828125L4.3167176953125,9.333353828125L2.9167176953125002,9.333353828125L4.5500576953125,7.000023828125L2.9167176953125002,4.666693828125L4.3167176953125,4.666693828125L5.2500576953125,6.000193828125L6.1833876953125,4.666693828125L7.5833876953125,4.666693828125L5.9500576953125,7.000023828125Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><defs><clipPath id=\"master_svg0_169_5075\"><rect x=\"0\" y=\"0\" width=\"16\" height=\"16\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_169_5075)\"><g><path d=\"M10.66667,1.333343505859375L14,4.666013505859375L14,14.006043505859376C14,14.370643505859375,13.7033,14.666643505859374,13.338,14.666643505859374L2.662,14.666643505859374C2.2966670000000002,14.666643505859374,2,14.363343505859374,2,14.005343505859376L2,1.994677505859375C2,1.629343505859375,2.2966670000000002,1.333343505859375,2.662,1.333343505859375L10.66667,1.333343505859375ZM8.66667,6.000013505859375L7.33333,6.000013505859375L7.33333,10.000013505859375L10.66667,10.000013505859375L10.66667,8.666673505859375L8.66667,8.666673505859375L8.66667,6.000013505859375Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_169_5119\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_169_5119)\"><g><path d=\"M7.61821984375,4.7308184765625L8.443639843749999,5.5562384765625C10.03846984375,7.1509084765625,10.03846984375,9.7365584765625,8.443639843749999,11.3311884765625L8.23713984375,11.5371884765625C6.64224984375,13.1308884765625,4.057459843749999,13.1304884765625,2.46312984375,11.5361884765625C0.86879884375,9.9418184765625,0.86835184375,7.3570384765625,2.46213984375,5.7621484765625L3.28754984375,6.5875684765625C2.14002384375,7.7251184765625,2.13597684375,9.5787984765625,3.27852984375,10.7213484765625C4.42106984375,11.8638884765625,6.27474984375,11.8598884765625,7.41229984375,10.7123184765625L7.61879984375,10.5058184765625C8.75741984375,9.3668584765625,8.75741984375,7.5206084765625,7.61879984375,6.3816484765625L6.79338984375,5.5562384765625L7.61879984375,4.7313984765625L7.61821984375,4.7308184765625ZM11.53708984375,8.2372384765625L10.71221984375,7.4124084765625C11.85978984375,6.2748584765625,11.86378984375,4.4211784765625,10.72124984375,3.2786284765625C9.57869984375,2.1360774765625,7.72501984375,2.1401254765625,6.58746984375,3.2876484765625L6.38096984375,3.4941484765625C5.2423498437500005,4.6331084765625,5.2423498437500005,6.4793584765625,6.38096984375,7.6183184765625L7.20637984375,8.443738476562501L6.38096984375,9.2685684765625L5.55612984375,8.443738476562501C3.96129984375,6.8490584765625,3.96129984375,4.2634084765625,5.55612984375,2.6687384765625L5.76262984375,2.4628184765625C7.35758984375,0.8694274765625001,9.94204984375,0.8700584765625,11.53618984375,2.4642284765625C13.13038984375,4.0583984765625,13.13098984375,6.6428684765625,11.53758984375,8.2378184765625L11.53708984375,8.2372384765625Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_1_18792\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_1_18792)\"><g><path d=\"M7.61821984375,4.7308184765625L8.443639843749999,5.5562384765625C10.03846984375,7.1509084765625,10.03846984375,9.7365584765625,8.443639843749999,11.3311884765625L8.23713984375,11.5371884765625C6.64224984375,13.1308884765625,4.057459843749999,13.1304884765625,2.46312984375,11.5361884765625C0.86879884375,9.9418184765625,0.86835184375,7.3570384765625,2.46213984375,5.7621484765625L3.28754984375,6.5875684765625C2.14002384375,7.7251184765625,2.13597684375,9.5787984765625,3.27852984375,10.7213484765625C4.42106984375,11.8638884765625,6.27474984375,11.8598884765625,7.41229984375,10.7123184765625L7.61879984375,10.5058184765625C8.75741984375,9.3668584765625,8.75741984375,7.5206084765625,7.61879984375,6.3816484765625L6.79338984375,5.5562384765625L7.61879984375,4.7313984765625L7.61821984375,4.7308184765625ZM11.53708984375,8.2372384765625L10.71221984375,7.4124084765625C11.85978984375,6.2748584765625,11.86378984375,4.4211784765625,10.72124984375,3.2786284765625C9.57869984375,2.1360774765625,7.72501984375,2.1401254765625,6.58746984375,3.2876484765625L6.38096984375,3.4941484765625C5.2423498437500005,4.6331084765625,5.2423498437500005,6.4793584765625,6.38096984375,7.6183184765625L7.20637984375,8.443738476562501L6.38096984375,9.2685684765625L5.55612984375,8.443738476562501C3.96129984375,6.8490584765625,3.96129984375,4.2634084765625,5.55612984375,2.6687384765625L5.76262984375,2.4628184765625C7.35758984375,0.8694274765625001,9.94204984375,0.8700584765625,11.53618984375,2.4642284765625C13.13038984375,4.0583984765625,13.13098984375,6.6428684765625,11.53758984375,8.2378184765625L11.53708984375,8.2372384765625Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_169_5111\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_169_5111)\"><g><path d=\"M11.083418046875,4.08331298828125L14.000048046875,4.08331298828125L14.000048046875,5.24998298828125L11.083418046875,5.24998298828125L11.083418046875,4.08331298828125ZM9.916748046875,6.99998298828125L14.000048046875,6.99998298828125L14.000048046875,8.16664298828125L9.916748046875,8.16664298828125L9.916748046875,6.99998298828125ZM11.666748046875,9.91664298828125L14.000048046875,9.91664298828125L14.000048046875,11.08331298828125L11.666748046875,11.08331298828125L11.666748046875,9.91664298828125ZM1.166748046875,12.83331298828125C1.166748046875,10.25598298828125,3.256088046875,8.16664298828125,5.833418046875,8.16664298828125C8.410748046875,8.16664298828125,10.500078046875,10.25598298828125,10.500078046875,12.83331298828125L9.333418046875,12.83331298828125C9.333418046875,10.90031298828125,7.766408046875,9.33331298828125,5.833418046875,9.33331298828125C3.900418046875,9.33331298828125,2.333418046875,10.90031298828125,2.333418046875,12.83331298828125L1.166748046875,12.83331298828125ZM5.833418046875,7.58331298828125C3.899668046875,7.58331298828125,2.333418046875,6.01706298828125,2.333418046875,4.08331298828125C2.333418046875,2.14956298828125,3.899668046875,0.58331298828125,5.833418046875,0.58331298828125C7.767168046875,0.58331298828125,9.333418046875,2.14956298828125,9.333418046875,4.08331298828125C9.333418046875,6.01706298828125,7.767168046875,7.58331298828125,5.833418046875,7.58331298828125ZM5.833418046875,6.41664298828125C7.122578046875,6.41664298828125,8.166748046875,5.37248298828125,8.166748046875,4.08331298828125C8.166748046875,2.79414298828125,7.122578046875,1.74998298828125,5.833418046875,1.74998298828125C4.5442480468749995,1.74998298828125,3.500078046875,2.79414298828125,3.500078046875,4.08331298828125C3.500078046875,5.37248298828125,4.5442480468749995,6.41664298828125,5.833418046875,6.41664298828125Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_1_18784\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_1_18784)\"><g><path d=\"M11.083418046875,4.08331298828125L14.000048046875,4.08331298828125L14.000048046875,5.24998298828125L11.083418046875,5.24998298828125L11.083418046875,4.08331298828125ZM9.916748046875,6.99998298828125L14.000048046875,6.99998298828125L14.000048046875,8.16664298828125L9.916748046875,8.16664298828125L9.916748046875,6.99998298828125ZM11.666748046875,9.91664298828125L14.000048046875,9.91664298828125L14.000048046875,11.08331298828125L11.666748046875,11.08331298828125L11.666748046875,9.91664298828125ZM1.166748046875,12.83331298828125C1.166748046875,10.25598298828125,3.256088046875,8.16664298828125,5.833418046875,8.16664298828125C8.410748046875,8.16664298828125,10.500078046875,10.25598298828125,10.500078046875,12.83331298828125L9.333418046875,12.83331298828125C9.333418046875,10.90031298828125,7.766408046875,9.33331298828125,5.833418046875,9.33331298828125C3.900418046875,9.33331298828125,2.333418046875,10.90031298828125,2.333418046875,12.83331298828125L1.166748046875,12.83331298828125ZM5.833418046875,7.58331298828125C3.899668046875,7.58331298828125,2.333418046875,6.01706298828125,2.333418046875,4.08331298828125C2.333418046875,2.14956298828125,3.899668046875,0.58331298828125,5.833418046875,0.58331298828125C7.767168046875,0.58331298828125,9.333418046875,2.14956298828125,9.333418046875,4.08331298828125C9.333418046875,6.01706298828125,7.767168046875,7.58331298828125,5.833418046875,7.58331298828125ZM5.833418046875,6.41664298828125C7.122578046875,6.41664298828125,8.166748046875,5.37248298828125,8.166748046875,4.08331298828125C8.166748046875,2.79414298828125,7.122578046875,1.74998298828125,5.833418046875,1.74998298828125C4.5442480468749995,1.74998298828125,3.500078046875,2.79414298828125,3.500078046875,4.08331298828125C3.500078046875,5.37248298828125,4.5442480468749995,6.41664298828125,5.833418046875,6.41664298828125Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"8\" height=\"5\" viewBox=\"0 0 8 5\"><g><path d=\"M1.04031,0C0.621059,0,0.387973,0.484966,0.649878,0.812348L3.60957,4.51196C3.80973,4.76216,4.19027,4.76216,4.39043,4.51196L7.35012,0.812348C7.61203,0.484966,7.37894,0,6.95969,0L1.04031,0Z\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"30\" height=\"23.75\" viewBox=\"0 0 30 23.75\"><g><path d=\"M29.9999,13.6104C29.9999,17.5218,26.8643,20.712,22.9986,20.712L22.4351,20.712C21.7447,20.712,21.1851,20.1524,21.1851,19.462C21.1851,18.7717,21.7447,18.212,22.4351,18.212L22.9986,18.212C25.4739,18.212,27.4999,16.1507,27.4999,13.6042C27.5111,11.335,25.8925,9.40665,23.7018,9.06454L23.0672,8.96363C22.8403,8.92754,22.6276,8.82958,22.4527,8.68051L22.3623,8.60346C22.1903,8.45688,22.0613,8.26642,21.9889,8.05234L21.7797,7.43317C20.7827,4.47809,18.0577,2.49912,15,2.5C11.9415,2.5,9.21554,4.47931,8.21969,7.4319L8.01173,8.05034C7.9396,8.26483,7.81059,8.45572,7.63847,8.60264L7.54801,8.67987C7.37296,8.8293,7.16005,8.92749,6.93275,8.96363L6.29446,9.06513C4.10739,9.40667,2.48891,11.3351,2.50007,13.6095C2.5028,16.155,4.52203,18.2093,7.00142,18.212L7.37188,18.212C8.06223,18.212,8.62188,18.7717,8.62188,19.462C8.62188,20.1524,8.06223,20.712,7.37188,20.712L7.00004,20.712C3.13099,20.7077,0.00426413,17.5267,0.0000876603,13.6169C-0.0170164,10.1337,2.47069,7.15445,5.86107,6.60266C7.20722,2.65472,10.8742,0,14.9996,0C19.1248,-0.00118385,22.7912,2.65363,24.1378,6.60249C27.5304,7.15593,30.017,10.1344,29.9999,13.6104ZM16.25,14.4822L17.6517,15.8839C18.1398,16.372,18.9313,16.372,19.4194,15.8839C19.9076,15.3957,19.9076,14.6043,19.4194,14.1161L15.8839,10.5806C15.3957,10.0924,14.6043,10.0924,14.1161,10.5806L10.5806,14.1161C10.0924,14.6043,10.0924,15.3957,10.5806,15.8839C11.0688,16.372,11.8602,16.372,12.3484,15.8839L13.75,14.4822L13.75,22.75C13.75,23.3023,14.1977,23.75,14.75,23.75L15.25,23.75C15.8023,23.75,16.25,23.3023,16.25,22.75L16.25,14.4822Z\" fill-rule=\"evenodd\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14.000022888183594\" height=\"12.220413208007812\" viewBox=\"0 0 14.000022888183594 12.220413208007812\"><g><path d=\"M0.000023365,6.11256L0,6.10714L0.000023365,6.10174L0.000023365,6.09093Q0.000023365,5.95013,0.0626569,5.82403Q0.12529,5.69793,0.237482,5.61285L5.66874,0.181593Q5.71192,0.138414,5.76269,0.104488Q5.81346,0.0705633,5.86988,0.047195Q5.9263,0.0238266,5.98619,0.0119133Q6.04608,0,6.10714,0Q6.16821,0,6.2281,0.0119133Q6.28799,0.0238266,6.34441,0.047195Q6.40082,0.0705633,6.4516,0.104488Q6.50237,0.138414,6.54555,0.181593Q6.63275,0.268798,6.67995,0.382737Q6.72714,0.496675,6.72714,0.62Q6.72714,0.743327,6.67995,0.857264Q6.63275,0.971201,6.54555,1.0584L2.11302,5.49093L13.4,5.49093Q13.4591,5.49093,13.5171,5.50246Q13.575,5.51399,13.6296,5.5366Q13.6842,5.55922,13.7333,5.59205Q13.7825,5.62488,13.8243,5.66667Q13.866,5.70845,13.8989,5.75759Q13.9317,5.80673,13.9543,5.86132Q13.9769,5.91592,13.9885,5.97388Q14,6.03184,14,6.09093L14,6.12676Q14,6.18586,13.9885,6.24382Q13.9769,6.30177,13.9543,6.35637Q13.9317,6.41097,13.8989,6.4601Q13.866,6.50924,13.8243,6.55103Q13.7825,6.59281,13.7333,6.62564Q13.6842,6.65847,13.6296,6.68109Q13.575,6.7037,13.5171,6.71523Q13.4591,6.72676,13.4,6.72676L2.12522,6.72676L6.5605,11.162Q6.6477,11.2492,6.6949,11.3632Q6.74209,11.4771,6.74209,11.6004Q6.74209,11.7238,6.6949,11.8377Q6.6477,11.9516,6.5605,12.0388Q6.47329,12.126,6.35935,12.1732Q6.24542,12.2204,6.12209,12.2204Q5.99876,12.2204,5.88483,12.1732Q5.77089,12.126,5.68368,12.0388L0.277606,6.63277Q0.213799,6.59212,0.162081,6.53689Q0.110364,6.48167,0.073976,6.41533Q0.0375876,6.349,0.0188055,6.27571Q0.000023365,6.20242,0.000023365,6.12676L0.000023365,6.11256Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"32.666664123535156\" height=\"32.666664123535156\" viewBox=\"0 0 32.666664123535156 32.666664123535156\"><g><path d=\"M0,16.3333C0,25.354,7.31268,32.6667,16.3333,32.6667C25.354,32.6667,32.6667,25.354,32.6667,16.3333C32.6667,15.2058,32.5524,14.1049,32.3348,13.0416C32.226,12.51,32.0914,11.9877,31.9324,11.4763C31.6699,10.6325,30.7234,10.2547,29.9095,10.5989C29.2991,10.8571,29.019,11.559,29.2224,12.1898Q29.453,12.9049,29.6011,13.639Q29.8667,14.9557,29.8667,16.3333Q29.8667,21.939,25.9028,25.9028Q21.939,29.8667,16.3333,29.8667Q10.7276,29.8667,6.76382,25.9028Q2.8,21.939,2.8,16.3333Q2.8,10.7276,6.76382,6.76382Q10.7276,2.8,16.3333,2.8Q19.0885,2.8,21.6003,3.86237Q22.2589,4.14095,22.8768,4.48188C23.4544,4.80059,24.1902,4.66071,24.5617,4.11555C25.0603,3.38405,24.8697,2.37733,24.091,1.95628C23.6368,1.71072,23.1698,1.48605,22.691,1.28355C20.7369,0.457043,18.5885,0,16.3333,0C7.31268,0,0,7.31268,0,16.3333Z\" fill=\"currentColor\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"100%\" height=\"100%\" viewBox=\"0 0 24 24\"><defs><clipPath id=\"a\"><rect width=\"24\" height=\"24\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#a)\"><path d=\"M24 12q0 .295-.015.589-.014.294-.043.587-.029.293-.072.585-.043.291-.1.58-.058.289-.13.575-.071.285-.157.567-.085.282-.184.56-.1.277-.212.55-.113.271-.24.538-.125.266-.264.526t-.29.512q-.152.253-.315.498-.164.245-.34.481-.175.237-.362.465-.187.227-.385.446-.197.218-.406.426-.208.209-.426.406-.219.198-.446.385-.228.187-.465.363-.236.175-.481.339-.245.163-.498.315-.252.151-.512.29-.26.139-.526.265-.267.126-.539.239-.272.112-.55.212-.277.099-.559.184-.282.086-.567.157-.286.072-.575.13-.289.057-.58.1-.292.043-.585.072-.293.03-.587.043Q12.295 24 12 24t-.589-.015q-.294-.014-.587-.043-.293-.029-.585-.072-.291-.043-.58-.1-.289-.058-.575-.13-.286-.071-.567-.157-.282-.085-.56-.184-.277-.1-.55-.212-.271-.113-.538-.24-.266-.125-.526-.264t-.512-.29q-.253-.152-.498-.315-.245-.164-.481-.34-.237-.175-.465-.362-.227-.187-.446-.385-.218-.197-.426-.406-.209-.208-.406-.426-.198-.219-.385-.446-.187-.228-.362-.465-.176-.236-.34-.481-.163-.245-.315-.498-.151-.252-.29-.512-.139-.26-.265-.526-.126-.267-.239-.539-.112-.272-.212-.55-.099-.277-.184-.559-.086-.282-.157-.567-.072-.286-.13-.575-.057-.289-.1-.58-.043-.292-.072-.585-.03-.293-.044-.587Q0 12.295 0 12t.014-.589q.015-.294.044-.587.029-.293.072-.585.043-.291.1-.58.058-.289.13-.575.071-.286.157-.567.085-.282.184-.56.1-.277.212-.55.113-.271.24-.538.125-.266.264-.526t.29-.512q.152-.253.315-.498.164-.245.34-.481.175-.237.362-.465.187-.227.385-.446.197-.218.406-.426.208-.209.426-.406.219-.198.446-.385.228-.187.465-.362.236-.176.481-.34.245-.163.498-.315.252-.151.512-.29.26-.139.526-.265.267-.126.539-.239.272-.112.55-.212.277-.099.559-.184.281-.086.567-.157.286-.072.575-.13.289-.057.58-.1.292-.043.585-.072.293-.03.587-.044Q11.705 0 12 0t.589.014q.294.015.587.044.293.029.585.072.291.043.58.1.289.058.575.13.285.071.567.157.282.085.56.184.277.1.55.212.271.113.538.24.266.125.526.264t.512.29q.253.152.498.315.245.164.481.34.237.175.465.362.227.187.446.385.218.197.426.406.209.208.406.426.198.219.385.446.187.228.363.465.175.236.339.481.163.245.315.498.151.252.29.512.139.26.265.526.126.267.239.539.112.272.212.55.099.277.184.559.086.281.157.567.072.286.13.575.057.289.1.58.043.292.072.585.03.293.043.587.015.294.015.589z\" fill=\"#F7F8FA\"></path><path d=\"M8.562 7.63l8.136-2.582A1 1 0 0 1 18 6v9.101h-.003q.018.262-.078.532-.07.2-.2.389t-.309.354q-.179.165-.397.295-.218.13-.46.219-.093.033-.188.06-.096.027-.192.047-.096.019-.192.031-.097.012-.193.017-.095.004-.19.001-.093-.003-.185-.013-.091-.01-.18-.029-.088-.018-.171-.043-.084-.025-.163-.058-.078-.032-.151-.071-.073-.04-.14-.085-.066-.045-.125-.097-.059-.05-.11-.108-.051-.056-.095-.118-.043-.062-.077-.128t-.06-.135q-.072-.197-.07-.412.004-.216.08-.434.072-.2.201-.389.13-.189.309-.354.18-.165.397-.295.218-.13.46-.219.177-.064.36-.102.181-.039.363-.05.182-.012.357.003t.338.057V7.94l-7.936 2.454v6.529c.127.74-.553 1.57-1.52 1.921-1.046.38-2.126.053-2.411-.729-.286-.781.33-1.723 1.377-2.102.478-.174.983-.2 1.418-.102V8.584a1 1 0 0 1 .697-.953z\" fill-rule=\"evenodd\" fill=\"#333\"></path><path d=\"M19.289 18.374L5.854 4.94a1 1 0 1 0-1.415 1.415l13.435 13.435a1 1 0 1 0 1.415-1.415z\" fill=\"#F7F8FA\"></path><path d=\"M18.996 18.803a.5.5 0 0 1-.707.707L4.854 6.075a.5.5 0 0 1 .707-.707l13.435 13.435z\" fill=\"#333\"></path></g></svg>"

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"100%\" height=\"100%\" viewBox=\"0 0 24 24\"><defs><clipPath id=\"a\"><rect width=\"24\" height=\"24\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#a)\"><path d=\"M24 12q0 .295-.015.589-.014.294-.043.587-.029.293-.072.585-.043.291-.1.58-.058.289-.13.575-.071.285-.157.567-.085.282-.184.56-.1.277-.212.55-.113.271-.24.538-.125.266-.264.526t-.29.512q-.152.253-.315.498-.164.245-.34.481-.175.237-.362.465-.187.227-.385.446-.197.218-.406.426-.208.209-.426.406-.219.198-.446.385-.228.187-.465.363-.236.175-.481.339-.245.163-.498.315-.252.151-.512.29-.26.139-.526.265-.267.126-.539.239-.272.112-.55.212-.277.099-.559.184-.282.086-.567.157-.286.072-.575.13-.289.057-.58.1-.292.043-.585.072-.293.03-.587.043Q12.295 24 12 24t-.589-.015q-.294-.014-.587-.043-.293-.029-.585-.072-.291-.043-.58-.1-.289-.058-.575-.13-.286-.071-.567-.157-.282-.085-.56-.184-.277-.1-.55-.212-.271-.113-.538-.24-.266-.125-.526-.264t-.512-.29q-.253-.152-.498-.315-.245-.164-.481-.34-.237-.175-.465-.362-.227-.187-.446-.385-.218-.197-.426-.406-.209-.208-.406-.426-.198-.219-.385-.446-.187-.228-.362-.465-.176-.236-.34-.481-.163-.245-.315-.498-.151-.252-.29-.512-.139-.26-.265-.526-.126-.267-.239-.539-.112-.272-.212-.55-.099-.277-.184-.559-.086-.282-.157-.567-.072-.286-.13-.575-.057-.289-.1-.58-.043-.292-.072-.585-.03-.293-.044-.587Q0 12.295 0 12t.014-.589q.015-.294.044-.587.029-.293.072-.585.043-.291.1-.58.058-.289.13-.575.071-.286.157-.567.085-.282.184-.56.1-.277.212-.55.113-.271.24-.538.125-.266.264-.526t.29-.512q.152-.253.315-.498.164-.245.34-.481.175-.237.362-.465.187-.227.385-.446.197-.218.406-.426.208-.209.426-.406.219-.198.446-.385.228-.187.465-.362.236-.176.481-.34.245-.163.498-.315.252-.151.512-.29.26-.139.526-.265.267-.126.539-.239.272-.112.55-.212.277-.099.559-.184.281-.086.567-.157.286-.072.575-.13.289-.057.58-.1.292-.043.585-.072.293-.03.587-.044Q11.705 0 12 0t.589.014q.294.015.587.044.293.029.585.072.291.043.58.1.289.058.575.13.285.071.567.157.282.085.56.184.277.1.55.212.271.113.538.24.266.125.526.264t.512.29q.253.152.498.315.245.164.481.34.237.175.465.362.227.187.446.385.218.197.426.406.209.208.406.426.198.219.385.446.187.228.363.465.175.236.339.481.163.245.315.498.151.252.29.512.139.26.265.526.126.267.239.539.112.272.212.55.099.277.184.559.086.281.157.567.072.286.13.575.057.289.1.58.043.292.072.585.03.293.043.587.015.294.015.589z\" fill=\"#F7F8FA\"></path><path d=\"M8.562 7.629l8.135-2.583A1 1 0 0 1 18 5.999V15.1h-.003q.018.262-.077.532-.071.2-.2.389-.13.188-.31.353-.178.165-.396.296-.218.13-.46.219-.094.033-.189.06-.095.027-.191.046-.096.02-.193.032-.096.012-.192.017-.096.004-.19.001t-.185-.013q-.092-.01-.18-.029-.088-.018-.172-.043-.084-.026-.162-.058-.079-.032-.152-.071-.073-.04-.139-.085-.066-.045-.125-.097-.06-.051-.11-.108-.052-.056-.095-.118-.043-.062-.078-.128-.034-.066-.06-.135-.071-.197-.069-.413.003-.215.08-.433.071-.2.2-.389.13-.189.31-.354.179-.165.397-.295.218-.131.46-.219.176-.064.359-.102.182-.039.364-.05.182-.012.357.003t.338.057V7.938L9 10.392v6.529c.127.74-.553 1.57-1.52 1.921-1.045.38-2.125.053-2.41-.729-.286-.781.33-1.723 1.377-2.102.478-.174.983-.2 1.417-.102V8.582a1 1 0 0 1 .698-.953z\" fill-rule=\"evenodd\" fill=\"#333\"></path></g></svg>"

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"100%\" height=\"100%\" viewBox=\"0 0 56 56\"><defs><clipPath id=\"master_svg0_1_5326\"><rect x=\"0\" y=\"0\" width=\"56\" height=\"56\" rx=\"28\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_1_5326)\"><rect x=\"0\" y=\"0\" width=\"56\" height=\"56\" rx=\"28\" fill=\"#FFFFFF\" fill-opacity=\"1\"></rect><g><path d=\"M27.6084421875,17.62763L37.3425921875,24.1171C40.1133921875,25.9643,40.1133921875,30.0357,37.3425921875,31.8829L27.6084421875,38.3724C25.2825021875,39.923,22.1669921875,38.2556,22.1669921875,35.4602L22.1669921875,20.53981C22.1669921875,17.74438,25.2825021875,16.07701,27.6084421875,17.62763\" fill=\"#333333\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><defs><clipPath id=\"master_svg0_169_5611\"><rect x=\"0\" y=\"0\" width=\"16\" height=\"16\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_169_5611)\"><g><path d=\"M8.000013505859375,14.66661298828125C4.3180135058593745,14.66661298828125,1.333343505859375,11.68201298828125,1.333343505859375,7.99998298828125C1.333343505859375,4.3179829882812495,4.3180135058593745,1.33331298828125,8.000013505859375,1.33331298828125C11.682043505859374,1.33331298828125,14.666643505859374,4.3179829882812495,14.666643505859374,7.99998298828125C14.666643505859374,11.68201298828125,11.682043505859374,14.66661298828125,8.000013505859375,14.66661298828125ZM8.000013505859375,13.33331298828125C10.945533505859375,13.33331298828125,13.333343505859375,10.94550298828125,13.333343505859375,7.99998298828125C13.333343505859375,5.05446298828125,10.945533505859375,2.66664298828125,8.000013505859375,2.66664298828125C5.054493505859375,2.66664298828125,2.666673505859375,5.05446298828125,2.666673505859375,7.99998298828125C2.666673505859375,10.94550298828125,5.054493505859375,13.33331298828125,8.000013505859375,13.33331298828125ZM7.333343505859375,4.66664298828125L8.666673505859375,4.66664298828125L8.666673505859375,5.99998298828125L7.333343505859375,5.99998298828125L7.333343505859375,4.66664298828125ZM7.333343505859375,7.33331298828125L8.666673505859375,7.33331298828125L8.666673505859375,11.33331298828125L7.333343505859375,11.33331298828125L7.333343505859375,7.33331298828125Z\" fill=\"#FFBE3A\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><g><path d=\"M18,35.9996C15.5917,36.0151,13.2057,35.5373,10.9891,34.5957C6.6624,32.779,3.22096,29.3376,1.40434,25.0109C0.462658,22.7943,-0.0151469,20.4083,0.000365978,18C-0.0151469,15.5917,0.462658,13.2057,1.40434,10.9891C3.22096,6.6624,6.6624,3.22095,10.9891,1.40434C13.2057,0.462654,15.5917,-0.0151482,18,0.000366211C20.4083,-0.0151482,22.7943,0.462654,25.0109,1.40434C29.3376,3.22095,32.779,6.6624,34.5957,10.9891C35.5373,13.2057,36.0151,15.5917,35.9996,18C36.0151,20.4083,35.5373,22.7943,34.5957,25.0109C32.779,29.3376,29.3376,32.779,25.0109,34.5957C22.7943,35.5373,20.4083,36.0151,18,35.9996ZM16.5,20.5L16.5,11.5Q16.5,11.4263,16.5072,11.353Q16.5144,11.2796,16.5288,11.2074Q16.5432,11.1351,16.5646,11.0646Q16.586,10.9941,16.6142,10.926Q16.6424,10.8579,16.6771,10.7929Q16.7119,10.7279,16.7528,10.6666Q16.7937,10.6054,16.8405,10.5484Q16.8872,10.4914,16.9393,10.4393Q16.9914,10.3872,17.0484,10.3405Q17.1054,10.2937,17.1666,10.2528Q17.2279,10.2119,17.2929,10.1771Q17.3579,10.1424,17.426,10.1142Q17.4941,10.086,17.5646,10.0646Q17.6351,10.0432,17.7074,10.0288Q17.7796,10.0144,17.853,10.0072Q17.9263,10,18,10Q18.0737,10,18.147,10.0072Q18.2204,10.0144,18.2926,10.0288Q18.3649,10.0432,18.4354,10.0646Q18.5059,10.086,18.574,10.1142Q18.6421,10.1424,18.7071,10.1771Q18.7721,10.2119,18.8334,10.2528Q18.8946,10.2937,18.9516,10.3405Q19.0086,10.3872,19.0607,10.4393Q19.1128,10.4914,19.1595,10.5484Q19.2063,10.6054,19.2472,10.6666Q19.2881,10.7279,19.3229,10.7929Q19.3576,10.8579,19.3858,10.926Q19.414,10.9941,19.4354,11.0646Q19.4568,11.1351,19.4712,11.2074Q19.4856,11.2796,19.4928,11.353Q19.5,11.4263,19.5,11.5L19.5,20.5Q19.5,20.5737,19.4928,20.647Q19.4856,20.7204,19.4712,20.7927Q19.4568,20.8649,19.4354,20.9354Q19.414,21.006,19.3858,21.074Q19.3576,21.1421,19.3229,21.2071Q19.2881,21.2721,19.2472,21.3334Q19.2063,21.3946,19.1595,21.4516Q19.1128,21.5086,19.0607,21.5607Q19.0086,21.6128,18.9516,21.6595Q18.8946,21.7063,18.8334,21.7472Q18.7721,21.7882,18.7071,21.8229Q18.6421,21.8576,18.574,21.8858Q18.5059,21.914,18.4354,21.9354Q18.3649,21.9568,18.2926,21.9712Q18.2204,21.9856,18.147,21.9928Q18.0737,22,18,22Q17.9263,22,17.853,21.9928Q17.7796,21.9856,17.7074,21.9712Q17.6351,21.9568,17.5646,21.9354Q17.4941,21.914,17.426,21.8858Q17.3579,21.8576,17.2929,21.8229Q17.2279,21.7882,17.1666,21.7472Q17.1054,21.7063,17.0484,21.6595Q16.9914,21.6128,16.9393,21.5607Q16.8872,21.5086,16.8405,21.4516Q16.7937,21.3946,16.7528,21.3334Q16.7119,21.2721,16.6771,21.2071Q16.6424,21.1421,16.6142,21.074Q16.586,21.006,16.5646,20.9354Q16.5432,20.8649,16.5288,20.7927Q16.5144,20.7204,16.5072,20.647Q16.5,20.5737,16.5,20.5ZM18,24Q17.9018,24,17.804,24.0096Q17.7062,24.0193,17.6098,24.0384Q17.5135,24.0576,17.4194,24.0861Q17.3254,24.1146,17.2346,24.1522Q17.1439,24.1898,17.0572,24.2362Q16.9706,24.2825,16.8889,24.3371Q16.8072,24.3916,16.7312,24.454Q16.6553,24.5163,16.5858,24.5858Q16.5163,24.6553,16.454,24.7312Q16.3916,24.8072,16.3371,24.8889Q16.2825,24.9706,16.2362,25.0572Q16.1898,25.1439,16.1522,25.2346Q16.1146,25.3254,16.0861,25.4194Q16.0576,25.5135,16.0384,25.6098Q16.0193,25.7062,16.0096,25.804Q16,25.9018,16,26Q16,26.0983,16.0096,26.196Q16.0193,26.2938,16.0384,26.3902Q16.0576,26.4866,16.0861,26.5806Q16.1146,26.6746,16.1522,26.7654Q16.1898,26.8561,16.2362,26.9428Q16.2825,27.0294,16.3371,27.1111Q16.3916,27.1928,16.454,27.2688Q16.5163,27.3447,16.5858,27.4142Q16.6553,27.4837,16.7312,27.546Q16.8072,27.6084,16.8889,27.6629Q16.9706,27.7175,17.0572,27.7638Q17.1439,27.8102,17.2346,27.8478Q17.3254,27.8854,17.4194,27.9139Q17.5135,27.9424,17.6098,27.9616Q17.7062,27.9807,17.804,27.9904Q17.9017,28,18,28Q18.0983,28,18.196,27.9904Q18.2938,27.9807,18.3902,27.9616Q18.4865,27.9424,18.5806,27.9139Q18.6746,27.8854,18.7654,27.8478Q18.8561,27.8102,18.9428,27.7638Q19.0294,27.7175,19.1111,27.6629Q19.1928,27.6084,19.2688,27.546Q19.3447,27.4837,19.4142,27.4142Q19.4837,27.3447,19.546,27.2688Q19.6084,27.1928,19.6629,27.1111Q19.7175,27.0294,19.7638,26.9428Q19.8102,26.8561,19.8478,26.7654Q19.8854,26.6746,19.9139,26.5806Q19.9424,26.4866,19.9616,26.3902Q19.9807,26.2938,19.9904,26.196Q20,26.0983,20,26Q20,25.9018,19.9904,25.804Q19.9807,25.7062,19.9616,25.6098Q19.9424,25.5135,19.9139,25.4194Q19.8854,25.3254,19.8478,25.2346Q19.8102,25.1439,19.7638,25.0572Q19.7175,24.9706,19.6629,24.8889Q19.6084,24.8072,19.546,24.7312Q19.4837,24.6553,19.4142,24.5858Q19.3447,24.5163,19.2688,24.454Q19.1928,24.3916,19.1111,24.3371Q19.0294,24.2825,18.9428,24.2362Q18.8561,24.1898,18.7654,24.1522Q18.6746,24.1146,18.5806,24.0861Q18.4866,24.0576,18.3902,24.0384Q18.2938,24.0193,18.196,24.0096Q18.0983,24,18,24Z\" fill-rule=\"evenodd\" fill=\"#FFBE3A\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_3_16811\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_3_16811)\"><g transform=\"matrix(0,-1,1,0,-5.000158309936523,15.999902725219727)\"><path d=\"M5.685418207641602,11.555760517578126C5.438002807641602,11.314272517578125,5.438002807641602,10.917784517578125,5.685418207641602,10.676294517578125C5.926247207641602,10.441232517578126,6.311906207641601,10.441232517578126,6.5527322076416015,10.676294517578125L8.999872207641602,13.064830517578125L11.447012207641603,10.676294517578125C11.687842207641602,10.441232517578126,12.073492207641602,10.441232517578126,12.314322207641602,10.676294517578125C12.5617422076416,10.917784517578125,12.5617422076416,11.314272517578125,12.314322207641602,11.555760517578126L9.478472207641602,14.323700517578125C9.346532207641602,14.452480517578124,9.171122207641602,14.510710517578126,8.999872207641602,14.498380517578125C8.828622207641601,14.510710517578126,8.653212207641602,14.452480517578124,8.521272207641601,14.323700517578125L5.685418207641602,11.555760517578126Z\" fill-rule=\"evenodd\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"8\" viewBox=\"0 0 8 8\"><polygon fill=\"#AAA\" points=\"7.018 8 8 7.018 4.99 3.992 8 .982 7.018 0 4.008 3.01 .982 0 0 .982 3.026 3.992 0 7.018 .982 8 4.008 4.974\"></polygon></svg>"

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><defs><clipPath id=\"master_svg0_248_45569\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"24\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_248_45569)\"><g><path d=\"M12,19Q12.17184,19,12.34347,18.9916Q12.51511,18.9831,12.686119999999999,18.9663Q12.85713,18.9494,13.02711,18.9242Q13.19709,18.899,13.36563,18.8655Q13.53417,18.832,13.70086,18.7902Q13.86755,18.7485,14.03199,18.6986Q14.19643,18.648699999999998,14.35823,18.5908Q14.52002,18.532899999999998,14.67878,18.4672Q14.83754,18.401400000000002,14.99288,18.3279Q15.1482,18.2545,15.2998,18.1734Q15.4513,18.092399999999998,15.5987,18.0041Q15.7461,17.9158,15.889,17.8203Q16.0319,17.724800000000002,16.1699,17.622500000000002Q16.3079,17.5201,16.4408,17.411099999999998Q16.5736,17.3021,16.7009,17.186700000000002Q16.828200000000002,17.0713,16.9497,16.9497Q17.0713,16.828200000000002,17.186700000000002,16.7009Q17.3021,16.5736,17.411099999999998,16.4408Q17.5201,16.3079,17.622500000000002,16.1699Q17.724800000000002,16.0319,17.8203,15.889Q17.9158,15.7461,18.0041,15.5987Q18.092399999999998,15.4513,18.1734,15.2998Q18.2545,15.1482,18.3279,14.99288Q18.401400000000002,14.83754,18.4672,14.67878Q18.532899999999998,14.52002,18.5908,14.35823Q18.648699999999998,14.19643,18.6986,14.03199Q18.7485,13.86755,18.7902,13.70086Q18.832,13.53417,18.8655,13.36563Q18.899,13.19709,18.9242,13.02711Q18.9494,12.85713,18.9663,12.686119999999999Q18.9831,12.51511,18.9916,12.34347Q19,12.17184,19,12Q19,11.82816,18.9916,11.65653Q18.9831,11.48489,18.9663,11.313880000000001Q18.9494,11.14287,18.9242,10.97289Q18.899,10.80291,18.8655,10.63437Q18.832,10.46583,18.7902,10.299140000000001Q18.7485,10.13245,18.6986,9.96801Q18.648699999999998,9.80357,18.5908,9.641770000000001Q18.532899999999998,9.479980000000001,18.4672,9.32122Q18.401400000000002,9.16246,18.3279,9.00711Q18.2545,8.85177,18.1734,8.70022Q18.092399999999998,8.54867,18.0041,8.40128Q17.9158,8.25389,17.8203,8.11101Q17.724800000000002,7.96813,17.622500000000002,7.8301Q17.5201,7.69208,17.411099999999998,7.5592500000000005Q17.3021,7.426410000000001,17.186700000000002,7.29909Q17.0713,7.17176,16.9497,7.05025Q16.828200000000002,6.9287399999999995,16.7009,6.81334Q16.5736,6.69794,16.4408,6.5889299999999995Q16.3079,6.47991,16.1699,6.37755Q16.0319,6.27518,15.889,6.17971Q15.7461,6.08424,15.5987,5.9959Q15.4513,5.907556,15.2998,5.826551Q15.1482,5.745546,14.99288,5.6720749999999995Q14.83754,5.598604,14.67878,5.532843Q14.52002,5.467083,14.35823,5.409191Q14.19643,5.3513,14.03199,5.301418Q13.86755,5.251535,13.70086,5.2097809999999996Q13.53417,5.168027,13.36563,5.134503Q13.19709,5.100979,13.02711,5.0757644Q12.85713,5.0505502,12.686119999999999,5.0337069Q12.51511,5.0168636,12.34347,5.0084318Q12.17184,5,12,5Q11.82816,5,11.65653,5.0084318Q11.48489,5.0168636,11.313880000000001,5.0337069Q11.14287,5.0505502,10.97289,5.0757644Q10.80291,5.100979,10.63437,5.134503Q10.46583,5.168027,10.299140000000001,5.2097809999999996Q10.13245,5.251535,9.96801,5.301418Q9.80357,5.3513,9.641770000000001,5.409191Q9.479980000000001,5.467083,9.32122,5.532843Q9.16246,5.598604,9.00711,5.6720749999999995Q8.85177,5.745546,8.70022,5.826551Q8.54867,5.907556,8.40128,5.995899Q8.25389,6.08424,8.11101,6.17971Q7.96813,6.27518,7.8301,6.37755Q7.69208,6.47991,7.5592500000000005,6.5889299999999995Q7.426410000000001,6.69794,7.29909,6.81334Q7.17176,6.9287399999999995,7.05025,7.05025Q6.9287399999999995,7.17176,6.81334,7.29909Q6.69794,7.426410000000001,6.5889299999999995,7.5592500000000005Q6.47991,7.69208,6.37755,7.8301Q6.27518,7.96813,6.17971,8.11101Q6.08424,8.25389,5.9959,8.40128Q5.907556,8.54867,5.826551,8.70022Q5.745546,8.85177,5.6720749999999995,9.00711Q5.598604,9.16246,5.532843,9.32122Q5.467083,9.479980000000001,5.409191,9.641770000000001Q5.3513,9.80357,5.301418,9.96801Q5.251535,10.13245,5.2097809999999996,10.299140000000001Q5.168027,10.46583,5.134503,10.63437Q5.100979,10.80291,5.0757644,10.97289Q5.0505502,11.14287,5.0337069,11.313880000000001Q5.0168636,11.48489,5.0084318,11.65653Q5,11.82816,5,12Q5,12.17184,5.0084318,12.34347Q5.0168636,12.51511,5.0337069,12.686119999999999Q5.0505502,12.85713,5.0757644,13.02711Q5.100979,13.19709,5.134503,13.36563Q5.168027,13.53417,5.2097809999999996,13.70086Q5.251535,13.86755,5.301418,14.03199Q5.3513,14.19643,5.409191,14.35823Q5.467083,14.52002,5.532843,14.67878Q5.598604,14.83754,5.6720749999999995,14.99288Q5.745546,15.1482,5.826551,15.2998Q5.907556,15.4513,5.995899,15.5987Q6.08424,15.7461,6.17971,15.889Q6.27518,16.0319,6.37755,16.1699Q6.47991,16.3079,6.5889299999999995,16.4408Q6.69794,16.5736,6.81334,16.7009Q6.9287399999999995,16.828200000000002,7.05025,16.9497Q7.17176,17.0713,7.29909,17.186700000000002Q7.426410000000001,17.3021,7.5592500000000005,17.411099999999998Q7.69208,17.5201,7.8301,17.622500000000002Q7.96813,17.724800000000002,8.11101,17.8203Q8.25389,17.9158,8.40128,18.0041Q8.54867,18.092399999999998,8.70022,18.1734Q8.85177,18.2545,9.00711,18.3279Q9.16246,18.401400000000002,9.32122,18.4672Q9.479980000000001,18.532899999999998,9.641770000000001,18.5908Q9.80357,18.648699999999998,9.96801,18.6986Q10.13245,18.7485,10.299140000000001,18.7902Q10.46583,18.832,10.63437,18.8655Q10.80291,18.899,10.97289,18.9242Q11.14287,18.9494,11.313880000000001,18.9663Q11.48489,18.9831,11.65653,18.9916Q11.82816,19,12,19ZM11.99995,17.8Q12.142330000000001,17.8,12.28454,17.793Q12.42675,17.786,12.56845,17.772Q12.710149999999999,17.7581,12.85099,17.7372Q12.99183,17.7163,13.13147,17.688499999999998Q13.27112,17.6607,13.40924,17.6261Q13.54735,17.5915,13.6836,17.5502Q13.81985,17.5089,13.95391,17.460900000000002Q14.08797,17.4129,14.21951,17.3585Q14.35106,17.304000000000002,14.47977,17.2431Q14.60848,17.1822,14.73405,17.115099999999998Q14.85962,17.048000000000002,14.98174,16.974800000000002Q15.1039,16.901600000000002,15.2223,16.822499999999998Q15.3406,16.7434,15.455,16.6586Q15.5694,16.573700000000002,15.6794,16.4834Q15.7895,16.3931,15.895,16.2975Q16.000500000000002,16.2018,16.1012,16.1012Q16.2018,16.000500000000002,16.2975,15.895Q16.3931,15.7895,16.4834,15.6794Q16.573700000000002,15.5694,16.6586,15.455Q16.7434,15.3406,16.822499999999998,15.2223Q16.901600000000002,15.1039,16.974800000000002,14.98174Q17.048000000000002,14.85962,17.115099999999998,14.73405Q17.1822,14.60848,17.2431,14.47977Q17.304000000000002,14.35106,17.3585,14.21951Q17.4129,14.08797,17.460900000000002,13.95391Q17.5089,13.81985,17.5502,13.6836Q17.5915,13.54735,17.6261,13.40924Q17.6607,13.27112,17.688499999999998,13.13147Q17.7163,12.99183,17.7372,12.85099Q17.7581,12.710149999999999,17.772,12.56845Q17.786,12.42675,17.793,12.28454Q17.8,12.142330000000001,17.8,11.99995Q17.8,11.857569999999999,17.793,11.71536Q17.786,11.57315,17.772,11.43145Q17.7581,11.289760000000001,17.7372,11.14891Q17.7163,11.00807,17.688499999999998,10.86843Q17.6607,10.72878,17.6261,10.59067Q17.5915,10.452549999999999,17.5502,10.3163Q17.5089,10.18005,17.460900000000002,10.04599Q17.4129,9.91193,17.3585,9.78039Q17.304000000000002,9.64884,17.2431,9.52013Q17.1822,9.39142,17.115099999999998,9.26585Q17.048000000000002,9.14028,16.974800000000002,9.01816Q16.901600000000002,8.89603,16.822499999999998,8.77764Q16.7434,8.65926,16.6586,8.54489Q16.573700000000002,8.430530000000001,16.4834,8.32047Q16.3931,8.21041,16.2975,8.10491Q16.2018,7.99941,16.1012,7.8987300000000005Q16.000500000000002,7.79805,15.895,7.70243Q15.7895,7.60682,15.6794,7.51649Q15.5694,7.426159999999999,15.455,7.34135Q15.3406,7.25653,15.2223,7.17743Q15.1039,7.09832,14.98174,7.02513Q14.85962,6.95193,14.73405,6.88481Q14.60848,6.81769,14.47977,6.75681Q14.35106,6.69594,14.21951,6.64145Q14.08797,6.5869599999999995,13.95391,6.539Q13.81985,6.49103,13.6836,6.4497Q13.54735,6.40837,13.40924,6.37377Q13.27112,6.33917,13.13147,6.3114Q12.99183,6.28362,12.85099,6.2627299999999995Q12.710149999999999,6.24184,12.56845,6.22788Q12.42675,6.21392,12.28454,6.2069399999999995Q12.142330000000001,6.19995,11.99995,6.19995Q11.857569999999999,6.19995,11.71536,6.2069399999999995Q11.57315,6.21392,11.43145,6.22788Q11.289760000000001,6.24184,11.14891,6.2627299999999995Q11.00807,6.28362,10.86843,6.3114Q10.72878,6.33917,10.59067,6.37377Q10.452549999999999,6.40837,10.3163,6.4497Q10.18005,6.49103,10.04599,6.539Q9.91193,6.5869599999999995,9.78039,6.64145Q9.64884,6.69594,9.52013,6.75681Q9.39142,6.81769,9.26585,6.88481Q9.14028,6.95193,9.01816,7.02513Q8.89603,7.09832,8.77764,7.17743Q8.65926,7.25653,8.54489,7.34135Q8.430530000000001,7.426159999999999,8.32047,7.51649Q8.21041,7.60682,8.10491,7.70243Q7.99941,7.79805,7.8987300000000005,7.8987300000000005Q7.79805,7.99941,7.70243,8.10491Q7.60682,8.21041,7.51649,8.32047Q7.426159999999999,8.430530000000001,7.34135,8.54489Q7.25653,8.65926,7.17743,8.77764Q7.09832,8.89603,7.02513,9.01816Q6.95193,9.14028,6.88481,9.26585Q6.81769,9.39142,6.75681,9.52013Q6.69594,9.64884,6.64145,9.78039Q6.5869599999999995,9.91193,6.539,10.04599Q6.49103,10.18005,6.4497,10.3163Q6.40837,10.452549999999999,6.37377,10.59067Q6.33917,10.72878,6.3114,10.86843Q6.28362,11.00807,6.2627299999999995,11.14891Q6.24184,11.289760000000001,6.22788,11.43145Q6.21392,11.57315,6.2069399999999995,11.71536Q6.19995,11.857569999999999,6.19995,11.99995Q6.19995,12.142330000000001,6.2069399999999995,12.28454Q6.21392,12.42675,6.22788,12.56845Q6.24184,12.710149999999999,6.2627299999999995,12.85099Q6.28362,12.99183,6.3114,13.13147Q6.33917,13.27112,6.37377,13.40924Q6.40837,13.54735,6.4497,13.6836Q6.49103,13.81985,6.539,13.95391Q6.5869599999999995,14.08797,6.64145,14.21951Q6.69594,14.35106,6.75681,14.47977Q6.81769,14.60848,6.88481,14.73405Q6.95193,14.85962,7.02513,14.98174Q7.09832,15.1039,7.17743,15.2223Q7.25653,15.3406,7.34135,15.455Q7.426159999999999,15.5694,7.51649,15.6794Q7.60682,15.7895,7.70243,15.895Q7.79805,16.000500000000002,7.8987300000000005,16.1012Q7.99941,16.2018,8.10491,16.2975Q8.21041,16.3931,8.32047,16.4834Q8.430530000000001,16.573700000000002,8.54489,16.6586Q8.65926,16.7434,8.77764,16.822499999999998Q8.89603,16.901600000000002,9.01816,16.974800000000002Q9.14028,17.048000000000002,9.26585,17.115099999999998Q9.39142,17.1822,9.52013,17.2431Q9.64884,17.304000000000002,9.78039,17.3585Q9.91193,17.4129,10.04599,17.460900000000002Q10.18005,17.5089,10.3163,17.5502Q10.452549999999999,17.5915,10.59067,17.6261Q10.72878,17.6607,10.86843,17.688499999999998Q11.00807,17.7163,11.14891,17.7372Q11.289760000000001,17.7581,11.43145,17.772Q11.57315,17.786,11.71536,17.793Q11.857569999999999,17.8,11.99995,17.8Z\" fill-rule=\"evenodd\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g><g><path d=\"M19,12Q19,11.82816,18.99157,11.65653Q18.98314,11.48489,18.96629,11.313880000000001Q18.94945,11.14287,18.92423,10.97289Q18.89902,10.80291,18.8655,10.63437Q18.83197,10.46583,18.790219999999998,10.299140000000001Q18.74846,10.13245,18.69858,9.96801Q18.648699999999998,9.80357,18.59081,9.641770000000001Q18.53292,9.479980000000001,18.46716,9.32122Q18.4014,9.16246,18.32792,9.00711Q18.25445,8.85177,18.17345,8.70022Q18.09244,8.54867,18.0041,8.40128Q17.91576,8.25389,17.82029,8.11101Q17.72482,7.96813,17.62245,7.8301Q17.52009,7.69208,17.41107,7.5592500000000005Q17.30206,7.426410000000001,17.18666,7.29909Q17.07126,7.17176,16.94975,7.05025Q16.82824,6.9287399999999995,16.70091,6.81334Q16.57359,6.69794,16.44075,6.5889299999999995Q16.30792,6.47991,16.16989,6.37755Q16.031869999999998,6.27518,15.88899,6.17971Q15.74611,6.08424,15.59872,5.9959Q15.45133,5.907556,15.29978,5.826551Q15.14823,5.745546,14.99289,5.6720749999999995Q14.83754,5.598604,14.67878,5.532843Q14.52002,5.467083,14.358229999999999,5.409191Q14.19643,5.3513,14.03199,5.301418Q13.86755,5.251535,13.70086,5.2097809999999996Q13.53417,5.168027,13.36563,5.134503Q13.19709,5.100979,13.02711,5.0757644Q12.857133,5.0505502,12.68612,5.0337069Q12.515107,5.0168636,12.343474,5.0084318Q12.17184,5,12,5L12,6.19995Q12.142381,6.19995,12.284591,6.2069399999999995Q12.426801,6.2139299999999995,12.568496,6.22788Q12.710192,6.24184,12.851032,6.2627299999999995Q12.991872,6.2836300000000005,13.13152,6.3114Q13.27116,6.33918,13.40928,6.37378Q13.54739,6.40838,13.68364,6.44971Q13.819890000000001,6.49104,13.95395,6.53901Q14.08801,6.5869800000000005,14.21955,6.64146Q14.35109,6.69595,14.479800000000001,6.75683Q14.608509999999999,6.8177,14.73408,6.8848199999999995Q14.85965,6.9519400000000005,14.981770000000001,7.02514Q15.1039,7.09834,15.22228,7.17744Q15.34067,7.25655,15.45503,7.34136Q15.56939,7.4261800000000004,15.67945,7.51651Q15.78952,7.60683,15.89501,7.70245Q16.00051,7.79807,16.10119,7.89875Q16.20187,7.99943,16.29748,8.10493Q16.3931,8.21042,16.48343,8.32049Q16.57375,8.43055,16.65857,8.54491Q16.743380000000002,8.65927,16.822490000000002,8.777660000000001Q16.90159,8.89604,16.97479,9.01817Q17.04798,9.14029,17.115099999999998,9.26586Q17.18222,9.39143,17.2431,9.52014Q17.30397,9.64885,17.35846,9.7804Q17.41294,9.911940000000001,17.46091,10.046Q17.50888,10.180060000000001,17.55021,10.31631Q17.591540000000002,10.45256,17.62613,10.59067Q17.66073,10.72879,17.68851,10.86843Q17.71628,11.00808,17.737180000000002,11.14892Q17.75807,11.289760000000001,17.77202,11.43145Q17.785980000000002,11.57315,17.79296,11.71536Q17.79995,11.857569999999999,17.79995,11.99995L17.79995,12L19,12Z\" fill-rule=\"evenodd\" fill=\"#2672FF\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"10\" height=\"2\" viewBox=\"0 0 10 2\"><g><path d=\"M2,1Q2,1.09849,1.98079,1.19509Q1.96157,1.29169,1.92388,1.38268Q1.88619,1.47368,1.83147,1.55557Q1.77675,1.63746,1.70711,1.70711Q1.63746,1.77675,1.55557,1.83147Q1.47368,1.88619,1.38268,1.92388Q1.29169,1.96157,1.19509,1.98079Q1.09849,2,1,2Q0.901509,2,0.80491,1.98079Q0.708311,1.96157,0.617316,1.92388Q0.526322,1.88619,0.44443,1.83147Q0.362537,1.77675,0.292893,1.70711Q0.223249,1.63746,0.16853,1.55557Q0.113811,1.47368,0.0761205,1.38268Q0.0384294,1.29169,0.0192147,1.19509Q0,1.09849,0,1Q0,0.901509,0.0192147,0.80491Q0.0384294,0.708311,0.0761205,0.617316Q0.113811,0.526322,0.16853,0.44443Q0.223249,0.362537,0.292893,0.292893Q0.362537,0.223249,0.44443,0.16853Q0.526322,0.113811,0.617316,0.0761205Q0.708311,0.0384294,0.80491,0.0192147Q0.901509,0,1,0Q1.09849,0,1.19509,0.0192147Q1.29169,0.0384294,1.38268,0.0761205Q1.47368,0.113811,1.55557,0.16853Q1.63746,0.223249,1.70711,0.292893Q1.77675,0.362537,1.83147,0.44443Q1.88619,0.526322,1.92388,0.617316Q1.96157,0.708311,1.98079,0.80491Q2,0.901509,2,1ZM6,1Q6,1.09849,5.98078,1.19509Q5.96157,1.29169,5.92388,1.38268Q5.88619,1.47368,5.83147,1.55557Q5.77675,1.63746,5.70711,1.70711Q5.63746,1.77675,5.55557,1.83147Q5.47368,1.88619,5.38268,1.92388Q5.29169,1.96157,5.19509,1.98079Q5.09849,2,5,2Q4.90151,2,4.80491,1.98079Q4.70831,1.96157,4.61732,1.92388Q4.52632,1.88619,4.44443,1.83147Q4.36254,1.77675,4.29289,1.70711Q4.22325,1.63746,4.16853,1.55557Q4.11381,1.47368,4.07612,1.38268Q4.03843,1.29169,4.01921,1.19509Q4,1.09849,4,1Q4,0.901509,4.01921,0.80491Q4.03843,0.708311,4.07612,0.617316Q4.11381,0.526322,4.16853,0.44443Q4.22325,0.362537,4.29289,0.292893Q4.36254,0.223249,4.44443,0.16853Q4.52632,0.113811,4.61732,0.0761205Q4.70831,0.0384294,4.80491,0.0192147Q4.90151,0,5,0Q5.09849,0,5.19509,0.0192147Q5.29169,0.0384294,5.38268,0.0761205Q5.47368,0.113811,5.55557,0.16853Q5.63746,0.223249,5.70711,0.292893Q5.77675,0.362537,5.83147,0.44443Q5.88619,0.526322,5.92388,0.617316Q5.96157,0.708311,5.98078,0.80491Q6,0.901509,6,1ZM10,1Q10,1.09849,9.98078,1.19509Q9.96157,1.29169,9.92388,1.38268Q9.88619,1.47368,9.83147,1.55557Q9.77675,1.63746,9.70711,1.70711Q9.63746,1.77675,9.55557,1.83147Q9.47368,1.88619,9.38268,1.92388Q9.29169,1.96157,9.19509,1.98079Q9.09849,2,9,2Q8.90151,2,8.80491,1.98079Q8.70831,1.96157,8.61732,1.92388Q8.52632,1.88619,8.44443,1.83147Q8.36254,1.77675,8.29289,1.70711Q8.22325,1.63746,8.16853,1.55557Q8.11381,1.47368,8.07612,1.38268Q8.03843,1.29169,8.01921,1.19509Q8,1.09849,8,1Q8,0.901509,8.01921,0.80491Q8.03843,0.708311,8.07612,0.617316Q8.11381,0.526322,8.16853,0.44443Q8.22325,0.362537,8.29289,0.292893Q8.36254,0.223249,8.44443,0.16853Q8.52632,0.113811,8.61732,0.0761205Q8.70831,0.0384294,8.80491,0.0192147Q8.90151,0,9,0Q9.09849,0,9.19509,0.0192147Q9.29169,0.0384294,9.38268,0.0761205Q9.47368,0.113811,9.55557,0.16853Q9.63746,0.223249,9.70711,0.292893Q9.77675,0.362537,9.83147,0.44443Q9.88619,0.526322,9.92388,0.617316Q9.96157,0.708311,9.98078,0.80491Q10,0.901509,10,1Z\" fill=\"#D8D8D8\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"16.470703125\" height=\"20\" viewBox=\"0 0 16.470703125 20\"><g><g><path d=\"M2.35294,-1.33717e-13L10.1644,-1.33717e-13C10.8105,-1.33717e-13,11.4282,0.265681,11.8725,0.734719L15.8258,4.90759C16.2398,5.34465,16.4706,5.92378,16.4706,6.52582L16.4706,17.6471C16.4706,18.9466,15.4171,20,14.1176,20L2.35294,20C1.05345,20,0,18.9466,0,17.6471L0,2.35294C0,1.05345,1.05345,-1.33717e-13,2.35294,-1.33717e-13Z\" fill-rule=\"evenodd\" fill=\"#E94848\" fill-opacity=\"1\"></path></g><g><path d=\"M6.562211792755127,6.359347927551269C6.559441792755127,5.77749192755127,7.0261117927551275,5.3021122375512695,7.607921792755127,5.2941179275512695C8.189731792755126,5.3021122375512695,8.656391792755127,5.77749192755127,8.653621792755127,6.359347927551269C8.653621792755127,7.0341479275512695,8.330201792755126,7.904767927551269,8.051721792755128,8.77551792755127C8.446331792755128,9.523027927551269,8.958761792755126,10.20210792755127,9.569311792755126,10.78666792755127C10.294001792755127,10.53734792755127,11.242471792755126,10.300337927551269,11.895331792755126,10.300337927551269C12.476671792755127,10.30825792755127,12.943201792755127,10.78283792755127,12.941171792755126,11.36422792755127C12.941171792755126,11.94914792755127,12.469281792755128,12.429457927551269,11.895331792755126,12.429457927551269C11.081961792755127,12.429457927551269,10.092171792755128,12.05855792755127,9.408671792755127,11.49811792755127C8.472381792755126,11.72416792755127,7.500911792755127,12.10229792755127,6.575591792755127,12.473197927551269C6.173121792755127,13.24416792755127,5.721961792755128,14.08803792755127,5.340091792755127,14.55377792755127C5.142461792755127,14.76523792755127,4.864811792755127,14.88353792755127,4.575401792755127,14.87960792755127C4.001323792755127,14.87960792755127,3.529433061155127,14.39807792755127,3.529433061155127,13.81436792755127C3.527600122755127,13.52080792755127,3.644308792755127,13.23891792755127,3.853122792755127,13.03256792755127C4.372095792755127,12.60575792755127,5.236831792755127,12.317507927551269,6.205891792755127,11.930957927551269C6.678851792755127,10.989717927551268,7.048551792755127,9.87579792755127,7.376791792755126,8.83516792755127C6.958531792755127,7.987557927551269,6.562211792755127,7.085247927551269,6.562211792755127,6.359347927551269ZM8.026161792755126,6.35813792755127C8.026161792755126,6.11978592755127,7.842521792755127,5.93252792755127,7.607911792755127,5.93252792755127L7.607911792755127,5.933731927551269C7.373171792755127,5.933731927551269,7.189651792755127,6.11991992755127,7.189651792755127,6.359347927551269C7.189651792755127,6.6937279275512696,7.403661792755127,7.284667927551269,7.663821792755127,7.89994792755127C7.858431792755127,7.2676779275512695,8.026161792755126,6.67781792755127,8.026161792755126,6.35813792755127ZM8.872511792755127,10.982487927551269C8.462651792755127,10.55369792755127,8.099061792755126,10.08295792755127,7.7877517927551265,9.57804792755127L7.7877517927551265,9.57684792755127C7.568791792755127,10.25525792755127,7.337931792755127,10.944767927551268,7.048481792755127,11.607397927551268C7.646771792755127,11.37639792755127,8.252291792755127,11.15503792755127,8.872511792755127,10.982487927551269ZM12.313731792755126,11.36543792755127C12.313731792755126,11.125877927551269,12.130081792755126,10.93982792755127,11.895471792755126,10.93982792755127L11.895341792755127,10.938757927551269C11.503971792755127,10.938757927551269,10.833851792755127,11.09431792755127,10.218581792755128,11.271807927551269C10.754801792755128,11.574637927551269,11.423581792755126,11.791047927551269,11.895341792755127,11.791047927551269C12.130081792755126,11.791047927551269,12.313731792755126,11.60378792755127,12.313731792755126,11.36543792755127ZM4.863301792755127,14.13057792755127C5.067681792755127,13.880047927551269,5.359541792755127,13.38153792755127,5.653801792755127,12.846517927551268C5.046951792755127,13.092097927551269,4.513133792755127,13.32442792755127,4.267557792755127,13.51770792755127C4.196933792755127,13.60049792755127,4.157743792755127,13.705637927551269,4.156940792755127,13.81437792755127C4.154635792755127,13.92666792755127,4.197719792755127,14.03514792755127,4.276444792755127,14.11525792755127C4.355169792755127,14.195367927551269,4.4628797927551265,14.24033792755127,4.575191792755127,14.239987927551269C4.682101792755127,14.244157927551269,4.786111792755127,14.204657927551269,4.863301792755127,14.13057792755127Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g><path d=\"M15.58118585510254,4.25974L12.308265855102539,0.931819C11.838675855102538,0.45438,11.23988085510254,0.129982,10.588235855102539,0L10.588235855102539,3.7352C10.588235855102539,4.92108,11.533623855102539,5.88235,12.69989585510254,5.88235L16.470585855102538,5.88235C16.32802585510254,5.26801,16.020065855102537,4.70616,15.58118585510254,4.25974Z\" fill=\"#000000\" fill-opacity=\"0.10000000149011612\"></path></g></g></svg>"

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14.001220703125\" height=\"12.0006103515625\" viewBox=\"0 0 14.001220703125 12.0006103515625\"><g><path d=\"M9.2949,11.8839L5.69362,9.80934L3.719,11.6696C3.16318,12.1933,2.25054,11.7992,2.25054,11.0356L2.25054,9.00107L9.36525,3.50195L1.98882,7.84424L0.304124,6.39895C-0.193235,5.97227,-0.0591159,5.16987,0.549968,4.92813L12.807,0.0633736C13.4947,-0.209545,14.188,0.444798,13.9553,1.14706L10.5566,11.4031C10.3831,11.9267,9.77285,12.1593,9.2949,11.8839Z\" fill-rule=\"evenodd\" fill=\"currentColor\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#00BF6F\" cx=\"9\" cy=\"9\" r=\"9\"></circle><path d=\"M13.898 7.5l-5.234 5.104a1.157 1.157 0 0 1-1.589 0l-2.622-2.546a1.05 1.05 0 0 1-.327-.773c0-.598.5-1.088 1.12-1.088.306 0 .589.12.795.316l1.828 1.773 4.45-4.33c.208-.196.48-.316.795-.316.62 0 1.121.49 1.121 1.088-.01.294-.13.566-.337.773z\" fill=\"#FFF\"></path></g></svg>"

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"14.74\" height=\"14\" viewBox=\"0 0 14.74 14\"><path d=\"M6.992 14q-.171 0-.343-.009-.171-.008-.342-.025t-.34-.043q-.17-.025-.34-.059-.168-.034-.334-.075-.167-.042-.33-.092-.165-.05-.327-.108-.161-.058-.32-.124t-.314-.14q-.155-.073-.306-.154-.152-.081-.299-.17-.147-.088-.29-.183-.143-.096-.28-.198-.138-.103-.271-.212t-.26-.224q-.127-.115-.248-.237-.122-.121-.237-.249-.115-.127-.224-.26t-.211-.27q-.103-.138-.198-.281-.095-.143-.183-.29-.089-.148-.17-.3-.08-.15-.154-.306-.073-.155-.139-.314-.066-.159-.123-.32Q.35 9.195.3 9.03.251 8.866.209 8.7q-.041-.167-.075-.335-.033-.169-.058-.339-.026-.17-.042-.34-.017-.171-.026-.343Q0 7.172 0 7q0-.172.008-.343.009-.172.026-.343.017-.171.042-.341t.059-.339Q.168 5.466.21 5.3q.042-.167.091-.331.05-.164.108-.326.058-.162.124-.32.066-.16.14-.315.073-.155.154-.307.08-.151.169-.299.088-.147.184-.29.095-.143.198-.28.102-.139.21-.272.11-.133.225-.26.116-.127.237-.249.122-.121.25-.237.126-.115.26-.224.132-.11.27-.211.138-.103.281-.198.143-.096.29-.184.148-.088.3-.17.15-.08.306-.154.155-.073.314-.14.159-.065.32-.123.163-.058.327-.108.164-.05.331-.091.167-.042.335-.075.169-.034.339-.06.17-.024.34-.041.172-.017.344-.026Q6.828 0 7 0q.16 0 .321.007.16.008.32.022.16.015.32.037.159.022.316.052.158.029.315.065.156.037.31.08.155.044.308.095.152.05.302.108.15.058.297.122.147.065.291.136.144.071.285.149.14.077.277.161t.27.175q.133.09.261.186.129.096.253.198.124.102.243.21.12.108.234.22.114.113.223.231.109.119.212.241.103.123.201.251.098.128.19.26.091.131.176.267.086.136.165.276.08.14.152.283.073.143.139.29.066.146.125.295.06.15.112.301.052.152.097.306.046.154.084.31.038.156.07.314.03.158.054.316.024.16.04.319h.577a.2.2 0 0 1 .146.336l-1.149 1.233a.2.2 0 0 1-.284.008l-1.292-1.232a.2.2 0 0 1 .138-.345h.657q-.033-.26-.089-.517-.055-.256-.134-.507-.079-.25-.18-.492-.101-.242-.223-.474-.123-.232-.266-.453-.143-.22-.305-.426t-.342-.397q-.18-.19-.377-.364t-.409-.33q-.211-.155-.436-.29-.225-.136-.46-.25-.237-.115-.482-.208-.246-.093-.499-.163-.252-.07-.51-.117-.259-.048-.52-.071Q7.263 1.2 7 1.2q-.142 0-.284.007-.143.007-.284.02-.142.015-.283.036-.14.02-.28.048t-.278.063q-.138.034-.274.076-.137.041-.27.089-.135.048-.266.102-.132.055-.26.116-.13.06-.255.128-.125.067-.248.14-.122.073-.24.152-.119.08-.233.164-.114.085-.224.175-.11.09-.216.186Q3 2.798 2.9 2.9q-.1.1-.196.206-.096.105-.186.215t-.175.225q-.085.114-.164.233-.08.118-.153.24t-.14.248q-.067.125-.128.254-.06.129-.115.26-.055.132-.103.266-.048.134-.09.27-.04.137-.075.275-.035.138-.062.277-.028.14-.049.28-.02.142-.035.283-.014.142-.02.284Q1.2 6.858 1.2 7t.007.285q.007.142.021.283.014.142.035.283.02.14.049.28.027.14.062.278t.076.275q.041.136.09.27.047.134.102.265.054.132.115.26.06.13.128.255.067.126.14.248.074.122.153.24.079.119.164.233.084.114.175.224.09.11.186.216.095.105.196.206.1.1.206.196.106.096.216.186t.224.175q.114.085.233.164.118.08.24.153t.248.14q.126.067.254.128.129.06.26.115.132.055.266.103.134.048.27.09.137.04.275.075.138.035.277.063.14.027.281.048.14.021.283.035.141.014.283.021.143.007.285.007.06 0 .117.012.058.011.113.034.055.022.104.055.049.033.09.075.042.042.075.09.033.05.056.104.022.055.034.113.011.058.011.117 0 .06-.011.117-.012.058-.034.113-.023.054-.056.103-.033.05-.074.091-.042.042-.091.075-.05.033-.104.055-.055.023-.113.034Q7.06 14 7 14h-.008z\" fill-rule=\"evenodd\" fill=\"#2672FF\"></path></svg>"

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FFBE3A\" cx=\"9\" cy=\"9\" r=\"9\"></circle><g transform=\"translate(7.56 2.52)\" fill=\"#FFF\"><rect x=\".36\" width=\"2.16\" height=\"9.36\" rx=\"1.08\"></rect><circle cx=\"1.44\" cy=\"11.88\" r=\"1.44\"></circle></g></g></svg>"

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"16.470703125\" height=\"20\" viewBox=\"0 0 16.470703125 20\"><g><g><path d=\"M2.35294,-1.33717e-13L10.1644,-1.33717e-13C10.8105,-1.33717e-13,11.4282,0.265681,11.8725,0.734719L15.8258,4.90759C16.2398,5.34465,16.4706,5.92378,16.4706,6.52582L16.4706,17.6471C16.4706,18.9466,15.4171,20,14.1176,20L2.35294,20C1.05345,20,0,18.9466,0,17.6471L0,2.35294C0,1.05345,1.05345,-1.33717e-13,2.35294,-1.33717e-13Z\" fill-rule=\"evenodd\" fill=\"#2672FF\" fill-opacity=\"1\"></path></g><g><path d=\"M3.529411792755127,7.647058963775635L4.846861792755127,7.647058963775635L6.184271792755127,13.015318963775634L6.224191792755127,13.015318963775634L7.631461792755127,7.647058963775635L8.839121792755126,7.647058963775635L10.246391792755126,13.015318963775634L10.286321792755128,13.015318963775634L11.623731792755127,7.647058963775635L12.941171792755126,7.647058963775635L10.885161792755127,14.705878963775636L9.647551792755127,14.705878963775636L8.260241792755128,9.396938963775636L8.220321792755126,9.396938963775636L6.823031792755128,14.705878963775636L5.575451792755127,14.705878963775636L3.529411792755127,7.647058963775635Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g><path d=\"M15.58118585510254,4.25974L12.308265855102539,0.931819C11.838675855102538,0.45438,11.23988085510254,0.129982,10.588235855102539,0L10.588235855102539,3.7352C10.588235855102539,4.92108,11.533623855102539,5.88235,12.69989585510254,5.88235L16.470585855102538,5.88235C16.32802585510254,5.26801,16.020065855102537,4.70616,15.58118585510254,4.25974Z\" fill=\"#000000\" fill-opacity=\"0.10000000149011612\"></path></g></g></svg>"

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"16.470703125\" height=\"20\" viewBox=\"0 0 16.470703125 20\"><g><g><path d=\"M2.35294,-1.33717e-13L10.1644,-1.33717e-13C10.8105,-1.33717e-13,11.4282,0.265681,11.8725,0.734719L15.8258,4.90759C16.2398,5.34465,16.4706,5.92378,16.4706,6.52582L16.4706,17.6471C16.4706,18.9466,15.4171,20,14.1176,20L2.35294,20C1.05345,20,0,18.9466,0,17.6471L0,2.35294C0,1.05345,1.05345,-1.33717e-13,2.35294,-1.33717e-13Z\" fill-rule=\"evenodd\" fill=\"#00BF6F\" fill-opacity=\"1\"></path></g><g><path d=\"M4.878575549285888,6.470588684082031L6.422022549285889,6.470588684082031L8.235292549285889,8.961938684082032L10.04857254928589,6.470588684082031L11.592012549285888,6.470588684082031L8.990822549285888,9.88136868408203L11.76470254928589,13.529408684082032L10.221262549285889,13.529408684082032L8.235292549285889,10.80078868408203L6.249322549285889,13.529408684082032L4.705882549285889,13.529408684082032L7.458172549285889,9.88136868408203L4.878575549285888,6.470588684082031Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g><path d=\"M15.58118585510254,4.25974L12.308265855102539,0.931819C11.838675855102538,0.45438,11.23988085510254,0.129982,10.588235855102539,0L10.588235855102539,3.7352C10.588235855102539,4.92108,11.533623855102539,5.88235,12.69989585510254,5.88235L16.470585855102538,5.88235C16.32802585510254,5.26801,16.020065855102537,4.70616,15.58118585510254,4.25974Z\" fill=\"#000000\" fill-opacity=\"0.10000000149011612\"></path></g></g></svg>"

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ selectContactConfig; });

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(1);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./src/http/ww-open-component/index.js

let request = external_vue_default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

/**
 * @method 获取企业微信分享配置
 */

function httpGetWxworkConfig() {
  let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  request = external_vue_default.a.prototype.commonRequest;
  params.location_url = window.location.href;
  return request.get("/app_api/wx_work/ac_info/", params);
}
// EXTERNAL MODULE: ./src/assets/js/utils/tools.js
var tools = __webpack_require__(4);

// CONCATENATED MODULE: ./packages/ww-open-component/src/wxConfig.js



// eslint-disable-next-line import/prefer-default-export
function selectContactConfig() {
  httpGetWxworkConfig({
    location_url: window.location.href,
    c_type: "ac"
  }).then(res => {
    Object(tools["j" /* loadJS */])("https://res.wx.qq.com/open/js/jweixin-1.2.0.js", () => {
      Object(tools["j" /* loadJS */])("https://res.wx.qq.com/wwopen/js/jsapi/jweixin-1.0.0.js", () => {
        Object(tools["j" /* loadJS */])("https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js", () => {
          var _wx, _res$data, _res$data2, _res$data3, _res$data4, _res$data5;
          wx && ((_wx = wx) === null || _wx === void 0 ? void 0 : _wx.agentConfig({
            corpid: res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.corpid,
            // 必填，企业微信的corpid，必须与当前登录的企业一致
            agentid: +(res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.agentid),
            // 必填，企业微信的应用id （e.g. 1000247）
            timestamp: res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.timestamp,
            // 必填，生成签名的时间戳
            nonceStr: res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.noncestr,
            // 必填，生成签名的随机串
            signature: res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.signature,
            // 必填，签名，见附录1
            jsApiList: ["selectEnterpriseContact"],
            // 必填，传入需要使用的接口名称
            success(res) {
              // 回调
              console.log(res, "wxwork agentConfig res");
            },
            fail(res) {
              console.log("wxwork agentConfig error", res);
              if (res.errMsg.includes("function not exist")) {
                // eslint-disable-next-line no-alert
                alert("版本过低请升级");
              }
            }
          }));
        });
      });
    });
  });
}

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui/lib/theme-chalk/dialog.css");

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),
/* 112 */,
/* 113 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/input-number.css");

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSpaceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCurrentSpace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return switchSpace; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

let request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

// 获取空间列表
function fetchSpaceList(host) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get(`${host || ""}/api/enterprise/space_list/`);
  // return request.get('/app_api/ent/space_list/');
}

// 获取当前空间
function fetchCurrentSpace() {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/api/enterprise/current_space/");
  // return request.get('/app_api/ent/current_space/');
}

// 切换空间
function switchSpace(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/enterprise/switch_space/", params);
  // return request.get('/app_api/ent/switch_space/');
}

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchBeanChangeStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clickToBeanPageHandler; });
/* unused harmony export httpGetNotifyBeans */
/* unused harmony export httpUpdateNotifyBeans */
/* harmony import */ var blueimp_md5__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47);
/* harmony import */ var blueimp_md5__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(blueimp_md5__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(111);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);



const REWARD_API_MAP = {
  "prod": "//rewards.wenjuan.com/",
  "default": "//point-sys-test.wenjuan.com/"
};
// 环保豆 独立的请求签名及签名规则
const APPSECRET = '62a98ae621552f98297da04bc15ce478';
const APPKEY = 'wj0livbtnt7xuu7cv3';
const KEY_NOTIFY_CHANGE = 'notify-center-change';
const KEY_BEAN_CHANGE = 'is-bean-change';
// todo:通过location.host判断
const host = window.location.host;
let REWARD_API_PRE = REWARD_API_MAP.default;
if (host === 'www-pre.wenjuan.com' || host === 'www.wenjuan.com') {
  REWARD_API_PRE = REWARD_API_MAP.prod;
}

// 参数签名
function getJsonParams(postData) {
  const strData = JSON.stringify(postData);
  const timestamp = new Date().getTime() / 1000;
  const checkField = {
    appkey: APPKEY,
    timestamp
  };
  const data = {};
  Object.assign(data, checkField);
  const keyList = Object.keys(data).sort();
  const valueList = [strData];
  keyList.forEach(key => {
    if (key !== 'app_secret') {
      valueList.push(data[key]);
    }
  });
  const signature = blueimp_md5__WEBPACK_IMPORTED_MODULE_0___default()(valueList.join('') + APPSECRET);
  return {
    payload: strData,
    params: {
      appkey: APPKEY,
      timestamp,
      signature
    }
  };
}
function getParams(data) {
  let isAppApi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const checkField = {
    appkey: APPKEY,
    timestamp: new Date().getTime() / 1000
  };
  if (isAppApi) {
    checkField.web_site = 'wenjuan_mweb';
  }
  data = data || {};
  Object.assign(data, checkField);
  const keyList = Object.keys(data).sort();
  const valueList = [];
  keyList.forEach(key => {
    if (key !== 'app_secret') {
      valueList.push(data[key]);
    }
  });
  data.signature = blueimp_md5__WEBPACK_IMPORTED_MODULE_0___default()(valueList.join('') + APPSECRET);
  return data;
}
async function ajaxPromise(url) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  try {
    const {
      type,
      data
    } = params;
    const config = {
      url,
      method: type || 'GET',
      withCredentials: true
    };
    if (config.method === 'GET') {
      config.params = data;
    } else {
      config.headers = {
        'Content-Type': 'application/json'
      };
      config.data = data;
    }
    const {
      data: res
    } = await axios__WEBPACK_IMPORTED_MODULE_1___default()(config);
    const responseData = typeof res === 'object' ? res : JSON.parse(res);
    return responseData;
  } catch (error) {
    console.log(error);
    Promise.reject(error);
  }
}
function timeFormat(timestamp) {
  const time = new Date(timestamp);
  const year = time.getFullYear();
  const month = time.getMonth() + 1;
  const date = time.getDate();
  const hours = time.getHours();
  const minutes = time.getMinutes();
  const seconds = time.getSeconds();
  return `${year}-${settingDigit(month)}-${settingDigit(date)} ${settingDigit(hours)}:${settingDigit(minutes)}:${settingDigit(seconds)}`;
}
function settingDigit(m) {
  return m < 10 ? `0${m}` : m;
}
function getLocalBeanIsChange() {
  return _utils_cookie__WEBPACK_IMPORTED_MODULE_2__[/* get */ "b"](KEY_BEAN_CHANGE) === 'true';
}
function getlocalBeanNotifyCenterIsChange() {
  return _utils_cookie__WEBPACK_IMPORTED_MODULE_2__[/* get */ "b"](KEY_NOTIFY_CHANGE) === 'true';
}
async function fetchBeanChangeStatus() {
  let isBeanChange = false;
  const isNotifyCenterChange = getlocalBeanNotifyCenterIsChange();
  if (!isNotifyCenterChange) {
    const data = getParams();
    const resData = await ajaxPromise(`${REWARD_API_PRE}rewards_api/user/notify-center`, {
      data
    });
    if (resData.code === 1) {
      var _resData$data, _resData$data$rewards;
      if (((_resData$data = resData.data) === null || _resData$data === void 0 ? void 0 : (_resData$data$rewards = _resData$data.rewards) === null || _resData$data$rewards === void 0 ? void 0 : _resData$data$rewards.changed) === 1) {
        isBeanChange = true;
      }
      // 请求成功后设置时间，限制时间内将不再请求
      const nowTime = new Date().getTime() + 60 * 1000 * 15;
      const time = timeFormat(nowTime);
      _utils_cookie__WEBPACK_IMPORTED_MODULE_2__[/* set */ "c"](KEY_NOTIFY_CHANGE, true, time);
      _utils_cookie__WEBPACK_IMPORTED_MODULE_2__[/* set */ "c"](KEY_BEAN_CHANGE, isBeanChange, time);
    }
  }
  return isBeanChange;
}

// 点击事件
function clickToBeanPageHandler() {
  if (!getLocalBeanIsChange()) {
    window.location.href = `${REWARD_API_PRE}rewards/m/home`;
  } else {
    const paramData = getJsonParams();
    const {
      params
    } = paramData;
    ajaxPromise(`${REWARD_API_PRE}rewards_api/user/notify-center?appkey=${params.appkey}&timestamp=${params.timestamp}&signature=${params.signature}`, {
      type: 'POST'
    }).then(res => {
      window.location.href = `${REWARD_API_PRE}rewards/m/home`;
    }).catch(e => {
      window.location.href = `${REWARD_API_PRE}rewards/m/home`;
    });
  }
}

// 获取是否有待领取环保豆(发布页)
async function httpGetNotifyBeans() {
  let resultData = {};
  const data = getParams();
  await ajaxPromise(`${REWARD_API_PRE}rewards_api/user/notify-center/rewards/banner`, {
    data
  }).then(res => {
    resultData = res;
  });
  return resultData;
}

// 更新环保豆状态(发布页)
async function httpUpdateNotifyBeans(param) {
  let resultData = {};
  const paramData = getJsonParams(param);
  const {
    params
  } = paramData;
  await ajaxPromise(`${REWARD_API_PRE}rewards_api/user/notify-center/rewards/banner?appkey=${params.appkey}&timestamp=${params.timestamp}&signature=${params.signature}`, {
    data: paramData.payload,
    type: 'POST'
  }).then(res => {
    resultData = res;
  });
  return resultData;
}

/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTI4cHgiIGhlaWdodD0iNDVweCIgdmlld0JveD0iMCAwIDEyOCA0NSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDxkZWZzPgogICAgICAgIDxwb2x5Z29uIGlkPSJwYXRoLTEiIHBvaW50cz0iMCAwIDQ0Ljk5OTk3NjQgMCA0NC45OTk5NzY0IDQ0Ljk5OTkyOTIgMCA0NC45OTk5MjkyIj48L3BvbHlnb24+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0i6aG16Z2iLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIzIj4KICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC02Ij4KICAgICAgICAgICAgICAgIDxnIGlkPSLnvJbnu4QiPgogICAgICAgICAgICAgICAgICAgIDxtYXNrIGlkPSJtYXNrLTIiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGF0aC0xIj48L3VzZT4KICAgICAgICAgICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IkNsaXAtMiI+PC9nPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMi40OTk5ODgyLDQ0Ljk5OTk3NjQgTDIyLjQ5OTk4ODIsNDQuOTk5OTc2NCBDMTAuMDczNDEsNDQuOTk5OTc2NCAwLDM0LjkyNjU2NjQgMCwyMi40OTk3NTIyIEMwLDEwLjA3MzQxIDEwLjA3MzQxLDAgMjIuNDk5OTg4MiwwIEwyMi40OTk5ODgyLDAgQzM0LjkyNjMzMDQsMCA0NC45OTk5NzY0LDEwLjA3MzQxIDQ0Ljk5OTk3NjQsMjIuNDk5NzUyMiBDNDQuOTk5OTc2NCwzNC45MjY1NjY0IDM0LjkyNjMzMDQsNDQuOTk5OTc2NCAyMi40OTk5ODgyLDQ0Ljk5OTk3NjQiIGlkPSJGaWxsLTEiIGZpbGw9IiMyNjcyRkYiIG1hc2s9InVybCgjbWFzay0yKSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTI4Ljk0MTk4NjgsMzYuNDgxNjgyMSBMMjkuMTA3MTcxLDM4LjYxMTM3OTYgQzI5LjEzNDMwODUsMzguNjAyMTc2NCAyOS4xNjI4NjE3LDM4LjU5Njk4NDkgMjkuMTkxNjUxLDM4LjU5Njk4NDkgQzI5LjI1MjA2MTMsMzguNTk2OTg0OSAyOS4zMTM4ODc0LDM4LjYxODkzMDkgMjkuMzY1MDk0NSwzOC42Njc3NzgyIEMzMC41ODk4MTgsMzkuODM1MTU5MiAzMS42MzQ3MjY3LDQxLjE4ODAxODUgMzIuNDYzNDc5OSw0Mi42NzcyNzI5IEMzMS41MTY3Mzc5LDQzLjE0NTkyNDMgMzAuNTMyNDc1NSw0My41NDk0NDYgMjkuNTE2MTIwMiw0My44ODI4ODIyIEMyNy4zMDgwNzgxLDQ0LjYwNjg2MTQgMjQuOTUwMTkwNCw0NSAyMi41MDAwMzU0LDQ1IEMyMC4wNTAzNTI0LDQ1IDE3LjY5MjkzNjYsNDQuNjA3MDk3NCAxNS40ODUzNjY1LDQzLjg4MzM1NDIgTDE1LjQ4NTM2NjUsNDMuODgzMzU0MiBMMTYuMDU5NzM1OSwzNi40ODE2ODIxIEwyOC45NDE5ODY4LDM2LjQ4MTY4MjEgWiBNMTUuODA4MzcyNiwzOC41OTcwMzIxIEMxNS44MzcxNjE5LDM4LjU5NzAzMjEgMTUuODY1NzE1MSwzOC42MDE5ODc3IDE1Ljg5Mjg1MjYsMzguNjExNDI2OCBMMTUuODkyODUyNiwzOC42MTE0MjY4IEwxNS40ODM5MDM0LDQzLjg4MjY5MzUgQzE0LjQ2NzMxMjEsNDMuNTQ5NDkzMSAxMy40ODMwNDk3LDQzLjE0NTczNTUgMTIuNTM2MzA3OCw0Mi42NzczMjAxIEMxMy4zNjUyOTY5LDQxLjE4NzgyOTcgMTQuNDEwMjA1NiwzOS44MzUyMDY0IDE1LjYzNDkyOTEsMzguNjY3ODI1NCBDMTUuNjg1OTAwMiwzOC42MTg5NzggMTUuNzQ3NzI2NCwzOC41OTcwMzIxIDE1LjgwODM3MjYsMzguNTk3MDMyMSBaIiBpZD0i5b2i54q257uT5ZCIIiBmaWxsPSIjQURDQkZGIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjIuNDc0NTAyNiwxMS40MjYxOTg1IEwyMi40NzQ1MDI2LDExLjQyNjE5ODUgQzE2LjQ0MTUwMDQsMTEuNDI2MTk4NSAxMS4xMDkzNTE1LDE1LjM0ODYxNzUgOS4zMTMwOTAzLDIxLjEwNzg4NTggTDYuODQ5NDg0NiwyOS4wMDY3NjI2IEM2LjY2NTE4NjEzLDI5LjU5NzY1MDQgNi41NzE1MDMwNCwzMC4yMTMwNzk5IDYuNTcxNTAzMDQsMzAuODMxODEzIEw2LjU3MTUwMzA0LDMwLjg0ODU2NzQgQzYuNTcxNTAzMDQsMzMuMDEyMDA5NyA3LjcxMTk4MjU3LDM1LjAxNTQ1OTIgOS41NzI0Mjk2NCwzNi4xMTk4MzQxIEMxMi45OTEwMzY1LDM4LjE0OTAwNTEgMTYuODkzMzk3NCwzOS4yMTk4NzEzIDIwLjg2ODkxMTMsMzkuMjE5ODcxMyBMMjQuMTMxMDY1MSwzOS4yMTk4NzEzIEMyOC4xMDY1NzksMzkuMjE5ODcxMyAzMi4wMDg3MDM5LDM4LjE0OTAwNTEgMzUuNDI3MzEwOCwzNi4xMTk4MzQxIEwzNS40Mjc1NDY4LDM2LjExOTgzNDEgQzM3LjI4Nzc1NzksMzUuMDE1NDU5MiAzOC40Mjg0NzM0LDMzLjAxMjAwOTcgMzguNDI4NDczNCwzMC44NDg1Njc0IEMzOC40Mjg0NzM0LDMwLjIxODc0MzMgMzguMzMxNDg2NiwyOS41OTI2OTQ5IDM4LjE0MDgxNjcsMjguOTkyNjAzOSBMMzUuNjE0MjA1LDIxLjAzODk4MDMgQzMzLjc5NTk5NzksMTUuMzE0NjM2NyAyOC40ODA4Mzk0LDExLjQyNjE5ODUgMjIuNDc0NTAyNiwxMS40MjYxOTg1IiBpZD0iRmlsbC03IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMzUuNjE0MjUyMiwyMS4wMzkwNTExIEMzMy43OTU4MDkxLDE1LjMxNDQ3MTYgMjguNDgwODg2NiwxMS40MjYyNjkzIDIyLjQ3NDU0OTgsMTEuNDI2MjY5MyBDMjIuNDQ5MzAwMiwxMS40MjYyNjkzIDIyLjQyNDI4NjYsMTEuNDI3Njg1MiAyMi4zOTkyNzMsMTEuNDI3Njg1MiBDMjYuNTMxMDA0LDExLjQ1ODEyNjMgMjkuOTM2NjMyMiwxNC44MjY5NDE5IDI5Ljk5MTg1MDksMTguOTY5MDU2IEMzMC4wMTUyMTI3LDIwLjcyOTY4NDYgMjkuNDQzMjAzMSwyMi4zNTU4MDU5IDI4LjQ2NDYwNDIsMjMuNjU5MzQ1OSBDMjguMjg3ODU3LDIzLjg5NDg1MTUgMjguMDk2NzE1MSwyNC4xMTgzMjIzIDI3Ljg5NDQ4MjQsMjQuMzMxNDEgTDI3LjYwNDIzLDI0LjYyMTg5ODQgTDI2Ljk4OTk4MDQsMjUuMjM2MTQ4IEMyNS4zODM5MTcxLDI2Ljg0MTk3NTMgMjUuMzgzOTE3MSwyOS40NDU3NTE2IDI2Ljk4OTk4MDQsMzEuMDUxNTc4OSBDMjcuNzYxMTU1MSwzMS44MjI3NTM2IDI4LjgwNzAwNzYsMzIuMjU2MDA4NCAyOS44OTc2OTU5LDMyLjI1NjAwODQgTDM4LjI2MTQ0ODUsMzIuMjU2MDA4NCBDMzguMzY5MjkwMiwzMS43OTk4NjM4IDM4LjQyODUyMDYsMzEuMzI4NjE2NiAzOC40Mjg1MjA2LDMwLjg0ODQwMjIgQzM4LjQyODUyMDYsMzAuMjE4NTc4MSAzOC4zMzE1MzM4LDI5LjU5Mjc2NTcgMzguMTQwODYzOSwyOC45OTI2NzQ3IEwzNS42MTQyNTIyLDIxLjAzOTA1MTEgWiIgaWQ9IkZpbGwtOSIgZmlsbD0iI0JCRDFGRiI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTIyLjQ5Mjk1NjEsMTEuNDI2NDEwOSBDMjIuNDg2ODIwNywxMS40MjY0MTA5IDIyLjQ4MDY4NTIsMTEuNDI2MTc0OSAyMi40NzQ1NDk4LDExLjQyNjE3NDkgQzE2LjQ0MTU0NzYsMTEuNDI2MTc0OSAxMS4xMDkzOTg3LDE1LjM0ODU5MzkgOS4zMTMxMzc1LDIxLjEwNzg2MjIgTDYuODQ5NTMxNzksMjkuMDA2NzM5IEM2LjY2NTIzMzMyLDI5LjU5NzYyNjggNi41NzE1NTAyMywzMC4yMTMwNTYzIDYuNTcxNTUwMjMsMzAuODMxNzg5NCBMNi41NzE1NTAyMywzMC44NDg1NDM4IEM2LjU3MTU1MDIzLDMxLjMyODUyMjIgNi42MzA1NDQ2MiwzMS43OTk3Njk0IDYuNzM4Mzg2MzYsMzIuMjU2MTUgTDE0Ljk0NzgwOTYsMzIuMjU2MTUgQzE2LjAzODI2MTksMzIuMjU2MTUgMTcuMDg0MzUwNCwzMS44MjI4OTUyIDE3Ljg1NTUyNTEsMzEuMDUxNDg0NSBDMTkuNDYxMzUyNCwyOS40NDU2NTczIDE5LjQ2MTM1MjQsMjYuODQxODgwOSAxNy44NTU1MjUxLDI1LjIzNjA1MzYgTDE3LjI0MTI3NTUsMjQuNjIxODA0IEwxNi45NTEwMjMxLDI0LjMzMTU1MTYgQzE2Ljc0OTAyNjMsMjQuMTE4MjI3OSAxNi41NTc2NDg1LDIzLjg5NDc1NzIgMTYuMzgxMTM3MywyMy42NTk0ODc1IEMxNS40MDI1Mzg0LDIyLjM1NTcxMTUgMTQuODMwMjkyOCwyMC43Mjk4MjYxIDE0Ljg1MzY1NDYsMTguOTY4OTYxNiBDMTQuOTA4ODczMywxNC44MTEyNzMgMTguMzM5OTg3LDExLjQzMTgzODQgMjIuNDkyOTU2MSwxMS40MjY0MTA5IiBpZD0iRmlsbC0xMSIgZmlsbD0iI0JCRDFGRiI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTIyLjQ5OTk4ODIsMzYuNzQxNDY5OCBMMjIuNDk5OTg4MiwzNi43NDE0Njk4IEMyMS45MzQ4MjE5LDM2Ljc0MTQ2OTggMjEuNDc2Nzg5NSwzNi4yODM0Mzc0IDIxLjQ3Njc4OTUsMzUuNzE4MjcxMSBMMjMuNTIzMTg2OSwzNS43MTgyNzExIEMyMy41MjMxODY5LDM2LjI4MzQzNzQgMjMuMDY1MTU0NSwzNi43NDE0Njk4IDIyLjQ5OTk4ODIsMzYuNzQxNDY5OCIgaWQ9IkZpbGwtMTMiIGZpbGw9IiNCQkQxRkYiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNC45OTQ3OTAxLDMyLjI1NjA1NTYgQzI0Ljk5NDc5MDEsMzAuODc4MTgyNiAyMy44Nzc5MDg0LDI5Ljc2MTMwMDggMjIuNTAwMDM1NCwyOS43NjEzMDA4IEMyMS4xMjIxNjI0LDI5Ljc2MTMwMDggMjAuMDA1MDQ0NywzMC44NzgxODI2IDIwLjAwNTA0NDcsMzIuMjU2MDU1NiBDMjAuMDA1MDQ0NywzMy42MzM5Mjg1IDIxLjEyMjE2MjQsMzQuNzUwODEwMyAyMi41MDAwMzU0LDM0Ljc1MDgxMDMgQzIzLjg3NzkwODQsMzQuNzUwODEwMyAyNC45OTQ3OTAxLDMzLjYzMzkyODUgMjQuOTk0NzkwMSwzMi4yNTYwNTU2IiBpZD0iRmlsbC0xNSIgZmlsbD0iIzJCNDA2MyI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTI4Ljg0MjMzMzQsMTkuMDcyODg2MSBDMjguODQyMzMzNCwxOC4yMTI5ODM5IDI4LjY3MDMwNTgsMTcuMzkzNDMzOCAyOC4zNjAyMzEzLDE2LjY0NTYyMSBDMjcuNDA3MTE3OSwxNC4zNDc0MzU1IDI1LjE0MjY3NzMsMTIuNzMwNTE3MyAyMi40OTk5NjQ2LDEyLjczMDUxNzMgQzIxLjY0MDA2MjQsMTIuNzMwNTE3MyAyMC44MjAyNzYzLDEyLjkwMjU0NDkgMjAuMDcyNDYzNSwxMy4yMTI2MTk1IEMxNy43NzQyNzgsMTQuMTY1NzMyOCAxNi4xNTc1OTU4LDE2LjQzMDE3MzUgMTYuMTU3NTk1OCwxOS4wNzI4ODYxIEMxNi4xNTc1OTU4LDE5LjM5NTIzMTUgMTYuMTgxNjY1NSwxOS43MTE5MTM0IDE2LjIyODE1MzEsMjAuMDIxMjc5OSBDMTYuMzQ2ODQ5OCwyMC44MTAzODg5IDE3LjE3NjA3NDksMjEuMjc4MzMyNCAxNy45MTM1MDQ4LDIwLjk3Mjc0MTQgQzE4LjQzNzEzOSwyMC43NTU4NzgxIDE4LjczOTY2MjIsMjAuMjA5NTkgMTguNjU2MTI2MiwxOS42NDg5MDczIEMxOC42MjgwNDQ4LDE5LjQ2MTA2OTIgMTguNjEzNDE0MiwxOS4yNjg3NDc1IDE4LjYxMzQxNDIsMTkuMDcyODg2MSBDMTguNjEzNDE0MiwxNy40NTM2MDgxIDE5LjYwNDI4NCwxNi4wNjYwNjAxIDIxLjAxMjM2MjEsMTUuNDgyMDE1NiBDMjEuNDcwNjMwNSwxNS4yOTIwNTM3IDIxLjk3MzAyNjcsMTUuMTg2NTcxNyAyMi40OTk5NjQ2LDE1LjE4NjU3MTcgQzI0LjExOTI0MjYsMTUuMTg2NTcxNyAyNS41MDcwMjY2LDE2LjE3NzIwNTUgMjYuMDkwODM1MSwxNy41ODU1MTk2IEMyNi4yODEwMzMsMTguMDQzNzg4IDI2LjM4NjI3OSwxOC41NDYxODQyIDI2LjM4NjI3OSwxOS4wNzI4ODYxIEMyNi4zODYyNzksMjAuMTQ1ODc2MSAyNS45NTE2MDgzLDIxLjExNzE1OTcgMjUuMjQ4NjMxMiwyMS44MjA2MDg4IEwyNS4yNDgxNTkyLDIxLjgyMDEzNjkgTDI1LjIyNzYyOTIsMjEuODQwNjY2OSBMMjEuNjMyMjc1MSwyNS40MzYwMjEgQzIxLjE1Mjc2ODcsMjUuOTE1NTI3NCAyMS4xNTI3Njg3LDI2LjY5MzA3MzQgMjEuNjMyMjc1MSwyNy4xNzI1Nzk4IEMyMi4xMTIwMTc1LDI3LjY1MjA4NjIgMjIuODg5MzI3NiwyNy42NTIwODYyIDIzLjM2OTA2OTksMjcuMTcyNTc5OCBMMjYuOTYyNTM2MiwyMy41Nzg4Nzc2IEwyNi45ODQ3MTgxLDIzLjU1NjY5NTcgTDI2Ljk4NDQ4MjEsMjMuNTU2MjIzOCBDMjguMTMxODA1LDIyLjQwODY2NDkgMjguODQyMzMzNCwyMC44MjQwNzU2IDI4Ljg0MjMzMzQsMTkuMDcyODg2MSIgaWQ9IkZpbGwtMTciIGZpbGw9IiNCQkQxRkYiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zMS4zOTkyNjgzLDI4LjE1NjM5MzkgQzMxLjM5OTI2ODMsMjkuNjMyNDMzNSAzMC40NDIxNDMzLDMwLjgyODgzOTcgMjkuMjYxMzExNiwzMC44Mjg4Mzk3IEMyOC4wODA3MTU5LDMwLjgyODgzOTcgMjcuMTIzMzU0OSwyOS42MzI0MzM1IDI3LjEyMzM1NDksMjguMTU2MzkzOSBDMjcuMTIzMzU0OSwyNi42ODAzNTQyIDI4LjA4MDcxNTksMjUuNDgzOTQ4IDI5LjI2MTMxMTYsMjUuNDgzOTQ4IEMzMC40NDIxNDMzLDI1LjQ4Mzk0OCAzMS4zOTkyNjgzLDI2LjY4MDM1NDIgMzEuMzk5MjY4MywyOC4xNTYzOTM5IiBpZD0iRmlsbC0xOSIgZmlsbD0iIzJCNDA2MyI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTI5LjI2MTI4OCwyNy4yMDQ4ODUyIEMyOS4yNjEyODgsMjYuODU2MTEwMyAyOC45Nzg4MjI4LDI2LjU3Mzg4MTIgMjguNjMwNTIsMjYuNTczODgxMiBDMjguMjgxOTgxMSwyNi41NzM4ODEyIDI3Ljk5OTUxNiwyNi44NTYxMTAzIDI3Ljk5OTUxNiwyNy4yMDQ4ODUyIEMyNy45OTk1MTYsMjcuNTUzNDI0IDI4LjI4MTk4MTEsMjcuODM1NjUzMiAyOC42MzA1MiwyNy44MzU2NTMyIEMyOC45Nzg4MjI4LDI3LjgzNTY1MzIgMjkuMjYxMjg4LDI3LjU1MzQyNCAyOS4yNjEyODgsMjcuMjA0ODg1MiIgaWQ9IkZpbGwtMjEiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNy44NzY1MjcxLDI4LjE1NjM5MzkgQzE3Ljg3NjUyNzEsMjkuNjMyNDMzNSAxNi45MTk0MDIxLDMwLjgyODgzOTcgMTUuNzM4NTcwNCwzMC44Mjg4Mzk3IEMxNC41NTc3Mzg3LDMwLjgyODgzOTcgMTMuNjAwNjEzOCwyOS42MzI0MzM1IDEzLjYwMDYxMzgsMjguMTU2MzkzOSBDMTMuNjAwNjEzOCwyNi42ODAzNTQyIDE0LjU1NzczODcsMjUuNDgzOTQ4IDE1LjczODU3MDQsMjUuNDgzOTQ4IEMxNi45MTk0MDIxLDI1LjQ4Mzk0OCAxNy44NzY1MjcxLDI2LjY4MDM1NDIgMTcuODc2NTI3MSwyOC4xNTYzOTM5IiBpZD0iRmlsbC0yMyIgZmlsbD0iIzJCNDA2MyI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTE1LjczODU0NjgsMjcuMjA0ODg1MiBDMTUuNzM4NTQ2OCwyNi44NTYxMTAzIDE1LjQ1NjA4MTcsMjYuNTczODgxMiAxNS4xMDc1NDI4LDI2LjU3Mzg4MTIgQzE0Ljc1OTI0LDI2LjU3Mzg4MTIgMTQuNDc2Nzc0OCwyNi44NTYxMTAzIDE0LjQ3Njc3NDgsMjcuMjA0ODg1MiBDMTQuNDc2Nzc0OCwyNy41NTM0MjQgMTQuNzU5MjQsMjcuODM1NjUzMiAxNS4xMDc1NDI4LDI3LjgzNTY1MzIgQzE1LjQ1NjA4MTcsMjcuODM1NjUzMiAxNS43Mzg1NDY4LDI3LjU1MzQyNCAxNS43Mzg1NDY4LDI3LjIwNDg4NTIiIGlkPSJGaWxsLTI1IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNOS41NjI2ODM3NywyMC4zODY2NDQgQzExLjEyMjk2NzQsMTYuMjA4NDI1MyAxNC41ODMxMDYzLDEzLjEwMjcyNDcgMTguNzY4ODc2MiwxMS45MzQzOTk4IEMxNy44NjcyMDYsMTAuMzgxNDMxNSAxNC41MjQxMTE5LDUuMDgwNDMxNjQgMTEuNDY4NDM4NSw2LjE2OTk0MDAyIEM3Ljg5NzE1NDE2LDcuNDQzMDM4OTUgOC4zMDQ5MjMzOCwxNy41MDg0MjU3IDguMzA0OTIzMzgsMTcuNTA4NDI1NyBDOC4yODI3NDE0OSwxOC45MTIyNTYyIDguNjgwNTk5NjYsMTkuNzkyOTI0NCA5LjU2MjY4Mzc3LDIwLjM4NjY0NCIgaWQ9IkZpbGwtMjciIGZpbGw9IiNBNUMzRjkiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zNS4zOTQxNzk1LDIwLjQwNTMwOTggQzM2LjMwMTc0OTIsMTkuNzY0Mzk0OCAzNi42OTUxMjM4LDE4LjY1MDM0NDcgMzYuNjk1MTIzOCwxNy41MDg0NDkzIEMzNi42OTUxMjM4LDE3LjUwODQ0OTMgMzcuMTAyNjU3MSw3LjQ0MzA2MjU1IDMzLjUzMTM3MjcsNi4xNjk5NjM2MiBDMzAuNDY4Mzg0LDUuMDc3ODU5NDggMjcuMTE2MDg2OCwxMC40MDc0MTI2IDI2LjIyNDMyNzYsMTEuOTQ1OTg2MyBDMzAuMzk1NDY2OSwxMy4xMjQ5MzAyIDMzLjg0MjE1NTEsMTYuMjMwNjMwOCAzNS4zOTQxNzk1LDIwLjQwNTMwOTgiIGlkPSJGaWxsLTI5IiBmaWxsPSIjQTVDM0Y5Ij48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPHBhdGggZD0iTTc4LjU2NjA4MTcsMzMuMzIyNzk1MyBDNzguODc0NzQwNCwzMy4zNDMzMjU0IDc5LjI3NjEzODIsMzMuMjE0NDgxNiA3OS4yNTg5MTE4LDMzLjc1ODE3MzkgQzc5LjE4NTk5NDgsMzYuMDQwNTQ4OCA3OS40NTkwMjA4LDM4LjMzNTkwMjYgNzkuMDY4OTQ5OSw0MC42MDQ4MjY4IEM3OC44NjQ1OTMzLDQxLjc5NDE1MzcgNzguMjk0MjM1Niw0Mi44MDI0ODU4IDc3LjI2NDQyOTUsNDMuNDk4NjE5NiBDNzcuMDMyNjk5Niw0My42NTUzMDg3IDc2Ljc4ODkzNDcsNDMuODE0NTkzNSA3Ni40OTQ2NzA3LDQzLjc4Njc0ODIgQzc2LjE4NDgzMjIsNDMuNzU3NDg2OSA3Ni4wMzgwNTQxLDQzLjUyMjQ1MzMgNzYuMjk2Njg1Niw0My4zMzc5MTg4IEM3Ny45MzQwMzI3LDQyLjE3MDIzNDUgNzcuOTY1OTYxOSw0MC41MDYxODgyIDc3Ljk4MDQ1NDksMzguODM1MTMyNyBMNzcuOTg0NjMzOSwzOC40MTc1MDYgQzc3Ljk4NjUxODQsMzguMjc4NDM3MiA3Ny45ODkyMDA5LDM4LjEzOTYwMjkgNzcuOTkzNjAwMiwzOC4wMDEyODY0IEM3OC4wMDUzOTksMzcuNjIwMTgyNiA3Ny45OTUyNTIsMzcuMjM4NjA2OSA3Ny45OTU0ODgsMzYuODU3NTAzMiBDNzcuOTk1NzI0LDM1Ljg0MDkxMTggNzguMDEwMTE4NiwzNC44MjQwODQ1IDc3Ljk4OTExNjYsMzMuODA3OTY1MiBDNzcuOTc5OTEzNSwzMy4zNjM4NTU0IDc4LjIyMDYxMDYsMzMuMzAwMzc3NCA3OC41NjYwODE3LDMzLjMyMjc5NTMgWiBNMTExLjcyNzIwNiwzNC41Nzc5ODM1IEMxMTIuOTI5Mjc1LDMyLjU5NTMwMDEgMTE1LjYzOTQ3OCwzMi42NjAxOTM5IDExNi44MTc5NDksMzQuNjU2NTY0MSBDMTE3LjI0MTI5MywzNS4zNzM2OTk5IDExNy40NDE4NzQsMzYuMTUyMTg5OCAxMTcuNDMwMDc1LDM2Ljk4NTE5MDYgQzExNy40MzA1NjcsMzcuODc0MzU0IDExNy4xOTU5ODYsMzguNjkyNzI0MiAxMTYuNjc3MDcxLDM5LjQxOTUzNTEgQzExNS40NDQwODgsNDEuMTQ4MDcwNyAxMTIuOTE3NzEyLDQxLjEzMjAyNDIgMTExLjc3Njc2MSwzOS4zMzc4ODY5IEMxMTAuNzkyNzM0LDM3Ljc5MDM0NiAxMTAuNzc2NDUyLDM2LjE0NTExMDUgMTExLjcyNzIwNiwzNC41Nzc5ODM1IFogTTY0LjI1Njg5ODIsMzQuMjY4MDI3IEM2NS4wNDQzNTUzLDMzLjI1Mjg1MTYgNjYuMTA3NjcwMSwzMi45NjMzMDcxIDY3LjMxODQ3MSwzMy4yMzM5NzM0IEM2OC4zNjcxNTUzLDMzLjQ2ODA2MzEgNjguOTM4NjkyOSwzNC4xOTQ4NzQgNjkuMTkzNTQ4NywzNS4yMjA5MDQ0IEM2OS4zMjgwNTU5LDM1Ljc2MjQ3MjkgNjkuMTg5MzAxMSwzNi4wMzk3NDY1IDY4LjYxNTQwMzcsMzYuMTEzODQzNSBDNjcuNTMyOTc0NiwzNi4yNTM1NDIyIDY2LjQ1ODU2ODgsMzYuNDc3OTU2OCA2NS4zNzI2MDAxLDM2LjU2MTQ5MjkgQzY0LjYwNjE0NDksMzYuNjIwNDg3MyA2NC41Mjc4MDA0LDM2LjkyNzk2NjEgNjQuNjk4MTc2MiwzNy41Nzc2MTIzIEM2NS4wMzg2OTE4LDM4Ljg3NTI1MjkgNjUuODYwMzY1NywzOS42MDQ0MjM1IDY2Ljk2NDUwNDcsMzkuNTA3MjAwOCBDNjcuNzIxOTkyNiwzOS40NDA0MTkxIDY4LjE5NDY1NTcsMzguOTYzMjcyNSA2OC42MDM4NDA4LDM4LjM4ODE5NTIgQzY4Ljc0MjU5NTYsMzguMTkzMjc3NyA2OC44Mjk5MDczLDM3LjgzNjcxNTYgNjkuMTQ1MTczMywzNy45ODIwNzc4IEM2OS40ODIzODUyLDM4LjEzNzM1MSA2OS4zMTY0OTMsMzguNDc3ODY2NyA2OS4yMjc3NjU0LDM4LjcyMTM5NTUgQzY4LjgxOTA1MjMsMzkuODQyMDUyOSA2OC4wNDA1NjIzLDQwLjUzOTgzODYgNjYuODMxNDEzMyw0MC42NzY5NDE1IEM2NS42NTU3NzMxLDQwLjgxMDI2ODggNjQuNTUzNTIyLDQwLjIwMzMzNDYgNjMuOTkzMzExMiwzOS4xNDExOTk2IEM2My42Mjg5NjE5LDM4LjQ1MDQ5MzMgNjMuNTE5MjMyMywzNy43MDEwMjg1IDYzLjQ5NjgxNDQsMzYuOTAzNDI0NCBDNjMuNTI5Mzc5MywzNS45ODAwNDQyIDYzLjY0OTk2MzksMzUuMDQ5ODIwNyA2NC4yNTY4OTgyLDM0LjI2ODAyNyBaIE04NS43NDU3OTMzLDMzLjMwNDEyOTUgQzg2LjM3NTg1MzQsMzMuMzEzNTY4NiA4Ni4zNjA1MTQ5LDMzLjY2NzI5ODkgODYuMzU1MzIzNCwzNC4xMDA1NTM3IEM4Ni4zNDU4ODQyLDM0Ljg4ODcxODggODYuMzUyNzI3NiwzNS42NzcxMTk4IDg2LjM1MjcyNzYsMzYuNDY1NTIwOCBMODYuMzQ0MjMyNCwzNi40NjU1MjA4IEM4Ni4zNDQyMzI0LDM3LjMwNDg5MyA4Ni4zNDg5NTIsMzguMTQ0MDI5MiA4Ni4zNDMwNTI1LDM4Ljk4MzE2NTQgQzg2LjMzNzYyNSwzOS43NDI1NDEyIDg1Ljk2MzEyODYsNDAuMjA2OTQ1IDg1LjIyNjQwNjcsNDAuNDE3NDM3IEM4NC4yODEwODA2LDQwLjY4NzYzMTMgODMuMzM0NTc0Niw0MC44MDA2NjQ1IDgyLjM2ODcxODUsNDAuNTYwMjAzNCBDODEuMzg2NTc5OSw0MC4zMTUyNTg3IDgwLjg4Mzk0NzcsMzkuNzI4MTQ2NSA4MC44NjkzMTcxLDM4LjcyMTIzMDMgQzgwLjg0NTk1NTMsMzcuMTE5NDE0NiA4MC44NzU2ODg1LDM1LjUxNjY1NTEgODAuODQ5OTY2OSwzMy45MTQ2MDM0IEM4MC44NDI0MTU2LDMzLjQzNjk4NDkgODEuMDE4NDU0OSwzMy4zMTQ5ODQ1IDgxLjQ2OTY0NCwzMy4zMDg2MTMxIEM4MS45NjkyMDg1LDMzLjMwMTUzMzcgODIuMTMyMDMzLDMzLjQ2NjcxOCA4Mi4xMjE4ODYsMzMuOTY4ODc4MyBDODIuMDkzMDk2NywzNS4zOTI1MzA5IDgyLjEwMTgyNzksMzYuODE3MTI3NCA4Mi4xMTUyNzg2LDM4LjI0MTI1MiBDODIuMTI3Nzg1NCwzOS41OTUyOTEyIDgzLjI2OTQ0NDgsNDAuMjc0NDM0NiA4NC40OTUxMTIzLDM5LjY4NDk2MjcgQzg0Ljk5NjA5MjYsMzkuNDQzNzkzNiA4NS4wNjgwNjU4LDM5LjAxMTAxMDcgODUuMDY5NDgxNiwzOC41MzY2OTU5IEM4NS4wNzQyMDEyLDM3LjA2MTYwMDEgODUuMDg1MDU2MiwzNS41ODY1MDQ0IDg1LjA2OTAwOTcsMzQuMTExNjQ0NyBDODUuMDYzODE4MiwzMy42MjAzMzk0IDg1LjEwMjI4MjUsMzMuMjk0NDU0NCA4NS43NDU3OTMzLDMzLjMwNDEyOTUgWiBNMTA5LjQ5MDIzMywzMy43OTMwNzUgQzEwOS43NTY4ODcsMzQuMDM2ODM5OCAxMDkuOTgxMzAyLDM0LjMxNTI5MzMgMTEwLjA2NjcyNiwzNC42NzMyNzEzIEMxMTAuMTQzMTgzLDM0Ljk5NTE0NDcgMTEwLjA5ODgxOSwzNS4yODk2NDQ3IDEwOS43NTIxNjgsMzUuNDQyMDg2MiBDMTA5LjQzODMxOCwzNS41ODAzNjkgMTA5LjIxMjAxNSwzNS40Mjk4MTUzIDEwOS4wMjg4OTcsMzUuMTkwMjk4MSBDMTA4Ljk1MjQ0LDM1LjA5MDI0MzYgMTA4Ljg5NTA5NywzNC45NzQ2MTQ2IDEwOC44MzcwNDcsMzQuODYxNTgxNCBDMTA4LjU1MDA5OCwzNC4zMDQ0Mzg0IDEwOC4xNjIzODcsMzMuOTA4NzA0IDEwNy40NzA1MDEsMzMuOTYxNzk4OSBDMTA2Ljc4MzA5OCwzNC4wMTQ0MjE5IDEwNi4zNjk2NjYsMzQuNDI1OTY2OCAxMDYuMDc1NDAyLDM1LjAwMTA0NDEgQzEwNS44MTI1MjMsMzUuNTE0NTMxMyAxMDUuNzU0NDcyLDM2LjA2Njk1NDcgMTA1Ljc3MjE3LDM2LjYzMjU5MjkgQzEwNS43NTc3NzYsMzcuMzYxMDU1NyAxMDUuODk4ODksMzguMDUzNDEzOCAxMDYuMzA3ODM5LDM4LjY2NTc3NTYgQzEwNy4wNzczNjIsMzkuODE4MDU0IDEwOC40NzQzNDksMzkuODQ3MzE1MiAxMDkuMjk5NTYzLDM4LjczNzI3NjggQzEwOS4zNjAyMDksMzguNjU1NjI4NSAxMDkuNDA3NjQxLDM4LjU2NDMwNTIgMTA5LjQ2OTcwMywzOC40ODQwNzI5IEMxMDkuNjE2MDA5LDM4LjI5NTUyNjggMTA5LjcxMzcwNCwzNy45NTkwMjI4IDExMC4wMzkzNTMsMzguMTUwODcyNSBDMTEwLjMyMjA1NCwzOC4zMTcwMDA3IDExMC4xODA5MzksMzguNTk3ODE0IDExMC4xMDgwMjIsMzguODM4OTgzMSBDMTA5LjU3NTQyMSw0MC42MDI2Nzk0IDEwNy4zNDYxNDEsNDEuMjc0NTA3NSAxMDUuODc5MDY4LDQwLjExMzQ5NzkgQzEwNC4xNjg5MzksMzguNzYwMTY2NiAxMDQuMTc5MzIyLDM1LjA5ODAzMDkgMTA1Ljg5NzIzOCwzMy43NDcwNTk0IEMxMDYuOTUxODIyLDMyLjkxODA3MDIgMTA4LjU1NDgxOCwzMi45Mzc0MjA0IDEwOS40OTAyMzMsMzMuNzkzMDc1IFogTTg3Ljk2MjExODEsMzQuNDQ1NTUyOSBDODguMjI5MjQ0NywzMy42MjEyODMzIDg5LjUzNDY3MjYsMzMuMDIwNzIwNCA5MC43NTMwMjQ3LDMzLjE1OTk0NzIgQzkxLjg3NTA5OCwzMy4yODgwODMgOTIuNDMzODkyOSwzMy44MjEzOTIzIDkyLjQ5NTAxMTEsMzQuOTA2MTgxMSBDOTIuNTM2NTQzMSwzNS42NDEyNTEyIDkyLjUwMjc5ODMsMzYuMzgwODA0OSA5Mi41MDI3OTgzLDM3LjExODQ3MDcgTDkyLjUwMjc5ODMsMzcuMTE4NDcwNyBMOTIuNTEzODg5MywzNy4xMTg0NzA3IEM5Mi41MTM4ODkzLDM3LjgwNTE2NTQgOTIuNTA0OTIyMSwzOC40OTIwOTYxIDkyLjUxNjQ4NSwzOS4xNzg3OTA4IEM5Mi41MjgwNDc5LDM5Ljg2NTk1NzQgOTIuMTk0ODQ3Niw0MC4yNzIwNzQ4IDkxLjU0NjYxNzIsNDAuNDUzMDY5NiBDOTAuNzAyMDUzNiw0MC42ODg4MTEyIDg5Ljg1NDg5NDEsNDAuNzg2NzQxOSA4OC45ODgzODQ1LDQwLjU3MDM1MDUgQzg4LjIwMjU3OTMsNDAuMzczNTQ1MiA4Ny42NTg2NTEsMzkuOTM3MjIyNyA4Ny41MzI2MzksMzkuMTAyODA2IEM4Ny40MTA4NzQ2LDM4LjI5NjIzNDcgODcuNzA2MDgyNSwzNy42NTYwMjc2IDg4LjM4MDc0MjMsMzcuMTk5MTc1MSBDODkuMDY0NjA1MywzNi43MzU5NTExIDg5LjgzODYxMTcsMzYuNDU5ODU3NCA5MC42MzAzMTY0LDM2LjI5MDE4OTUgQzkxLjI3MTIzMTQsMzYuMTUzMDg2NSA5MS4zMzYzNjEyLDM1Ljc5MTgwNDkgOTEuMzAwNzI4NiwzNS4yNTcwNzk4IEM5MS4yNjIwMjgzLDM0LjY3NDkyMzEgOTEuMjMxMzUxMiwzNC4xMDY2ODkyIDkwLjUzODk5MzEsMzMuOTI3ODE4MiBDODkuOTc4NzgyNCwzMy43ODMxNjM5IDg5LjU0MTA0NCwzMy45OTg4NDc0IDg5LjI0NDQyMDIsMzQuNDg2Mzc3MSBDODkuMTM5ODgyMSwzNC42NTg4NzY2IDg5LjA3NjQwNDIsMzQuODU1OTE3OSA4OC45ODQ4NDQ5LDM1LjAzNjkxMjcgQzg4LjgzNzgzMDksMzUuMzI4MTA5IDg4LjU5NDMwMiwzNS40Mzc4Mzg2IDg4LjI4NzUzMTIsMzUuMzM4NzI4IEM4Ny45Njk2Njk0LDM1LjIzNTg0MTggODcuODg0OTUzNSwzNC45NzgxNTQzIDg3LjkxOTE3MDIsMzQuNjY5NDk1NiBDODcuOTI3NDI5NCwzNC41OTM5ODI4IDg3LjkzODk5MjMsMzQuNTE3MjkwMSA4Ny45NjIxMTgxLDM0LjQ0NTU1MjkgWiBNMTAzLjIxOTAzNSwzOS42NTIzNzQyIEMxMDMuMTgzODc0LDQwLjI0MzQ5NzkgMTAyLjkxMjczNiw0MC41NjM3MTk1IDEwMi4zNjUyNjgsNDAuNTc0MTAyNSBDMTAxLjg2MjYzNiw0MC41ODM3Nzc2IDEwMS41NDU3MTgsNDAuMzE4MzAyOCAxMDEuNTA2MzEsMzkuODA2MjMxNSBDMTAxLjQ2MzU5OCwzOS4yNTIzOTIyIDEwMS43NzEzMTIsMzguOTMyNDA2NiAxMDIuMjk5NDMsMzguODk0NDE0MiBDMTAyLjg0MDk5OSwzOC44NTU0Nzc5IDEwMy4xMjM0NjQsMzkuMTg5Mzg2MiAxMDMuMjE5MDM1LDM5LjY1MjM3NDIgWiBNNzQuODYyNDYxMSwzMy4zMDA4NDk0IEM3NS42MTIxNjE4LDMzLjQ5MDU3NTQgNzYuMTI1ODg1LDMzLjk2Mzk0NjMgNzYuMjAwNDUzOSwzNC43NzY4ODkgQzc2LjM2MzA0MjQsMzYuNTUwOTY4MyA3Ni4yNDI5Mjk5LDM4LjMzMDIzOTEgNzYuMjY1MTExOCw0MC4xMDY5MTQxIEM3Ni4yNjk2NjI3LDQwLjQ3OTI1MyA3Ni4wNTk1NDY0LDQwLjUyMjA2NjEgNzUuODI0ODE3NSw0MC41MjYxOTc0IEw3NS42ODI1NDcxLDQwLjUyNjM2MTEgQzc1LjYzNTE1MjgsNDAuNTI2NDE5NiA3NS41ODgyOTQ0LDQwLjUyNzI1NzYgNzUuNTQzNDkyNCw0MC41MzEyMDE4IEM3NS4wOTUxMzUsNDAuNTcwODQ2IDc0Ljk3NzYxODIsNDAuMzQxNzExOCA3NC45ODA2ODU5LDM5LjkzNjA2NjQgQzc0Ljk5MjQ4NDgsMzguNDM2OTAwOSA3NC45OTU3ODg1LDM2LjkzNzk3MTUgNzQuOTgwOTIxOSwzNS40MzkwNDIxIEM3NC45NjkzNTksMzQuMjkyNDI3MSA3NC4zOTc4MjEzLDMzLjc4ODg1MSA3My4yNDIwMDMzLDMzLjg2Mzg5MTkgQzcyLjI1MjU0OTQsMzMuOTI4MzEzNyA3MS44ODc0OTIxLDM0LjMwODcwOTUgNzEuODgzOTUyNCwzNS4zMDI4ODMgQzcxLjg3ODc2MDksMzYuODAxODEyNCA3MS44Njg4NDk4LDM4LjMwMDk3NzkgNzEuODkwNTU5OCwzOS43OTk2NzEzIEM3MS44OTc0MDMxLDQwLjI4MjcxNzQgNzEuODIxODkwMyw0MC41Mzc4MDkxIDcxLjI0MDQ0MTYsNDAuNTQ4OTAwMSBDNzAuNjAwNDcwNSw0MC41NjA2OTkgNzAuNjI3ODQzOSw0MC4yMDg4NTY0IDcwLjYzMzk3OTMsMzkuNzc1NjAxNiBDNzAuNjQ2NDg2MSwzOC45MzcxNzM0IDcwLjYzNzc1NDksMzguMDk4OTgxMSA3MC42Mzg0NjI5LDM3LjI2MDMxNjggQzcwLjYzOTE3MDgsMzYuMzk2NjM5IDcwLjY1ODA0OSwzNS41MzIyNTMyIDcwLjYzMjU2MzQsMzQuNjY5MjgzMyBDNzAuNjE2MDQ1LDM0LjExMDQ4ODQgNzAuODM1NzQwMSwzMy43NDc1NTQ5IDcxLjM1MTExNTEsMzMuNTQ4ODYxOCBDNzIuNDk2Nzg2MSwzMy4xMDcxMTE4IDczLjY3MjE5MDMsMzIuOTk5MjcwMSA3NC44NjI0NjExLDMzLjMwMDg0OTQgWiBNOTguMzE4MjA1NywzMy4yOTQwNzY4IEM5OS4yMTUzOTIzLDMzLjUxNDk1MTggOTkuNjgyMTU1OSwzNC4wNjk5NzExIDk5LjcwMTAzNDEsMzQuOTc2NTk2OCBDOTkuNzM1NzIyOCwzNi42NTQzOTczIDk5LjcwNjY5NzYsMzguMzMzODQ5NSA5OS43Mjk4MjM0LDQwLjAxMTg4NiBDOTkuNzM2NDMwOCw0MC40OTM1MTYyIDk5LjQ4Njc2NjUsNDAuNTQyMzYzNSA5OS4xMDY4NDI3LDQwLjUzNTI4NDIgQzk4LjczODAwOTcsNDAuNTI3OTY4OSA5OC40NjU0NTU3LDQwLjQ5NjgxOTggOTguNDcxMTE5MSw0MC4wMTExNzggQzk4LjQ4ODgxNzQsMzguNTEwODMyNyA5OC40ODQwOTc5LDM3LjAxMDAxNTQgOTguNDc0ODk0OCwzNS41MDk2NzAxIEM5OC40NjY2MzU1LDM0LjExNDU3MDggOTcuMTQ4MjI4OSwzMy4zNzkyNjQ3IDk1LjkxMDA1NDcsMzQuMDY2NDMxNCBDOTUuNDcxMTM2NCwzNC4zMDk3MjQzIDk1LjM3MzIwNTcsMzQuNzAyODYyOSA5NS4zNzUzMjk1LDM1LjE2MzI1NTEgQzk1LjM4MTQ2NDksMzYuNzE0NTcxNSA5NS4zNjE2NDI4LDM4LjI2NjM2IDk1LjM4NjE4NDUsMzkuODE3NDQwNSBDOTUuMzk0MjA3Nyw0MC4zMjUyNjQyIDk1LjI2ODkwMzcsNDAuNTQzNzc5NCA5NC43MDk2MzY4LDQwLjU0NzEwNTcgQzk0LjEyNjc3MjMsNDAuNTUwMTUwOCA5NC4xMjA2MzY5LDQwLjI0MTQ5MjEgOTQuMTI3MjQ0MiwzOS44MjI2MzIgQzk0LjE0MTE2NjksMzguOTU4MjQ2MiA5NC4xMzE0OTE4LDM4LjA5MzM4ODQgOTQuMTMxNzI3OCwzNy4yMjg1MzA3IEM5NC4xMzE5NjM4LDM2LjM2MzkwODkgOTQuMTQ3NTM4MywzNS40OTg4MTUyIDk0LjEyNjUzNjMsMzQuNjM0NjY1MyBDOTQuMTEyNjEzNiwzNC4wNzA2NzkgOTQuMzU5NjgyMSwzMy43MjQyNjM5IDk0Ljg3NDExMzIsMzMuNTMyNDE0MiBDOTUuOTk5NDkwMiwzMy4xMTIxMzgxIDk3LjE1MjQ3NjUsMzMuMDA3MTI4MSA5OC4zMTgyMDU3LDMzLjI5NDA3NjggWiBNMTIzLjIyMDU0LDMzLjc2NzczMSBDMTIzLjQ2NDc3NywzMy45Njc4NCAxMjMuNTcxOTEsMzMuODAxMDAzOCAxMjMuNzI2MDA0LDMzLjY4MTgzNTIgQzEyNC4wNzU3MjIsMzMuNDEwNjk3IDEyNC40NzEyMjEsMzMuMjYyMjY3MSAxMjQuOTExMDgzLDMzLjE5OTk2OSBDMTI3LjA3NjQxMywzMi44OTIyNTQzIDEyNy45MDMwNDIsMzMuNTk4Mjk5MSAxMjcuOTA0NDU4LDM1Ljc3MjM2MDQgQzEyNy45MDU0MDIsMzcuMTIxNDQ0IDEyNy44ODc0NjgsMzguNDcwNTI3NyAxMjcuOTEzNjYxLDM5LjgxODkwMzUgQzEyNy45MjM1NzMsNDAuMzMwNTAyOSAxMjcuNzg4MTIxLDQwLjU0ODA3NDIgMTI3LjIzMTQ1LDQwLjU0NTcxNDQgQzEyNi42ODUzOTgsNDAuNTQzNTkwNiAxMjYuNjA3OTk4LDQwLjI5MTU2NjYgMTI2LjYxMTMwMSwzOS44Mzk5MDU1IEMxMjYuNjIyODY0LDM4LjMxMzEzMDcgMTI2LjYzMjMwMywzNi43ODU0MTIgMTI2LjU5MzM2NywzNS4yNTkzNDUxIEMxMjYuNTY5MDYxLDM0LjMwMDA5NjQgMTI2LjEwNTgzNywzMy45MDU3Nzc5IDEyNS4xOTg3NCwzMy45NDk2Njk3IEMxMjQuNDEyNDYyLDMzLjk4Nzg5ODEgMTIzLjk3MjEyOCwzNC40MDQzOTg0IDEyMy45NjI0NTMsMzUuMTk2NTc1MSBDMTIzLjk0MzEwMywzNi43NDkwNzE1IDEyMy45NDEyMTUsMzguMzAyMDM5OCAxMjMuOTYyNDUzLDM5Ljg1NDMwMDEgQzEyMy45Njg4MjUsNDAuMzIzNDIzNSAxMjMuODY3MTE4LDQwLjU0MTQ2NjggMTIzLjMzNjY0MSw0MC41NDU3MTQ0IEMxMjIuODA2NjM1LDQwLjU1MDQzMzkgMTIyLjY5ODc5Myw0MC4zNDExMjE5IDEyMi43MDYxMDksMzkuODY3Mjc4OSBDMTIyLjcyODUyNywzOC40MTY5NjA4IDEyMi43MzcyNTgsMzYuOTY1Njk4OSAxMjIuNzA0MjIxLDM1LjUxNTYxNjggQzEyMi42Nzg3MzUsMzQuMzkyMTI3NiAxMjIuMTkwOTcsMzMuODU0MDk4OCAxMjEuMzIyNTcyLDMzLjg3NDE1NjkgQzEyMC40OTQ1MjcsMzMuODkzMjcxMSAxMjAuMDI0NDYsMzQuMzU0MTM1MiAxMjAuMDEyNjYxLDM1LjIzNzYzNTIgQzExOS45OTIxMzEsMzYuNzY0NjQ2IDExOS45ODk1MzUsMzguMjkyMTI4NyAxMjAuMDE1MjU3LDM5LjgxODY2NzUgQzEyMC4wMjM3NTIsNDAuMzI0MTMxNSAxMTkuOTEwMjQ3LDQwLjU0NTcxNDQgMTE5LjM0NjQ5Niw0MC41NDcxMzM5IEMxMTguNzcyMTI3LDQwLjU0ODMxMDEgMTE4Ljc0ODUyOSw0MC4yNTg3NjU3IDExOC43NTY3ODgsMzkuODI5NzU4NSBDMTE4Ljc3NDAxNSwzOC45Mzk0MTUyIDExOC43NjE5OCwzOC4wNDgzNjM5IDExOC43NjIyMTYsMzcuMTU3NTQ4NiBDMTE4Ljc2MjQ1MiwzNi4zMTc0Njg1IDExOC43ODk1ODksMzUuNDc2NjgwNSAxMTguNzUzNzIxLDM0LjYzODI1MjIgQzExOC43MjYxMTEsMzMuOTkzMzI1NSAxMTkuMDI2NzQ3LDMzLjYxNTA1MzUgMTE5LjU5ODc1NiwzMy40NDY4MDE1IEMxMjAuODQzMDY2LDMzLjA4MTUwODMgMTIyLjA5MzI3NSwzMi44NDQxMTQ4IDEyMy4yMjA1NCwzMy43Njc3MzEgWiBNNTUuMzc0MTgzNywzMy43NDQ2MDUyIEM1NS43MzQyODU1LDM0Ljk2MjI0OTQgNTYuMDk1NTY3MSwzNi4xNzk2NTc2IDU2LjQ1OTY4MDUsMzcuMzk2MzU3OSBDNTYuNTY4MjMwMiwzNy43NTkyOTE0IDU2LjY4NzM5ODgsMzguMTE4OTIxMiA1Ni44NDk3NTE0LDM4LjYzMTcwMDQgQzU3LjMwMjU5MjMsMzcuMTA2MTA1NSA1Ny43MTIyNDk0LDM1LjcyNTE2NDggNTguMTIyMTQyNCwzNC4zNDM5ODgyIEM1OC4xNzI2NDE2LDM0LjE3MzYxMjQgNTguMjIyNDMyOSwzNC4wMDMwMDA2IDU4LjI3MTk4ODEsMzMuODMyMTUyOSBDNTguMzM0NTIyMiwzMy42MTY3MDU0IDU4LjM1MTA0MDYsMzMuMzM3NTQzOSA1OC42NTY2MzE2LDMzLjM0NzY5MDkgQzU4Ljk2NTA1NDIsMzMuMzU4MzA5OSA1OC45NTEzNjc1LDMzLjY2NjAyNDcgNTkuMDEzMTkzNiwzMy44NjQ3MTc4IEM1OS40MDQ2ODA0LDM1LjEyNjAxNzggNTkuNzY5OTczNywzNi4zOTUzNDExIDYwLjE2NDUyODIsMzcuNjU1NDYxMyBDNjAuMjUzNDkxNywzNy45Mzk1NzgyIDYwLjI3MDAxMDEsMzguMjYxNDUxNiA2MC41NDM1MDgxLDM4LjU0MzY4MDggQzYwLjk2Njg1MTksMzcuMDUwNDE0OCA2MS4zNzk4MTI2LDM1LjU5MzQ4OTQgNjEuNzkzNDgxMiwzNC4xMzY1NjM5IEM2MS44NDkxNzE5LDMzLjk0MTE3NDUgNjEuODgzNjI0NywzMy43MzQ2OTQxIDYxLjk3MTQwODMsMzMuNTU0NDA3MyBDNjIuMTUxNDU5MiwzMy4xODUxMDI0IDYyLjUwMjEyMTgsMzMuMzA1Njg2OSA2Mi43Nzg2ODc1LDMzLjM1Njg5NDEgQzYzLjE4NTk4NDgsMzMuNDMyNjQyOSA2Mi45MjMzNDE4LDMzLjcyMzYwMzIgNjIuODcxMTkwNywzMy44OTQ2ODY5IEM2Mi4yNDc3MzgsMzUuOTM0NzEyOSA2MS42MDU4NzkxLDM3Ljk2OTMxMTQgNjAuOTc1ODE5LDQwLjAwNzY4NTYgQzYwLjg3ODU5NjIsNDAuMzIxNzcxNyA2MC43NjcyMTQ4LDQwLjU0NjE4NjMgNjAuMzYyNTEzMyw0MC41NDA1MjI5IEM1OS45NTA0OTY1LDQwLjUzNDM4NzUgNTkuODY4MTQwMyw0MC4yODk5MTQ3IDU5Ljc3Mzk4NTMsMzkuOTc4ODk2MyBDNTkuMzc3NTQzLDM4LjY2NzgwNSA1OC45NjU5OTgxLDM3LjM2MDk2MTMgNTguNTA0ODk4LDM1Ljg3NDMwMjcgQzU4LjA2MjkxMiwzNy4yOTM0NzE3IDU3LjY3NzU2MDcsMzguNTQ4ODcyMyA1Ny4yNzgyODY2LDM5LjgwMDI2MTMgQzU3LjE3NzI4ODIsNDAuMTE2MjM1MiA1Ny4xOTUyMjI1LDQwLjUxOTI4NDkgNTYuNjcwODgwNCw0MC41Mzg2MzUxIEM1Ni4yNjU5MDY2LDQwLjU1MzUxOTggNTYuMTYyMjU4LDQwLjMyMzkwOTUgNTYuMDg4OTQxNyw0MC4wNzI0NjI5IEw1Ni4wNDY0MjM5LDM5LjkyMDc1NTggQzU2LjAzOTIyMTUsMzkuODk1NjI4MyA1Ni4wMzE3ODA2LDM5Ljg3MDcyNzggNTYuMDIzODI5OSwzOS44NDYyNzY5IEM1NS4zOTYxMjk2LDM3LjkxMzYyMDcgNTQuNzczODU2OCwzNS45Nzk1NDg2IDU0LjE2NzYzMDUsMzQuMDQwMDQ5MSBDNTQuMDk5NjY4OSwzMy44MjIyNDE4IDUzLjc5MjY2MjEsMzMuNDUxNzU3IDU0LjIzMjI4ODMsMzMuMzY2NTY5MSBDNTQuNjIyMTIzMiwzMy4yOTEwNTYzIDU1LjE3NzE0MjUsMzMuMDc3OTY4NiA1NS4zNzQxODM3LDMzLjc0NDYwNTIgWiBNOTEuMjkzMTc3NCwzNi43OTM3NjU2IEM5MC41OTk2MzkzLDM2LjkxNzY1MzggOTAuMDE1MzU4OSwzNy4xNDU4NDQxIDg5LjQ2ODEyNjksMzcuNDY3MDA5NiBDODguODU1NTI5MiwzNy44MjY4NzU0IDg4LjY5Mjk0MDYsMzguMzgxODk0NiA4OC44NjI2MDg1LDM5LjAzNzQ0MDIgQzg5LjAyMzMwOTIsMzkuNjU3ODI1MiA4OS43MDc2NDQxLDQwLjAyMTIzMDcgOTAuNDQyNzE0MiwzOS45MTY0NTY2IEM5MS4wOTY2MDgsMzkuODIzMDA5NSA5MS4zMjY0NTAyLDM5LjQyOTYzNDkgOTEuMjk5NTQ4NywzOC43OTc5MjMgQzkxLjI3MTcwMzQsMzguMTQ0MjY1MiA5MS4yOTMxNzc0LDM3LjQ4ODQ4MzUgOTEuMjkzMTc3NCwzNi43OTM3NjU2IFogTTExNS4zOTc2MDEsMzQuNTYwMDQ5MiBDMTE0LjcxMDE5OCwzMy43MzQzNjM4IDExMy42MjM1MjEsMzMuNzMxMDYwMSAxMTIuOTc1MjkxLDM0LjU1Mjk2OTkgQzExMi4wNzk3NTYsMzUuNjg4MjU3OSAxMTIuMTg5NzIyLDM4LjE5NzE3MTMgMTEzLjE4MTI5OSwzOS4yNjE0MzAxIEMxMTMuOTI2MDQ1LDQwLjA2MDkyMjEgMTE0Ljk0ODA2MywzOS45OTE1NDQ3IDExNS41NzkwNjcsMzkuMDk4NjA1NiBDMTE2LjAwOTQ5LDM4LjQ4OTU0NzUgMTE2LjA2Mzc2NSwzNy43Nzg1NDcyIDExNi4xMjc5NTEsMzcuMDcwMzc4NSBDMTE2LjE0MDkzLDM2LjA5ODYyMjkgMTE1Ljg1MjMyOSwzNS4xMDYzMzczIDExNS4zOTc2MDEsMzQuNTYwMDQ5MiBaIE02Ni40NDI5OTQzLDMzLjk2MDA3NjMgQzY1LjUxNzcyNjMsMzMuOTQ0NTAxOCA2NC44NzAyMDM4LDM0LjU2MzIzNDkgNjQuNjU2NjQ0MSwzNS41NTQxMDQ3IEM2NC41NzI4NzIxLDM1Ljk0Mjc1OTcgNjQuNjkzNjkyNiwzNS45OTk4NjYzIDY1LjAyMjY0NTMsMzUuOTQ2NzcxNCBDNjUuNjk5MTkzLDM1LjgzNzI3NzggNjYuMzgyNTg0LDM1Ljc2MDgyMSA2Ny4wNTIyODgzLDM1LjYxOTcwNjUgQzY3LjMyNTU1MDMsMzUuNTYyMTI3OSA2Ny43NjQ3MDQ2LDM1LjY3NDQ1MzMgNjcuODM4ODAxNSwzNS4zMzk4MzcxIEM2Ny45MTMxMzQ0LDM1LjAwMzMzMzEgNjcuNjc0MzI1MiwzNC42NjMwNTM0IDY3LjQyNTEzMjksMzQuMzk1OTI2OSBDNjcuMTUxNjM0OSwzNC4xMDI2MDY3IDY2LjgxNTYwMjgsMzMuOTQ0NzM3OCA2Ni40NDI5OTQzLDMzLjk2MDA3NjMgWiBNNzguNjg2NTAxMSwzMC42MjQ2Mjc5IEM3OS4xMzM0NDI2LDMwLjY0NTYyOTkgNzkuMzU2OTEzMywzMC45MTI3NTY1IDc5LjM4NDA1MDcsMzEuMzYxMzQ5OCBDNzkuMzMwMDExOSwzMS44MzMzMDUgNzkuMDU5ODE3NiwzMi4wODI3MzMyIDc4LjU4NDA4NjgsMzIuMDYxNzMxMiBDNzguMTM3ODUzMywzMi4wNDIxNDUxIDc3Ljg3MjE0MjUsMzEuNzY0ODcxNSA3Ny44ODg4OTY5LDMxLjMzMzI2ODUgQzc3LjkwNzA2NzIsMzAuODY3MjEyOCA3OC4yMDYwNTA4LDMwLjYwMTk3NDEgNzguNjg2NTAxMSwzMC42MjQ2Mjc5IFogTTkxLjAyMjIyNzksNi4wMDEzODQ0NCBDOTEuNjYxOTYzMSw2LjAzMjc2OTQ1IDkyLjMwNDc2NTksNi4wMjc1Nzc5NSA5Mi45NDUyMDksNi4wMDQyMTYxNyBDOTMuMzYyODg5Myw1Ljk4ODY0MTY1IDkzLjM4OTA4MjgsNi4xMzMwNTk5MSA5My4yNTYyMjc1LDYuNDgxODM0NzQgQzkyLjg5ODk1NzQsNy40MjA3ODk0NSA5Mi41NzI2MDA1LDguMzcxMzA3MDUgOTIuMjA4NzIzMSw5LjM4NzY2MjM5IEw5Mi4yMDg3MjMxLDkuMzg3NjYyMzkgTDkzLjg4MjM3NTUsOS4zODc0NjMyOSBMOTMuODgyMzc1NSw5LjM4NzQ2MzI5IEw5NC40MTg2NTI5LDkuMzg4MTM0MzUgQzk0LjY1MjUwNjcsOS4zODg2MDYzIDk0Ljc0NDUzNzksOS4yMDA1MzIxOSA5NC44NjUzNTg0LDkuMDU1ODc3OTUgQzk1LjMzODk2NTQsOC40OTAyMzk3NCA5NS44MDkyNjg3LDcuOTIxNTMzODMgOTYuMjc2NzQwMiw3LjM1MDQ2ODE0IEM5Ni40MTQ1NTExLDcuMTgxOTgwMTYgOTYuNTQzNjMwOCw3LjA0MDM5MzYyIDk2Ljc5ODAxNDYsNy4wNDQ4NzcyIEM5Ny42MzMxMzkyLDcuMDU4Nzk5ODcgOTguNDY4NzM1Nyw3LjA0ODE4MDg4IDk5LjMwNDMzMjMsNy4wNTIxOTI1IEM5OS40MTA3NTgyLDcuMDUyNjY0NDYgOTkuNTc0MDU0Niw3LjAwMjYzNzIyIDk5LjU5NDgyMDYsNy4xNTEzMDMwOCBDOTkuNjA3NTYzNCw3LjI0MTY4MjQ4IDk5LjUxNjk0ODEsNy4zNjAxNDMyMiA5OS40NDc1NzA2LDcuNDQ1ODAzMDcgQzk5LjA1NzQ5OTcsNy45Mjk1NTcwNiA5OC42NTY1NzM5LDguNDA0NTc5ODkgOTguMjY2OTc0OSw4Ljg4ODU2OTg2IEM5OC4xNjQzMjQ3LDkuMDE1NzYxNzYgOTcuOTQyNzQxOCw5LjEzMjMzNDY4IDk4LjA0NDIxMjEsOS4zMTM1NjU0NCBDOTguMTM2MjQzNCw5LjQ3NzgwNTgyIDk4LjM2MzQ4OTcsOS4zODQ1OTQ2OSA5OC41MjkxNDYsOS4zODc0MjY0MiBDOTkuMTExNzc0Niw5LjM5NzEwMTUgOTkuNjk0ODc1MSw5LjM5MTQzODA0IDEwMC4yNzc3NCw5LjM5MTQzODA0IEMxMDAuNzc4NzIsOS4zOTEyMDIwNiAxMDEuMDA4MzI2LDkuNjIwNTcyMjQgMTAxLjAxMzk5LDEwLjE0MTYxMDcgQzEwMS4wMjYxNDcsMTEuMjU5ODg5NSAxMDEuMDM5OTAzLDExLjM0OTM1MTggMTAwLjA3Njk1NiwxMS4zNTYxNDEyIEw5NS44OTc2NzE4LDExLjM1NjE1NzcgTDk1Ljg5NzY3MTgsMTEuMzU2MTU3NyBMOTEuOTkyNTY3NiwxMS4zNDU1NjgyIEM5MS42MzMxNzM4LDExLjM0MzY4MDQgOTEuNDIwNTU4LDExLjQxNTE4MTYgOTEuMzI0NTE1MiwxMS44MDEyNDA5IEM5MS4yMjE4NjQ5LDEyLjIxMjU0OTcgOTEuMDU4NTY4NSwxMi42MTIwNTk3IDkwLjg5MDU1MjQsMTMuMDAzMzEwNSBDOTAuNzM5NzYyOCwxMy4zNTQ0NDUxIDkwLjc5NzgxMzMsMTMuNDY3MjQyNCA5MS4yMDQ4NzQ1LDEzLjQ2Mjc1ODggQzkyLjkzMzg4MjEsMTMuNDQzNjQ0NyA5NC42NjMxMjU3LDEzLjQ1NDQ5OTYgOTYuMzkyMzY5MiwxMy40NTQ3MzU2IEM5OC4xNDA5NjI5LDEzLjQ1NDczNTYgOTkuODg5NTU2NiwxMy40NTE2Njc5IDEwMS42MzgzODYsMTMuNDU2NjIzNCBDMTAyLjI3NTk5OCwxMy40NTg1MTEyIDEwMi40MTU5MzIsMTMuNjA4NTkzIDEwMi40MjYwNzksMTQuMjUxODY3OCBDMTAyLjQ0NTQzLDE1LjQ1Mjk5MzYgMTAyLjQ0NTQzLDE1LjQ1Mjc1NzYgMTAxLjI2NDEyNiwxNS40NTI1MjE2IEw5OC45MzI1NDk2LDE1LjQ1MjI1NjEgTDk4LjkzMjU0OTYsMTUuNDUyMjU2MSBMOTYuNjAwOTczNCwxNS40NTQ2NDU0IEM5Ni41MTQzNjk2LDE1LjQ1NDg4MTQgOTYuNDA4NjUxNywxNS40MDk1NzM3IDk2LjI5NDQzODUsMTUuNTc0NzU4IEM5Ni44NzQyMzU0LDE1LjkxNzE2MTQgOTcuNDQ2OTUyOSwxNi4yNTY5NjkxIDk4LjAyMTA4NjMsMTYuNTk0ODg5IEM5OS4zMjU1NzAzLDE3LjM2MjA1MiAxMDAuNjI0MTU1LDE4LjE0MDU0MiAxMDEuOTQxMTQ2LDE4Ljg4NjIzMTEgQzEwMi4yNTkyNDMsMTkuMDY2MjgxOSAxMDIuMzY4OTczLDE5LjI2OTQ1ODYgMTAyLjM1NDM0MiwxOS42MjE1MzcxIEMxMDIuMzI4Mzg1LDIwLjI0MDUwNjMgMTAyLjM0NzAyNywyMC44NjEzNjMyIDEwMi4zNDcwMjcsMjEuNjAxODYwOCBDMTAxLjA2OTQ0NCwyMC44NTIzOTYxIDk5Ljg2NTI1MDksMjAuMTQ1NjQzMyA5OC41MDYyNTYyLDE5LjM0ODAzOTEgQzk4LjUwNjI1NjIsMjAuMjk3ODQ4OCA5OC41Nzk0MDkyLDIxLjEyODAxNzkgOTguNDkxMzg5NiwyMS45NDA3MjQ2IEM5OC4yODM0OTM0LDIzLjg2MjA1MzggOTcuMzc2Mzk1NiwyNC42OTU5OTg1IDk1LjQzNjg5NjEsMjQuNzI5NTA3NCBDOTMuMDQ3ODU5MywyNC43NzEyNzU0IDkwLjY1NzQwNjYsMjQuNzM1ODc4NyA4OC4yNjc2NjE5LDI0Ljc0NzY3NzYgQzg3LjkzOTQxNzEsMjQuNzQ5MzI5NSA4Ny44MDk4NjU0LDI0LjY1MDkyNjggODcuODM1MzUxLDI0LjMxNzAxODYgQzg3Ljg3OTI0MjgsMjMuNzQwMDUzNCA4Ny42MDU3NDQ4LDIzLjAxMDE3NDkgODcuOTQwMzYxLDIyLjYyMzg3OTYgQzg4LjI2MzQxNDMsMjIuMjUwNzk5MSA4OS4wMDIwMjQsMjIuNTE2NzQ1OCA4OS41NTY4MDczLDIyLjUwNjM2MjggQzkxLjI0NjQwNjYsMjIuNDc0OTc3OCA5Mi45MzY3MTM4LDIyLjQ4MDQwNTIgOTQuNjI2MDc3MiwyMi40NDg1NDgzIEM5NS41MjI3OTE5LDIyLjQzMTc5MzkgOTUuOTk3MzQyOCwyMS42NzAwNTgzIDk1LjY3Mjg3MzYsMjAuODI0NTUwNyBDOTUuNTY5NzUxNCwyMC41NTYyNDQyIDk1LjM0MTc5NzEsMjAuNjc3MzAwNyA5NS4xNzM3ODExLDIwLjY3NjgyODggQzkyLjQ1MzY2NzgsMjAuNjY4NTY5NiA4OS43MzM1NTQ1LDIwLjY3MTE2NTMgODcuMDEzNjc3MSwyMC42NzExNjUzIEM4Ni40Njk1MTI5LDIwLjY3MTE2NTMgODUuOTI1MzQ4NiwyMC42ODAzNjg0IDg1LjM4MTY1NjMsMjAuNjY3MTUzNyBDODUuMTA3NDUwNCwyMC42NjA1NDYzIDg0Ljk1MzgyOSwyMC43MDU4NTQgODQuOTU4MDc2NiwyMS4wNDA0NzAyIEM4NC45NzU1MzksMjIuNDU4OTMxMyA4NC45NDQzODk5LDIzLjg3Nzg2NDMgODQuOTc5Nzg2NiwyNS4yOTUzODE1IEM4NS4wMDQ4MDAyLDI2LjI5OTQ2NiA4NS4zNjkzODU1LDI2LjYyNTU4NyA4Ni40MDk1NzQ2LDI2LjYyNzQ3NDggQzkxLjg0OTU2NTIsMjYuNjM2NDQyIDk3LjI4OTc5MTksMjYuNjM5MjczNyAxMDIuNzMwMDE4LDI2LjYzMjQzMDQgQzEwMy45NDI0NzEsMjYuNjMwNzc4NSAxMDQuNzUwOTMsMjUuNzYzNTYxIDEwNC43NTYxMjIsMjQuNDgxOTY2OSBDMTA0Ljc2NTU2MSwyMi4wOTIyMjIyIDEwNC43NTg5NTQsMTkuNzAyNDc3NCAxMDQuNzU4OTU0LDE3LjMxMjczMjcgQzEwNC43NTg5NTQsMTMuOTUxNDY4NCAxMDQuNzY2OTc3LDEwLjU5MDIwNCAxMDQuNzQ4ODA2LDcuMjI4OTM5NjkgQzEwNC43NDY2ODMsNi44MDExMTIzOCAxMDQuODQ0NjEzLDYuNjc3MjI0MTYgMTA1LjI4OTQzMSw2LjY3ODQwNDA1IEMxMTIuNTc1NDc0LDYuNjkzNTA2NjEgMTE5Ljg2MTI4MSw2LjY5MzUwNjYxIDEyNy4xNDczMjQsNi42ODA1Mjc4NSBDMTI3LjcxNjAzLDYuNjc5MzQ3OTYgMTI3Ljg4NDI4Miw2Ljg5NTI2NzQzIDEyNy44ODMxMDksNy40Mzk2Njc2NSBDMTI3Ljg3MDM2LDEzLjM0NTk1IDEyNy44NzYyNTksMTkuMjUyNDY4MiAxMjcuODcyNDgzLDI1LjE1ODk4NjUgQzEyNy44NzIyNDcsMjUuNTA3NzYxMyAxMjcuODY2ODIsMjUuODYyMTk5NiAxMjcuODA3MzU0LDI2LjIwNDEzMTEgQzEyNy40ODk3MjgsMjguMDI3MDU3NyAxMjYuNDUxMTkxLDI4Ljg1OTgyMjUgMTI0LjQ1ODU5NiwyOC45MTQ1NjkzIEMxMjIuODQxOTE0LDI4Ljk1ODkzMzEgMTIyLjg2ODgxNSwyOC45NTgyMjUyIDEyMi44Mjg2OTksMjcuMzQxMzA3IEMxMjIuODE0NTQsMjYuNzc4OTcyNCAxMjIuOTY1MDk0LDI2LjYyMjI4MzMgMTIzLjUyNjcyMSwyNi42MzAzMDY2IEMxMjQuNzIyMTgzLDI2LjY0NzI5NyAxMjUuMDQ0NTI4LDI2LjI5MjYyMjcgMTI1LjA0NSwyNS4xMDA5MzYgQzEyNS4wNDc1OTYsMTkuOTMzMDI3NSAxMjUuMDQwMjgxLDE0Ljc2NDg4MyAxMjUuMDU2MzI3LDkuNTk2NTAyNTMgQzEyNS4wNTc3NDMsOS4xNTE5MjA4MSAxMjQuOTI1MTI0LDkuMDQzODQzMDkgMTI0LjQ5NzUzMiw5LjA0NTAyMjk4IEMxMTkuMDU3NTQyLDkuMDU4MDAxNzUgMTEzLjYxNzMxNSw5LjA2MDM2MTUyIDEwOC4xNzcwODgsOS4wNDI2NjMyIEMxMDcuNjc2ODE2LDkuMDQxMDExMzYgMTA3LjU3MDg2Miw5LjIwMDI5NjIxIDEwNy41NzE4MDYsOS42NzA4MzU0NiBDMTA3LjU4NDA3NywxNC43NjExMDc0IDEwNy41NzgxNzcsMTkuODUxNjE1MiAxMDcuNTY4MDMsMjQuOTQyMTIzMSBDMTA3LjU2NDI1NSwyNi43OTg3OTQ2IDEwNi41MTcyMjIsMjguMjc0MzYyMiAxMDQuODkzNjk3LDI4Ljc1NjkzNjMgQzEwNC40ODA1LDI4Ljg3OTQwODcgMTA0LjA1NzE1NiwyOC45MTY2OTMxIDEwMy42MjgxNDksMjguOTE2NDU3MiBDOTcuNzIxNjMwOCwyOC45MTM2MjU0IDkxLjgxNTM0ODUsMjguOTExNTAxNiA4NS45MDg4MzAyLDI4LjkwOTM3NzggTDg1LjkwODgzMDIsMjguOTA5Mzc3OCBMODUuNzMzOTcwOCwyOC45MDkxNDE5IEM4My4yODkyNDMzLDI4Ljg2NjY2NTkgODIuMTc3Nzg5LDI3Ljc3NTAzMzcgODIuMTQzMTAwMywyNS4zMzI2NjYgQzgyLjExODU1ODcsMjMuNjA1MzEwMyA4Mi4xMzgzODA4LDIxLjg3NzI0NjYgODIuMTM4MzgwOCwyMC4wMDEyMjUgQzgxLjU0ODY3MjksMjAuMzkwNTg4IDgxLjA2Nzc1MDYsMjAuNzA2MzI2IDgwLjU4ODQ4MDIsMjEuMDI0ODk1NyBDNzkuNTIxNjI1NywyMS43MzQwMDgyIDc4LjQ2MjA4NjQsMjIuNDU0NjgzNyA3Ny4zODQ4NDg5LDIzLjE0Nzk4NTggQzc3LjA1ODI1NTksMjMuMzU4MjQxOCA3Ni44OTI1OTk3LDIzLjU4NDU0NDIgNzYuOTIxMTUzLDIzLjk5Mjc4NTQgQzc2Ljk1NzI1NzUsMjQuNTE0NTMxOCA3Ni45MzY3Mjc1LDI1LjA0MTcwNTcgNzYuOTE1OTYxNSwyNS41NjU1NzU4IEM3Ni44MzAwNjU2LDI3LjczMDE5OCA3NS43ODg2OTY3LDI4Ljc4NTcyNTYgNzMuNjMwNDQ1OSwyOC45MTAwODU4IEM3MS44OTMxNzkxLDI5LjAxMDM3NjIgNzEuOTE0MTgxMSwyOS4wMTAxNDAzIDcxLjg4NDY4MzksMjcuMjgyNzg0NSBDNzEuODc1OTUyOCwyNi43NzM1NDUgNzIuMDAxMDIwOSwyNi42MjUzNTExIDcyLjUyMjc2NzMsMjYuNjMyMTk0NCBDNzMuNzkwOTEwNywyNi42NDgyNDA5IDc0LjEwMjE2NTEsMjYuMzIwMjMyMSA3NC4xMDM4MTY5LDI1LjA0MzU5MzUgQzc0LjExMTEzMjIsMTkuOTkyMDIxOSA3NC4xMDgwNjQ1LDE0Ljk0MDQ1MDMgNzQuMTA1NDY4Nyw5Ljg4ODg3ODczIEM3NC4xMDUyMzI4LDkuMjMxOTE3MjEgNzMuOTkwNzgzNiw5LjEyNTAxOTM3IDczLjMwNzE1NjcsOS4xMjQ1NDc0MiBDNjkuMzA0NzQxMyw5LjEyMjQyMzYyIDY1LjMwMjMyNTksOS4xMTQ4NzIzNCA2MS4yOTk5MTA2LDkuMTM0Njk0NDUgQzYwLjgyMTExMjEsOS4xMzcwNTQyMyA2MC42NDU3ODA4LDkuMDIyNjA1MTEgNjAuNjg5NjcyNiw4LjUzMDU5MTkgQzYwLjczMjYyMDUsOC4wNDg3MjU3MyA2MC43MTY1NzQxLDcuNTU5MDcyMyA2MC42OTI5NzYzLDcuMDc0NjEwMzcgQzYwLjY3NzYzNzgsNi43NjA1MjQyNCA2MC43OTQ2ODI2LDYuNjgzMzU5NTggNjEuMDkzNDMwMiw2LjY4MzgzMTUzIEM2Ni4xNjQzNTIsNi42OTEzODI4MiA3MS4yMzU1MDk3LDYuNjkzOTc4NTcgNzYuMzA2NDMxNCw2LjY4MzEyMzYgQzc2LjkxMjY1NzgsNi42ODE3MDc3NCA3Ni45MzQ4Mzk3LDcuMDM3MzI1OTIgNzYuOTM0MTMxNyw3LjQ4NTY4MzI4IEM3Ni45Mjg3MDQyLDExLjcyMTAwODUgNzYuOTI5MTc2MiwxNS45NTY1Njk3IDc2LjkzNjAxOTUsMjAuMTkyMzY2OCBDNzYuOTM2MjU1NSwyMC4zOTEyOTU5IDc2LjgxNDQ5MTEsMjAuNjY1NzM3OCA3Ny4wMzQxODYyLDIwLjc3ODUzNTEgQzc3LjIwOTA0NTYsMjAuODY4Njc4NSA3Ny4zNzc3Njk1LDIwLjY1MzIzMSA3Ny41NDI0ODE5LDIwLjU2MDk2MzggQzgwLjIzNzU4MTYsMTkuMDUyODMxMiA4Mi42MjU0Mzg1LDE3LjA2ODQ5NTkgODUuMzQ0MzcxOSwxNS41Nzk0Nzc1IEM4NS4yMDc1MDQ5LDE1LjM2ODc0OTYgODUuMDM3ODM3LDE1LjQ1Nzk0OTEgODQuOTA0MjczNywxNS40NTcyNDEyIEM4My4xOTQzODA0LDE1LjQ0OTQ1MzkgODEuNDg0NDg3LDE1LjQzODgzNDkgNzkuNzc1MDY1NSwxNS40NjAwNzI5IEM3OS4zNjIzNDA4LDE1LjQ2NTAyODQgNzkuMjA0NDcxOCwxNS4zODkwNDM2IDc5LjIwOTY2MzMsMTQuOTI3NDcxNSBDNzkuMjI2ODg5NywxMy40NTQ5NzE2IDc5LjIwNTE3OTcsMTMuNDU0NzM1NiA4MC42ODkyNDI2LDEzLjQ1NDczNTYgQzgyLjkyMzcxNDEsMTMuNDU0NzM1NiA4NS4xNTgxODU2LDEzLjQ0NjQ3NjQgODcuMzkyNDIxMSwxMy40NjI3NTg4IEM4Ny43NTg0MjIzLDEzLjQ2NTU5MDYgODcuOTc5MDYxMywxMy4zNzgwNDI5IDg4LjA2MjU5NzQsMTMuMDAyODM4NiBDODguMTgzNDE3OSwxMi40NjA1NjIyIDg4LjczNDY2MTUsMTEuODQwMTc3MiA4OC40NzA4Mzg2LDExLjQ1MDgxNDIgQzg4LjI1NDY4MzEsMTEuMTMxNTM2NSA4Ny40NTU2NjMxLDExLjM2NTg2MjMgODYuOTE1NTEwNSwxMS4zNjM3Mzg1IEM4NC44NzU0ODQ1LDExLjM1NDUzNTMgODIuODM1MjIyNSwxMS4zNTA5OTU3IDgwLjc5NTQzMjUsMTEuMzY4MjIyIEM4MC40MTgxMDQ0LDExLjM3MTUyNTcgODAuMjk5ODc5NiwxMS4yNzI2NTExIDgwLjI5Nzc1NTgsMTAuODgzNzYwMSBDODAuMjk3NDM1NiwxMC44MzA0NDYgODAuMjk3MTA4NCwxMC43NzkwMzYgODAuMjk2ODQzNiwxMC43Mjk0NjIxIEw4MC4yOTY1NTY3LDEwLjQ1MzUwNzQgQzgwLjMwMzA5NTQsOS4zOTA5NjYwOCA4MC40MzUxNzA2LDkuMzkwOTY2MDggODEuNzc0OTc1NCw5LjM5MDk2NjA4IEw4MS43NzQ5NzU0LDkuMzkwOTY2MDggTDg0LjM0OTQ5MDUsOS4zOTA5NjYwOCBDODMuNzQ1Mzg4LDguNjU0NDgwMTIgODMuMjE4NDUwMSw4LjAyMjc2ODIgODIuNzA2MTQyOCw3LjM3OTcyOTM1IEM4Mi41OTM4MTc1LDcuMjM4NjE0NzcgODIuMzQ1MzMzMSw3LjExNDQ5MDU4IDgyLjQ0NTYyMzYsNi45MTAxMzQwMSBDODIuNTI2MDkxOSw2Ljc0NTY1NzY1IDgyLjc2Mzk1NzMsNi44Mzc2ODg5IDgyLjkyODkwNTYsNi44Mzk1NzY3MiBDODMuMDEwOTk0OCw2Ljg0MDQ1MjMyIDgzLjA5MDMwNTYsNi44NDEwNDg4IDgzLjE2Njk2MjUsNi44NDE0MjA5MSBMODMuNTk2MDUwNSw2Ljg0MTM5OTAxIEM4My44NjIyMDM0LDYuODQwMTczMzcgODQuMDg5ODcwNyw2LjgzNzEwOTU4IDg0LjI4NzAwODUsNi44MzU3MTEzNiBMODQuNTYwODEyOCw2LjgzNTMwMTE4IEM4NS43ODMxNDQ3LDYuODQzNTg5OTggODUuNjA5ODcxNSw3LjAzMTUwNzIxIDg3LjA3MjkwNzUsOC43MzQyNDA1NCBDODcuNTY3OTg4NCw5LjMxMDI2MTc2IDg4LjU2Mjg2OTgsOS42MDQ5OTc3MyA4OS4yMjc4NTQ2LDkuMzgzODg2NzUgQzg5LjQzNTk4NjgsOS4zMTQ1MDkzNSA4OS40NDY2MDU4LDkuMTMxODYyNzIgODkuNTAzOTQ4Myw4Ljk3NTE3MzYyIEM4OS44MTExOTExLDguMTM4MTYxMjIgOTAuMTI5MDUyOSw3LjMwNDIxNjUzIDkwLjQxMDgxMDEsNi40NTg0NzI5NyBDOTAuNTE4MTc5OSw2LjEzNTY1NTY3IDkwLjY1NjkzNDcsNS45ODM2ODYxMiA5MS4wMjIyMjc5LDYuMDAxMzg0NDQgWiBNNTQuNzcxMDk1OSwxMC4yNDQxNDI5IEM1NS40ODE4NjAzLDEwLjY0MjIzNzEgNTYuMTk5NDY4LDExLjAzMDg5MjEgNTYuOTMxMjM0NCwxMS4zODg2MzQxIEM1Ny4yNDgxNTIzLDExLjU0MzY3MTQgNTcuMjQ5NTY4MiwxMS43Nzg0NjkgNTcuMjQ5MzMyMiwxMi4wNTg1NzQ0IEM1Ny4yNDU3OTI1LDE0LjczNzYyNzYgNTcuMjQ3MjA4NCwxNy40MTY2ODA4IDU3LjI0NjczNjQsMjAuMDk1NzM0IEM1Ny4yNDY1MDA1LDIyLjczNTg1MSA1Ny4yMzIzNDE4LDI1LjM3NjQzOTggNTcuMjU4NTM1MywyOC4wMTYzMjA4IEM1Ny4yNjM0OTA4LDI4LjUxNTE3NzMgNTcuMTE0ODI1LDI4LjY0NzMyNDggNTYuNjM5MzMwMiwyOC42MTQ3NTk5IEM1Ni4wNDA0MTkyLDI4LjU3MzQ2MzggNTUuNDM1ODQ0NywyOC41ODgwOTQ0IDU0LjgzNDgwOTgsMjguNjEwOTg0MiBDNTQuNDk1NzEwMSwyOC42MjM5NjMgNTQuMzU5MzE1LDI4LjU0NTYxODQgNTQuMzYwMjU0MSwyOC4xNjczNDY0IEM1NC4zNzEzNDk5LDIyLjI4NDg5NzggNTQuMzY5MjI2MSwxNi40MDI5MjEyIDU0LjM2MzMyNjcsMTAuNTIwNDcyNyBDNTQuMzYzMDkwNywxMC4xODUzODQ1IDU0LjQwNTA5NDcsMTAuMDM5MDc4NCA1NC43NzEwOTU5LDEwLjI0NDE0MjkgWiBNMTExLjUyMzY1MSwxMS41NDM3ODkzIEMxMTEuOTM0NzI0LDExLjgzODA1MzQgMTExLjg4OTQxNywxMi41NjQ2MjgzIDExMi4wNjA5NzIsMTMuMDk2MDQ5NyBDMTEyLjIyMTQzNywxMy41OTM3MjY0IDExMi4zNTA5ODksMTQuMTAxMDc4MSAxMTIuNTQ1OTA2LDE0Ljc4NTY0OSBDMTEyLjc2NzAxNywxMy44NzMzNTk4IDExMi45NTEzMTYsMTMuMTIzNDIzMSAxMTMuMTMwNDIzLDEyLjM3MjA3MDYgQzExMy4zNDQyMTgsMTEuNDc0NjQ3OSAxMTMuMzQyMzMsMTEuNDc0MTc2IDExNC4yNzAxOTQsMTEuNDUxMDUwMiBDMTE1LjYxNTczOCwxMS40MTczMDU0IDExNS42MTIxOTksMTEuNDE2MzYxNSAxMTUuMjI1NDMxLDEyLjcxOTY2NTUgQzExNC43NjcxNjMsMTQuMjYyOTU4NyAxMTQuMzIxODczLDE1LjgxMDAyNzYgMTEzLjg1NTgxOCwxNy4zNTExOTcgQzExMy43NzE4MSwxNy42Mjg3MDY3IDExMy43NzUzNDksMTcuODU2ODk3IDExMy45MDkxNDksMTguMTIzNTUxNiBDMTE0LjUzNTQzMywxOS4zNzIxMDg5IDExNS4xMzc4ODQsMjAuNjMyOTM2OSAxMTUuNzUzMzEzLDIxLjg4NjkyMTcgTDExNS44MjU5OTcsMjIuMDM4NjM0OSBDMTE1LjkxMzgyMiwyMi4yMTUzNjE3IDExNi4wMjM0NTUsMjIuMzc1ODE0NyAxMTYuMjcyNywyMi4zNTkxMTI4IEMxMTYuNDg0MzcyLDIyLjM0NDk1NDEgMTE2LjU3OTEwMiwyMi4yMDEyNDM4IDExNi42NTQyNTMsMjIuMDQxNzcwOSBMMTE2LjcyNjQ4NSwyMS44ODEyNTgyIEwxMTYuNzI2NDg1LDIxLjg4MTI1ODIgQzExNy4yNDk0MTEsMjAuNzU0OTM3MyAxMTcuNzU5MTIyLDE5LjYyMjI0NTEgMTE4LjI5OTI3NSwxOC41MDQxODM0IEMxMTguNDYyMzM2LDE4LjE2NjczNTUgMTE4LjQ4NTIyNSwxNy44NjUzOTIxIDExOC4zNzUwMjQsMTcuNTA5MDY2IEMxMTcuODA3NDk4LDE1LjY3NDEwNDUgMTE3LjI2NzgxNywxMy44MzExMTk4IDExNi42OTkzNDcsMTEuOTk2NjMwMyBDMTE2LjU3NDA0MywxMS41OTMxMDg3IDExNi41NzQ5ODcsMTEuMzc5MzEzIDExNy4wOTE1NDIsMTEuNDQxNjExMSBDMTE3LjQxNzE5MSwxMS40ODA3ODMzIDExNy43NTg2NSwxMS40OTM1MjYxIDExOC4wNzk4MTYsMTEuNDM5NDg3MyBDMTE4Ljc2MzkxNSwxMS4zMjQzMzAyIDExOS4wMzMxNjUsMTEuNjI3MDg5NCAxMTkuMTcwNzQsMTIuMjY3NTMyNSBDMTE5LjMzNzEwNCwxMy4wNDIwMTA5IDExOS42MTE1NDYsMTMuNzkzMzYzNCAxMTkuODg4NTg0LDE0LjcxOTEwMzQgQzEyMC4xOTMyMzEsMTMuODY2MDQ0NSAxMjAuNDU0Njk0LDEzLjE1MjkyMDMgMTIwLjcwMjk0MiwxMi40MzQ4NDA2IEMxMjEuMDQzNjk0LDExLjQ1MDM0MjIgMTIxLjAzOTQ0NiwxMS40NTQ1ODk4IDEyMi4wODQxMTksMTEuNDQ3NTEwNSBDMTIzLjYwNjE3NCwxMS40MzY4OTE1IDEyMy41MDcwNjQsMTEuMzgwOTY0OCAxMjIuOTU2NzY0LDEyLjc2ODUxMjkgQzEyMi4zOTE4MzQsMTQuMTkzNTgxMyAxMjEuODM2MTA3LDE1LjYyMjE4OTUgMTIxLjI1MjA2MiwxNy4wMzk0NzA3IEMxMjEuMTE1NjY3LDE3LjM3MDA3NTIgMTIxLjExMzMwNywxNy42NjA1NjM2IDEyMS4yMTg3ODksMTcuOTg5OTg4MyBDMTIxLjY2MTk1NSwxOS4zNzE4NzI5IDEyMi4zOTY1NTMsMjAuNTY2MzkxMyAxMjMuNTA4MDA4LDIxLjUwNDE2NjEgQzEyMy43OTIzNjEsMjEuNzQzOTE5MyAxMjMuOTAxMzgyLDIxLjk4MzY3MjUgMTIzLjg4NTMzNiwyMi4zNDY2MDYgQzEyMy44NTc5NjIsMjIuOTY2OTkxIDEyMy44ODEwODgsMjMuNTg5MjYzOCAxMjMuODc0OTUzLDI0LjIxMDgyODcgQzEyMy44NzM3NzMsMjQuMzM5NjcyNCAxMjMuOTQyNDQyLDI0LjUxMTQ2NDEgMTIzLjgxOTAyNiwyNC41ODkzMzY3IEMxMjMuNjUwMDY2LDI0LjY5NTk5ODUgMTIzLjUzNTE0NSwyNC41MTc4MzU1IDEyMy40MjQ5NDQsMjQuNDI2NzQ4MSBDMTIyLjIzMDQyNSwyMy40NDA4MzM5IDEyMS4yNzE0MTIsMjIuMjQ4MjAzMyAxMjAuNDE0NTc4LDIwLjk2Nzc4OTEgQzEyMC4yMzE0NTksMjAuNjk0MjkxMSAxMjAuMDU5OTA0LDIwLjQxMjc2OTkgMTE5LjgxNzMxOSwyMC4wMzE5MDIxIEMxMTkuMjQwMTE4LDIxLjEwMTU4ODQgMTE4LjY4NzkzLDIyLjA3ODA2MzUgMTE4LjE4MTUyMiwyMy4wNzc0Mjg1IEMxMTcuNzQxNjYsMjMuOTQ1MzUzOSAxMTcuMTEwODkyLDI0LjUxOTAxNTQgMTE2LjEwMzk3NiwyNC41MDgxNjA0IEMxMTUuMDk1NDA4LDI0LjQ5NzU0MTQgMTE0LjQ4MjgxLDIzLjkwMzExMzkgMTE0LjA1OTkzOCwyMy4wMjk1MjUgQzExMy41ODAxOTYsMjIuMDM4NjU1MyAxMTMuMDUzMDIyLDIxLjA3MDQzOTMgMTEyLjUwNzQ0MiwyMC4wMTcyNzE1IEMxMTEuMzUzMjc2LDIxLjc0NTU3MTEgMTEwLjI0NjMwNSwyMy40MTUxMTI0IDEwOC42MjQ5MDMsMjQuODg5MjY0MiBDMTA4LjYyNDkwMywyNC41NzMxODkxIDEwOC42MjUwNTcsMjQuMjcyMDIzOSAxMDguNjI1MiwyMy45ODE1MTQyIEwxMDguNjI1MjEyLDIyLjczMTc4NiBDMTA4LjYyNDk1LDIyLjQ2MzY3MDEgMTA4LjYyNDQzLDIyLjE5OTgyNzkgMTA4LjYyMzQ4NSwyMS45MzYwMDUgQzEwOC42MjI3NzksMjEuNzA5NDY2NiAxMDguNzkzMTU1LDIxLjU5NzM3NzIgMTA4LjkyMDExMSwyMS40NTcyMDY2IEMxMDkuODc2NTI4LDIwLjQwMDAyNzEgMTEwLjY5NDg5OCwxOS4yNTE1MjQzIDExMS4yOTUyMjUsMTcuOTUxNzU5OSBDMTExLjQ0MjQ3NSwxNy42MzI3MTgzIDExMS40NTc4MTQsMTcuMzUyODQ4OSAxMTEuMzI4MDI2LDE3LjAxMzc0OTEgQzExMC42OTA0MTUsMTUuMzQ3MDM5NiAxMTAuMDkxMDMyLDEzLjY2NTQ2MzYgMTA5LjQ1NTA3MiwxMS45OTgyODIxIEMxMDkuMjk5MDkxLDExLjU4OTU2OSAxMDkuMjkxMzA0LDExLjM5MDYzOTkgMTA5LjgxNzc3LDExLjQ0Mjc5MDkgQzExMC4zOTQyNjMsMTEuNDk5NjYxNSAxMTEuMDg5Njg5LDExLjIzMzAwNjkgMTExLjUyMzY1MSwxMS41NDM3ODkzIFogTTYxLjAxNDM1NDEsMTIuMjMzNDEwNiBDNjMuOTg2MjU1NSwxMi4yNTE4NjM2IDY2Ljk1ODE1NjksMTIuMjQxNDgwNiA2OS45Mjk4MjIzLDEyLjI0NDA3NjMgQzcwLjY0NjI1MDEsMTIuMjQ1MDIwMyA3MC43NDkxMzYzLDEyLjM0NzkwNjUgNzAuNzQ5ODQ0MywxMy4wNDMzMzIzIEM3MC43NTIyMDQsMTUuNTY4NTI4MiA3MC43NTI0NCwxOC4wOTM0ODgxIDcwLjc1MDMxNjIsMjAuNjE4NjgzOSBDNzAuNzUwMDgwMiwyMC44OTAyOTQxIDcwLjc0NDY1MjgsMjEuMTYzNTU2MSA3MC43MTQyMTE3LDIxLjQzMzI3ODQgQzcwLjUwNjc4NzQsMjMuMjY2MTE2MSA2OS40MDU3MTYxLDI0LjI3NjEwMDEgNjcuNTc5NDg1OCwyNC4yODQ4MzEyIEM2NS4zNjUwNzI0LDI0LjI5NTQ1MDIgNjMuMTUwNjU5LDI0LjI3NTM5MjEgNjAuOTM2NDgxNSwyNC4yOTQ4MDcgQzYwLjUxNTczMzYsMjQuMjk4MjgyIDYwLjQyMDg3MDYsMjQuMTU2OTMxNCA2MC40MjQ2NDYyLDIzLjc2MzMyMDggQzYwLjQ0MjgxNjUsMjEuOTE4MjEyMyA2MC40MzI2Njk1LDIwLjA3Mjg2NzggNjAuNDMyOTA1NCwxOC4yMjc3NTkzIEM2MC40MzMxNDE0LDE2LjQyMTM1MTEgNjAuNDQ5NjU5OCwxNC42MTQ0NzA5IDYwLjQyMTgxNDUsMTIuODA4NzcwNiBDNjAuNDE0NDk5MiwxMi4zMzUzOTk3IDYwLjU2ODU5MjUsMTIuMjMwODYxNiA2MS4wMTQzNTQxLDEyLjIzMzQxMDYgWiBNNjMuNTM0ODMwNCwxNC4yNTIwMDk0IEM2My4xMzc0NDQyLDE0LjI0NDkzMDEgNjMuMTAxMTAzNywxNC40MTk1NTM1IDYzLjEwNDg3OTMsMTQuNzM4MzU5MSBDNjMuMTE3ODU4MSwxNS44ODMwODYzIDYzLjEwOTgzNDgsMTcuMDI4MDQ5NCA2My4xMDk4MzQ4LDE4LjE3Mjc3NjUgQzYzLjEwOTgzNDgsMTkuMzM3MDg5OCA2My4xMjYzNTMzLDIwLjUwMTg3NSA2My4xMDA4Njc3LDIxLjY2NTQ4MDMgQzYzLjA5MjEzNjUsMjIuMDYyMTU4NiA2My4yMzIzMDcyLDIyLjE2MTI2OTIgNjMuNjAyMDg0LDIyLjE1MzcxNzkgQzY0LjU3MTk1MTgsMjIuMTMzODk1OCA2NS41NDIyOTE1LDIyLjE0OTcwNjMgNjYuNTEyNjMxMiwyMi4xNDY0MDI2IEM2Ny41NjQxNDcyLDIyLjE0MzA5ODkgNjguMDE4ODc2LDIxLjcyMjU4NjkgNjguMDI4MDc5MSwyMC42NzQzNzQ2IEM2OC4wNDUzMDU1LDE4LjY3NTg4MDcgNjguMDI2NDI3MywxNi42NzczODY3IDY4LjA0MDg1OTYsMTQuNjc4ODkyOCBDNjguMDQzMTgxNywxNC4zNDMzMzI3IDY3LjkzNTEwNCwxNC4yNTEwNjU1IDY3LjYwOTQ1NDksMTQuMjU0ODQxMSBDNjYuMjUxNDA0MSwxNC4yNzAxNzk3IDY0Ljg5MjY0NTMsMTQuMjc2MzE1MSA2My41MzQ4MzA0LDE0LjI1MjAwOTQgWiBNOTMuNjMyNjExNywxNi4zNTY3ODc2IEM5Mi41MDc3MDY2LDE1LjU3MjYzNDIgOTEuMzIxNDQ3NSwxNS4yNjM5NzU1IDg5Ljk3OTkxNSwxNS40MDU3OTgxIEM4OS43MjI5MzU1LDE1LjQzMzE3MTUgODkuNDk1MjE3MSwxNS40NzgwMDcyIDg5LjI3MTAzODUsMTUuNjExODA2NSBDODcuODA3OTc3NiwxNi40ODU4NjczIDg2LjMzODMwOTQsMTcuMzQ4NjAxMyA4NC44NzUyNDg1LDE4LjIyMjQyNjIgQzg0Ljc1ODY3NTYsMTguMjkyMDM5NiA4NC41NzAzNjU1LDE4LjMxMTE1MzggODQuNTYyMzQyMywxOC41Mzc0NTYyIEw4NC41NjIzNDIzLDE4LjUzNzQ1NjIgTDk3LjA1Mjg3MDQsMTguNTM3NDU2MiBDOTcuMDY3NTAxLDE4LjUwNTEyNzMgOTcuMDgyMzY3NiwxOC40NzMwMzQ0IDk3LjA5Njk5ODIsMTguNDQwNDY5NSBDOTUuOTM4MTEyNCwxNy43NTE2NTEgOTQuNzM1ODA2NywxNy4xMjU2MDI1IDkzLjYzMjYxMTcsMTYuMzU2Nzg3NiBaIE01NC4zNjY1ODMyLDYuMTk1NjE3NTYgQzU0Ljg5MjU1MDksNi40OTE1MDcyIDU1LjQ1ODk0MDcsNi42NTkzNTcxNyA1Ni4wMzI4MTYyLDYuODAzMzU4NTEgTDU2LjcyMjk1MTgsNi45NzEzODEgQzU2Ljk1Mjc4OTQsNy4wMjgwMTgyIDU3LjE4MTcxNjgsNy4wODc1MDc4NiA1Ny40MDc2MjU5LDcuMTU2NTE4MTggQzU4LjIzMjM2NzUsNy40MDg1NDIyMSA1OS4wMTUxMDUxLDcuNzI3MzQ3ODkgNTkuNTkyMDcwMiw4LjQxNjg3NDMyIEM1OS44MTQ1OTcsOC42ODMwNTcgNTkuODgxODUwNiw4LjkxMzM3MTEgNTkuNzAxNTYzOCw5LjI0Nzk4NzI4IEM1OS4zMDg2NjExLDkuOTc3MTU3OTMgNTguOTYxNzc0MSwxMC43MzA4NzAzIDU4LjUzNzAxNDUsMTEuNTk0Nzg0MSBDNTcuNjkxNTA2OSwxMC4wMTc3NDYxIDU2LjIzMzE2NTYsOS4zNzAyMjM2NSA1NC44Nzg2NTQ1LDguNTg2MzA2MiBDNTQuMTk1NDk5NCw4LjE5MDgwNzgyIDUzLjgwNDQ4NDYsNi45NzU5OTUzNSA1NC4wOTk0NTY2LDYuMjU4ODU5NTUgQzU0LjE2OTc3NzksNi4wODgwMTE4IDU0LjI2MDg2NTIsNi4xMzYxNTEyMiA1NC4zNjY1ODMyLDYuMTk1NjE3NTYgWiIgaWQ9IuW9oueKtue7k+WQiCIgZmlsbD0iIzI2NzJGRiI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==");

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MEMBER_PKG_TYPE_ENUM; });
/* unused harmony export MEMBER_PKG_TYPE_MAPPING */
/* unused harmony export dialogInit */
/* unused harmony export checkMemberPKG */
/* harmony import */ var _http_package_dialog_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43);


// 用户套餐版本的枚举，按照数组index升序
const MEMBER_PKG_TYPE_ENUM = ["free",
// 后端无此字段，前端定义
"advance_version", "enterprise_version", "enterprise_ultimate_version", "enterprise_ultimate_free_version"];

// 用户套餐版本对应中文
const MEMBER_PKG_TYPE_MAPPING = {
  free: "基础版",
  advance_version: "高级版",
  enterprise_version: "企业版",
  enterprise_ultimate_version: "旗舰版",
  enterprise_ultimate_free_version: "旗舰版（试用）"
};

/**
 * 包装packageDialog需要的所有参数
 * @param {*} PKGList 所有套餐信息列表
 * @param {*} memberPKG 当前用户套餐信息
 * @param {*} memberPKGType 当前用户套餐版本
 * @param {*} nextPKGType 需要升级的套餐版本，如果省略，则默认取下一个版本
 * @returns
 */
function dialogInit(PKGList, memberPKG, memberPKGType, nextPKGType) {
  const i = MEMBER_PKG_TYPE_ENUM.findIndex(type => type === memberPKGType) || 0;
  const nextType = nextPKGType || MEMBER_PKG_TYPE_ENUM[i + 1];
  let packageType = "";
  if (nextType === "enterprise_version") {
    packageType = "enterprise";
  }
  if (nextType === "enterprise_ultimate_version") {
    packageType = "ultimate";
  }
  return {
    packages: PKGList,
    selPackage: PKGList[nextType],
    curPackageData: memberPKG,
    packageType
  };
}

/**
 * 获取用户套餐版本和信息
 * @returns {Promise<{
 *  version: 'free'|'advance_version'|'enterprise_version'|'enterprise_ultimate_version'|'enterprise_ultimate_free_version';
 *  data: object;
 * }>}
 */
function checkMemberPKG(params) {
  return Object(_http_package_dialog_index_js__WEBPACK_IMPORTED_MODULE_0__[/* httpMemberPackageInfo */ "a"])(params).then(_ref => {
    let {
      data,
      status_code,
      status
    } = _ref;
    if (status_code === 1 && status === 200) {
      const {
        package_status,
        free_package_status
      } = data;
      // 新版套餐试用版，优先级比新版套餐高
      if (free_package_status) {
        return {
          version: free_package_status.version,
          data
        };
      }
      // 新版套餐
      if (package_status) {
        return {
          version: package_status.version,
          data
        };
      }
      return {
        version: "free",
        data
      };
    }
  }).catch(error => {
    console.log("httpMemberPackageInfo err: ", error);
    return Promise.reject(error);
  });
}

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initQiyuKF; });
/* harmony import */ var _http_header_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49);
/* harmony import */ var _tools_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
// 初始化客服


function initQiyuKF() {
  let cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let login = arguments.length > 1 ? arguments[1] : undefined;
  window.ysf = window.ysf || function () {
    (window.ysf.a = window.ysf.a || []).push([window, document, "ysf"]);
  };
  const temp = document.createElement("script");
  temp.async = true;
  temp.src = "https://qiyukf.com/script/24ada582654049dffe310a772b0c0db1.js?hidden=1";
  const miniApp = Object(_tools_js__WEBPACK_IMPORTED_MODULE_1__[/* isWxMiniApp */ "i"])();
  if (!miniApp) {
    document.body.appendChild(temp);
  }
  if (login) {
    setTimeout(() => {
      Object(_http_header_index_js__WEBPACK_IMPORTED_MODULE_0__[/* getUserInfo */ "b"])().then(res => {
        if (res.status == 200 && res.status_code == 1 && res.data && res.data.id) {
          setYsfUser(res.data, cb);
        } else {
          setYsfUser(null, cb);
        }
      }).catch(e => {
        setYsfUser(null, cb);
      });
    }, 1500);
  }
}
function setYsfUser() {
  let userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let cb = arguments.length > 1 ? arguments[1] : undefined;
  let ysfParams = {};
  const userId = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || getCookie("_za");
  if (userId) {
    ysfParams = {
      uid: userId,
      data: JSON.stringify([{
        key: "real_name",
        value: userId
      }])
    };
  }
  window.ysf && window.ysf("config", ysfParams);
  cb && cb(ysfParams);
}
function getCookie(c_name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(`${c_name}=`);
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      let c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui/lib/message-box");

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/my-hover-head/src/index.vue?vue&type=template&id=0b23ffb4&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ul-bg user-head-bg" },
    [
      _c("div", { staticClass: "user-head" }, [
        _c(
          "div",
          {
            staticClass: "account-version",
            class: [
              {
                "advance-version":
                  _vm.curVersion === "advance_version" && !_vm.isEntMember
              },
              {
                "enterprise-version":
                  _vm.curVersion === "enterprise_version" && !_vm.isEntMember
              },
              {
                "enterprise-ultimate-version":
                  (_vm.curVersion === "enterprise_ultimate_version" ||
                    _vm.curVersion === "enterprise_ultimate_free_version") &&
                  !_vm.isEntMember
              },
              {
                "hide-version": _vm.isEntMember
              }
            ]
          },
          [
            _vm.microAppInfo.isWAUser === "isWxwork"
              ? _c(
                  "div",
                  [
                    _c("WwOpenComponent", {
                      staticClass: "nickname",
                      attrs: {
                        "open-id":
                          _vm.userInfo.nickname || _vm.userInfo.username
                      }
                    })
                  ],
                  1
                )
              : _c("div", { staticClass: "nickname" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.userInfo.nickname || _vm.userInfo.username) +
                      "\n            "
                  )
                ]),
            _vm._v(" "),
            !_vm.isEntMember && !_vm.privateMode
              ? _c("div", { staticClass: "version" }, [
                  _vm.curVersion === "free"
                    ? _c("span", {
                        staticClass: "version-logo",
                        attrs: { t: "free" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curVersion === "advance_version"
                    ? _c("span", {
                        staticClass: "version-logo",
                        attrs: { t: "advance" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curVersion === "enterprise_version"
                    ? _c("span", {
                        staticClass: "version-logo",
                        attrs: { t: "enterprise" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curVersion === "enterprise_ultimate_version" ||
                  _vm.curVersion === "enterprise_ultimate_free_version"
                    ? _c("span", {
                        staticClass: "version-logo",
                        attrs: { t: "enterprise-ultimate" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curVersion === "free"
                    ? _c(
                        "span",
                        {
                          staticClass: "right-href",
                          on: {
                            click: function($event) {
                              return _vm.updatePackageInfo(false)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "promote-icon" }),
                          _vm._v("升级套餐\n                ")
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.curVersion !== "free" && !_vm.isEntMember && !_vm.privateMode
          ? _c("div", { staticClass: "version-guide" }, [
              _c("div", { staticClass: "left-date" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.expireTimeText) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.microAppInfoLoading,
                      expression: "!microAppInfoLoading"
                    }
                  ],
                  staticClass: "right-operate"
                },
                [
                  _vm.microAppInfo.isFreeTry
                    ? _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.updatePackageInfo(true)
                            }
                          }
                        },
                        [_vm._v("购买")]
                      )
                    : _vm.curVersion === "enterprise_ultimate_free_version"
                    ? _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.updatePackageInfo(true)
                            }
                          }
                        },
                        [_vm._v("购买正式版")]
                      )
                    : _vm.curVersion === "free" ||
                      _vm.curVersion === "advance_version" ||
                      _vm.curVersion === "enterprise_version"
                    ? _c("span", [
                        _c(
                          "i",
                          {
                            on: {
                              click: function($event) {
                                return _vm.updatePackageInfo(false)
                              }
                            }
                          },
                          [_vm._v("续费")]
                        ),
                        _vm._v(" "),
                        !_vm.microAppInfo.isWAUser
                          ? _c("i", { staticClass: "grey-word" }, [
                              _vm._v(" 或 ")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.microAppInfo.isWAUser
                          ? _c(
                              "i",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.updatePackageInfo(true)
                                  }
                                }
                              },
                              [_vm._v("升级")]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curVersion === "enterprise_ultimate_version"
                    ? _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.updatePackageInfo(false)
                            }
                          }
                        },
                        [_vm._v("续费")]
                      )
                    : _vm._e()
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bottom-a" },
          [
            _c(
              "a",
              {
                staticClass: "user-head-hover-item acount-item",
                on: { click: _vm.gotoAccount }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                !_vm.isEntMember && !_vm.privateMode
                  ? _c("span", {
                      staticClass: "enterprise-certificate",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goCertificate.apply(null, arguments)
                        }
                      }
                    })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            !_vm.isEntMember && !_vm.privateMode
              ? _c(
                  "a",
                  {
                    staticClass: "user-head-hover-item",
                    attrs: { href: "/member/mywallet/" }
                  },
                  [
                    _c("i", { staticClass: "user-head-icon wallet-icon" }),
                    _c("i", [_vm._v("钱包")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.privateMode
              ? _c(
                  "a",
                  {
                    staticClass: "user-head-hover-item",
                    attrs: { href: "/member/mycoupon/" }
                  },
                  [
                    _c("i", { staticClass: "user-head-icon coupon-icon" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "user-head-hover-item-text" }, [
                      _vm._v(
                        "\n                    优惠券\n                    "
                      ),
                      _vm.hasNewCoupon
                        ? _c("i", { staticClass: "user-head-point" })
                        : _vm._e()
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.privateMode
              ? _c(
                  "a",
                  {
                    staticClass: "user-head-hover-item",
                    attrs: { href: "javascript:void(0);" },
                    on: { click: _vm.gotoRewards }
                  },
                  [
                    _c("i", { staticClass: "user-head-icon rewards-icon" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "user-head-hover-item-text" }, [
                      _vm._v(
                        "\n                    环保豆\n                    "
                      ),
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isBeanChange,
                            expression: "isBeanChange"
                          }
                        ],
                        staticClass: "user-head-point"
                      })
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "user-head-hover-item",
                attrs: { href: "/member/mycollect/" }
              },
              [
                _c("i", { staticClass: "user-head-icon collect-icon" }),
                _vm._v(" "),
                _c("i", { staticClass: "user-head-hover-item-text" }, [
                  _vm._v(
                    "\n                    模板收藏\n                    "
                  ),
                  _vm.hasNewCollect
                    ? _c("i", { staticClass: "user-head-point" })
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            !_vm.privateMode
              ? _c(
                  "a",
                  {
                    staticClass: "user-head-hover-item",
                    attrs: { href: "/message/list/" }
                  },
                  [
                    _c("i", { staticClass: "user-head-icon message-icon" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "user-head-hover-item-text" }, [
                      _vm._v(
                        "\n                    站内信\n                    "
                      ),
                      _vm.hasUnreadMsg
                        ? _c("i", { staticClass: "user-head-point" })
                        : _vm._e()
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.privateMode && !_vm.microAppInfo.isMicroEnv
              ? _c(
                  "a",
                  { staticClass: "user-head-hover-item", attrs: { href: "/" } },
                  [
                    _c("i", { staticClass: "user-head-icon home-icon" }),
                    _vm._v(" "),
                    _c("i", [_vm._v("访问首页")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.privateMode && !_vm.isCommonMember
              ? _c(
                  "a",
                  {
                    staticClass: "user-head-hover-item",
                    attrs: { href: _vm.privateAdminUrl },
                    on: { click: _vm.gotoPrivateAdmin }
                  },
                  [
                    _c("i", { staticClass: "user-head-icon home-icon" }),
                    _vm._v(" "),
                    _c("i", [_vm._v("企业管理后台")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isEntMember && !_vm.microAppInfo.isMicroEnv
              ? _c("div", { staticClass: "border-line" })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isThridPlatform && !_vm.isUser315
              ? _c(
                  "a",
                  {
                    staticClass: "user-head-hover-item logout",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function($event) {
                        return _vm.logoutDialog(true)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "user-head-icon go-out-icon" }),
                    _vm._v("退出登录\n            ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("hover-header")
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "wj-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: "退出确认",
            type: "small",
            width: "350px",
            visible: _vm.logoutDialogShow
          },
          on: {
            "update:visible": function($event) {
              _vm.logoutDialogShow = $event
            }
          }
        },
        [
          _c("span", [_vm._v("你要退出" + _vm._s(_vm.companyNameZH) + "么?")]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "wj-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function($event) {
                      return _vm.logoutDialog(false)
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "wj-button",
                {
                  attrs: { size: "medium", type: "primary" },
                  on: { click: _vm.logoutClickHandler }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("PackageDialog", {
        attrs: {
          "active-version": _vm.activeVersion,
          source: "用户菜单",
          "micro-data": _vm.microAppInfo
        },
        model: {
          value: _vm.showPackageDialog,
          callback: function($$v) {
            _vm.showPackageDialog = $$v
          },
          expression: "showPackageDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "account-text" }, [
      _c("i", { staticClass: "user-head-icon account-icon" }),
      _vm._v(" "),
      _c("i", [_vm._v("账号")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "user-head-hover-item",
        attrs: { href: "/member/mydownloadcenter/" }
      },
      [
        _c("i", { staticClass: "user-head-icon download-icon" }),
        _vm._v(" "),
        _c("i", [_vm._v("数据下载")])
      ]
    )
  }
]
render._withStripped = true


// CONCATENATED MODULE: ./packages/my-hover-head/src/index.vue?vue&type=template&id=0b23ffb4&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui/lib/theme-chalk/message-box.css"
var message_box_css_ = __webpack_require__(189);

// EXTERNAL MODULE: external "@wenjuan/ui/lib/message-box"
var message_box_ = __webpack_require__(170);
var message_box_default = /*#__PURE__*/__webpack_require__.n(message_box_);

// EXTERNAL MODULE: external "@wenjuan/ui/lib/theme-chalk/button.css"
var button_css_ = __webpack_require__(60);

// EXTERNAL MODULE: external "@wenjuan/ui/lib/button"
var button_ = __webpack_require__(31);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external "@wenjuan/ui/lib/theme-chalk/dialog.css"
var dialog_css_ = __webpack_require__(110);

// EXTERNAL MODULE: external "@wenjuan/ui/lib/dialog"
var dialog_ = __webpack_require__(45);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog_);

// EXTERNAL MODULE: ./src/assets/js/package-dialog/package-about.js
var package_about = __webpack_require__(145);

// EXTERNAL MODULE: ./src/http/space/index.js
var space = __webpack_require__(127);

// EXTERNAL MODULE: ./src/assets/js/utils/tools.js
var tools = __webpack_require__(4);

// EXTERNAL MODULE: ./src/assets/js/beanMessageTip.js
var beanMessageTip = __webpack_require__(128);

// EXTERNAL MODULE: ./src/http/header/index.js
var header = __webpack_require__(49);

// EXTERNAL MODULE: ./packages/package-dialog/index.js + 23 modules
var package_dialog = __webpack_require__(53);

// EXTERNAL MODULE: ./packages/ww-open-component/src/main.vue + 6 modules
var main = __webpack_require__(48);

// EXTERNAL MODULE: ./packages/tools.js
var packages_tools = __webpack_require__(10);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/my-hover-head/src/index.vue?vue&type=script&lang=js&














/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: "MyHoverHead",
  components: {
    "wj-dialog": dialog_default.a,
    "wj-button": button_default.a,
    PackageDialog: package_dialog["default"],
    WwOpenComponent: main["a" /* default */]
  },
  props: {
    userInfo: {
      type: Object,
      default: () => {}
    },
    // 当前套餐版本
    curVersion: {
      type: String,
      default: ""
    },
    // 套餐过期时间
    expireTime: {
      type: String,
      default: ""
    },
    // 企业空间的企业成员（企业子账号）
    isEntMember: {
      type: Boolean,
      default: false
    },
    memberPKGInfo: {
      type: Object,
      default: () => {}
    },
    privateMode: {
      type: Boolean,
      default: false
    },
    privateAdminUrl: {
      type: String,
      default: ""
    },
    companyNameZH: {
      type: String,
      default: "问卷网"
    }
  },
  data() {
    return {
      isBeanChange: false,
      // 积分系统相关
      logoutDialogShow: false,
      // 退出登录确认框
      showPackageDialog: false,
      // 购买弹框显隐控制
      activeVersion: "enterprise_ultimate_version",
      // 套餐升级弹框的高亮版本
      isCommonMember: false,
      // 是否为部署版普通成员
      microAppData: {} // 微应用信息
    };
  },

  computed: {
    expireTimeText() {
      if (this.expireTime) {
        // 试用版
        if (this.curVersion === "enterprise_ultimate_free_version") {
          return `试用时间剩余${Math.ceil((new Date(this.expireTime) - new Date().getTime()) / 1000 / 60 / 60 / 24)}天`;
        }
        return `${this.expireTime.replace("-", "年").replace("-", "月")}日到期`;
      }
      return "";
    },
    hasNewCoupon() {
      return this.userInfo.is_new_coupon == 1;
    },
    hasNewCollect() {
      return this.userInfo.is_new_collect == 1;
    },
    hasUnreadMsg() {
      return this.userInfo.unread_msg_count > 0;
    },
    isUser315() {
      return this.userInfo.ps_id === "315";
    },
    isThridPlatform() {
      return Object(tools["b" /* distinguishUserAgentUtils */])().isDingding || Object(tools["b" /* distinguishUserAgentUtils */])().isFeishu || Object(tools["b" /* distinguishUserAgentUtils */])().isWxwork;
    },
    microAppInfo() {
      return this.$parent.microAppInfo || this.microAppData;
    },
    microAppInfoLoading() {
      return this.$parent.microAppInfoLoading || false;
    }
  },
  mounted() {
    // 部署版不发送请求
    if (!this.privateMode) {
      this.initBeanTips();
    }
    if (this.privateMode) {
      this.getDeployCurrentRole();
    }
    this.getUserPackage();
  },
  methods: {
    getDeployCurrentRole() {
      Object(header["d" /* httpDeployCurrentRole */])({
        unIntercept: true
      }).then(res => {
        console.log("res::::::", res);
        const {
          data
        } = res;
        this.isCommonMember = data.role === "member";
      });
    },
    gotoRewards() {
      Object(beanMessageTip["a" /* clickToBeanPageHandler */])();
    },
    initBeanTips() {
      // 获取环保豆信息，显示红点
      Object(beanMessageTip["b" /* fetchBeanChangeStatus */])().then(isChange => {
        this.isBeanChange = !!isChange;
      }).catch(e => {
        console.log(e);
      });
    },
    // 企业认证
    goCertificate() {
      window.location.href = "/member/certificate/";
    },
    gotoAccount() {
      window.location.href = "/member/";
    },
    updatePackageInfo() {
      let isNextVersion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      try {
        const memberPKGType = this.curVersion;
        if (this.curVersion === "free") {
          this.activeVersion = "advance_version";
          this.showPackageDialog = true;
        } else {
          this.dealPackageDialog(isNextVersion);
        }
      } catch (error) {
        console.log("httpPackageList err: ", error);
      }
    },
    // 显示购买套餐弹窗
    // isNextVersion, true:升级，false:续费
    async dealPackageDialog(isNextVersion) {
      // 高级版、企业标准版，打开购买弹窗
      // 新版购买弹框
      if (isNextVersion) {
        // 升级
        if (this.curVersion === "enterprise_ultimate_free_version") {
          // 与后端产品沟通，线上已无试用版，试用版都是后台赠送的企业标准版
          this.activeVersion = "enterprise_ultimate_version";
        } else {
          const i = package_about["a" /* MEMBER_PKG_TYPE_ENUM */].findIndex(type => type === this.curVersion) || 0;
          this.activeVersion = package_about["a" /* MEMBER_PKG_TYPE_ENUM */][i + 1];
        }
        this.showPackageDialog = true;
      } else {
        // 续费
        this.activeVersion = this.curVersion;
        this.showPackageDialog = true;
      }
    },
    // 跳转企业管理相关逻辑
    // 点击企业协作的跳转逻辑：
    // 1.企业空间：跳转到相对应的企业
    // 2.个人空间：
    // 1）加入过多个企业，且有一个是企业主，跳转自己的企业；
    // 2）只有一个企业，且是企业主，跳转自己的企业；
    // 3）加入过多个企业，都只是企业成员，创建企业；
    // 4）加入过一个企业，只是企业成员，创建企业；
    // 5）没加入过企业，跳转企业创建页
    gotoEnterprise() {
      // 获取当前所在空间
      Object(space["a" /* fetchCurrentSpace */])().then(res => {
        if (res.status === 200 && res.status_code === 1) {
          if (res.data.space_type == 2) {
            // 企业空间
            window.location.href = `/enterprise/setting/?ent_id=${res.data.ent_id}`;
          } else if (res.data.space_type == 1) {
            // 个人空间
            Object(space["b" /* fetchSpaceList */])().then(listRes => {
              if (listRes.status === 200 && listRes.status_code === 1) {
                if (listRes.data.space_list.length > 0 && listRes.data.space_list[0].space_type == 2 && listRes.data.space_list[0].is_admin === 1) {
                  // 创建过企业
                  window.location.href = `/enterprise/setting/?ent_id=${listRes.data.space_list[0].id}`;
                } else {
                  // 企业旗舰版试用版
                  if (this.curVersion === "enterprise_ultimate_free_version") {
                    // 个人空间没创建过企业，一律跳转创建企业页面
                    window.location.href = "/enterprise/add/";
                    return;
                  }
                  // 企业标准版
                  if (this.curVersion === "enterprise_version") {
                    // 个人空间没创建过企业，一律跳转创建企业页面
                    window.location.href = "/enterprise/add/";
                    return;
                  }
                  // 企业旗舰版
                  if (this.curVersion === "enterprise_ultimate_version") {
                    // 个人空间没创建过企业，一律跳转创建企业页面
                    window.location.href = "/enterprise/add/";
                    return;
                  }
                  message_box_default.a.confirm("您当前的账号套餐不支持企业协作功能，您可以升级您的账号套餐以使用该功能。", "提示", {
                    confirmButtonText: "升级套餐",
                    callback(action) {
                      if (action === "confirm") {
                        // 发送付费套餐线索
                        Object(header["g" /* sendPayClue */])({
                          clue_resource: "触发套餐卡点",
                          clue_tag_list: ["企业协作"]
                        });
                        setTimeout(() => {
                          location.href = "/senior_user/";
                        }, 20);
                      }
                    }
                  });
                }
              }
            });
          }
        }
      });
    },
    logoutDialog(status) {
      this.logoutDialogShow = status;
    },
    logoutClickHandler() {
      if (!this.privateMode) {
        // 退出账号 清除本地记录
        this.userLogout();
      } else {
        this.handleDeployLogout();
      }
      this.logoutDialog(false);
    },
    userLogout() {
      // 清除登录用户 ID
      if (window.gio_logout) {
        window.gio_logout();
      } else {
        // 删除项目文件夹 id
        sessionStorage.removeItem("folderId");
        sessionStorage.removeItem("list_pagenum");
      }
      window.location.href = "/logout";
    },
    // 部署版退出登录
    handleDeployLogout() {
      Object(header["a" /* deloyLogout */])().then(res => {
        if (res.status_code === 1) {
          window.location.href = "/logout";
        }
      });
    },
    gotoPrivateAdmin(e) {
      e && e.preventDefault();
      console.log(this.privateAdminUrl);
      Object(header["f" /* httpLoginAsAdmin */])().then(res => {
        var _res$data;
        console.log(res);
        if ((_res$data = res.data) !== null && _res$data !== void 0 && _res$data.is_success) {
          console.log("注入登录态成功");
          window.location.href = this.privateAdminUrl;
        }
      }).catch(e => {
        console.log("注入登录态失败");
      });
    },
    //  获取套餐信息
    getUserPackage() {
      // 如果父级有传microAppInfo，不需要单独调用接口
      if (this.$parent.microAppInfo) return;
      Object(header["c" /* getUserPackage */])().then(res => {
        if (res.status === 200 && res.status_code === 1) {
          const {
            data
          } = res;
          this.getMicroAppInfo(data);
        }
      });
    },
    // 返回微应用账号信息
    getMicroAppInfo(data) {
      const curMicroData = {};
      if (data) {
        var _data$package_status;
        curMicroData.isFreeTry = data === null || data === void 0 ? void 0 : (_data$package_status = data.package_status) === null || _data$package_status === void 0 ? void 0 : _data$package_status.is_trial;
        curMicroData.isWAUser = data === null || data === void 0 ? void 0 : data.third_part_type;
      }
      const [isWxwork, isDingTalk, isFeishu] = [packages_tools["default"].$ENV.get("isWxwork"), packages_tools["default"].$ENV.get("isDingTalk"), packages_tools["default"].$ENV.get("isLark")];
      const mapList = {
        isWxwork: "isWxwork",
        isDingTalk: "isDingTalk",
        business_wx: "isWxwork",
        ding_talk: "isDingTalk",
        feishu: "isFeishu",
        isFeishu: "isFeishu",
        default: ""
      };
      // 合并所有数据来源
      Object.assign(curMicroData, {
        isWAUser: mapList[curMicroData.isWAUser] || mapList.default,
        // 微应用账户
        isMicroEnv: isWxwork || isDingTalk || isFeishu,
        // 是不是微应用环境
        isWxwork,
        isDingTalk,
        isFeishu,
        curMicro: isDingTalk ? "isDingTalk" : isFeishu ? "isFeishu" : isWxwork ? "isWxwork" : "Mozilla" // 当前微笑应用环境
      });

      this.microAppData = curMicroData;
    }
  }
});
// CONCATENATED MODULE: ./packages/my-hover-head/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var my_hover_head_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/my-hover-head/src/index.vue?vue&type=style&index=0&id=0b23ffb4&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/my-hover-head/src/index.vue?vue&type=style&index=0&id=0b23ffb4&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/my-hover-head/src/index.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  my_hover_head_srcvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "0b23ffb4",
  null
  
)

/* harmony default export */ var src = (component.exports);
// CONCATENATED MODULE: ./packages/my-hover-head/index.js

src.install = function (Vue) {
  Vue.component(src.name, src);
};
/* harmony default export */ var my_hover_head = __webpack_exports__["default"] = (src);

/***/ }),
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui/lib/theme-chalk/message-box.css");

/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/badge");

/***/ }),
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/badge.css");

/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-inner-header/src/index.vue?vue&type=template&id=045aee09&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: ["business-common-header"] }, [
    _vm.showTips
      ? _c("div", { staticClass: "old-tip" }, [
          _vm._v(
            "\n        您当前的浏览器版本过低，可能无法正常使用问卷网功能，建议您使用最新"
          ),
          _c(
            "a",
            {
              staticClass: "browser-url",
              attrs: { href: _vm.browserDd, target: "__blank" }
            },
            [_vm._v(_vm._s(_vm.currentBrowser))]
          ),
          _vm._v("浏览器\n    ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("section", { staticClass: "content" }, [
      _c(
        "section",
        { staticClass: "left-logo-menu" },
        [
          _c("SpacePicker", {
            attrs: {
              "cur-version": _vm.curVersion,
              "member-p-k-g-info": _vm.memberPKGInfo,
              "user-info": _vm.userInfo,
              "private-mode": _vm.privateMode,
              "logo-url": _vm.logoUrl
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "menu-list" },
            _vm._l(_vm.showMenuList, function(item) {
              return _c(
                "a",
                {
                  key: item.key,
                  staticClass: "menu left-menu",
                  class: [item.key === _vm.activeMenu ? "active" : ""],
                  attrs: {
                    "data-key": item.key,
                    href: item.href || "javascript:void(0);",
                    target: item.target || ""
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "menu-btn",
                      on: {
                        click: function($event) {
                          return _vm.gotoMerchant(item)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(item.text) +
                            "\n                            "
                        ),
                        item.subTextConf && !item.subTextConf.isHide
                          ? _c(
                              "div",
                              {
                                staticClass: "sub-text",
                                style: item.subTextConf.style || {}
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item.subTextConf.subText || "") +
                                    "\n                            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "right-personage" },
        [
          _c("InnerRightMenu", {
            attrs: {
              "member-p-k-g-info": _vm.memberPKGInfo,
              "user-info": _vm.userInfo,
              "cur-version": _vm.curVersion,
              "expire-time": _vm.expireTime,
              "is-ent-member": _vm.isEntMember,
              "is-thrid-platform": _vm.isThridPlatform,
              "set-discover": _vm.setDiscover,
              "private-mode": _vm.privateMode,
              "private-admin-url": _vm.privateAdminUrl,
              "company-name-z-h": _vm.companyNameZH,
              "show-desktop-btn": _vm.showDesktopBtn,
              "show-pwa-install-guide-popup": _vm.showPwaInstallGuidePopup
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/common-inner-header/src/index.vue?vue&type=template&id=045aee09&scoped=true&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-inner-header/src/space-picker.vue?vue&type=template&id=0392b7bf&scoped=true&
var space_pickervue_type_template_id_0392b7bf_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "space-picker-wrap" },
    [
      _c(
        "div",
        {
          staticClass: "space-picker",
          class: { "no-picker": _vm.noPicker },
          attrs: { id: "space-picker" }
        },
        [
          _c(
            "div",
            { staticClass: "current-space" },
            [
              _vm.current == "enterprise"
                ? [
                    _c("img", {
                      staticClass: "space-logo",
                      attrs: {
                        width: "36",
                        height: "36",
                        src: _vm.currentSpace.logo,
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "space-name" }, [
                      _vm._v(_vm._s(_vm.currentSpace.name))
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.current == "person"
                ? [
                    _c("img", {
                      staticClass: "person-logo",
                      attrs: {
                        width: "101",
                        src: _vm.logoUrl || _vm.blueLogo,
                        alt: "问卷网_网络调查平台，问卷调查，报名表、考试测验"
                      }
                    })
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "space-arrow" }, [
            _c("img", { attrs: { width: "8", src: _vm.arrowDown } })
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "picker-list actions" }, [
            _vm.showCreateEntry
              ? _c(
                  "li",
                  {
                    staticClass: "space-item",
                    on: { click: _vm.toCreateEnterprise }
                  },
                  [
                    _c("span", { staticClass: "prefix svg-icon plus" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "name" }, [_vm._v("创建团队")]),
                    _vm._v(" "),
                    !_vm.isEnterprisePkgVersion
                      ? _c("span", { staticClass: "enterprise-pkg-mini" })
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showEnterpriseManagerEntry
              ? _c(
                  "li",
                  {
                    staticClass: "space-item",
                    on: { click: _vm.toManageEnterpise }
                  },
                  [
                    _vm.isCurrentSpaceAdmin
                      ? [
                          _c("span", {
                            staticClass: "prefix svg-icon enterprise"
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "name" }, [
                            _vm._v("团队管理")
                          ])
                        ]
                      : [
                          _c("span", { staticClass: "prefix svg-icon group" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "name" }, [
                            _vm._v("团队成员")
                          ])
                        ]
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasJoinedEnterprise
              ? _c("li", { staticClass: "space-item switch-space-control" }, [
                  _c("span", { staticClass: "prefix svg-icon switch-icon" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "name" }, [_vm._v("切换空间")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "suffix svg-icon arrow-right" }),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "picker-list switch-space-list" },
                    _vm._l(_vm.enterpriseList, function(item) {
                      return _c(
                        "li",
                        {
                          key: item.id,
                          staticClass: "space-item",
                          class: { active: item.id === _vm.currentSpace.id },
                          on: {
                            click: function($event) {
                              return _vm.chooseSpace(item)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "svg-icon checked" })
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tooltips-i-know",
              attrs: { id: "tooltips-i-know" }
            },
            [
              _c("h4", { staticClass: "title" }, [_vm._v("提示")]),
              _vm._v(" "),
              _c("p", { staticClass: "switch-space-desc" }, [
                _vm._v(
                  "\n                点击下拉按钮可以切换当前空间。个人空间的项目归属自己，企业空间的项目归属企业创建者。\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "wj-button",
                {
                  staticClass: "sure-switch",
                  attrs: { type: "text", size: "mini" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.closePopover.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("\n                我知道了\n            ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "space-popper-arrow" })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.showUpgradeDialog
        ? _c("div", { staticClass: "upgrade-dialog" }, [
            _c("div", { staticClass: "message" }, [
              _c("div", { staticClass: "content" }, [
                _c("span", {
                  staticClass: "close-icon wj-icon-close",
                  on: { click: _vm.closeDialog }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "pic" }),
                _vm._v(" "),
                _vm._m(0)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "footer" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "controls" },
                  [
                    !_vm.microAppInfo.isWAUser && !_vm.microAppInfo.isFreeTry
                      ? _c(
                          "wj-button",
                          {
                            staticClass: "free-use-btn",
                            attrs: { type: "primary", plain: "" },
                            on: { click: _vm.freeUse }
                          },
                          [_vm._v("免费试用")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "wj-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.upgradAccount }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.microAppInfo.isWAUser ? "购买套餐" : "升级套餐"
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("PackageDialog", {
        attrs: {
          "active-version": _vm.activeVersion,
          excludes: _vm.excludes,
          "lowest-version": "enterprise_version",
          "active-equity": "ent-cooperation",
          source: "企业协作"
        },
        model: {
          value: _vm.showPackageDialog,
          callback: function($$v) {
            _vm.showPackageDialog = $$v
          },
          expression: "showPackageDialog"
        }
      })
    ],
    1
  )
}
var space_pickervue_type_template_id_0392b7bf_scoped_true_staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tips" }, [
      _c("h2", [
        _c("span", { staticClass: "highlight" }, [_vm._v("企业级")]),
        _vm._v("\n                        团队协作\n                    ")
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("权限灵活，高效协同")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                        支持灵活分配团队成员每个项目的编辑、数据查阅等权限\n                    "
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("企业团队人数灵活支持，可任意扩容人数")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "desc" }, [
      _c("h3", { staticClass: "text" }, [_vm._v("更灵活的企业级团队协作方案")]),
      _vm._v(" "),
      _c("span", { staticClass: "enterprise-pkg" })
    ])
  }
]
space_pickervue_type_template_id_0392b7bf_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/common-inner-header/src/space-picker.vue?vue&type=template&id=0392b7bf&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui/lib/theme-chalk/button.css"
var button_css_ = __webpack_require__(60);

// EXTERNAL MODULE: external "@wenjuan/ui/lib/button"
var button_ = __webpack_require__(31);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: ./src/assets/js/package-dialog/package-about.js
var package_about = __webpack_require__(145);

// EXTERNAL MODULE: ./src/http/space/index.js
var space = __webpack_require__(127);

// EXTERNAL MODULE: ./src/assets/js/utils/tools.js
var tools = __webpack_require__(4);

// CONCATENATED MODULE: ./src/assets/image/header/space-picker/arrow-down.svg
/* harmony default export */ var arrow_down = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjUiIHZpZXdCb3g9IjAgMCA4IDUiPgogIDxwYXRoIGZpbGw9IiM3MDcwNzAiIGQ9Ik04LjE4Mjg1NzE0LDEwLjE2MzkyMjYgQzguMDY2NTcxNDMsMTAuMDQxMDQxNCA4LjAwMDg1NzE0LDkuODcyMTk3MDkgOCw5LjY5NTUzNTg2IEM4LjAxNTE0Mjg2LDkuMjk2ODc1NTcgOC4zMjE0Mjg1Nyw4Ljk4NjM4OTU2IDguNjg1NzE0MjksOS4wMDA0NTk5MyBDOC44NzQyODU3MSw4Ljk5OTUyMTkgOS4wNTUxNDI4Niw5LjA4MTEzMDAxIDkuMTg4NTcxNDMsOS4yMjY4MzY0MyBMMTIsMTIuMjgyMjkzOSBMMTQuODExNDI4Niw5LjIyNjgzNjQzIEMxNC45NDQ4NTcxLDkuMDgxMTMwMDEgMTUuMTI1NzE0Myw4Ljk5OTUyMTkgMTUuMzE0Mjg1Nyw5LjAwMDQ1OTkzIEMxNS42Nzg1NzE0LDguOTg2Mzg5NTYgMTUuOTg0ODU3MSw5LjI5Njg3NTU3IDE2LDkuNjk1NTM1ODYgQzE1Ljk5OTE0MjksOS44NzIxOTcwOSAxNS45MzM0Mjg2LDEwLjA0MTA0MTQgMTUuODE3MTQyOSwxMC4xNjM5MjI2IEwxMi41MDI4NTcxLDEzLjc3NzgxNzIgQzEyLjIyMzcxNDMsMTQuMDc3OTg0OSAxMS43NzYyODU3LDE0LjA3Nzk4NDkgMTEuNDk3MTQyOSwxMy43Nzc4MTcyIEw4LjE4Mjg1NzE0LDEwLjE2MzkyMjYgWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTggLTkpIi8+Cjwvc3ZnPgo=");
// EXTERNAL MODULE: ./src/assets/image/brand-logo/with-text-blue.svg
var with_text_blue = __webpack_require__(135);

// CONCATENATED MODULE: ./src/assets/image/header/space-picker/ent-default-avator.svg
/* harmony default export */ var ent_default_avator = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgdmlld0JveD0iMCAwIDQ0IDQ0Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiBmaWxsPSIjMjY3MkZGIiByeD0iMjIiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwIDEwKSI+CiAgICAgIDxwb2x5Z29uIHBvaW50cz0iMCAwIDI0IDAgMjQgMjQgMCAyNCIvPgogICAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xMiwxOSBMMTQsMTkgTDE0LDYgTDIwLjM5NCw4Ljc0IEMyMC43NjE5Mzc5LDguODk3NzI1NzQgMjEuMDAwMzU2LDkuMjU5NjgwNjMgMjEsOS42NiBMMjEsMTkgTDIzLDE5IEwyMywyMSBMMSwyMSBMMSwxOSBMMywxOSBMMyw1LjY1IEMyLjk5OTk0OTgzLDUuMjU0NzEwMzEgMy4yMzI3NTUzOSw0Ljg5NjQ4NzYxIDMuNTk0LDQuNzM2IEwxMS4yOTcsMS4zMTIgQzExLjQ1MTgzNjYsMS4yNDMyMTEzNSAxMS42MzA5NzUxLDEuMjU3NTE0NDEgMTEuNzcyOTM1LDEuMzUwMDAwMzggQzExLjkxNDg5NDksMS40NDI0ODYzNCAxMi4wMDAzNjA1LDEuNjAwNTcxMTUgMTIsMS43NyBMMTIsMTkgWiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==");
// EXTERNAL MODULE: ./packages/package-dialog/index.js + 23 modules
var package_dialog = __webpack_require__(53);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-inner-header/src/space-picker.vue?vue&type=script&lang=js&









// ★no-picker 条件
// 1、普通用户（无企业）。2、只有一个企业且是管理员。
// ★current-space 中 两类样式显示逻辑
// 问卷网logo：1、普通用户（无企业）。2、个人空间（有企业且不是管理员）。
// 企业logo：1、当前所在空间类型为企业空间。2、只有一个企业且是管理员。
// ★列表需要添加个人空间的 条件
// no-picker 条件 取反

/* harmony default export */ var space_pickervue_type_script_lang_js_ = ({
  components: {
    [button_default.a.name]: button_default.a,
    PackageDialog: package_dialog["default"]
  },
  props: {
    // 当前套餐版本
    curVersion: {
      type: String,
      default: ""
    },
    memberPKGInfo: {
      type: Object,
      default: () => {}
    },
    userInfo: {
      type: Object,
      default: () => {}
    },
    // 是否为部署版
    privateMode: {
      type: Boolean,
      default: false
    },
    // 问卷网 logo
    logoUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      enterpriseList: [],
      currentSpace: {},
      arrowDown: arrow_down,
      blueLogo: with_text_blue["default"],
      entDefaultAvator: ent_default_avator,
      // getUrlParam: null,
      // urlDelP: null,
      showUpgradeDialog: false,
      showPackageDialog: false,
      // 购买弹框显隐控制
      activeVersion: "enterprise_version",
      // 套餐升级弹框的高亮版本
      excludes: []
    };
  },
  computed: {
    // 不展示下拉菜单
    noPicker() {
      // 未开通企业版 & 未加入其他企业 & 未创建过企业
      // return (
      //     !this.isEnterprisePkgVersion &&
      //     !this.hasJoinedEnterprise &&
      //     !this.hasCreatedEnterprise
      // );

      // 现在是放开了个人空间，让个人账户可以购买企业版
      return false;
    },
    current() {
      if (this.currentSpace.space_type === "1") {
        return "person";
      }
      return "enterprise";
    },
    // 套餐是否为企业版
    isEnterprisePkgVersion() {
      if (this.privateMode) {
        // 部署版
        return true;
      }
      return this.curVersion.startsWith("enterprise");
    },
    // 加入过其他企业
    hasJoinedEnterprise() {
      return this.enterpriseList.length > 1;
    },
    // 创建过至少一个企业
    hasCreatedEnterprise() {
      return this.enterpriseList.some(v => {
        return v.space_type === "2" && v.is_admin === 1;
      });
    },
    // 当前空间是否为企业主
    isCurrentSpaceAdmin() {
      return this.currentSpace.is_admin === 1;
    },
    // 是否展示创建企业入口
    showCreateEntry() {
      return this.current === "person" && !this.hasCreatedEnterprise;
    },
    // 是否展示企业管理入口
    showEnterpriseManagerEntry() {
      return this.current === "enterprise";
    },
    // 获取微应用数据
    microAppInfo() {
      return this.$parent.microAppInfo;
    }
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val !== null && val !== void 0 && val.id) {
          const isNewUser = localStorage.getItem(`${val.id}isNewUser`);
          if (this.hasJoinedEnterprise && isNewUser) {
            this.$nextTick(() => {
              this.dealGuideTooltip();
            });
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    // 获取企业列表
    this.getEnterpriseList();
  },
  methods: {
    dealGuideTooltip() {
      document.getElementById("tooltips-i-know").style.display = "block";
    },
    toHome() {
      if (this.current === "enterprise") return;
      window.location.href = "/";
    },
    chooseSpace(item) {
      if (this.currentSpace.id === item.id) return;
      Object(space["c" /* switchSpace */])({
        space_type: item.space_type,
        ent_id: item.id
      }).then(res => {
        // 列表页，清除URL上的fid和session storage中的folderId
        this.delUrlFolderId("fid");
        sessionStorage.removeItem("folderId");
        window.location.reload();
      });
    },
    getEnterpriseList() {
      Object(space["b" /* fetchSpaceList */])().then(res => {
        this.enterpriseList = res.data.space_list;
        for (let i = 0; i < this.enterpriseList.length; i++) {
          // 当前空间标识is_current
          if (this.enterpriseList[i].is_current) {
            this.currentSpace = this.enterpriseList[i];
            if (!this.enterpriseList[i].logo) {
              this.currentSpace.logo = ent_default_avator;
            }
            break;
          }
        }
      });
    },
    // 创建企业
    toCreateEnterprise() {
      if (this.isEnterprisePkgVersion) {
        window.location.href = "/enterprise/add/";
      } else {
        this.showUpgradeDialog = true;
      }
    },
    // 跳转企业管理
    toManageEnterpise() {
      window.location.href = `/enterprise/setting/?ent_id=${this.currentSpace.id}`;
    },
    closePopover() {
      document.getElementById("tooltips-i-know").style.display = "none";
      localStorage.removeItem(`${this.userInfo.id}isNewUser`);
    },
    // 删除URL上的folder_id
    delUrlFolderId(key) {
      if (Object(tools["d" /* getQueryString */])(key)) {
        const url = Object(tools["k" /* urlDelP */])(window.location.href, key);
        window.history.pushState("", "", url);
      }
    },
    // 关闭套餐卡点弹窗
    closeDialog() {
      this.showUpgradeDialog = false;
    },
    // 免费试用企业版
    freeUse() {
      window.open("/s/UZBZJvX9GO6/");
    },
    // 升级套餐
    upgradAccount() {
      if (this.microAppInfo.isFreeTry) {
        this.excludes = ["advance_version"];
      }
      // 关闭卡点弹框，打开购买弹框
      this.closeDialog();
      this.showPackageDialog = true;
    }
  }
});
// CONCATENATED MODULE: ./packages/common-inner-header/src/space-picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_space_pickervue_type_script_lang_js_ = (space_pickervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-inner-header/src/space-picker.vue?vue&type=style&index=0&id=0392b7bf&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/common-inner-header/src/space-picker.vue?vue&type=style&index=0&id=0392b7bf&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/common-inner-header/src/space-picker.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_space_pickervue_type_script_lang_js_,
  space_pickervue_type_template_id_0392b7bf_scoped_true_render,
  space_pickervue_type_template_id_0392b7bf_scoped_true_staticRenderFns,
  false,
  null,
  "0392b7bf",
  null
  
)

/* harmony default export */ var space_picker = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-inner-header/src/inner-right-menu.vue?vue&type=template&id=9ee6369e&scoped=true&
var inner_right_menuvue_type_template_id_9ee6369e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-right-menu" },
    [
      !_vm.isEntMember && _vm.renewalReminder.status
        ? _c(
            "div",
            {
              staticClass: "renewal-reminder",
              on: { click: _vm.updatePackageInfo }
            },
            [
              _c("i", { staticClass: "renewal-reminder-svg" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "lang-content",
                domProps: { innerHTML: _vm._s(_vm.renewalReminder.langContent) }
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "short-content",
                domProps: {
                  innerHTML: _vm._s(_vm.renewalReminder.shortContent)
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isEntMember &&
      _vm.curVersion === "free" &&
      !_vm.privateMode &&
      !_vm.microAppInfo["isWAUser"] &&
      _vm.onMounted
        ? _c("div", {
            staticClass: "guild-ent-ultimate",
            on: { click: _vm.gotoSenior }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isDisplayDesktopBtn && !_vm.isThridPlatform && !_vm.privateMode
        ? _c("div", { staticClass: "menu desktop-pwa-menu" }, [
            _c(
              "div",
              {
                staticClass: "menu-btn",
                on: {
                  mouseenter: function($event) {
                    return _vm.trackEventHandler("Client_Entrance")
                  }
                }
              },
              [
                _c("SvgIcon", { attrs: { name: "header/desktop" } }),
                _vm._v(" "),
                _c("span", { staticClass: "client-text" }, [_vm._v("客户端")])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ul-bg" }, [
              _c(
                "div",
                { staticClass: "desktop-install-wrap triangle-before" },
                [
                  _c(
                    "div",
                    { staticClass: "desktop-install-box" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("p", { staticClass: "desktop-subtitle" }, [
                        _vm._v("添加问卷网到电脑桌面")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "desktop-subtitle-shortcut" }, [
                        _vm._v(
                          "\n                        可从桌面快捷访问\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "WdButton",
                        {
                          staticClass: "desktop-install-btn",
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.pwaInstallDesktop("Client_PWA")
                            }
                          }
                        },
                        [_vm._v("立即添加")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "desktop-button-box" }, [
                    _c("div", { staticClass: "desktop-other-btn" }, [
                      _c(
                        "div",
                        {
                          staticClass: "btn-wrap",
                          on: {
                            mouseenter: function($event) {
                              return _vm.trackEventHandler("Client_APP_QRCode")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "btn-title" },
                            [
                              _c("SvgIcon", {
                                attrs: { name: "header/phone" }
                              }),
                              _vm._v("下载手机APP")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "btn-desc" },
                            [
                              _vm._v("随时看数据"),
                              _c("SvgIcon", {
                                attrs: { name: "header/right-arrow" }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(1)
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "desktop-other-btn" }, [
                      _c(
                        "div",
                        {
                          staticClass: "btn-wrap",
                          on: {
                            mouseenter: function($event) {
                              return _vm.trackEventHandler("Client_MP_QRCode")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "btn-title" },
                            [
                              _c("SvgIcon", {
                                attrs: { name: "header/weixin" }
                              }),
                              _vm._v("关注公众号")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "btn-desc" },
                            [
                              _vm._v("随时收通知"),
                              _c("SvgIcon", {
                                attrs: { name: "header/right-arrow" }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(2)
                    ])
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isThridPlatform && !_vm.privateMode
        ? _c("section", { staticClass: "menu found-menu" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "ul-bg" }, [
              _c(
                "ul",
                { staticClass: "dropdown-menu triangle-before" },
                _vm._l(_vm.foundList, function(item, i) {
                  return _c(
                    "li",
                    {
                      key: i,
                      staticClass: "dropdown-menu-li",
                      on: {
                        click: function($event) {
                          return _vm.goNext(item)
                        }
                      }
                    },
                    [
                      _c("p", { staticClass: "title" }, [
                        _vm._v(_vm._s(item.title))
                      ]),
                      _vm._v(" "),
                      item.desc
                        ? _c("p", { staticClass: "desc" }, [
                            _vm._v(_vm._s(item.desc))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.showQrCode
                        ? _c("section", { staticClass: "official-accounts" }, [
                            _vm._m(4, true)
                          ])
                        : _c("div", { staticClass: "sub-dropdown-menu-bg" }, [
                            _c(
                              "div",
                              { staticClass: "sub-dropdown-menu-content" },
                              _vm._l(item.subMenu, function(ulItem, index) {
                                return _c(
                                  "ul",
                                  {
                                    key: ulItem.key,
                                    staticClass: "sub-dropdown-menu"
                                  },
                                  [
                                    index === 1
                                      ? _c("p", { staticClass: "line-boder" })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(ulItem.menu, function(liItem) {
                                      return _c(
                                        "li",
                                        {
                                          key: liItem.key,
                                          staticClass: "sub-dropdown-menu-li",
                                          on: {
                                            click: function($event) {
                                              return _vm.goNext(liItem)
                                            }
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "menu-icon",
                                            attrs: { "data-type": liItem.key }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "sub-menu-word" },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "title" },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(liItem.text) +
                                                      "\n                                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              item.desc
                                                ? _c(
                                                    "p",
                                                    { staticClass: "desc" },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(liItem.desc) +
                                                          "\n                                        "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          ])
                    ]
                  )
                }),
                0
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.privateMode
        ? _c("section", { staticClass: "menu help-menu" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "ul-bg" }, [
              _c("ul", { staticClass: "help-dropdown-menu triangle-before" }, [
                _vm._m(6),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "dropdown-menu-li",
                    on: { click: _vm.gotoQiyu }
                  },
                  [_vm._v("\n                    在线客服\n                ")]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "menu personal-center" },
        [
          _c(
            "div",
            { staticClass: "avator-part" },
            [
              _c(
                "wd-badge",
                {
                  staticClass: "item",
                  attrs: {
                    "is-dot":
                      (_vm.hasNewCoupon ||
                        _vm.hasNewCollect ||
                        _vm.hasUnreadMsg ||
                        _vm.isBeanChange) &&
                      !_vm.privateMode
                  }
                },
                [
                  _c("img", {
                    staticClass: "avator",
                    attrs: { src: _vm.userInfo.portrait }
                  })
                ]
              ),
              _vm._v(" "),
              _c("span", {
                staticClass: "avator-version",
                class: [
                  {
                    "advance-version": _vm.curVersion === "advance_version"
                  },
                  {
                    "enterprise-version":
                      _vm.curVersion === "enterprise_version"
                  },
                  {
                    "enterprise-ultimate-version":
                      _vm.curVersion === "enterprise_ultimate_version" ||
                      _vm.curVersion === "enterprise_ultimate_free_version"
                  }
                ]
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("MyHoverHead", {
            attrs: {
              "user-info": _vm.userInfo,
              "cur-version": _vm.curVersion,
              "expire-time": _vm.expireTime,
              "is-ent-member": _vm.isEntMember,
              "member-p-k-g-info": _vm.memberPKGInfo,
              "private-mode": _vm.privateMode,
              "private-admin-url": _vm.privateAdminUrl,
              "company-name-z-h": _vm.companyNameZH
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("PackageDialog", {
        attrs: {
          "active-version": _vm.activeVersion,
          source: "头部导航",
          "micro-data": _vm.microAppInfo
        },
        model: {
          value: _vm.showPackageDialog,
          callback: function($$v) {
            _vm.showPackageDialog = $$v
          },
          expression: "showPackageDialog"
        }
      }),
      _vm._v(" "),
      _vm.pwaInstallGuideVisible
        ? _c("pwaInstallGuide", {
            attrs: { visible: _vm.pwaInstallGuideVisible },
            on: {
              "update:visible": function($event) {
                _vm.pwaInstallGuideVisible = $event
              },
              close: _vm.pwaGuideCloseHandler,
              install: _vm.pwaGuideInstallHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var inner_right_menuvue_type_template_id_9ee6369e_scoped_true_staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "desktop-logo" }, [
      _c("img", {
        attrs: {
          src: "https://s1.wenjuan.com/assets/images/pwa/shortcut.png",
          width: "48",
          height: "48",
          alt: "问卷网"
        }
      })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "desktop-qrcode-popup" }, [
      _c("img", {
        attrs: {
          src:
            "https://s1.wenjuan.com/assets/images/business/common-inner-header/download-app.png",
          width: "100px",
          height: "100px",
          alt: "下载手机APP"
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("下载手机APP")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "desktop-qrcode-popup" }, [
      _c("img", {
        attrs: {
          src:
            "https://s1.wenjuan.com/assets/images/business/common-inner-header/wechat-official-accounts.png",
          width: "100px",
          height: "100px",
          alt: "问卷网公众号"
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("问卷网公众号")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "menu-btn" }, [
      _c("i", { staticClass: "right-icon icon-found" }),
      _vm._v(" "),
      _c("span", [_vm._v("发现")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "official-accounts-content" }, [
      _c("img", {
        staticClass: "qr-code",
        attrs: {
          src: "https://static.wenjuan.pub/homepage/wx_qrcode.jpg",
          alt: "问卷网公众号"
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "name" }, [_vm._v("问卷网公众号")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "menu-btn" }, [
      _c("i", { staticClass: "right-icon icon-help" }),
      _vm._v(" "),
      _c("span", [_vm._v("帮助")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "dropdown-menu-li" }, [
      _c("a", { attrs: { href: "/helpcenter/", target: "_blank" } }, [
        _vm._v("帮助文档")
      ])
    ])
  }
]
inner_right_menuvue_type_template_id_9ee6369e_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/common-inner-header/src/inner-right-menu.vue?vue&type=template&id=9ee6369e&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/message.css"
var message_css_ = __webpack_require__(14);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/message"
var message_ = __webpack_require__(3);
var message_default = /*#__PURE__*/__webpack_require__.n(message_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/button.css"
var theme_chalk_button_css_ = __webpack_require__(8);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/button"
var lib_button_ = __webpack_require__(2);
var lib_button_default = /*#__PURE__*/__webpack_require__.n(lib_button_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/badge.css"
var badge_css_ = __webpack_require__(237);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/badge"
var badge_ = __webpack_require__(219);
var badge_default = /*#__PURE__*/__webpack_require__.n(badge_);

// EXTERNAL MODULE: ./src/components/svg-icon/index.vue + 5 modules
var svg_icon = __webpack_require__(12);

// EXTERNAL MODULE: ./src/assets/js/utils/qiyuKF.js
var qiyuKF = __webpack_require__(156);

// EXTERNAL MODULE: ./packages/my-hover-head/index.js + 7 modules
var my_hover_head = __webpack_require__(186);

// EXTERNAL MODULE: ./src/assets/js/header-config.js
var header_config = __webpack_require__(54);

// EXTERNAL MODULE: ./src/assets/js/utils/cookie.js
var cookie = __webpack_require__(6);

// EXTERNAL MODULE: ./src/assets/js/beanMessageTip.js
var beanMessageTip = __webpack_require__(128);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-inner-header/src/pwa-install-guide.vue?vue&type=template&id=6eb29285&
var pwa_install_guidevue_type_template_id_6eb29285_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "WdDialog",
    {
      staticClass: "pwa-install-guide-dialog",
      attrs: {
        visible: _vm.dialogVisible,
        title: "添加问卷网到桌面",
        width: "600"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.closeHandler
      }
    },
    [
      _c("div", { staticClass: "video-wrapper" }, [
        _c("video", {
          staticClass: "video",
          attrs: {
            src: _vm.videoUrl,
            preload: "auto",
            muted: "",
            autoplay: "",
            loop: ""
          },
          domProps: { muted: true }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "WdButton",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.installHandler }
            },
            [_vm._v("添加到桌面")]
          )
        ],
        1
      )
    ]
  )
}
var pwa_install_guidevue_type_template_id_6eb29285_staticRenderFns = []
pwa_install_guidevue_type_template_id_6eb29285_render._withStripped = true


// CONCATENATED MODULE: ./packages/common-inner-header/src/pwa-install-guide.vue?vue&type=template&id=6eb29285&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dialog.css"
var dialog_css_ = __webpack_require__(15);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dialog"
var dialog_ = __webpack_require__(7);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-inner-header/src/pwa-install-guide.vue?vue&type=script&lang=js&





/* harmony default export */ var pwa_install_guidevue_type_script_lang_js_ = ({
  components: {
    WdDialog: dialog_default.a,
    WdButton: lib_button_default.a
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.visible
    };
  },
  computed: {
    videoUrl() {
      return `https://s1.wenjuan.com/assets/images/pwa/video/pwa-install-guide-${Object(tools["b" /* distinguishUserAgentUtils */])().isMac ? "mac" : "win"}.mp4`;
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    }
  },
  methods: {
    closeHandler() {
      this.$emit("close");
      this.$emit("update:visible", false);
    },
    installHandler() {
      this.$emit("install");
    }
  }
});
// CONCATENATED MODULE: ./packages/common-inner-header/src/pwa-install-guide.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_pwa_install_guidevue_type_script_lang_js_ = (pwa_install_guidevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-inner-header/src/pwa-install-guide.vue?vue&type=style&index=0&id=6eb29285&prod&lang=scss&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/common-inner-header/src/pwa-install-guide.vue?vue&type=style&index=0&id=6eb29285&prod&lang=scss&

// CONCATENATED MODULE: ./packages/common-inner-header/src/pwa-install-guide.vue






/* normalize component */

var pwa_install_guide_component = Object(componentNormalizer["a" /* default */])(
  src_pwa_install_guidevue_type_script_lang_js_,
  pwa_install_guidevue_type_template_id_6eb29285_render,
  pwa_install_guidevue_type_template_id_6eb29285_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var pwa_install_guide = (pwa_install_guide_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-inner-header/src/inner-right-menu.vue?vue&type=script&lang=js&














const PWA_INSTALL_GUIDE_DISABLED = "pwa_install_guide_disable";
/* harmony default export */ var inner_right_menuvue_type_script_lang_js_ = ({
  components: {
    MyHoverHead: my_hover_head["default"],
    WdBadge: badge_default.a,
    PackageDialog: package_dialog["default"],
    WdButton: lib_button_default.a,
    SvgIcon: svg_icon["a" /* default */],
    pwaInstallGuide: pwa_install_guide
  },
  props: {
    userInfo: {
      type: Object,
      default: () => {}
    },
    // 当前套餐版本
    curVersion: {
      type: String,
      default: ""
    },
    // 套餐过期时间
    expireTime: {
      type: String,
      default: ""
    },
    // 企业空间的企业成员（企业子账号）
    isEntMember: {
      type: Boolean,
      default: false
    },
    memberPKGInfo: {
      type: Object,
      default: () => {}
    },
    isThridPlatform: {
      type: Boolean,
      default: false
    },
    //  设置发现栏目
    setDiscover: {
      type: Function,
      default: null
    },
    privateMode: {
      type: Boolean,
      default: false
    },
    privateAdminUrl: {
      type: String,
      default: ""
    },
    companyNameZH: {
      type: String,
      default: "问卷网"
    },
    // 是否显示客户端按钮
    showDesktopBtn: {
      type: Boolean,
      default: false
    },
    // 是否显示 pwa 安装引导弹窗
    showPwaInstallGuidePopup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 拦截配置函数
      foundList: this.setDiscover ? this.setDiscover(header_config["a" /* innerFoundMenu */]) : header_config["a" /* innerFoundMenu */],
      isBeanChange: false,
      // 环保豆
      showPackageDialog: false,
      // 购买弹框显隐控制
      activeVersion: "enterprise_ultimate_version",
      // 套餐升级弹框的高亮版本
      isPwaAppInstalled: false,
      // 是否安装了pwa应用
      pwaInstallGuideVisible: false,
      // pwa 安装引导弹窗
      onMounted: false // 用于显示企业试用版 需等挂载完毕
    };
  },

  computed: {
    expireTimeText() {
      if (this.expireTime) {
        // 试用版
        if (this.curVersion === "enterprise_ultimate_free_version") {
          return `试用时间剩余${Math.ceil((new Date(this.expireTime) - new Date().getTime()) / 1000 / 60 / 60 / 24)}天`;
        }
        return `${this.expireTime.replace("-", "年").replace("-", "月")}日到期`;
      }
      return false;
    },
    hasNewCoupon() {
      return this.userInfo.is_new_coupon == 1;
    },
    hasNewCollect() {
      return this.userInfo.is_new_collect == 1;
    },
    hasUnreadMsg() {
      return this.userInfo.unread_msg_count > 0;
    },
    renewalReminder() {
      // `advance_version`|高级版 `enterprise_version`|企业标准版 `enterprise_ultimate_version`|企业旗舰版 `enterprise_ultimate_free_version`|企业旗舰试用版
      const versionArr = ["advance_version", "enterprise_version", "enterprise_ultimate_version", "enterprise_ultimate_free_version"];
      const {
        curVersion
      } = this;
      if (!versionArr.includes(curVersion)) {
        return {
          status: false
        };
      }

      // 到期日期
      const targetTime = new Date(this.expireTime);
      const targetDate = this.getDate(targetTime);

      // 当前日期
      const currentTime = new Date();
      const currentDate = this.getDate(currentTime);
      const target = new Date(targetDate);
      const current = new Date(currentDate);

      // 当前时间大于等于目标时间
      if (target < current) {
        return {
          status: false
        };
      }

      // 当前时间小于目标时间
      const timeDiff = Math.abs(target.getTime() - current.getTime());
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
      const status = daysDiff <= 7;

      // const targetday = targetTime.getDate();
      // const day = currentTime.getDate();

      // const number = targetday - day || "今";
      // 上面计算number有问题 直接用x号-y号 跨月有问题，改成用时间戳
      const number = daysDiff || "今";

      // 还剩多少天
      const versionList = {
        advance_version: "高级版",
        enterprise_version: "企业标准版",
        enterprise_ultimate_version: "企业旗舰版",
        enterprise_ultimate_free_version: "企业旗舰版"
      };
      const versionText = versionList[curVersion];
      const content = `${versionText}将在<span class="number" style="color: #ff6d56;">${number}</span
        >天后过期，`;
      const shortContent = `${content}请及时续费`;
      const langContent = `${content}为了避免影响使用，请及时续费`;
      return {
        status,
        langContent,
        shortContent
      };
    },
    // 获取微应用数据
    microAppInfo() {
      return this.$parent.microAppInfo;
    },
    microAppInfoLoading() {
      return this.$parent.microAppInfoLoading || false;
    },
    isDisplayDesktopBtn() {
      return this.showDesktopBtn && !this.isPwaAppInstalled;
    }
  },
  mounted() {
    // 部署版不发送请求
    if (!this.privateMode) {
      Object(qiyuKF["a" /* initQiyuKF */])(null, true);
      this.initBeanTips();
    }
    setTimeout(() => {
      this.onMounted = true;
    }, 1500);
    this.initPWA();
  },
  beforeDestroy() {
    window.removeEventListener("appinstalled", this.pwaAppInstalledHandler);
  },
  methods: {
    initBeanTips() {
      // 获取环保豆信息，显示红点
      Object(beanMessageTip["b" /* fetchBeanChangeStatus */])().then(isChange => {
        this.isBeanChange = !!isChange;
      }).catch(e => {
        console.log(e);
      });
    },
    goNext(item) {
      if (item.href) {
        window.open(item.href, item.target);
      }
    },
    gotoQiyu() {
      window.ysf && window.open(window.ysf("url"));
    },
    gotoSenior() {
      window.open("/s/UZBZJvX9GO6/#", "_blank");
    },
    updatePackageInfo() {
      try {
        this.activeVersion = this.curVersion;
        this.showPackageDialog = true;
      } catch (error) {
        console.log("httpPackageList err: ", error);
      }
    },
    getDate(targetTime) {
      const targetYear = targetTime.getFullYear();
      const targetMonth = targetTime.getMonth() + 1;
      const targetday = targetTime.getDate();
      const targetDate = `${targetYear}-${targetMonth.toString().padStart(2, "0")}-${targetday.toString().padStart(2, "0")}`;
      return targetDate;
    },
    initPWA() {
      // pwa appinstalled 事件监听
      window.addEventListener("appinstalled", this.pwaAppInstalledHandler);

      // 初始化 PWA 引导弹窗
      this.initPWAGuidePopup();
    },
    // pwa 安装引导弹窗，若用户未安装时弹出，规则：每日只弹1次，关闭后则3日不再主动弹窗，不关闭第2天继续弹窗
    initPWAGuidePopup() {
      if (this.showPwaInstallGuidePopup) {
        this.pwaInstallGuideVisible = true;
        this.trackEventHandler("PwaPopup_Time");
        Object(cookie["c" /* set */])(PWA_INSTALL_GUIDE_DISABLED, true, 1);
      }
    },
    pwaGuideCloseHandler() {
      Object(cookie["c" /* set */])(PWA_INSTALL_GUIDE_DISABLED, true, 3);
    },
    pwaGuideInstallHandler() {
      this.pwaInstallDesktop("PwaPopup");
    },
    isBrowserSupportedPWA() {
      return "serviceWorker" in navigator && /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9.]+)/.test(navigator.userAgent);
    },
    async pwaInstallDesktop(type) {
      // PWA立即添加，点击事件埋点
      if (type === "Client_PWA") {
        this.trackEventHandler(`${type}_Add`);
      } else {
        this.trackEventHandler(`${type}_AddDesktop`);
      }
      if (!this.isBrowserSupportedPWA()) {
        this.trackEventHandler(`${type}_AddError`);
        message_default()("添加失败，当前浏览器不支持，推荐使用Chrome浏览器");
        return;
      }
      if (!window.$pwaInstallPromptEvent) {
        message_default()("已安装成功");
        return;
      }
      const choiceResult = await window.$pwaInstallPromptEvent.prompt();
      console.log(`Install prompt was: ${choiceResult.outcome}`);
      if (choiceResult.outcome === "accepted") {
        // 用户接受安装
        this.trackEventHandler(`${type}_AddSuccessfully`);
        if (type === "PwaPopup") {
          this.pwaInstallGuideVisible = false;
        }
      } else {
        // 用户拒绝安装
        this.trackEventHandler(`${type}_AddFailure`);
      }
      // 用完后清除事件，避免重复使用
      window.$pwaInstallPromptEvent = null;
    },
    // 埋点事件
    trackEventHandler(type) {
      window.zytrack && window.zytrack("custom", type);
    },
    pwaAppInstalledHandler() {
      // App was installed
      console.log("PWA was installed in business");
      this.isPwaAppInstalled = true;
      window.$pwaIsInstall = true;
    }
  }
});
// CONCATENATED MODULE: ./packages/common-inner-header/src/inner-right-menu.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_inner_right_menuvue_type_script_lang_js_ = (inner_right_menuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-inner-header/src/inner-right-menu.vue?vue&type=style&index=0&id=9ee6369e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/common-inner-header/src/inner-right-menu.vue?vue&type=style&index=0&id=9ee6369e&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/common-inner-header/src/inner-right-menu.vue






/* normalize component */

var inner_right_menu_component = Object(componentNormalizer["a" /* default */])(
  src_inner_right_menuvue_type_script_lang_js_,
  inner_right_menuvue_type_template_id_9ee6369e_scoped_true_render,
  inner_right_menuvue_type_template_id_9ee6369e_scoped_true_staticRenderFns,
  false,
  null,
  "9ee6369e",
  null
  
)

/* harmony default export */ var inner_right_menu = (inner_right_menu_component.exports);
// EXTERNAL MODULE: ./packages/tools.js
var packages_tools = __webpack_require__(10);

// EXTERNAL MODULE: ./src/http/header/index.js
var header = __webpack_require__(49);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-inner-header/src/index.vue?vue&type=script&lang=js&
// import { Button } from '@wenjuan/ui';







/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: "CommonInnerHeader",
  components: {
    // 'wj-button': Button,
    SpacePicker: space_picker,
    InnerRightMenu: inner_right_menu
    // HeaderMenu
  },

  props: {
    activeMenu: {
      type: String,
      default: ""
    },
    // 设置左边导航的数据与排序
    setNavMenu: {
      type: Function,
      default: null
    },
    // 设置发现栏目的数据与排序
    setDiscover: {
      type: Function,
      default: null
    },
    // 是否为部署版
    privateMode: {
      type: Boolean,
      default: false
    },
    // 部署版管理后台URL
    privateAdminUrl: {
      type: String,
      default: ""
    },
    // 问卷网 logo
    logoUrl: {
      type: String,
      default: ""
    },
    // 问卷网名称
    companyNameZH: {
      type: String,
      default: "问卷网"
    },
    // 微应用调整
    microData: {
      type: Object,
      default: null
    },
    // 是否显示客户端按钮
    showDesktopBtn: {
      type: Boolean,
      default: false
    },
    // 是否显示 pwa 安装引导弹窗
    showPwaInstallGuidePopup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userInfo: {},
      showMenuList: [],
      curVersion: "",
      expireTime: "",
      // 套餐过期时间
      isEntMember: false,
      // 企业空间的企业成员（企业子账号）
      memberPKGInfo: {},
      currentBrowser: "",
      // 当前浏览器类型
      showTips: false,
      // 浏览器版本过低banner提醒
      browserDd: "",
      // 浏览器下载链接
      show: 1,
      microAppInfo: {},
      // 微应用测试
      microAppInfoLoading: true // 续费升级loading
    };
  },

  computed: {
    isThridPlatform() {
      return Object(tools["b" /* distinguishUserAgentUtils */])().isDingding || Object(tools["b" /* distinguishUserAgentUtils */])().isFeishu || Object(tools["b" /* distinguishUserAgentUtils */])().isWxwork;
    }
  },
  watch: {
    microData: {
      handler(cval) {
        cval && (this.microAppInfo = {
          ...this.microAppInfo,
          ...cval
        });
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.browserList = {
      Edge: "https://www.microsoft.com/zh-cn/edge/home",
      Chrome: "https://www.google.cn/intl/zh-CN/chrome/",
      Firefox: "https://www.firefox.com.cn/",
      Safari: "https://www.google.cn/intl/zh-CN/chrome/"
    };
    this.dealBrowser();
    this.getUserInfo();
    const useId = Object(cookie["b" /* get */])("hawkeye_mid");
    if (Object(cookie["b" /* get */])(`${useId}_show_open_a_shop`)) {
      this.show = 0;
    }
  },
  methods: {
    dealBrowser() {
      const browserArr = Object(tools["e" /* getUserAgentInfo */])();
      if (browserArr && browserArr.length > 1) {
        this.currentBrowser = browserArr[0];
        this.browserDd = this.browserList[browserArr[0]];
        if (browserArr[0] === "IE" || browserArr[0] === "Chrome" && (browserArr[1] < 49 || browserArr[1] === 49)) {
          window.location.href = "/";
          return;
        }
        if (browserArr[0] === "Edge" && browserArr[1] < 69 || browserArr[0] === "Chrome" && browserArr[1] < 69 || browserArr[0] === "Firefox" && browserArr[1] < 65 || browserArr[0] === "Safari" && browserArr[1] < 13) {
          this.showTips = true;
        }
      }
    },
    getMenuListAndColor() {
      const list = [];
      //  私有化
      if (this.privateMode) {
        header_config["b" /* menuConfig */].inner = ["list", "contact"];
      }
      // sass版本的枚举 - menu
      header_config["b" /* menuConfig */].inner.forEach(ele => {
        if (!(this.isThridPlatform && ["libs"].includes(ele)) && !(this.isEntMember && ["merchant"].includes(ele))) {
          const item = header_config["c" /* menuList */][ele];
          list.push(item);
        }
      });
      this.showMenuList = this.setNavMenu ? this.setNavMenu(list) : list;
      this.useCacheConf();
    },
    getUserInfo() {
      Object(header["b" /* getUserInfo */])({}).then(res => {
        if (res.status == "200") {
          this.userInfo = res.data || {};
          this.isEntMember = res.data.member_type === 1;
          this.getMenuListAndColor();
          this.getUserPackage();
        }
      });
    },
    //  获取套餐信息
    getUserPackage() {
      Object(header["c" /* getUserPackage */])().then(res => {
        if (res.status === 200 && res.status_code === 1) {
          const {
            data
          } = res;
          this.memberPKGInfo = data;
          this.getMicroAppInfo(data);
          // 免费版
          if (!data.hasOwnProperty("super_account") && !data.hasOwnProperty("package_status") && !data.hasOwnProperty("free_package_status")) {
            this.curVersion = "free";
            return;
          }

          // 新套餐
          if (data.package_status) {
            if (data.package_status.version == "advance_version") {
              this.curVersion = "advance_version";
            }
            if (data.package_status.version == "enterprise_version") {
              this.curVersion = "enterprise_version";
            }
            if (data.package_status.version == "enterprise_ultimate_version") {
              this.curVersion = "enterprise_ultimate_version";
            }
            this.expireTime = data.package_status.expire_time || "";
          }

          // 企业旗舰试用版
          if (data.free_package_status) {
            this.curVersion = "enterprise_ultimate_free_version";
            this.expireTime = data.free_package_status.expire_time || "";
          }
        }
      });
    },
    // 跳转到商户入驻，判断用户入驻状态并跳转到对应的页面
    gotoMerchant(item) {
      this.useCacheConf(true);
      // 判断商户审核状态 根据不同状态跳转到不同页面
      if (item.key === "merchant") {
        const useId = Object(cookie["b" /* get */])("hawkeye_mid");
        Object(cookie["c" /* set */])(`${useId}_show_open_a_shop`, 1);
        if (Object(cookie["b" /* get */])(`${useId}_show_open_a_shop`)) {
          this.show = 0;
        }
        Object(header["e" /* httpGetStroeBaseInfo */])().then(res => {
          if (res.status == 200 && res.status_code == 1) {
            // 已提交申请，创建创建了商户数据
            if (res.data) {
              // 判断商户审核状态
              if (res.data.settled_status === 4) {
                // 审核成功 签约完成，跳转到商户详情页面
                window.location.href = "/member/merchant/merchantInfo/";
              } else {
                // 审核中 审核成功未签约 审核失败 跳转到商户信息录入页面
                window.location.href = "/member/merchant/myMerchant/";
              }
            } else {
              // 未提交申请 没有商户数据 跳转到商户开通页面
              window.location.href = "/member/merchant/openApplication/";
            }
          } else {
            console.log("获取商户信息失败");
            console.log(res);
          }
        }).catch(e => {
          console.log("获取商户信息失败");
          console.log(e);
        });
      }
      !item.href && this.$emit("clickMenu", item);
    },
    // 返回微应用账号信息
    getMicroAppInfo(data) {
      const curMicroData = {};
      if (data) {
        var _data$package_status;
        curMicroData.isFreeTry = data === null || data === void 0 ? void 0 : (_data$package_status = data.package_status) === null || _data$package_status === void 0 ? void 0 : _data$package_status.is_trial;
        curMicroData.isWAUser = data === null || data === void 0 ? void 0 : data.third_part_type;
      }
      const [isWxwork, isDingTalk, isFeishu] = [packages_tools["default"].$ENV.get("isWxwork"), packages_tools["default"].$ENV.get("isDingTalk"), packages_tools["default"].$ENV.get("isLark")];
      const mapList = {
        isWxwork: "isWxwork",
        isDingTalk: "isDingTalk",
        business_wx: "isWxwork",
        ding_talk: "isDingTalk",
        feishu: "isFeishu",
        isFeishu: "isFeishu",
        default: ""
      };
      // 合并所有数据来源
      Object.assign(curMicroData, {
        isWAUser: mapList[curMicroData.isWAUser] || mapList.default,
        // 微应用账户
        isMicroEnv: isWxwork || isDingTalk || isFeishu,
        // 是不是微应用环境
        isWxwork,
        isDingTalk,
        isFeishu,
        curMicro: isDingTalk ? "isDingTalk" : isFeishu ? "isFeishu" : isWxwork ? "isWxwork" : "Mozilla" // 当前微笑应用环境
      }, this.microData);
      this.microAppInfo = curMicroData;
      this.microAppInfoLoading = false;
    },
    /**
     * @param {Boolean} isOnClick 是否点击
     * @description  获取当前配置对象
     * @tools 每天刷新缓存，点击之后就不在出现提示
     *
     * */
    useCacheConf(isOnClick) {
      const item = this.showMenuList.find(it => it.key === "innerCollectPost") || {};
      if (item && item.key === "innerCollectPost") {
        const keyName = "innerCollectPost-save-time";
        const tempName = new Date().getDate();
        const preDate = JSON.parse(localStorage.getItem(keyName)) || {};
        if (!isOnClick) {
          if (tempName !== preDate.date || !preDate.isClicked) {
            localStorage.setItem(keyName, JSON.stringify({
              date: tempName,
              isClicked: false
            }));
            item.subTextConf.isHide = false;
          }
        } else {
          localStorage.setItem(keyName, JSON.stringify({
            date: tempName,
            isClicked: true
          }));
          item.subTextConf.isHide = true;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/common-inner-header/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_inner_header_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-inner-header/src/index.vue?vue&type=style&index=0&id=045aee09&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/common-inner-header/src/index.vue?vue&type=style&index=0&id=045aee09&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/common-inner-header/src/index.vue






/* normalize component */

var src_component = Object(componentNormalizer["a" /* default */])(
  common_inner_header_srcvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "045aee09",
  null
  
)

/* harmony default export */ var src = (src_component.exports);
// CONCATENATED MODULE: ./packages/common-inner-header/index.js

src.install = function (Vue) {
  Vue.component(src.name, src);
};
/* harmony default export */ var common_inner_header = __webpack_exports__["default"] = (src);

/***/ })
/******/ ])["default"];